export type Maybe<T> = T | undefined
export type InputMaybe<T> = T | undefined
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** ISO 8601 date-time string */
  DateTime: { input: string; output: string }
  /** Arbitrary JSON value */
  JSON: { input: unknown; output: Record<string, unknown> }
}

export type AiAgentConfiguration = {
  __typename?: 'AIAgentConfiguration'
  /** Display name the voice agent uses for itself. */
  agentName?: Maybe<Scalars['String']['output']>
  /** Voice identifier used for text-to-speech. */
  agentVoiceId?: Maybe<Scalars['String']['output']>
  /** Business address the agent can share with callers. */
  businessAddress?: Maybe<Scalars['String']['output']>
  /** Business name the agent refers to. */
  businessName?: Maybe<Scalars['String']['output']>
  /** Whether a cleaning requires an initial exam first. */
  cleaningRequiresInitialExam?: Maybe<Scalars['Boolean']['output']>
  /** Appointment type id used for consultation bookings. */
  consultApptId?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Appointment type id used for emergency bookings. */
  emergencyApptId?: Maybe<Scalars['String']['output']>
  /** Appointment type id used for general bookings. */
  generalApptId?: Maybe<Scalars['String']['output']>
  /** Opening greeting the agent speaks when a call starts. */
  greeting?: Maybe<Scalars['String']['output']>
  /** Message the agent reads after booking in the hygiene / new-patient flow. */
  hygienePostBookingMessage?: Maybe<Scalars['String']['output']>
  /** Unique identifier for this AI agent configuration. */
  id: Scalars['ID']['output']
  /** Appointment type id used for limited-exam bookings. */
  limitedExamApptId?: Maybe<Scalars['String']['output']>
  /** Location this AI agent configuration applies to. */
  locationId: Scalars['String']['output']
  /** LLM model used by the SMS agent (defaults to gpt-4o). */
  model?: Maybe<Scalars['String']['output']>
  /** Promotional offers the agent can present, with eligibility rules. */
  offers?: Maybe<Array<AiAgentOffer>>
  /** Organization that owns this configuration (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Whether this location only serves pediatric patients. */
  pediatricOnly?: Maybe<Scalars['Boolean']['output']>
  /** Message the agent reads after successfully booking an appointment. */
  postBookingMessage?: Maybe<Scalars['String']['output']>
  /** Timestamp of the last SMS agent prompt deploy; absent means never deployed. */
  promptDeployedDate?: Maybe<Scalars['DateTime']['output']>
  /** Free-form version label of the deployed SMS agent prompt (supplied by Atlas). */
  promptVersion?: Maybe<Scalars['String']['output']>
  /** Say This, Not That phrase rules giving the agent a replacement phrase for a stop phrase on a given channel. */
  sayThisNotThatRules?: Maybe<Array<SayThisNotThatRuleType>>
  /** Services the practice offers, with pricing and consult requirements. */
  services?: Maybe<Array<AiAgentService>>
  /** Services the practice explicitly does not offer. */
  servicesNotOffered?: Maybe<Array<AiAgentService>>
  /** Whether an SMS confirmation is sent after booking. */
  smsConfirmationEnabled?: Maybe<Scalars['Boolean']['output']>
  /** Shared SMS agent system prompt for this location; rendered with template vars at reply time. */
  systemPrompt?: Maybe<Scalars['String']['output']>
  /** Sampling temperature for the SMS agent LLM. */
  temperature?: Maybe<Scalars['Float']['output']>
  /** ElevenLabs-format tool definitions. Each object defines a webhook tool with name, description, and api_schema. */
  tools?: Maybe<Scalars['JSON']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Extra instructions appended to the voice agent prompt. */
  voiceAgentAddendum?: Maybe<Scalars['String']['output']>
  /** Tool names enabled for the voice agent. */
  voiceAgentTools?: Maybe<Array<Scalars['String']['output']>>
  /** Workspace this configuration belongs to. */
  workspaceId: Scalars['String']['output']
}

export type AiAgentConfigurationSnapshot = {
  __typename?: 'AIAgentConfigurationSnapshot'
  /** Whether HMO state insurance was accepted at turn time. */
  acceptInsuranceStateHMO?: Maybe<Scalars['Boolean']['output']>
  /** Snapshot of business hours at turn time. */
  businessHours?: Maybe<Scalars['String']['output']>
  /** Snapshot of accepted insurances at turn time. */
  insurances?: Maybe<Scalars['String']['output']>
  /** Snapshot of active offers at turn time. */
  offers?: Maybe<Scalars['String']['output']>
  /** Snapshot of offered services at turn time. */
  services?: Maybe<Scalars['String']['output']>
}

export type AiAgentNotificationInput = {
  /** Channels for emergency-appointment-request notifications. */
  emergencyAppointmentRequest?: InputMaybe<NotificationChannelInput>
  /** Whether AI-agent notifications are enabled. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Channels for new AI-agent-call notifications. */
  newAIAgentCall?: InputMaybe<NotificationChannelInput>
  /** Channels for new-appointment-booked notifications. */
  newAppointmentBooked?: InputMaybe<NotificationChannelInput>
}

export type AiAgentNotificationSettings = {
  __typename?: 'AIAgentNotificationSettings'
  /** Channels for emergency-appointment-request notifications. */
  emergencyAppointmentRequest?: Maybe<NotificationChannel>
  /** Whether AI-agent notifications are enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** Channels for new AI-agent-call notifications. */
  newAIAgentCall?: Maybe<NotificationChannel>
  /** Channels for new-appointment-booked notifications. */
  newAppointmentBooked?: Maybe<NotificationChannel>
}

export type AiAgentOffer = {
  __typename?: 'AIAgentOffer'
  /** Any, Insured, or Uninsured */
  eligibleInsurance: Scalars['String']['output']
  /** Name of the offer. */
  name: Scalars['String']['output']
  /** Whether the offer only applies to emergency visits. */
  onlyEmergencyEligible: Scalars['Boolean']['output']
  /** Patient status the offer applies to: New Patient or Existing Patient. */
  patientStatus?: Maybe<Scalars['String']['output']>
}

export type AiAgentOfferInput = {
  /** Insurance eligibility: Any, Insured, or Uninsured */
  eligibleInsurance: Scalars['String']['input']
  /** Name of the offer */
  name: Scalars['String']['input']
  /** Whether the offer is only eligible for emergencies */
  onlyEmergencyEligible: Scalars['Boolean']['input']
  /** Patient status the offer applies to: New Patient or Existing Patient */
  patientStatus?: InputMaybe<Scalars['String']['input']>
}

export type AiAgentOverview = {
  __typename?: 'AIAgentOverview'
  /** Display name of the AI agent. */
  agentName?: Maybe<Scalars['String']['output']>
  /** Business address the agent references. */
  businessAddress?: Maybe<Scalars['String']['output']>
  /** Business name the agent represents. */
  businessName?: Maybe<Scalars['String']['output']>
  /** Appointment type id used for consultations. */
  consultApptId?: Maybe<Scalars['String']['output']>
  /** Appointment type id used for emergency appointments. */
  emergencyApptId?: Maybe<Scalars['String']['output']>
  /** Appointment type id used for general appointments. */
  generalApptId?: Maybe<Scalars['String']['output']>
  /** Greeting the agent opens calls with. */
  greeting?: Maybe<Scalars['String']['output']>
  /** Message sent to the caller after a hygiene appointment booking is made. */
  hygienePostBookingMessage?: Maybe<Scalars['String']['output']>
  /** Unique identifier of the AI agent configuration. */
  id: Scalars['ID']['output']
  /** Appointment type id used for limited exams. */
  limitedExamApptId?: Maybe<Scalars['String']['output']>
  /** Location this AI agent serves. */
  locationId: Scalars['String']['output']
  /** Promotional offers the agent can present. */
  offers?: Maybe<Array<AiAgentOffer>>
  /** Message sent to the caller after a booking is made. */
  postBookingMessage?: Maybe<Scalars['String']['output']>
  /** Say This, Not That phrase rules the agent applies when responding. */
  sayThisNotThatRules?: Maybe<Array<SayThisNotThatRuleType>>
  /** Services the agent offers. */
  services?: Maybe<Array<AiAgentService>>
  /** Services the agent explicitly does not offer. */
  servicesNotOffered?: Maybe<Array<AiAgentService>>
  /** Whether an SMS confirmation is sent after booking. */
  smsConfirmationEnabled?: Maybe<Scalars['Boolean']['output']>
}

export type AiAgentService = {
  __typename?: 'AIAgentService'
  /** Price of the required consultation, if any. */
  consultPrice?: Maybe<Scalars['Float']['output']>
  /** Whether a consultation is required before this service. */
  consultRequired: Scalars['Boolean']['output']
  /** High end of the service price range. */
  highPrice?: Maybe<Scalars['Float']['output']>
  /** Low end of the service price range. */
  lowPrice?: Maybe<Scalars['Float']['output']>
  /** Name of the service offered. */
  name: Scalars['String']['output']
}

export type AiAgentServiceInput = {
  /** Price of the required consult */
  consultPrice?: InputMaybe<Scalars['Float']['input']>
  /** Whether a consult is required for this service */
  consultRequired: Scalars['Boolean']['input']
  /** High end of the service price range */
  highPrice?: InputMaybe<Scalars['Float']['input']>
  /** Low end of the service price range */
  lowPrice?: InputMaybe<Scalars['Float']['input']>
  /** Name of the service */
  name: Scalars['String']['input']
}

export type AiConversationMessage = {
  __typename?: 'AIConversationMessage'
  /** Text content of the message. */
  content: Scalars['String']['output']
  /** Role of the message author (e.g. user, assistant, system). */
  role: Scalars['String']['output']
}

export type AiConversationTurn = {
  __typename?: 'AIConversationTurn'
  /** Activity record associated with this turn, if any. */
  activityId?: Maybe<Scalars['String']['output']>
  /** Snapshot of the agent configuration in effect at turn time. */
  agentConfiguration?: Maybe<AiAgentConfigurationSnapshot>
  /** AI agent that produced this turn, if any. */
  aiAgentId?: Maybe<Scalars['String']['output']>
  /** AI workflow that produced this turn, if any. */
  aiWorkflowId?: Maybe<Scalars['String']['output']>
  /** Contact this conversation is with. */
  contactId: Scalars['String']['output']
  /** Conversation history provided as context for this turn. */
  conversationHistory?: Maybe<Array<AiConversationMessage>>
  /** LLM cost of this turn, in USD. */
  costUsd?: Maybe<Scalars['Float']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Whether this turn represents a failed reply attempt (skip or error). */
  failed?: Maybe<Scalars['Boolean']['output']>
  /** Human-readable detail about why the reply failed. */
  failureMessage?: Maybe<Scalars['String']['output']>
  /** Stable machine code for why the reply failed. */
  failureReason?: Maybe<Scalars['String']['output']>
  /** Sending phone number for this turn. */
  from?: Maybe<Scalars['String']['output']>
  /** Unique identifier for this conversation turn. */
  id: Scalars['ID']['output']
  /** Whether this turn was the initial outbound message in the thread. */
  isInitialMessage?: Maybe<Scalars['Boolean']['output']>
  /** End-to-end latency of generating this turn, in milliseconds. */
  latencyMs?: Maybe<Scalars['Int']['output']>
  /** Location this turn belongs to. */
  locationId: Scalars['String']['output']
  /** Message that triggered this turn, if any. */
  messageId?: Maybe<Scalars['String']['output']>
  /** LLM model used to generate this turn. */
  model?: Maybe<Scalars['String']['output']>
  /** Organization that owns this turn (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Final text response generated for this turn. */
  response?: Maybe<Scalars['String']['output']>
  /** SMS delivery cost of this turn, in USD. */
  smsCostUsd?: Maybe<Scalars['Float']['output']>
  /** Intermediate reasoning and tool-call steps taken during this turn. */
  steps?: Maybe<Array<AiConversationTurnStep>>
  /** System prompt used to generate this turn. */
  systemPrompt?: Maybe<Scalars['String']['output']>
  /** Sampling temperature used to generate this turn. */
  temperature?: Maybe<Scalars['Float']['output']>
  /** Conversation thread this turn is part of. */
  threadId: Scalars['String']['output']
  /** Receiving phone number for this turn. */
  to?: Maybe<Scalars['String']['output']>
  /** Token usage recorded for this turn. */
  tokenUsage?: Maybe<AiTokenUsage>
  /** Zero-based position of this turn within the thread. */
  turnIndex?: Maybe<Scalars['Int']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this turn belongs to. */
  workspaceId: Scalars['String']['output']
}

export type AiConversationTurnListResult = {
  __typename?: 'AIConversationTurnListResult'
  /** Page of matching records */
  hits: Array<AiConversationTurn>
  /** Current page number */
  page: Scalars['Int']['output']
  /** Total number of matching records across all pages */
  total: Scalars['Int']['output']
}

export type AiConversationTurnStep = {
  __typename?: 'AIConversationTurnStep'
  /** Text output produced during this step. */
  text?: Maybe<Scalars['String']['output']>
  /** Tool calls made during this step. */
  toolCalls?: Maybe<Array<AiConversationTurnToolCall>>
  /** Results of the tool calls made during this step. */
  toolResults?: Maybe<Array<AiConversationTurnToolResult>>
}

export type AiConversationTurnToolCall = {
  __typename?: 'AIConversationTurnToolCall'
  /** Arguments passed to the tool call. */
  args?: Maybe<Scalars['JSON']['output']>
  /** Name of the tool the agent invoked. */
  toolName: Scalars['String']['output']
}

export type AiConversationTurnToolResult = {
  __typename?: 'AIConversationTurnToolResult'
  /** Whether the tool call resulted in an error. */
  isError: Scalars['Boolean']['output']
  /** Value returned by the tool. */
  result?: Maybe<Scalars['JSON']['output']>
  /** Name of the tool that produced this result. */
  toolName: Scalars['String']['output']
}

export type AiInputTokenDetails = {
  __typename?: 'AIInputTokenDetails'
  /** Number of input tokens served from cache. */
  cacheReadTokens?: Maybe<Scalars['Int']['output']>
}

export type AiTokenUsage = {
  __typename?: 'AITokenUsage'
  /** Number of input tokens served from cache. */
  cachedInputTokens?: Maybe<Scalars['Int']['output']>
  /** Detailed breakdown of input token usage. */
  inputTokenDetails?: Maybe<AiInputTokenDetails>
  /** Number of input (prompt) tokens used. */
  inputTokens?: Maybe<Scalars['Int']['output']>
  /** Number of output (completion) tokens used. */
  outputTokens?: Maybe<Scalars['Int']['output']>
  /** Total tokens used (input plus output). */
  totalTokens?: Maybe<Scalars['Int']['output']>
}

export type Action = {
  __typename?: 'Action'
  /** Synthetic client-facing identifier in the form queueName:queueId. */
  actionId: Scalars['ID']['output']
  /** Contact this action holds. */
  contactId: Scalars['ID']['output']
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Optional free-text note on this action. */
  note?: Maybe<Scalars['String']['output']>
  /** Organization that owns this action (multi-tenant isolation key). */
  orgId: Scalars['ID']['output']
  /** Identifier of the queue this action belongs to. */
  queueId: Scalars['String']['output']
  /** Name of the queue surface this action belongs to. */
  queueName: Scalars['String']['output']
  /** Current state of this action. */
  state: Scalars['String']['output']
  /** Timestamp until which this action's hold remains in effect. */
  untilDate?: Maybe<Scalars['DateTime']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** User who created or last changed this action. */
  userId: Scalars['ID']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this action belongs to. */
  workspaceId: Scalars['ID']['output']
}

export type ActionListResult = {
  __typename?: 'ActionListResult'
  /** Results for the current page. */
  hits: Array<Action>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type ActivateAccountResult = {
  __typename?: 'ActivateAccountResult'
  /** Whether Google sign-in is allowed for this account. */
  allowGoogle: Scalars['Boolean']['output']
  /** Activation code tied to this account. */
  code: Scalars['String']['output']
  /** Email address of the account being activated. */
  email: Scalars['String']['output']
  /** Pre-filled name for the account, if known. */
  name?: Maybe<Scalars['String']['output']>
  /** Pre-filled phone number for the account, if known. */
  phone?: Maybe<Scalars['String']['output']>
  /** Pre-filled job title/position for the account, if known. */
  position?: Maybe<Scalars['String']['output']>
}

export type Activity = {
  __typename?: 'Activity'
  /** When the activity occurred. */
  activityDate?: Maybe<Scalars['DateTime']['output']>
  /** Whether this activity is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Marketing channel attributed to this activity. */
  channel?: Maybe<Scalars['String']['output']>
  /** Number of contacts associated with this activity. */
  contactCount?: Maybe<Scalars['Int']['output']>
  /** Denormalized primary contact name. */
  contactName?: Maybe<Scalars['String']['output']>
  /** Denormalized primary contact phone number. */
  contactPhone?: Maybe<Scalars['String']['output']>
  /** Contacts associated with this activity. */
  contacts?: Maybe<Array<ActivityContact>>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Arbitrary activity-specific payload data. */
  data?: Maybe<Scalars['JSON']['output']>
  /** Human-readable description of the activity. */
  description?: Maybe<Scalars['String']['output']>
  /** Email address associated with the activity. */
  email?: Maybe<Scalars['String']['output']>
  /** Facebook click id attributed to this activity. */
  fbclid?: Maybe<Scalars['String']['output']>
  /** Google click id attributed to this activity. */
  gclid?: Maybe<Scalars['String']['output']>
  /** Unique identifier for this activity. */
  id: Scalars['ID']['output']
  /** Whether this activity is considered qualified. */
  isQualified?: Maybe<Scalars['Boolean']['output']>
  /** Location this activity occurred at. */
  locationId: Scalars['ID']['output']
  /** How contacts were matched to this activity. */
  matchTypes?: Maybe<Array<Scalars['String']['output']>>
  /** Name of the person who performed the activity (e.g. form submitter or caller). */
  nameFromActivity?: Maybe<Scalars['String']['output']>
  /** Source of the name captured from the activity. */
  nameSource?: Maybe<Scalars['String']['output']>
  /** Whether this activity is flagged for manual review. */
  needsReview?: Maybe<Scalars['Boolean']['output']>
  /** Free-form note attached to the activity. */
  note?: Maybe<Scalars['String']['output']>
  /** Organization that owns this activity (multi-tenant isolation key). */
  orgId: Scalars['ID']['output']
  /** Staff member who owns this activity. */
  owner?: Maybe<ActivityOwner>
  /** Phone number captured directly from the activity. */
  phoneFromActivity?: Maybe<Scalars['String']['output']>
  /** Referring URL the activity originated from. */
  referringUrl?: Maybe<Scalars['String']['output']>
  /** Reason the activity was flagged for review. */
  reviewReason?: Maybe<Scalars['String']['output']>
  /** Whether the contact opted in to SMS marketing via this activity. */
  smsMarketingOptIn?: Maybe<Scalars['Boolean']['output']>
  /** Source system or origin of the activity. */
  source?: Maybe<Scalars['String']['output']>
  /** Sub-type for finer classification; for Calls, 'inbound' or 'outbound'. */
  subType?: Maybe<Scalars['String']['output']>
  /** Tags applied to this activity. */
  tags?: Maybe<Array<Scalars['String']['output']>>
  /** Trackable ad campaign id attributed to this activity. */
  trackableCampaignId?: Maybe<Scalars['String']['output']>
  /** Tracking phone number involved in this activity. */
  trackingNumber?: Maybe<Scalars['String']['output']>
  /** Name of the tracking number involved in this activity. */
  trackingNumberName?: Maybe<Scalars['String']['output']>
  /** Kind of activity, e.g. Call, Note, Form, Appointment, Scheduler, Change. */
  type: Scalars['String']['output']
  /** Id of the underlying record (call, form, appointment, etc.) this activity represents. */
  typeId?: Maybe<Scalars['ID']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** UTM account id attributed to this activity. */
  utmAccountId?: Maybe<Scalars['String']['output']>
  /** UTM campaign attributed to this activity. */
  utmCampaign?: Maybe<Scalars['String']['output']>
  /** UTM campaign id attributed to this activity. */
  utmCampaignId?: Maybe<Scalars['String']['output']>
  /** UTM content attributed to this activity. */
  utmContent?: Maybe<Scalars['String']['output']>
  /** UTM keywords/term attributed to this activity. */
  utmKeywords?: Maybe<Scalars['String']['output']>
  /** UTM medium attributed to this activity. */
  utmMedium?: Maybe<Scalars['String']['output']>
  /** UTM source attributed to this activity. */
  utmSource?: Maybe<Scalars['String']['output']>
  /** Vendor/integration that produced this activity. */
  vendor?: Maybe<Scalars['String']['output']>
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this activity belongs to. */
  workspaceId: Scalars['ID']['output']
}

export type ActivityContact = {
  __typename?: 'ActivityContact'
  /** Contact id associated with this activity. */
  id: Scalars['ID']['output']
  /** Contact's lifecycle stage at match time. */
  lifecycleStage?: Maybe<Scalars['String']['output']>
  /** Location this contact belongs to. */
  locationId?: Maybe<Scalars['ID']['output']>
  /** When this contact was matched to the activity. */
  matchDate?: Maybe<Scalars['DateTime']['output']>
  /** Contact's name. */
  name?: Maybe<Scalars['String']['output']>
  /** Name captured directly from this activity (e.g. form or caller name). */
  nameFromActivity?: Maybe<Scalars['String']['output']>
  /** Index of this person among multiple contacts on the activity. */
  peopleIndex?: Maybe<Scalars['Int']['output']>
  /** Contact's phone number. */
  phone?: Maybe<Scalars['String']['output']>
}

export type ActivityCountResult = {
  __typename?: 'ActivityCountResult'
  /** Number of matching activities. */
  count: Scalars['Int']['output']
}

export type ActivityListResult = {
  __typename?: 'ActivityListResult'
  /** Results for the current page. */
  hits: Array<Activity>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type ActivityOwner = {
  __typename?: 'ActivityOwner'
  /** Alternate names/aliases for the owner. */
  aliases?: Maybe<Array<Scalars['String']['output']>>
  /** Owner's user id. */
  id?: Maybe<Scalars['ID']['output']>
  /** Owner's display name. */
  name: Scalars['String']['output']
  /** User id of the owner. */
  userId?: Maybe<Scalars['ID']['output']>
}

export type AdCampaign = {
  __typename?: 'AdCampaign'
  /** Ad platform account id this campaign runs under */
  accountId?: Maybe<Scalars['String']['output']>
  /** Display name of the ad platform account */
  accountName?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Unique identifier for the ad campaign */
  id: Scalars['ID']['output']
  /** Display name of the campaign */
  name: Scalars['String']['output']
  /** Organization that owns this campaign (multi-tenant isolation key) */
  orgId: Scalars['ID']['output']
  /** Specific ad platform: Google Ads, Local Service Ads, or Facebook Ads */
  platform?: Maybe<Scalars['String']['output']>
  /** Ad platform family: google or facebook */
  type: Scalars['String']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Campaign id assigned by the ad platform vendor */
  vendorCampaignId?: Maybe<Scalars['String']['output']>
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this campaign belongs to */
  workspaceId: Scalars['ID']['output']
}

export type AdPlatformMapping = {
  __typename?: 'AdPlatformMapping'
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Unique mapping ID, derived from org, workspace, source, and medium. */
  id: Scalars['ID']['output']
  /** UTM medium this mapping matches (lowercased). */
  medium: Scalars['String']['output']
  /** Organization that owns this mapping (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Ad platform the source/medium pair maps to (e.g. google, facebook). */
  platform: Scalars['String']['output']
  /** UTM source this mapping matches (lowercased). */
  source: Scalars['String']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this mapping belongs to. */
  workspaceId: Scalars['String']['output']
}

export type AdPlatformMappingListResult = {
  __typename?: 'AdPlatformMappingListResult'
  /** Matching records for the current page. */
  hits: Array<AdPlatformMapping>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching records across all pages. */
  total: Scalars['Int']['output']
}

/** Visual presets for the patient-facing packet */
export type AppearanceInput = {
  /** Accent color used in the patient-facing packet. */
  accentColor: Scalars['String']['input']
  /** white, warm, cool, or paper */
  backgroundPreset: Scalars['String']['input']
  /** system, classic, or modern */
  fontPreset: Scalars['String']['input']
}

export type Appointment = {
  __typename?: 'Appointment'
  /** Total monetary amount for the appointment, synced or calculated from the PMS. */
  amount?: Maybe<Scalars['Float']['output']>
  /** Date the appointment was originally booked, used for lead-time metrics. */
  appointmentMadeDate?: Maybe<Scalars['DateTime']['output']>
  /** Whether the patient confirmed the appointment (synced from PMS); null when no sync has written it. */
  confirmed?: Maybe<Scalars['Boolean']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Scheduled date of the appointment (date only; time is stored separately). */
  date?: Maybe<Scalars['DateTime']['output']>
  /** Short description of the appointment purpose or procedures. */
  description?: Maybe<Scalars['String']['output']>
  /** Scheduled length of the appointment in minutes (stored as a string). */
  duration?: Maybe<Scalars['String']['output']>
  /** Unique identifier for the appointment; generated from a vendor-specific id pattern (Sikka/Carestack/Kolla). */
  id: Scalars['ID']['output']
  /** Practice location where the appointment is scheduled. */
  locationId: Scalars['ID']['output']
  /** Free-form appointment notes or comments from the PMS. */
  note?: Maybe<Scalars['String']['output']>
  /** Internal patient this appointment belongs to; generated from a vendor-specific id pattern. */
  patientId?: Maybe<Scalars['ID']['output']>
  /** Raw appointment status as reported by the source PMS (e.g. Scheduled, Confirmed, Completed, Cancelled, No Show). */
  pmsStatus?: Maybe<Scalars['String']['output']>
  /** First procedure code for the appointment. Deprecated: use procedureCodes. */
  procedureCode1?: Maybe<Scalars['String']['output']>
  /** Amount for the first procedure code. Deprecated: use procedureCodes. */
  procedureCode1Amount?: Maybe<Scalars['String']['output']>
  /** Minutes allocated for the first procedure. Deprecated: use procedureCodes. */
  procedureCode1Time?: Maybe<Scalars['String']['output']>
  /** Second procedure code for the appointment. Deprecated: use procedureCodes. */
  procedureCode2?: Maybe<Scalars['String']['output']>
  /** Amount for the second procedure code. Deprecated: use procedureCodes. */
  procedureCode2Amount?: Maybe<Scalars['String']['output']>
  /** Minutes allocated for the second procedure. Deprecated: use procedureCodes. */
  procedureCode2Time?: Maybe<Scalars['String']['output']>
  /** Third procedure code for the appointment. Deprecated: use procedureCodes. */
  procedureCode3?: Maybe<Scalars['String']['output']>
  /** Amount for the third procedure code. Deprecated: use procedureCodes. */
  procedureCode3Amount?: Maybe<Scalars['String']['output']>
  /** Minutes allocated for the third procedure. Deprecated: use procedureCodes. */
  procedureCode3Time?: Maybe<Scalars['String']['output']>
  /** Procedure codes (e.g. ADA CDT codes) associated with this appointment. */
  procedureCodes?: Maybe<Array<Scalars['String']['output']>>
  /** Provider id(s) from the PMS assigned to this appointment; comma-delimited when multiple. */
  providerId?: Maybe<Scalars['String']['output']>
  /** Sikka office identifier for Sikka-sourced appointments. */
  sikkaOfficeId?: Maybe<Scalars['String']['output']>
  /** Sikka practice identifier for Sikka-sourced appointments. */
  sikkaPracticeId?: Maybe<Scalars['String']['output']>
  /** Channel that created the appointment: Voice Agent, SMS Agent, Scheduler, or In App Scheduler. */
  source?: Maybe<Scalars['String']['output']>
  /** Normalized internal status computed from pmsStatus and transactions: Scheduled, Completed, Broken, Cancelled, or Deleted. */
  status?: Maybe<Scalars['String']['output']>
  /** Scheduled time of the appointment in 24-hour HH:mm format. */
  time?: Maybe<Scalars['String']['output']>
  /** Business days between when the appointment was booked and its scheduled date. */
  timeToAppointment?: Maybe<Scalars['Int']['output']>
  /** Appointment type/category from the PMS (e.g. Cleaning, Consultation, Surgery). */
  type?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
}

export type AppointmentListResult = {
  __typename?: 'AppointmentListResult'
  /** Results for the current page. */
  hits: Array<Appointment>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type AppointmentType = {
  __typename?: 'AppointmentType'
  /** Whether this appointment type is offered by the AI agent. */
  activeAgent?: Maybe<Scalars['Boolean']['output']>
  /** Whether this appointment type is offered in the online scheduler. */
  activeScheduler?: Maybe<Scalars['Boolean']['output']>
  /** Optional user-defined alias used in the scheduler. */
  alias?: Maybe<Scalars['String']['output']>
  /** Default length of the appointment in minutes. */
  appointmentLength: Scalars['Float']['output']
  /** Whether scheduling of this appointment type is blocked. */
  blockScheduling?: Maybe<Scalars['Boolean']['output']>
  /** Notes explaining scheduling blocks for this appointment type. */
  blockSchedulingNotes?: Maybe<Array<Scalars['String']['output']>>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Display name of the appointment type as shown to users. */
  displayName: Scalars['String']['output']
  /** Whether this appointment type is excluded from double-booking. */
  doubleBookingExclusion?: Maybe<Scalars['Boolean']['output']>
  /** Blockout ids excluded when scheduling this appointment type. */
  excludedBlockouts?: Maybe<Array<Scalars['String']['output']>>
  /** Soonest availability offered, in hours from now (e.g. 24 = no appointments within 24 hours). */
  generalBuffer?: Maybe<Scalars['Float']['output']>
  /** Unique identifier for the appointment type. */
  id: Scalars['ID']['output']
  /** Kolla consumer id for the connector this appointment type syncs through. */
  kollaConsumerId: Scalars['String']['output']
  /** Hours removed from the start of the day's operating hours (e.g. 1 = skip first hour). */
  morningBuffer?: Maybe<Scalars['Float']['output']>
  /** How many hours into the future the morning buffer applies (e.g. 48 = only within the next 2 days). */
  morningBufferLookahead?: Maybe<Scalars['Float']['output']>
  /** Internal name of the appointment type. */
  name: Scalars['String']['output']
  /** Sort order used when listing appointment types. */
  order?: Maybe<Scalars['Float']['output']>
  /** Organization that owns this appointment type (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Patient type this appointment applies to: 'New Patient' or 'Existing Patient'. */
  patientType?: Maybe<Scalars['String']['output']>
  /** PMS procedure codes associated with this appointment type. */
  procedureCodes?: Maybe<Array<Scalars['String']['output']>>
  /** Start-time increment in minutes (e.g. 30 for :00/:30); falls back to SchedulingConfiguration.granularity when unset. */
  startIncrement?: Maybe<Scalars['Float']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Source PMS vendor, e.g. 'kolla' or 'carestack'. */
  vendor?: Maybe<Scalars['String']['output']>
  /** Appointment type's identifier in the source PMS vendor system. */
  vendorId: Scalars['String']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this appointment type belongs to. */
  workspaceId: Scalars['String']['output']
}

export type AppointmentTypeListResult = {
  __typename?: 'AppointmentTypeListResult'
  /** The page of items matching the query. */
  hits: Array<AppointmentType>
  /** Zero-based index of the returned page. */
  page: Scalars['Int']['output']
  /** Total number of items matching the query across all pages. */
  total: Scalars['Int']['output']
}

export type AscendLocation = {
  __typename?: 'AscendLocation'
  /** Ascend location id */
  id: Scalars['String']['output']
  /** Whether this location is already in use by an integration */
  isUsed: Scalars['Boolean']['output']
  /** Ascend location name */
  name: Scalars['String']['output']
}

export type AscendRequestInput = {
  /** JSON-encoded request body for POST */
  body?: InputMaybe<Scalars['String']['input']>
  /** Query params as filter string (e.g. "lastName==Smith") */
  filter?: InputMaybe<Scalars['String']['input']>
  /** Location whose Ascend integration to proxy through. */
  locationId: Scalars['ID']['input']
  /** HTTP method: get or post. */
  method?: Scalars['String']['input']
  /** Ascend API path to request. */
  path: Scalars['String']['input']
}

export type AscendRequestResult = {
  __typename?: 'AscendRequestResult'
  /** JSON-encoded response from Ascend */
  data?: Maybe<Scalars['String']['output']>
  /** Error message when the request failed. */
  error?: Maybe<Scalars['String']['output']>
  /** Round-trip response time in milliseconds. */
  responseTimeMs?: Maybe<Scalars['Int']['output']>
  /** Whether the Ascend request succeeded. */
  success: Scalars['Boolean']['output']
}

export type AssignedWorkspace = {
  __typename?: 'AssignedWorkspace'
  /** Workspace id this assignment grants access to. */
  id: Scalars['ID']['output']
  /** Locations the user is restricted to in this workspace; omitted means all locations. */
  locationIds?: Maybe<Array<Scalars['String']['output']>>
  /** Role id the user holds in this workspace. */
  roleId: Scalars['ID']['output']
}

export type AuthPayload = {
  __typename?: 'AuthPayload'
  /** JWT access token for authenticating subsequent requests. */
  accessToken: Scalars['String']['output']
  /** The authenticated user. */
  user: User
}

export type Availability = {
  __typename?: 'Availability'
  /** Appointment type ids this availability applies to */
  appointmentTypeIds?: Maybe<Array<Scalars['String']['output']>>
  /** Whether this availability has been archived */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Whether this is backup availability used when primary availability is unavailable */
  backupAvailability?: Maybe<Scalars['Boolean']['output']>
  /** When the availability record was created */
  createdDate?: Maybe<Scalars['DateTime']['output']>
  /** Unique identifier for the availability record */
  id: Scalars['ID']['output']
  /** Kolla consumer id tying this availability to the PMS connection */
  kollaConsumerId: Scalars['String']['output']
  /** Location this availability applies to */
  locationId: Scalars['String']['output']
  /** Deprecated single operatory id; use operatoryIds instead (V1 compatibility) */
  operatoryId?: Maybe<Scalars['String']['output']>
  /** Operatory ids this availability applies to */
  operatoryIds?: Maybe<Array<Scalars['String']['output']>>
  /** Organization that owns this record (multi-tenant isolation key) */
  orgId: Scalars['String']['output']
  /** Provider this availability is configured for */
  providerId: Scalars['String']['output']
  /** Time slots defining when the provider/operatory is available */
  timeSlots?: Maybe<LocationOpenHours>
  /** When the availability record was last updated */
  updatedDate?: Maybe<Scalars['DateTime']['output']>
  /** Workspace this availability belongs to */
  workspaceId: Scalars['String']['output']
}

export type AvailablePhoneNumber = {
  __typename?: 'AvailablePhoneNumber'
  /** City/state if available from AWS */
  locality?: Maybe<Scalars['String']['output']>
  /** E.164 format */
  phone: Scalars['String']['output']
  /** Number capability type (e.g. voice, messaging). */
  type: PhoneNumberType
}

export type BackgroundJobFilter = {
  /** Limit results by completion state. */
  complete?: InputMaybe<Scalars['Boolean']['input']>
  /** Limit results to this location. */
  locationId?: InputMaybe<Scalars['ID']['input']>
  /** Limit results to this organization. */
  orgId?: InputMaybe<Scalars['ID']['input']>
  /** Limit results to this job type. */
  type?: InputMaybe<Scalars['String']['input']>
}

export type BackgroundJobProgress = {
  __typename?: 'BackgroundJobProgress'
  /** Whether the job has finished. */
  complete: Scalars['Boolean']['output']
  /** Completed tasks (totalTasks - remaining) */
  completed: Scalars['Int']['output']
  /** When the job completed; unset if still running. */
  completedAt?: Maybe<Scalars['DateTime']['output']>
  /** When the job was created. */
  createdAt: Scalars['DateTime']['output']
  /** Human-readable job description. */
  description?: Maybe<Scalars['String']['output']>
  /** Unique identifier for the progress record. */
  id: Scalars['ID']['output']
  /** Identifier of the background job. */
  jobId: Scalars['ID']['output']
  /** Location the job is scoped to, if any. */
  locationId?: Maybe<Scalars['ID']['output']>
  /** Organization the job is scoped to, if any. */
  orgId?: Maybe<Scalars['ID']['output']>
  /** Completion percentage 0-100 */
  percentComplete: Scalars['Int']['output']
  /** Number of tasks still remaining. */
  remaining: Scalars['Int']['output']
  /** Total number of tasks in the job. */
  totalTasks: Scalars['Int']['output']
  /** Type of background job. */
  type: Scalars['String']['output']
}

export type BackgroundJobProgressConnection = {
  __typename?: 'BackgroundJobProgressConnection'
  /** Background jobs for the current page. */
  nodes: Array<BackgroundJobProgress>
  /** Pagination metadata. */
  pageInfo: PageInfo
}

export type BlockoutNote = {
  __typename?: 'BlockoutNote'
  /** Appointment type this blockout applies to, if any. */
  appointmentType?: Maybe<Scalars['String']['output']>
  /** End time of the blockout. */
  endTime: Scalars['String']['output']
  /** Text of the blockout note. */
  note: Scalars['String']['output']
  /** Start time of the blockout. */
  startTime: Scalars['String']['output']
}

export type BlockoutNoteInput = {
  /** Appointment type this blockout applies to, if any. */
  appointmentType?: InputMaybe<Scalars['String']['input']>
  /** End time of the blockout. */
  endTime: Scalars['String']['input']
  /** Text of the blockout note. */
  note: Scalars['String']['input']
  /** Start time of the blockout. */
  startTime: Scalars['String']['input']
}

export type BudgetListResult = {
  __typename?: 'BudgetListResult'
  /** The budget records on this page. */
  hits: Array<BudgetResult>
  /** Current page number. */
  page: Scalars['Int']['output']
  /** Total number of matching budget records. */
  total: Scalars['Int']['output']
}

export type BudgetMetricsResponse = {
  __typename?: 'BudgetMetricsResponse'
  /** Total budget for the period, in dollars. */
  total: Scalars['Float']['output']
}

export type BudgetResult = {
  __typename?: 'BudgetResult'
  /** Budgeted amount for the channel, in dollars. */
  amount?: Maybe<Scalars['Float']['output']>
  /** Goal for number of appointments. */
  appointmentGoal?: Maybe<Scalars['Int']['output']>
  /** Marketing channel this budget line is for. */
  channel: Scalars['String']['output']
  /** Budget record id, if persisted. */
  id?: Maybe<Scalars['ID']['output']>
  /** Internal goal amount for the channel, in dollars. */
  internalGoal?: Maybe<Scalars['Float']['output']>
  /** Goal for number of leads. */
  leadGoal?: Maybe<Scalars['Int']['output']>
  /** Location this budget is for. */
  locationId: Scalars['ID']['output']
  /** Goal for number of MQLs. */
  mqlGoal?: Maybe<Scalars['Int']['output']>
  /** Goal for number of new patients. */
  patientGoal?: Maybe<Scalars['Int']['output']>
  /** Target ad spend for the channel, in dollars. */
  targetSpend?: Maybe<Scalars['Float']['output']>
  /** Year-month (YYYY-MM) this budget covers. */
  yearMonth: Scalars['String']['output']
}

export type Call = {
  __typename?: 'Call'
  /** AI extraction results for the call. */
  ai?: Maybe<CallAi>
  /** Whether this call was handled by the AI agent. */
  aiAgent?: Maybe<Scalars['Boolean']['output']>
  /** All distinct call outcomes across the people on the call. */
  allPatientOutcomes?: Maybe<Array<Scalars['String']['output']>>
  /** Whether the call was answered. */
  answered?: Maybe<Scalars['Boolean']['output']>
  /** Who answered the call (staff name or AI). */
  answerer?: Maybe<Scalars['String']['output']>
  /** Appointment date discussed on the call, as free text. */
  appointmentDateString?: Maybe<Scalars['String']['output']>
  /** Whether this call has been archived. */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Staff member's phone number used to initiate an outbound click-to-call. */
  businessPhone?: Maybe<Scalars['String']['output']>
  /** Date and time the call took place. */
  callDate?: Maybe<Scalars['DateTime']['output']>
  /** Caller ID name reported for the call. */
  callerId?: Maybe<Scalars['String']['output']>
  /** Phone number of the caller. */
  callerPhone?: Maybe<Scalars['String']['output']>
  /** Marketing channel attributed to the call. */
  channel?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Call direction: inbound for incoming calls, outbound for click-to-call. */
  direction?: Maybe<Scalars['String']['output']>
  /** Total duration of the call in seconds. */
  duration?: Maybe<Scalars['Int']['output']>
  /** ElevenLabs conversation id for AI agent calls. */
  elevenLabsConversationId?: Maybe<Scalars['String']['output']>
  /** Google Click ID attributed to the call. */
  gclid?: Maybe<Scalars['String']['output']>
  /** Whether this call is part of the golden dataset for AI call processing evaluation. */
  golden?: Maybe<Scalars['Boolean']['output']>
  /** Unique identifier for this call. */
  id: Scalars['ID']['output']
  /** Landing page URL the caller visited before calling. */
  landingPageUrl?: Maybe<Scalars['String']['output']>
  /** Location this call belongs to. */
  locationId: Scalars['ID']['output']
  /** Free-text note on the call. */
  note?: Maybe<Scalars['String']['output']>
  /** Organization that owns this call (multi-tenant isolation key). */
  orgId: Scalars['ID']['output']
  /** Names of patients mentioned on the call. */
  patientNames?: Maybe<Scalars['String']['output']>
  /** Patients identified on the call. */
  patients?: Maybe<Array<CallPerson>>
  /** People on the call, derived from AI extraction or parsed names. */
  people?: Maybe<Array<CallPerson>>
  /** Duration of the recorded audio in seconds. */
  recordingDuration?: Maybe<Scalars['Int']['output']>
  /** Storage keys of the call's audio recordings. */
  recordings?: Maybe<Array<Scalars['String']['output']>>
  /** URL that referred the caller before the call. */
  referringUrl?: Maybe<Scalars['String']['output']>
  /** Staff member associated with the call. */
  staff?: Maybe<StaffSummary>
  /** Processing status of the call. */
  status?: Maybe<Scalars['String']['output']>
  /** Tags applied to the call. */
  tags?: Maybe<Array<Scalars['String']['output']>>
  /** Tracking phone number the call came in on. */
  trackingNumber?: Maybe<Scalars['String']['output']>
  /** Friendly name of the tracking number. */
  trackingNumberName?: Maybe<Scalars['String']['output']>
  /** Treatment or procedure discussed on the call. */
  treatment?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Marketing attribution campaign (UTM campaign). */
  utmCampaign?: Maybe<Scalars['String']['output']>
  /** Marketing attribution content (UTM content). */
  utmContent?: Maybe<Scalars['String']['output']>
  /** Marketing attribution keywords (UTM term). */
  utmKeywords?: Maybe<Scalars['String']['output']>
  /** Marketing attribution medium (UTM medium), lowercased. */
  utmMedium?: Maybe<Scalars['String']['output']>
  /** Marketing attribution source (UTM source), lowercased. */
  utmSource?: Maybe<Scalars['String']['output']>
  /** Call vendor: callrail, ringcentral, twilio, 11labs, or trackable. */
  vendor?: Maybe<Scalars['String']['output']>
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Audio waveform data URLs for the recording. */
  waveforms?: Maybe<Array<Scalars['String']['output']>>
  /** Workspace this call belongs to. */
  workspaceId: Scalars['ID']['output']
}

export type CallAi = {
  __typename?: 'CallAi'
  /** AI-extracted action items from the call. */
  actionItems?: Maybe<Scalars['String']['output']>
  /** Who answered the call, per AI extraction. */
  answerer?: Maybe<Scalars['String']['output']>
  /** Marketing channel inferred by AI extraction. */
  channel?: Maybe<Scalars['String']['output']>
  /** When AI extraction ran for this call. */
  extractionDate?: Maybe<Scalars['String']['output']>
  /** AI model used for extraction. */
  model?: Maybe<Scalars['String']['output']>
  /** People identified on the call by AI extraction. */
  people?: Maybe<Array<CallPerson>>
  /** AI-generated summary of the call. */
  summary?: Maybe<Scalars['String']['output']>
  /** Token usage for the AI extraction. */
  tokenUsage?: Maybe<CallTokenUsage>
}

export type CallAiInput = {
  /** AI-generated action items. */
  actionItems?: InputMaybe<Scalars['String']['input']>
  /** Who answered the call. */
  answerer?: InputMaybe<Scalars['String']['input']>
  /** Marketing channel attributed to the call. */
  channel?: InputMaybe<Scalars['String']['input']>
  /** When extraction ran (ISO date/time). */
  extractionDate?: InputMaybe<Scalars['String']['input']>
  /** Model used for extraction. */
  model?: InputMaybe<Scalars['String']['input']>
  /** People identified on the call. */
  people?: InputMaybe<Array<CallAiPersonInput>>
  /** AI-generated call summary. */
  summary?: InputMaybe<Scalars['String']['input']>
  /** Token usage for the extraction. */
  tokenUsage?: InputMaybe<CallTokenUsageInput>
}

export type CallAiPersonInput = {
  /** Appointment date (ISO date). */
  appointmentDate?: InputMaybe<Scalars['String']['input']>
  /** Whether an appointment was requested. */
  appointmentRequested?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether an appointment was scheduled. */
  appointmentScheduled?: InputMaybe<Scalars['Boolean']['input']>
  /** Appointment time. */
  appointmentTime?: InputMaybe<Scalars['String']['input']>
  /** Person's birth date (ISO date). */
  birthDate?: InputMaybe<Scalars['String']['input']>
  /** Person's email. */
  email?: InputMaybe<Scalars['String']['input']>
  /** Index of this person within the call. */
  index?: InputMaybe<Scalars['Int']['input']>
  /** Insurance provider. */
  insuranceProvider?: InputMaybe<Scalars['String']['input']>
  /** Whether this person is the caller. */
  isCaller?: InputMaybe<Scalars['Boolean']['input']>
  /** Person's name. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Call outcomes for this person. */
  outcomes?: InputMaybe<Array<Scalars['String']['input']>>
  /** Patient type (e.g. new, existing). */
  patientType?: InputMaybe<Scalars['String']['input']>
  /** Person's phone number. */
  phone?: InputMaybe<Scalars['String']['input']>
  /** Reason an appointment was not scheduled. */
  reasonForNotScheduling?: InputMaybe<Scalars['String']['input']>
  /** Referral source. */
  referral?: InputMaybe<Scalars['String']['input']>
  /** Relationship to the caller. */
  relationship?: InputMaybe<Scalars['String']['input']>
  /** Service requested. */
  serviceRequested?: InputMaybe<Scalars['String']['input']>
  /** Treatment discussed. */
  treatment?: InputMaybe<Scalars['String']['input']>
}

export type CallData = {
  __typename?: 'CallData'
  /** Whether this call data record is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** When the call occurred, copied from the Call for cost aggregation and sorting. */
  callDate?: Maybe<Scalars['DateTime']['output']>
  /** The call this ElevenLabs output record belongs to. */
  callId: Scalars['ID']['output']
  /** ElevenLabs call outcome: success, failure, or unknown. */
  callSuccessful?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Raw ElevenLabs post-call webhook payload and analysis data. */
  data?: Maybe<Scalars['JSON']['output']>
  /** Call duration in seconds, copied from the Call. */
  duration?: Maybe<Scalars['Int']['output']>
  /** ElevenLabs conversation identifier for this call. */
  elevenLabsConversationId?: Maybe<Scalars['String']['output']>
  /** Breakdown of ElevenLabs voice usage costs for the call. */
  elevenLabsCost?: Maybe<ElevenLabsCostSummary>
  /** ElevenLabs call-level error code, if the call failed. */
  errorCode?: Maybe<Scalars['Int']['output']>
  /** ElevenLabs call-level error reason, if the call failed. */
  errorReason?: Maybe<Scalars['String']['output']>
  /** Editable map of ElevenLabs data-collection values (id -> stringified value). Source of truth for the transcript footer; superseded the individual promoted analysis columns. */
  extractedData?: Maybe<Scalars['JSON']['output']>
  /** Unique identifier; same as callId so there is one record per call. */
  id: Scalars['ID']['output']
  /** Location this call was placed to or from. */
  locationId: Scalars['ID']['output']
  /** Reason the call did not book, as a snake_case token (e.g. transferred_to_human). */
  noBookingReason?: Maybe<Scalars['String']['output']>
  /** Organization that owns this record (multi-tenant isolation key). */
  orgId: Scalars['ID']['output']
  /** Why the call ended (ElevenLabs termination reason), e.g. "Call ended by remote party". */
  terminationReason?: Maybe<Scalars['String']['output']>
  /** Whether the agent made a duplicate tool call during the call. */
  toolDuplicate?: Maybe<Scalars['Boolean']['output']>
  /** Whether the agent encountered a tool error during the call. */
  toolError?: Maybe<Scalars['Boolean']['output']>
  /** Whether the agent encountered a tool timeout during the call. */
  toolTimeout?: Maybe<Scalars['Boolean']['output']>
  /** Twilio telephony cost for the call, in USD. */
  twilioTelephonyCostUsd?: Maybe<Scalars['Float']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this record belongs to. */
  workspaceId: Scalars['ID']['output']
}

export type CallDataListResult = {
  __typename?: 'CallDataListResult'
  /** Results for the current page. */
  hits: Array<CallData>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type CallListResult = {
  __typename?: 'CallListResult'
  /** Results for the current page. */
  hits: Array<Call>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type CallPatientInput = {
  /** Appointment date (ISO date). */
  appointmentDate?: InputMaybe<Scalars['String']['input']>
  /** Whether an appointment was requested. */
  appointmentRequested?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether an appointment was scheduled. */
  appointmentScheduled?: InputMaybe<Scalars['Boolean']['input']>
  /** Appointment time. */
  appointmentTime?: InputMaybe<Scalars['String']['input']>
  /** Patient birth date (ISO date). */
  birthDate?: InputMaybe<Scalars['String']['input']>
  /** Patient email. */
  email?: InputMaybe<Scalars['String']['input']>
  /** Index of this patient within the call. */
  index?: InputMaybe<Scalars['Int']['input']>
  /** Patient's insurance provider. */
  insuranceProvider?: InputMaybe<Scalars['String']['input']>
  /** Whether this patient is the caller. */
  isCaller?: InputMaybe<Scalars['Boolean']['input']>
  /** Location associated with the patient. */
  locationId?: InputMaybe<Scalars['String']['input']>
  /** Patient name. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Call outcomes for this patient. */
  outcomes?: InputMaybe<Array<Scalars['String']['input']>>
  /** Patient type (e.g. new, existing). */
  patientType?: InputMaybe<Scalars['String']['input']>
  /** Patient phone number. */
  phone?: InputMaybe<Scalars['String']['input']>
  /** Reason an appointment was not scheduled. */
  reasonForNotScheduling?: InputMaybe<Scalars['String']['input']>
  /** Referral source for the patient. */
  referral?: InputMaybe<Scalars['String']['input']>
  /** Patient's relationship to the caller. */
  relationship?: InputMaybe<Scalars['String']['input']>
  /** Service the patient requested. */
  serviceRequested?: InputMaybe<Scalars['String']['input']>
  /** Treatment discussed. */
  treatment?: InputMaybe<Scalars['String']['input']>
}

export type CallPerson = {
  __typename?: 'CallPerson'
  /** Appointment date discussed for this person. */
  appointmentDate?: Maybe<Scalars['String']['output']>
  /** Whether this person requested an appointment. */
  appointmentRequested?: Maybe<Scalars['Boolean']['output']>
  /** Whether an appointment was scheduled for this person. */
  appointmentScheduled?: Maybe<Scalars['Boolean']['output']>
  /** Appointment time discussed for this person. */
  appointmentTime?: Maybe<Scalars['String']['output']>
  /** Birth date for this person. */
  birthDate?: Maybe<Scalars['String']['output']>
  /** Email address for this person. */
  email?: Maybe<Scalars['String']['output']>
  /** Index of this person within the call's people list. */
  index?: Maybe<Scalars['Int']['output']>
  /** Insurance provider mentioned for this person. */
  insuranceProvider?: Maybe<Scalars['String']['output']>
  /** Whether this person is the caller. */
  isCaller?: Maybe<Scalars['Boolean']['output']>
  /** Name of the person on the call. */
  name?: Maybe<Scalars['String']['output']>
  /** Call outcomes attributed to this person. */
  outcomes?: Maybe<Array<Scalars['String']['output']>>
  /** Patient type: New Patient, Current Patient, Non-Patient, or Other. */
  patientType?: Maybe<Scalars['String']['output']>
  /** Phone number for this person. */
  phone?: Maybe<Scalars['String']['output']>
  /** Reason an appointment was not scheduled. */
  reasonForNotScheduling?: Maybe<Scalars['String']['output']>
  /** Referral source for this person. */
  referral?: Maybe<Scalars['String']['output']>
  /** Relationship of this person to the caller. */
  relationship?: Maybe<Scalars['String']['output']>
  /** Service the person requested. */
  serviceRequested?: Maybe<Scalars['String']['output']>
  /** Treatment or procedure the person is interested in. */
  treatment?: Maybe<Scalars['String']['output']>
}

export type CallRailCompany = {
  __typename?: 'CallRailCompany'
  /** CallRail company id */
  id: Scalars['String']['output']
  /** Whether this company is already in use by an integration */
  isUsed: Scalars['Boolean']['output']
  /** CallRail company name */
  name: Scalars['String']['output']
}

export type CallRailRoutingConfig = {
  __typename?: 'CallRailRoutingConfig'
  /** Location id that calls with this tag route to */
  locationId?: Maybe<Scalars['String']['output']>
  /** CallRail tag used to route incoming calls */
  tag?: Maybe<Scalars['String']['output']>
}

export type CallStaffInput = {
  /** Staff member ID. */
  id?: InputMaybe<Scalars['ID']['input']>
  /** Staff member name. */
  name?: InputMaybe<Scalars['String']['input']>
}

export type CallTokenUsage = {
  __typename?: 'CallTokenUsage'
  /** Input tokens consumed by AI extraction. */
  inputTokens?: Maybe<Scalars['Int']['output']>
  /** Output tokens produced by AI extraction. */
  outputTokens?: Maybe<Scalars['Int']['output']>
  /** Total tokens used by AI extraction. */
  totalTokens?: Maybe<Scalars['Int']['output']>
}

export type CallTokenUsageInput = {
  /** Input tokens consumed by extraction. */
  inputTokens?: InputMaybe<Scalars['Int']['input']>
  /** Output tokens produced by extraction. */
  outputTokens?: InputMaybe<Scalars['Int']['input']>
  /** Total tokens consumed by extraction. */
  totalTokens?: InputMaybe<Scalars['Int']['input']>
}

export type CallerIdResult = {
  __typename?: 'CallerIdResult'
  /** Caller ID name from the carrier, if available. */
  callerId?: Maybe<Scalars['String']['output']>
  /** Matched customer name, if known. */
  customerName?: Maybe<Scalars['String']['output']>
}

export type CampaignItem = {
  __typename?: 'CampaignItem'
  /** Ad account id the campaign belongs to. */
  accountId?: Maybe<Scalars['String']['output']>
  /** Ad account display name. */
  accountName?: Maybe<Scalars['String']['output']>
  /** Campaign id. */
  id: Scalars['ID']['output']
  /** Campaign display name. */
  name: Scalars['String']['output']
  /** Organization that owns this campaign (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Ad platform the campaign runs on (e.g. google, facebook). */
  platform?: Maybe<Scalars['String']['output']>
  /** Campaign type (e.g. the marketing category). */
  type: Scalars['String']['output']
  /** Campaign id as known by the ad vendor. */
  vendorCampaignId?: Maybe<Scalars['String']['output']>
  /** Workspace this campaign belongs to. */
  workspaceId: Scalars['String']['output']
}

export type CampaignListResult = {
  __typename?: 'CampaignListResult'
  /** Campaigns for the page. */
  hits: Array<CampaignItem>
  /** Zero-based page index of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching campaigns. */
  total: Scalars['Int']['output']
}

export type CarestackDashboardResult = {
  __typename?: 'CarestackDashboardResult'
  /** Base64-encoded PNG of the CloudWatch metric chart for Carestack sync activity. */
  base64: Scalars['String']['output']
  /** Workspaces represented in the dashboard chart. */
  workspaces: Array<CarestackWorkspaceStat>
}

export type CarestackPractice = {
  __typename?: 'CarestackPractice'
  /** Carestack practice id */
  id: Scalars['String']['output']
  /** Whether this practice is already in use by an integration */
  isUsed: Scalars['Boolean']['output']
  /** Carestack practice name */
  name: Scalars['String']['output']
}

export type CarestackWorkspaceStat = {
  __typename?: 'CarestackWorkspaceStat'
  /** Workspace included in the Carestack dashboard stats. */
  workspaceId: Scalars['String']['output']
  /** Display name of the workspace. */
  workspaceName?: Maybe<Scalars['String']['output']>
}

export type CdtCodeMapping = {
  __typename?: 'CdtCodeMapping'
  /** The category this CDT code is mapped to. */
  category: Scalars['String']['output']
  /** The CDT (dental procedure) code being mapped, stored uppercased. */
  cdtCode: Scalars['String']['output']
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Deterministic identifier for this mapping, derived from workspaceId and CDT code. */
  id: Scalars['ID']['output']
  /** Organization that owns this mapping (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this CDT code mapping belongs to. */
  workspaceId: Scalars['String']['output']
}

export type CdtCodeMappingListResult = {
  __typename?: 'CdtCodeMappingListResult'
  /** Matching records for the current page. */
  hits: Array<CdtCodeMapping>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching records across all pages. */
  total: Scalars['Int']['output']
}

export type ChannelBreakdownEntry = {
  __typename?: 'ChannelBreakdownEntry'
  /** Number of appointments attributed to this channel. */
  appointments: Scalars['Int']['output']
  /** Marketing channel this breakdown row is for (e.g. digital, referral, traditional). */
  channel: Scalars['String']['output']
  /** Number of leads attributed to this channel. */
  leads: Scalars['Int']['output']
  /** Number of marketing-qualified leads (MQLs) attributed to this channel. */
  mqls: Scalars['Int']['output']
  /** Number of new patients attributed to this channel. */
  patients: Scalars['Int']['output']
}

export type ChannelCount = {
  __typename?: 'ChannelCount'
  /** Marketing channel this count is for. */
  channel: Scalars['String']['output']
  /** Number of items attributed to this channel. */
  count: Scalars['Int']['output']
}

export type ChannelMappingV2 = {
  __typename?: 'ChannelMappingV2'
  /** Marketing channel the source/medium pair maps to. */
  channel: Scalars['String']['output']
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Unique identifier for this channel mapping (derived from org, workspace, source, and medium). */
  id: Scalars['ID']['output']
  /** UTM medium this mapping matches on (lowercased). */
  medium: Scalars['String']['output']
  /** Organization that owns this mapping (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** UTM source this mapping matches on (lowercased). */
  source: Scalars['String']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this mapping belongs to. */
  workspaceId: Scalars['String']['output']
}

export type ChannelMappingV2ListResult = {
  __typename?: 'ChannelMappingV2ListResult'
  /** Matching records for the current page. */
  hits: Array<ChannelMappingV2>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching records across all pages. */
  total: Scalars['Int']['output']
}

export enum ClientType {
  Native = 'NATIVE',
  Pwa = 'PWA',
}

export type CommLog = {
  __typename?: 'CommLog'
  /** Kolla REST channel string (PHONE, EMAIL, TEXT, IN_PERSON, CHANNEL_UNSPECIFIED), set when loaded via the Kolla REST endpoint */
  channel?: Maybe<Scalars['String']['output']>
  /** When the communication occurred */
  commDate?: Maybe<Scalars['DateTime']['output']>
  /** When the communication ended */
  commEndDate?: Maybe<Scalars['DateTime']['output']>
  /** Source of the communication (OpenDental: 0=user, 1=auto, 2=thirdParty) */
  commSource?: Maybe<Scalars['Int']['output']>
  /** PMS-defined definition number for the communication type; references the PMS definitions table */
  commType?: Maybe<Scalars['Int']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Unique identifier for the comm log record */
  id: Scalars['ID']['output']
  /** Location this comm log belongs to */
  locationId: Scalars['String']['output']
  /** Communication mode from the PMS. OpenDental: 0=None, 1=Email, 2=Mail, 3=Phone, 4=InPerson, 5=Text, 6=Form, 7=Statement, 8=Recall */
  mode?: Maybe<Scalars['Int']['output']>
  /** The note or description content */
  note?: Maybe<Scalars['String']['output']>
  /** Organization that owns this record (multi-tenant isolation key) */
  orgId: Scalars['String']['output']
  /** Trackable patient ID (K-{locationKey}-{PatNum}) */
  patientId?: Maybe<Scalars['String']['output']>
  /** Raw PMS patient number */
  pmsPatientId?: Maybe<Scalars['String']['output']>
  /** When the record was last updated in the PMS */
  pmsUpdatedDate?: Maybe<Scalars['DateTime']['output']>
  /** ProgramNum - which third-party program created the entry */
  programNum?: Maybe<Scalars['Int']['output']>
  /** Kolla REST provider resource that authored the entry (e.g. resources/provider_AD) */
  provider?: Maybe<Scalars['String']['output']>
  /** Direction: 0=Neither, 1=Sent, 2=Received */
  sentOrReceived?: Maybe<Scalars['Int']['output']>
  /** The Trackable record (Message or Activity id) this entry was written back from; marks the entry as Trackable-authored */
  sourceId?: Maybe<Scalars['String']['output']>
  /** Kolla REST short description / subject line for the entry (e.g. "General Note") */
  subject?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** PMS user number who created the entry */
  userNum?: Maybe<Scalars['Int']['output']>
  /** The raw PMS commlog ID (CommlogNum) */
  vendorId: Scalars['String']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this comm log belongs to */
  workspaceId: Scalars['String']['output']
}

export type CommLogListResult = {
  __typename?: 'CommLogListResult'
  /** The page of items matching the query. */
  hits: Array<CommLog>
  /** Zero-based index of the returned page. */
  page: Scalars['Int']['output']
  /** Total number of items matching the query across all pages. */
  total: Scalars['Int']['output']
}

export type CommLogWritebackRule = {
  __typename?: 'CommLogWritebackRule'
  /** PMS channel entries of this type are written under */
  channel: Scalars['String']['output']
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Rule id, composed from locationId and type */
  id: Scalars['ID']['output']
  /** Location this writeback rule applies to */
  locationId: Scalars['String']['output']
  /** Organization that owns this rule (multi-tenant isolation key) */
  orgId: Scalars['String']['output']
  /** Comm-log writeback type the rule covers */
  type: Scalars['String']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this rule belongs to */
  workspaceId: Scalars['String']['output']
}

export type CommLogWritebackRuleListResult = {
  __typename?: 'CommLogWritebackRuleListResult'
  /** Matching records for the current page. */
  hits: Array<CommLogWritebackRule>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching records across all pages. */
  total: Scalars['Int']['output']
}

export type CommandResult = {
  __typename?: 'CommandResult'
  /** Error message when the command failed. */
  error?: Maybe<Scalars['String']['output']>
  /** Whether the command succeeded. */
  success?: Maybe<Scalars['Boolean']['output']>
  /** Number of records synced by the command. */
  synced?: Maybe<Scalars['Int']['output']>
}

export enum ConnectorType {
  Ascend = 'ASCEND',
  Carestack = 'CARESTACK',
  Kolla = 'KOLLA',
  Sikka = 'SIKKA',
}

export type Contact = {
  __typename?: 'Contact'
  /** Total count of activities associated with this contact. */
  activityCount?: Maybe<Scalars['Int']['output']>
  /** All activity types associated with this contact. */
  activityTypes?: Maybe<Array<Scalars['String']['output']>>
  /** Date an advertising click occurred, used for attribution windows. */
  adClickDate?: Maybe<Scalars['DateTime']['output']>
  /** Primary address line for correspondence. */
  addressLine1?: Maybe<Scalars['String']['output']>
  /** Secondary address line (apartment, suite, etc.). */
  addressLine2?: Maybe<Scalars['String']['output']>
  /** Status of the nearest appointment: Unscheduled, Scheduled, Completed, Broken, Cancelled, or Deleted. */
  appointmentStatus?: Maybe<Scalars['String']['output']>
  /** Whether this contact is archived (soft delete preserving historical data). */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Date the patient became inactive (18+ months since last appointment). */
  becameInactiveDate?: Maybe<Scalars['DateTime']['output']>
  /** Date the contact first became a lead through any communication activity. */
  becameLeadDate?: Maybe<Scalars['DateTime']['output']>
  /** Date the contact became a patient based on procedure transactions. */
  becamePatientDate?: Maybe<Scalars['DateTime']['output']>
  /** Date of birth (date only). */
  birthDate?: Maybe<Scalars['DateTime']['output']>
  /** Cell phone number in normalized format; the primary number for most communication. */
  cellPhone?: Maybe<Scalars['String']['output']>
  /** Marketing channel classification computed from UTM parameters. */
  channel?: Maybe<Scalars['String']['output']>
  /** City from the contact address. */
  city?: Maybe<Scalars['String']['output']>
  /** Reason the lead was closed as lost (from the predefined LOST_REASONS set). */
  closedLostReason?: Maybe<Scalars['String']['output']>
  /** Lifetime value from collected payments (sum of all payment transactions). */
  collectedLtv?: Maybe<Scalars['Float']['output']>
  /** Staff member who converted this lead to a patient. */
  convertedBy?: Maybe<StaffSummary>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Email address, normalized to lowercase. */
  email?: Maybe<Scalars['String']['output']>
  /** Facebook click identifier (fbclid) for Facebook ad attribution. */
  fbclid?: Maybe<Scalars['String']['output']>
  /** Date of the first recorded activity for this contact. */
  firstActivityDate?: Maybe<Scalars['DateTime']['output']>
  /** Type of the first activity that created this contact. */
  firstActivityType?: Maybe<Scalars['String']['output']>
  /** Date of the first scheduled appointment. */
  firstAppointmentDate?: Maybe<Scalars['DateTime']['output']>
  /** Date the first appointment was scheduled (became New Patient Scheduled). */
  firstAppointmentMadeDate?: Maybe<Scalars['DateTime']['output']>
  /** Reason for the initial contact or inquiry. */
  firstContactReason?: Maybe<Scalars['String']['output']>
  /** First name parsed from the contact's full name. */
  firstName?: Maybe<Scalars['String']['output']>
  /** Date of the first financial transaction for revenue attribution. */
  firstTransactionDate?: Maybe<Scalars['DateTime']['output']>
  /** First Visit Value: total procedure charges on the patient's first official visit. */
  fvv?: Maybe<Scalars['Float']['output']>
  /** Google click identifier (gclid) for Google Ads attribution. */
  gclid?: Maybe<Scalars['String']['output']>
  /** Home phone number in normalized format. */
  homePhone?: Maybe<Scalars['String']['output']>
  /** Date the patient is next due for hygiene (last hygiene date plus recall interval). */
  hygieneDueDate?: Maybe<Scalars['DateTime']['output']>
  /** Hygiene Recall status (Due or Scheduled), or unset when not on the recall list; mirrors the recall list stage. */
  hygieneStatus?: Maybe<Scalars['String']['output']>
  /** Unique identifier for the contact. */
  id: Scalars['ID']['output']
  /** Whether the patient has ever had a periodontal procedure; once true it never reverts. */
  isPerio?: Maybe<Scalars['Boolean']['output']>
  /** Whether the lead is qualified based on appointments, activities, or manual qualification. */
  isQualified?: Maybe<Scalars['Boolean']['output']>
  /** Landing page URL the contact first arrived on. */
  landingPageURL?: Maybe<Scalars['String']['output']>
  /** Date of the most recent activity associated with this contact. */
  lastActivityDate?: Maybe<Scalars['DateTime']['output']>
  /** Date of the most recent completed appointment. */
  lastAppointmentDate?: Maybe<Scalars['DateTime']['output']>
  /** Subtype of the communication producing lastCommDate (direction for call/text/email, form title for forms). */
  lastCommActivitySubType?: Maybe<Scalars['String']['output']>
  /** Channel of the communication that produced lastCommDate (e.g. call, text, email, form, chat). */
  lastCommActivityType?: Maybe<Scalars['String']['output']>
  /** Date of the most recent communication (call, form, chat, scheduler, follow-up, or message). */
  lastCommDate?: Maybe<Scalars['DateTime']['output']>
  /** Date of the most recent hygiene procedure (prophy or perio). Deprecated; use hygieneDueDate for due-date logic. */
  lastHygieneDate?: Maybe<Scalars['DateTime']['output']>
  /** Last name parsed from the contact's full name. */
  lastName?: Maybe<Scalars['String']['output']>
  /** Date of the most recent financial transaction. */
  lastTransactionDate?: Maybe<Scalars['DateTime']['output']>
  /** Create time of the contact's most recent treatment plan. */
  lastTreatmentPlanDate?: Maybe<Scalars['DateTime']['output']>
  /** Lead conversion status derived from isConverted: Converted, Not Converted, or empty. */
  leadConversionStatus?: Maybe<Scalars['String']['output']>
  /** Staff member assigned as the owner of this lead. */
  leadOwner?: Maybe<StaffSummary>
  /** Lead workflow status: Needs Action, In Progress, Scheduled, Closed Won, or Closed Lost. */
  leadStatus?: Maybe<Scalars['String']['output']>
  /** Current patient lifecycle stage: Lead, Qualified Lead, New Patient Scheduled, or Patient. */
  lifecycleStage?: Maybe<Scalars['String']['output']>
  /** Location this contact belongs to. */
  locationId: Scalars['ID']['output']
  /** Matching algorithms used to identify this contact (phone, email, name, etc.). */
  matchTypes?: Maybe<Array<Scalars['String']['output']>>
  /** Primary contact name, normalized to "First Last" with capitalization. */
  name: Scalars['String']['output']
  /** Date of the nearest appointment (future or most recent past). */
  nearestAppointmentDate?: Maybe<Scalars['DateTime']['output']>
  /** Whether this contact needs staff action (set when leadStatus is Needs Action). */
  neededAction?: Maybe<Scalars['Boolean']['output']>
  /** Date the contact most recently entered the Needs Action state. */
  needsActionDate?: Maybe<Scalars['DateTime']['output']>
  /** Organization that owns this contact (multi-tenant isolation key). */
  orgId: Scalars['ID']['output']
  /** Additional phone numbers, cleaned to last 10 digits and deduplicated, used for phone matching. */
  otherPhone?: Maybe<Array<Scalars['String']['output']>>
  /** Date the patient record was created in the PMS. */
  patientCreatedDate?: Maybe<Scalars['DateTime']['output']>
  /** Patient record ids this contact is linked to across PMS systems (Sikka, Carestack, Kolla). */
  patientIds?: Maybe<Array<Scalars['String']['output']>>
  /** Patient name as stored in the PMS, shown when it differs from the contact name. */
  patientName?: Maybe<Scalars['String']['output']>
  /** Information about the patient referral source (e.g. referring patient name). */
  patientReferral?: Maybe<Scalars['String']['output']>
  /** Patient activity status: Active, Inactive (18+ months since last appointment), or NonPatient. */
  patientStatus?: Maybe<Scalars['String']['output']>
  /** Pipeline stages the contact is currently in. */
  pipelines?: Maybe<Array<ContactPipeline>>
  /** Advertising platform derived from the UTM parameters. */
  platform?: Maybe<Scalars['String']['output']>
  /** Patient's preferred method of communication (phone, email, text, etc.). */
  preferredCommunicationMethod?: Maybe<Scalars['String']['output']>
  /** Patient's preferred time or method for being contacted. */
  preferredContact?: Maybe<Scalars['String']['output']>
  /** Alternative name the contact prefers to be called. */
  preferredName?: Maybe<Scalars['String']['output']>
  /** Lifetime value from production (procedures total minus adjustments). */
  productionLtv?: Maybe<Scalars['Float']['output']>
  /** URL that originally referred the contact to the practice. */
  referralURL?: Maybe<Scalars['String']['output']>
  /** Attribution source as reported by the patient themselves. */
  reportedAttribution?: Maybe<Scalars['String']['output']>
  /** Total expected revenue from future scheduled appointments. */
  scheduledProduction?: Maybe<Scalars['Float']['output']>
  /** Computed SMS consent, gating both marketing and transactional sends. true = opted in (all SMS sends). false = opted out, blocks everything including transactional (STOP-equivalent). null/undefined = no signal: transactional may send, marketing may not. */
  smsMarketingConsent?: Maybe<Scalars['Boolean']['output']>
  /** State or province from the contact address. */
  state?: Maybe<Scalars['String']['output']>
  /** Tags for categorization, filtering, and workflow automation. */
  tags?: Maybe<Array<Scalars['String']['output']>>
  /** Internal Trackable campaign identifier (AdCampaign reference). */
  trackableCampaignId?: Maybe<Scalars['String']['output']>
  /** Unscheduled Treatment status (e.g. Unscheduled, Scheduled, Completed, Removed) or a workspace practice status; mirrors the treatment list stage. */
  treatmentStatus?: Maybe<Scalars['String']['output']>
  /** Total fee of pending procedures with no live appointment within the treatment window, deduplicated across plans. */
  unbookedTreatmentValue?: Maybe<Scalars['Float']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** UTM campaign parameter. */
  utmCampaign?: Maybe<Scalars['String']['output']>
  /** UTM content parameter (e.g. ad variant for A/B testing). */
  utmContent?: Maybe<Scalars['String']['output']>
  /** UTM keywords parameter. */
  utmKeywords?: Maybe<Scalars['String']['output']>
  /** UTM medium parameter (e.g. cpc, organic, email). */
  utmMedium?: Maybe<Scalars['String']['output']>
  /** UTM source parameter (e.g. google, facebook, direct). */
  utmSource?: Maybe<Scalars['String']['output']>
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Work phone number in normalized format. */
  workPhone?: Maybe<Scalars['String']['output']>
  /** Workspace this contact belongs to. */
  workspaceId: Scalars['ID']['output']
  /** Postal or ZIP code from the contact address. */
  zip?: Maybe<Scalars['String']['output']>
}

export type ContactListResult = {
  __typename?: 'ContactListResult'
  /** Results for the current page. */
  hits: Array<Contact>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type ContactPipeline = {
  __typename?: 'ContactPipeline'
  /** Identifier of the pipeline. */
  id: Scalars['String']['output']
  /** Pipeline key/slug. */
  key?: Maybe<Scalars['String']['output']>
  /** Current stage of the contact within the pipeline. */
  stage?: Maybe<Scalars['String']['output']>
}

export type ContactPipelineInput = {
  /** Pipeline id. */
  id: Scalars['String']['input']
  /** Stage within the pipeline. */
  stage: Scalars['String']['input']
}

export type ContactStaffInput = {
  /** Staff member id. */
  id: Scalars['ID']['input']
  /** Staff member name. */
  name: Scalars['String']['input']
}

export type ConversionLogItem = {
  __typename?: 'ConversionLogItem'
  /** When the contact became a lead, as an ISO date string. */
  becameLeadDate?: Maybe<Scalars['String']['output']>
  /** When the contact became a patient, as an ISO date string. */
  becamePatientDate?: Maybe<Scalars['String']['output']>
  /** Contact this conversion is for. */
  contactId: Scalars['ID']['output']
  /** Contact's display name. */
  contactName?: Maybe<Scalars['String']['output']>
  /** Conversion event date/time sent to the ad platform, as an ISO string. */
  conversionDateTime: Scalars['String']['output']
  /** Conversion type sent to the ad platform (e.g. QUALIFIED_LEAD_GENERATED). */
  conversionType: Scalars['String']['output']
  /** Monetary value sent with the conversion, in dollars. */
  conversionValue?: Maybe<Scalars['Float']['output']>
  /** When this conversion log record was created, as an ISO date string. */
  createdDate: Scalars['String']['output']
  /** Error message if the conversion failed to send. */
  errorMessage?: Maybe<Scalars['String']['output']>
  /** When the contact's first appointment was made, as an ISO date string. */
  firstAppointmentMadeDate?: Maybe<Scalars['String']['output']>
  /** Google click id (gclid) associated with the conversion, when known. */
  gclid?: Maybe<Scalars['String']['output']>
  /** Google Ads account id the conversion was sent to. */
  googleAdsAccountId: Scalars['String']['output']
  /** Conversion log record id. */
  id: Scalars['ID']['output']
  /** Location this conversion is for. */
  locationId: Scalars['ID']['output']
  /** Current send status of this conversion. */
  status: Scalars['String']['output']
}

export type ConversionLogListResult = {
  __typename?: 'ConversionLogListResult'
  /** Conversion log records for the page. */
  hits: Array<ConversionLogItem>
  /** Zero-based page index of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching conversion log records. */
  total: Scalars['Int']['output']
}

export type ConversionMetricsResponse = {
  __typename?: 'ConversionMetricsResponse'
  /** Metrics for the additional-treatment-revenue conversion stage. */
  ADDITIONAL_TREATMENT_REVENUE: ConversionStageMetrics
  /** Metrics for the new-patient-appointment-scheduled conversion stage. */
  NEW_PATIENT_APPOINTMENT_SCHEDULED: ConversionStageMetrics
  /** Metrics for the new-patient-generated conversion stage. */
  NEW_PATIENT_GENERATED: ConversionStageMetrics
  /** Metrics for the qualified-lead-generated conversion stage. */
  QUALIFIED_LEAD_GENERATED: ConversionStageMetrics
  /** Total conversions across all stages. */
  total: Scalars['Int']['output']
}

export type ConversionStageMetrics = {
  __typename?: 'ConversionStageMetrics'
  /** Number of conversions at this stage that failed to send. */
  failed: Scalars['Int']['output']
  /** Total number of conversions at this stage. */
  total: Scalars['Int']['output']
}

export type CreateActionInput = {
  /** Contact this action applies to. */
  contactId: Scalars['ID']['input']
  /** Optional free-text note on the action. */
  note?: InputMaybe<Scalars['String']['input']>
  /** Identifier of the queue this action belongs to. */
  queueId: Scalars['String']['input']
  /** Name of the queue this action belongs to. */
  queueName: Scalars['String']['input']
  /** Current state of the action. */
  state: Scalars['String']['input']
  /** Date the action is deferred until, if snoozed. */
  untilDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type CreateActivityInput = {
  /** Contact the activity belongs to. */
  contactId: Scalars['String']['input']
  /** Activity description. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Location the activity belongs to. */
  locationId?: InputMaybe<Scalars['String']['input']>
  /** Activity type. */
  type: Scalars['String']['input']
}

export type CreateAdPlatformMappingInput = {
  /** UTM medium to match. */
  medium: Scalars['String']['input']
  /** Ad platform this source/medium maps to. */
  platform: Scalars['String']['input']
  /** UTM source to match. */
  source: Scalars['String']['input']
}

export type CreateAvailabilityInput = {
  /** Appointment type IDs this availability applies to. */
  appointmentTypeIds: Array<Scalars['String']['input']>
  /** Whether this is backup availability, used only when primary availability is unavailable. */
  backupAvailability?: InputMaybe<Scalars['Boolean']['input']>
  /** Operatory IDs where the provider can be scheduled. */
  operatoryIds: Array<Scalars['String']['input']>
  /** Provider this availability belongs to. */
  providerId: Scalars['ID']['input']
  /** Weekly time slots when the provider is available. */
  timeSlots: LocationOpenHoursInput
}

export type CreateBudgetInput = {
  /** Planned budget amount for the channel. */
  amount?: InputMaybe<Scalars['Float']['input']>
  /** Target number of appointments for the period. */
  appointmentGoal?: InputMaybe<Scalars['Int']['input']>
  /** Marketing channel this budget is for. */
  channel: Scalars['String']['input']
  /** Internal spend goal for the period. */
  internalGoal?: InputMaybe<Scalars['Float']['input']>
  /** Target number of leads for the period. */
  leadGoal?: InputMaybe<Scalars['Int']['input']>
  /** Location this budget applies to. */
  locationId: Scalars['ID']['input']
  /** Target number of marketing qualified leads for the period. */
  mqlGoal?: InputMaybe<Scalars['Int']['input']>
  /** Target number of new patients for the period. */
  patientGoal?: InputMaybe<Scalars['Int']['input']>
  /** Target ad spend for the period. */
  targetSpend?: InputMaybe<Scalars['Float']['input']>
  /** Budget period in YYYY-MM format. */
  yearMonth: Scalars['String']['input']
}

export type CreateCallDataInput = {
  /** Call this data belongs to. */
  callId: Scalars['ID']['input']
  /** Raw call data payload. */
  data?: InputMaybe<Scalars['JSON']['input']>
  /** ElevenLabs conversation id associated with the call. */
  elevenLabsConversationId?: InputMaybe<Scalars['String']['input']>
  /** Location this call data belongs to. */
  locationId: Scalars['ID']['input']
}

export type CreateCdtCodeMappingInput = {
  /** Category this CDT code maps to. */
  category: Scalars['String']['input']
  /** CDT dental procedure code. */
  cdtCode: Scalars['String']['input']
}

export type CreateChannelMappingInput = {
  /** Channel this source/medium maps to. */
  channel: Scalars['String']['input']
  /** UTM medium to match. */
  medium: Scalars['String']['input']
  /** UTM source to match. */
  source: Scalars['String']['input']
}

export type CreateCommLogInput = {
  /** Communication channel: PHONE, EMAIL, TEXT, or IN_PERSON. Defaults to PHONE when omitted */
  channel?: InputMaybe<Scalars['String']['input']>
  /** When the communication happened (ISO 8601). Defaults to now */
  commDate?: InputMaybe<Scalars['String']['input']>
  /** The note content */
  note: Scalars['String']['input']
  /** Trackable patient id (K-{locationKey}-{PatNum}); the Kolla contact id and location are derived from it */
  patientId: Scalars['ID']['input']
  /** Kolla scheduler/user resource that authored the note, e.g. resources/user_1 */
  provider: Scalars['String']['input']
  /** Direction: 2 = received (inbound), 1 = sent (outbound). Defaults to sent */
  sentOrReceived?: InputMaybe<Scalars['Int']['input']>
}

export type CreateCommLogWritebackRuleInput = {
  /** PMS channel entries of this type are written under */
  channel: Scalars['String']['input']
  /** Location this writeback rule applies to */
  locationId: Scalars['ID']['input']
  /** Comm-log writeback type the rule covers */
  type: Scalars['String']['input']
}

export type CreateContactInput = {
  /** Date the contact became a lead. */
  becameLeadDate?: InputMaybe<Scalars['String']['input']>
  /** Cell phone number. */
  cellPhone?: InputMaybe<Scalars['String']['input']>
  /** Marketing channel for the contact. */
  channel?: InputMaybe<Scalars['String']['input']>
  /** Email address. */
  email?: InputMaybe<Scalars['String']['input']>
  /** Home phone number. */
  homePhone?: InputMaybe<Scalars['String']['input']>
  /** Staff member who owns this lead. */
  leadOwner?: InputMaybe<ContactStaffInput>
  /** Lead status of the contact. */
  leadStatus?: InputMaybe<Scalars['String']['input']>
  /** Location this contact belongs to. */
  locationId: Scalars['ID']['input']
  /** Contact name. */
  name: Scalars['String']['input']
  /** Marketing attribution campaign (UTM campaign). */
  utmCampaign?: InputMaybe<Scalars['String']['input']>
  /** Marketing attribution medium (UTM medium). */
  utmMedium?: InputMaybe<Scalars['String']['input']>
  /** Marketing attribution source (UTM source). */
  utmSource?: InputMaybe<Scalars['String']['input']>
  /** Work phone number. */
  workPhone?: InputMaybe<Scalars['String']['input']>
}

export type CreateCustomPageInput = {
  /** JSON-encoded array of filters to apply. */
  filters?: InputMaybe<Scalars['String']['input']>
  /** Join operator applied to the filters (e.g. AND/OR). */
  join: Scalars['String']['input']
  /** Display name for the custom page. */
  name: Scalars['String']['input']
  /** Base page/entity type the custom page is built on. */
  page: Scalars['String']['input']
}

export type CreateDniInput = {
  /** Area code used when provisioning pool phone numbers */
  areaCode: Scalars['String']['input']
  /** Number of phone numbers to buy at a time when growing the pool */
  buyStep?: InputMaybe<Scalars['Int']['input']>
  /** Destination phone number that pool calls are forwarded to */
  forwardTo: Scalars['String']['input']
  /** IVR configuration to apply to pool calls */
  ivrConfigId?: InputMaybe<Scalars['String']['input']>
  /** Optional label to identify this DNI pool */
  label?: InputMaybe<Scalars['String']['input']>
  /** Location this dynamic number insertion pool belongs to */
  locationId: Scalars['String']['input']
  /** Maximum number of phone numbers the pool may grow to */
  maxPoolSize?: InputMaybe<Scalars['Int']['input']>
  /** Minimum number of free (unassigned) numbers to keep available in the pool */
  minFree?: InputMaybe<Scalars['Int']['input']>
  /** Minimum number of phone numbers to keep in the pool */
  minPoolSize?: InputMaybe<Scalars['Int']['input']>
  /** Number of tracking phone numbers to provision in the pool */
  poolSize: Scalars['Int']['input']
  /** How long (seconds) a visitor keeps the same assigned number */
  sessionDuration: Scalars['Int']['input']
}

export type CreateElevenLabsDeploymentInput = {
  /** Optional note describing the deployment. */
  note?: InputMaybe<Scalars['String']['input']>
  /** Prompt draft to deploy. */
  promptDraftId?: InputMaybe<Scalars['ID']['input']>
  /** Prompt version to deploy. */
  promptVersionId?: InputMaybe<Scalars['ID']['input']>
  /** Location to deploy to when scope is location. */
  targetLocationId?: InputMaybe<Scalars['ID']['input']>
  /** Scope the deployment targets: workspaces or a location. */
  targetScope: ElevenLabsDeploymentScope
  /** Workspaces to deploy to when scope is workspace. */
  targetWorkspaceIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type CreateExtractionPromptInput = {
  /** Whether the prompt is active */
  active?: InputMaybe<Scalars['Boolean']['input']>
  /** LLM model to use */
  model: Scalars['String']['input']
  /** Free-form notes about the prompt */
  notes?: InputMaybe<Scalars['String']['input']>
  /** Prompt text */
  prompt: Scalars['String']['input']
  /** Version label for the prompt */
  promptVersion: Scalars['String']['input']
  /** Extraction stage this prompt runs in */
  stage: Scalars['String']['input']
}

export type CreateFeatureToggleInput = {
  /** Category grouping for the toggle. */
  category?: InputMaybe<FeatureToggleCategory>
  /** Description of what the feature toggle controls. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Human-readable display name for the toggle. */
  displayName?: InputMaybe<Scalars['String']['input']>
  /** Internal name of the feature toggle. */
  name: Scalars['String']['input']
  /** Release the toggle is associated with. */
  release?: InputMaybe<Scalars['String']['input']>
  /** Scope type of the toggle, e.g. org, workspace, location. */
  type: Scalars['String']['input']
  /** ID of the entity the toggle is scoped to. */
  typeId?: InputMaybe<Scalars['String']['input']>
}

export type CreateFileImportInput = {
  /** Name of the uploaded file. */
  fileName: Scalars['String']['input']
  /** Import IDs included in this file import. */
  importIds: Array<Scalars['String']['input']>
}

export type CreateFollowUpInput = {
  /** Scheduled appointment date linked to this follow-up. */
  appointmentDate?: InputMaybe<Scalars['String']['input']>
  /** Contact to create the follow-up for. */
  contactId: Scalars['ID']['input']
  /** Notes describing the follow-up. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Date the follow-up is due. */
  followUpDate?: InputMaybe<Scalars['String']['input']>
  /** Whether contact was successfully reached. */
  isConnected?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether an appointment was scheduled from this follow-up. */
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>
  /** Location the follow-up is associated with. */
  locationId: Scalars['ID']['input']
  /** Skip updating the parent contact when creating this follow-up. */
  noContactUpdate?: InputMaybe<Scalars['Boolean']['input']>
  /** User to assign as the follow-up owner. */
  ownerId?: InputMaybe<Scalars['ID']['input']>
  /** Display name of the follow-up owner. */
  ownerName?: InputMaybe<Scalars['String']['input']>
}

export type CreateFormFieldMappingInput = {
  /** Trackable form field the raw key maps to. */
  formField: Scalars['String']['input']
  /** Raw incoming form key to map. */
  rawKey: Scalars['String']['input']
}

export type CreateFormTemplateInput = {
  /** One of: registration, medicalHistory, consent, financialPolicy, custom */
  category: Scalars['String']['input']
  /** Form description. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Form name. */
  name: Scalars['String']['input']
  /** The ordered questions that make up the form. */
  questions: Array<FormQuestionInput>
}

export type CreateImportInput = {
  /** Date the activity occurred (ISO date). */
  activityDate?: InputMaybe<Scalars['String']['input']>
  /** Marketing channel attributed to the import. */
  channel?: InputMaybe<Scalars['String']['input']>
  /** Contact email on the record. */
  email?: InputMaybe<Scalars['String']['input']>
  /** Whether the record is already scheduled. */
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>
  /** Location the import belongs to. */
  locationId: Scalars['String']['input']
  /** Name on the imported record. */
  name: Scalars['String']['input']
  /** Contact phone number on the record. */
  phone?: InputMaybe<Scalars['String']['input']>
  /** Requested appointment date (ISO date). */
  requestedAppointmentDate?: InputMaybe<Scalars['String']['input']>
  /** Staff member associated with the import. */
  staff?: InputMaybe<Scalars['String']['input']>
  /** Treatment or service referenced. */
  treatment?: InputMaybe<Scalars['String']['input']>
  /** Activity type the import creates. */
  type: Scalars['String']['input']
  /** UTM campaign attributed to the import. */
  utmCampaign?: InputMaybe<Scalars['String']['input']>
  /** UTM medium attributed to the import. */
  utmMedium?: InputMaybe<Scalars['String']['input']>
  /** UTM source attributed to the import. */
  utmSource?: InputMaybe<Scalars['String']['input']>
  /** Vendor the record came from. */
  vendor?: InputMaybe<Scalars['String']['input']>
}

export type CreateListInput = {
  /** Stage rule matches fall into when they have no stored stage row. */
  defaultStageId?: InputMaybe<Scalars['ID']['input']>
  /** Entity type the list is built from: Contact, Activity, TreatmentPlan, Appointment, or Task. */
  entityType: Scalars['String']['input']
  /** List rule as a JSON-encoded FilterObject array. */
  filters?: InputMaybe<Scalars['String']['input']>
  /** Join operator applied across the rule filters (e.g. and/or). */
  join?: InputMaybe<Scalars['String']['input']>
  /** Display name of the new list. */
  name: Scalars['String']['input']
  /** Initial stages/lanes for the list. */
  stages?: InputMaybe<Array<ListStageInput>>
  /** List visibility: shared (default) or personal (visible only to its creator). */
  visibility?: InputMaybe<Scalars['String']['input']>
}

export type CreateListItemInput = {
  /** Entity (e.g. contact) to add as a member of the list. */
  entityId: Scalars['ID']['input']
  /** List to add the entity to. */
  listId: Scalars['ID']['input']
  /** Stage/lane to place the new member in; defaults to the list's match stage when omitted. */
  stageId?: InputMaybe<Scalars['ID']['input']>
}

export type CreateLocationInput = {
  /** Street address of the location. */
  address?: InputMaybe<Scalars['String']['input']>
  /** Business phone number of the location. */
  businessPhone?: InputMaybe<Scalars['String']['input']>
  /** City of the location. */
  city?: InputMaybe<Scalars['String']['input']>
  /** Name of the location. */
  name: Scalars['String']['input']
  /** Main office phone number of the location. */
  officeMainNumber?: InputMaybe<Scalars['String']['input']>
  /** Weekly open hours for the location. */
  openHours?: InputMaybe<LocationOpenHoursInput>
  /** State of the location. */
  state?: InputMaybe<Scalars['String']['input']>
  /** IANA timezone of the location. */
  timezone: Scalars['String']['input']
  /** Type of location. */
  type?: InputMaybe<Scalars['String']['input']>
  /** ZIP/postal code of the location. */
  zip?: InputMaybe<Scalars['String']['input']>
}

export type CreateNoteTemplateInput = {
  /** Body text of the note template. */
  body: Scalars['String']['input']
  /** Name of the note template. */
  name: Scalars['String']['input']
}

/** Create a location-scoped communication opt-out. Delete the OptOut record to clear the opt-out and allow communication again. */
export type CreateOptOutInput = {
  /** Phone number or email address to opt out. Phone keys normalize to the last 10 digits; email keys normalize to lowercase trimmed text. */
  key: Scalars['String']['input']
  /** Location where this phone or email should be opted out. */
  locationId: Scalars['ID']['input']
  /** Communication channel to opt out: phone or email. */
  type: OptOutType
}

export type CreatePaperworkInput = {
  /** Days until the link expires. Defaults to 14. */
  expiresInDays?: InputMaybe<Scalars['Int']['input']>
  /** The PaperworkTemplate to send */
  paperworkTemplateId: Scalars['ID']['input']
  /** The patient to send it to */
  patientId: Scalars['ID']['input']
}

export type CreatePaperworkTemplateInput = {
  /** Visual presets for the packet. */
  appearance?: InputMaybe<AppearanceInput>
  /** Practice branding for the packet. */
  branding?: InputMaybe<PaperworkBrandingInput>
  /** Completion screen content. */
  completion?: InputMaybe<ScreenContentInput>
  /** Optional description of the template. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Ordered list of forms to send */
  forms: Array<PaperworkFormInput>
  /** Name of the paperwork template. */
  name: Scalars['String']['input']
  /** Welcome screen content. */
  welcome?: InputMaybe<ScreenContentInput>
}

export type CreatePhoneNumberInput = {
  /** Whether this phone number is enabled. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Human-readable label for this phone number. */
  label?: InputMaybe<Scalars['String']['input']>
  /** Location this phone number belongs to. */
  locationId: Scalars['String']['input']
  /** The phone number in E.164 or national format. */
  phone: Scalars['String']['input']
  /** Telephony provider for this number (e.g. twilio, ringcentral). */
  provider: Scalars['String']['input']
  /** Provider's resource identifier for this phone number. */
  providerResourceId: Scalars['String']['input']
  /** Roles assigned to this phone number (e.g. inbound, outbound). */
  roles: Array<Scalars['String']['input']>
}

export type CreatePipelineInput = {
  /** Pipeline name. */
  name: Scalars['String']['input']
  /** Ordered stages for the pipeline. */
  stages?: InputMaybe<Array<PipelineStageInput>>
}

export type CreatePmsReferralMappingInput = {
  /** UTM campaign to attribute this referral type to. */
  campaign?: InputMaybe<Scalars['String']['input']>
  /** Marketing channel to attribute this referral type to. */
  channel?: InputMaybe<Scalars['String']['input']>
  /** Force the mapping even if it conflicts with existing rules. */
  force?: InputMaybe<Scalars['Boolean']['input']>
  /** UTM medium to attribute this referral type to. */
  medium?: InputMaybe<Scalars['String']['input']>
  /** PMS referral type this mapping applies to. */
  referralType: Scalars['String']['input']
  /** UTM source to attribute this referral type to. */
  source?: InputMaybe<Scalars['String']['input']>
}

export type CreatePromptDraftInput = {
  /** Prompt version this draft was branched from, if any. */
  baseVersionId?: InputMaybe<Scalars['ID']['input']>
  /** Draft prompt body text. */
  body: Scalars['String']['input']
  /** Optional human-friendly label for the draft. */
  friendlyName?: InputMaybe<Scalars['String']['input']>
  /** Prompt this draft belongs to. */
  promptId: Scalars['ID']['input']
}

export type CreatePromptFragmentInput = {
  /** Body text of the fragment. */
  body: Scalars['String']['input']
  /** Optional description of the fragment. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Unique name for the prompt fragment. */
  name: Scalars['String']['input']
}

export type CreatePromptInput = {
  /** Prompt body text. */
  body: Scalars['String']['input']
  /** Category the prompt belongs to. */
  category: PromptCategory
  /** Optional description of the prompt. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Unique key identifying the prompt. */
  key: Scalars['String']['input']
  /** Model the prompt runs against. */
  model: Scalars['String']['input']
  /** Display name of the prompt. */
  name: Scalars['String']['input']
  /** Sampling temperature for the prompt. */
  temperature: Scalars['Float']['input']
}

export type CreateRegistrationProfileInput = {
  /** Brand accent color. */
  accentColor?: InputMaybe<Scalars['String']['input']>
  /** Business address city. */
  addressCity?: InputMaybe<Scalars['String']['input']>
  /** Business address country. */
  addressCountry?: InputMaybe<Scalars['String']['input']>
  /** Business address postal code. */
  addressPostalCode?: InputMaybe<Scalars['String']['input']>
  /** Business address state. */
  addressState?: InputMaybe<Scalars['String']['input']>
  /** Business street address. */
  addressStreet?: InputMaybe<Scalars['String']['input']>
  /** Agent description. */
  agentDescription?: InputMaybe<Scalars['String']['input']>
  /** Agent service name. */
  agentServiceName?: InputMaybe<Scalars['String']['input']>
  /** Brand description. */
  brandDescription?: InputMaybe<Scalars['String']['input']>
  /** Brand name. */
  brandName?: InputMaybe<Scalars['String']['input']>
  /** Business industry. */
  businessIndustry?: InputMaybe<Scalars['String']['input']>
  /** Country the business is registered in. */
  businessRegistrationCountry?: InputMaybe<Scalars['String']['input']>
  /** Business entity type. */
  businessType?: InputMaybe<Scalars['String']['input']>
  /** Contact email address. */
  contactEmail?: InputMaybe<Scalars['String']['input']>
  /** Contact first name. */
  contactFirstName?: InputMaybe<Scalars['String']['input']>
  /** Contact last name. */
  contactLastName?: InputMaybe<Scalars['String']['input']>
  /** Contact phone number. */
  contactPhone?: InputMaybe<Scalars['String']['input']>
  /** Contact job title. */
  contactTitle?: InputMaybe<Scalars['String']['input']>
  /** Employer Identification Number (EIN). */
  ein?: InputMaybe<Scalars['String']['input']>
  /** HELP keyword response message. */
  helpMessage?: InputMaybe<Scalars['String']['input']>
  /** Legal business name. */
  legalBusinessName?: InputMaybe<Scalars['String']['input']>
  /** Estimated monthly RCS message volume. */
  monthlyRcsVolume?: InputMaybe<Scalars['String']['input']>
  /** Profile name. */
  name: Scalars['String']['input']
  /** Opt-in confirmation message. */
  optInConfirmationMessage?: InputMaybe<Scalars['String']['input']>
  /** S3 keys for uploaded opt-in documents. */
  optInDocuments?: InputMaybe<Array<Scalars['String']['input']>>
  /** S3 key for the opt-in screenshot. */
  optInScreenshotUrl?: InputMaybe<Scalars['String']['input']>
  /** URL where users opt in. */
  optInUrl?: InputMaybe<Scalars['String']['input']>
  /** Description of the opt-in workflow. */
  optInWorkflowDescription?: InputMaybe<Scalars['String']['input']>
  /** Opt-out details. */
  optOutDetails?: InputMaybe<Scalars['String']['input']>
  /** Privacy policy URL. */
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>
  /** S3 key for the RCS banner image. */
  rcsBannerImageKey?: InputMaybe<Scalars['String']['input']>
  /** S3 key for the RCS logo image. */
  rcsLogoImageKey?: InputMaybe<Scalars['String']['input']>
  /** Sample messages sent to recipients. */
  sampleMessages?: InputMaybe<Array<Scalars['String']['input']>>
  /** STOP keyword response message. */
  stopMessage?: InputMaybe<Scalars['String']['input']>
  /** S3 keys for uploaded supplemental documents. */
  supplementalDocuments?: InputMaybe<Array<Scalars['String']['input']>>
  /** Terms of service URL. */
  termsUrl?: InputMaybe<Scalars['String']['input']>
  /** Messaging use case category. */
  useCaseCategory?: InputMaybe<Scalars['String']['input']>
  /** Description of the messaging use case. */
  useCaseDescription?: InputMaybe<Scalars['String']['input']>
  /** Promotional video URL. */
  videoUrl?: InputMaybe<Scalars['String']['input']>
  /** Business website URL. */
  websiteUrl?: InputMaybe<Scalars['String']['input']>
}

export type CreateRoleInput = {
  /** Name of the new role. */
  name: Scalars['String']['input']
  /** Permission keys granted to the role. */
  permissions?: InputMaybe<Array<Scalars['String']['input']>>
}

export type CreateScorecardInput = {
  /** Whether this is the default scorecard. */
  default?: InputMaybe<Scalars['Boolean']['input']>
  /** Grouping dimension for the scorecard. */
  grouping: Scalars['String']['input']
  /** Scorecard name. */
  name: Scalars['String']['input']
}

export type CreateSendingDomainInput = {
  /** The domain to send from, e.g. mail.smithdental.com */
  domain: Scalars['String']['input']
  /** trackable (shared mail.trackable.io) or custom (own domain). Defaults to custom. */
  type?: InputMaybe<Scalars['String']['input']>
}

export type CreateSmsTemplateInput = {
  /** Message body of the SMS template. */
  body: Scalars['String']['input']
  /** Name of the SMS template. */
  name: Scalars['String']['input']
}

export type CreateStaffInput = {
  /** Whether the staff member is active */
  active?: InputMaybe<Scalars['Boolean']['input']>
  /** Alternate names the staff member is also known by */
  aliases?: InputMaybe<Array<Scalars['String']['input']>>
  /** Display name of the staff member */
  name: Scalars['String']['input']
  /** Linked user account id to associate with this staff member */
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type CreateStoredCredentialInput = {
  /** Human-readable label for the credential. */
  label: Scalars['String']['input']
  /** Location this credential is scoped to, if any. */
  locationId?: InputMaybe<Scalars['String']['input']>
  /** Optional JSON metadata for the credential. */
  metadata?: InputMaybe<Scalars['String']['input']>
  /** Password for the credential (stored encrypted). */
  password: Scalars['String']['input']
  /** Username for the credential. */
  username: Scalars['String']['input']
}

export type CreateTagColorInput = {
  /** Display color for the tag (hex or named color). */
  color: Scalars['String']['input']
  /** Entity the tag applies to (activities, contacts, or calls). */
  entity: Scalars['String']['input']
  /** Tag value/label text. */
  name: Scalars['String']['input']
}

export type CreateTaskInput = {
  /** Contact the task is linked to. */
  contactId?: InputMaybe<Scalars['String']['input']>
  /** Task description. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Task due date (ISO date). */
  dueDate?: InputMaybe<Scalars['String']['input']>
  /** Location the task belongs to. */
  locationId: Scalars['String']['input']
  /** ID of the task owner. */
  ownerId?: InputMaybe<Scalars['String']['input']>
  /** Role assigned to the task. */
  roleId?: InputMaybe<Scalars['String']['input']>
  /** Task title. */
  title: Scalars['String']['input']
}

export type CreateTaskTemplateInput = {
  /** Optional description applied to tasks created from this template. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Number of days after creation that the task is due. */
  dueInDays?: InputMaybe<Scalars['Int']['input']>
  /** Internal name of the task template. */
  name: Scalars['String']['input']
  /** User assigned as the owner of tasks created from this template. */
  ownerId?: InputMaybe<Scalars['String']['input']>
  /** Title applied to tasks created from this template. */
  title: Scalars['String']['input']
}

export type CreateThreadInput = {
  /** Whether the AI assistant is enabled for this thread. */
  aiEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Client-supplied unique identifier for the new thread. */
  id: Scalars['ID']['input']
  /** Location this thread belongs to. */
  locationId: Scalars['String']['input']
  /** Display name for the thread. */
  name?: InputMaybe<Scalars['String']['input']>
}

export type CreateUserInput = {
  /** Location IDs the new user may access. */
  allowedLocationIds?: InputMaybe<Array<Scalars['String']['input']>>
  /** New user's email address. */
  email: Scalars['String']['input']
  /** New user's display name. */
  name: Scalars['String']['input']
  /** New user's phone number. */
  phone?: InputMaybe<Scalars['String']['input']>
  /** Role to assign to the new user. */
  roleId?: InputMaybe<Scalars['ID']['input']>
  /** Staff record to link to the new user. */
  staffId?: InputMaybe<Scalars['ID']['input']>
}

export type CreateUtmAliasInput = {
  /** Canonical value the original is aliased to. */
  alias: Scalars['String']['input']
  /** Original UTM value to be normalized. */
  original: Scalars['String']['input']
  /** UTM parameter type being aliased, e.g. source, medium, campaign. */
  type: Scalars['String']['input']
}

/** Create a new workflow definition. Workflows are created inactive and must be activated via updateWorkflow(active: true) after the graph is valid. */
export type CreateWorkflowInput = {
  /** Opaque JSON blob for the frontend builder (preserved by the engine, never interpreted). Stores UI-only fields like node labels, editor state, and unsupported-node configs so round-trips are lossless. */
  builderJson?: InputMaybe<Scalars['String']['input']>
  /** The workflow graph edges connecting nodes */
  edges: Array<WorkflowEdgeInput>
  /** Location this workflow belongs to */
  locationId: Scalars['String']['input']
  /** Human-readable workflow name */
  name: Scalars['String']['input']
  /** The workflow graph nodes */
  nodes: Array<WorkflowNodeInput>
  /** JSON settings object (quiet hours, etc.) */
  settings?: InputMaybe<Scalars['String']['input']>
  /** When this workflow should enroll contacts */
  trigger: WorkflowTriggerInput
  /** Date on which a date-based trigger starts evaluating; enrollments before it are ignored */
  triggerStartDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type CreateWorkspaceInput = {
  /** Name of the new workspace. */
  name: Scalars['String']['input']
}

export type CreateWorkspaceInviteInput = {
  /** Unique invite code the invitee uses to accept. */
  code: Scalars['String']['input']
  /** Email address being invited. */
  email: Scalars['String']['input']
  /** Invite expiration timestamp (ISO date). */
  expiresAt: Scalars['String']['input']
  /** Locations the invitee will have access to. */
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
  /** Role to assign the invitee on acceptance. */
  roleId: Scalars['String']['input']
  /** Existing staff record to link to the invite, if any. */
  staffId?: InputMaybe<Scalars['String']['input']>
}

export type CustomPage = {
  __typename?: 'CustomPage'
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Filter definitions applied to the page */
  filters?: Maybe<Array<CustomPageFilter>>
  /** Unique identifier for the custom page */
  id: Scalars['ID']['output']
  /** How filters are combined: and or or */
  join: Scalars['String']['output']
  /** Display name of the custom page */
  name: Scalars['String']['output']
  /** Organization that owns this custom page (multi-tenant isolation key) */
  orgId: Scalars['String']['output']
  /** Entity the page filters: contacts, activities, tasks, appointments, or treatmentPlans */
  page: Scalars['String']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** User who owns this custom page */
  userId: Scalars['String']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
}

export type CustomPageFilter = {
  __typename?: 'CustomPageFilter'
  /** Attribute/field the filter targets */
  attribute: Scalars['String']['output']
  /** Date-specific operator, e.g. before, after, between */
  dateOperator?: Maybe<Scalars['String']['output']>
  /** Default value(s) applied when the filter is first added */
  defaultValue?: Maybe<Scalars['JSON']['output']>
  /** Human-readable label shown for this filter */
  displayName?: Maybe<Scalars['String']['output']>
  /** Group this filter belongs to for combined logic */
  group?: Maybe<Scalars['String']['output']>
  /** Whether to include dates in the past */
  includeInThePast?: Maybe<Scalars['Boolean']['output']>
  /** Whether to include today in the date range */
  includeToday?: Maybe<Scalars['Boolean']['output']>
  /** Whether to include full weeks in the date range */
  includeWeeks?: Maybe<Scalars['Boolean']['output']>
  /** Whether to include yesterday in the date range */
  includeYesterday?: Maybe<Scalars['Boolean']['output']>
  /** Whether to limit the date range to the current month */
  limitToMonth?: Maybe<Scalars['Boolean']['output']>
  /** Whether the attribute must be non-empty to match */
  nonEmpty?: Maybe<Scalars['Boolean']['output']>
  /** Comparison operator applied to the attribute */
  operator: Scalars['String']['output']
  /** Available options for select-style filters */
  options?: Maybe<Scalars['JSON']['output']>
  /** Whether this filter cannot be edited by the user */
  readOnly?: Maybe<Scalars['Boolean']['output']>
  /** Secondary attribute for filters that span two fields */
  secondaryAttribute?: Maybe<Scalars['String']['output']>
  /** Secondary value(s) for range or two-sided filters */
  secondaryValue?: Maybe<Array<Scalars['String']['output']>>
  /** Whether this filter is fixed and always applied */
  static?: Maybe<Scalars['Boolean']['output']>
  /** Sub-query applied within this filter */
  subQuery?: Maybe<Scalars['String']['output']>
  /** Filter type, e.g. string, number, date, boolean */
  type?: Maybe<Scalars['String']['output']>
  /** Uniqueness operator for deduplicating matches */
  uniqOperator?: Maybe<Scalars['String']['output']>
  /** Whether to use an asterisk wildcard in matching */
  useAsterisk?: Maybe<Scalars['Boolean']['output']>
  /** Value(s) to compare against; a string or array of strings */
  value?: Maybe<Scalars['JSON']['output']>
}

export type CustomPageListResult = {
  __typename?: 'CustomPageListResult'
  /** Custom pages matching the query for the current page. */
  hits: Array<CustomPage>
  /** Zero-based index of the returned page. */
  page: Scalars['Int']['output']
  /** Total number of custom pages matching the query. */
  total: Scalars['Int']['output']
}

export type CustomQuestion = {
  __typename?: 'CustomQuestion'
  /** Optional helper text shown with the question. */
  description?: Maybe<Scalars['String']['output']>
  /** Whether this question is shown on the scheduling form. */
  enabled: Scalars['Boolean']['output']
  /** Label shown for the question on the scheduling form. */
  fieldName: Scalars['String']['output']
  /** Input type: one-line, multiple-lines, or checkbox. */
  fieldType: Scalars['String']['output']
  /** Unique identifier for this custom question. */
  id: Scalars['ID']['output']
  /**
   * Deprecated: whether answering grants marketing consent. Use optIn instead.
   * @deprecated Use optIn instead
   */
  marketingConsent?: Maybe<Scalars['Boolean']['output']>
  /** Whether answering records an opt-in consent. */
  optIn?: Maybe<Scalars['Boolean']['output']>
  /** Whether the patient must answer this question. */
  required: Scalars['Boolean']['output']
}

export type CustomQuestionInput = {
  /** Optional help text describing the question. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Whether this question is enabled and shown. */
  enabled: Scalars['Boolean']['input']
  /** Field name/label of the custom question. */
  fieldName: Scalars['String']['input']
  /** Input type of the question, e.g. text, select, boolean. */
  fieldType: Scalars['String']['input']
  /** Unique identifier for the custom question. */
  id: Scalars['ID']['input']
  /** Whether this question is an opt-in consent checkbox. */
  optIn?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether an answer is required. */
  required: Scalars['Boolean']['input']
}

export type Dni = {
  __typename?: 'DNI'
  /** Area code used to purchase pool numbers */
  areaCode: Scalars['String']['output']
  /** Auto-scale step. How many numbers to buy each time the pool scales up. */
  buyStep?: Maybe<Scalars['Int']['output']>
  /** When this pool was created. */
  createdDate: Scalars['DateTime']['output']
  /** Whether the pool is active and serving tracking numbers. */
  enabled: Scalars['Boolean']['output']
  /** Destination number calls forward to. Any number (office line), not a managed PhoneNumber. */
  forwardTo: Scalars['String']['output']
  /** Unique identifier for this DNI pool. */
  id: Scalars['ID']['output']
  /** Optional FK to an IvrConfig. When set, pool calls run the IVR menu. */
  ivrConfigId?: Maybe<Scalars['String']['output']>
  /** Display name, e.g. "Main Website Pool" */
  label?: Maybe<Scalars['String']['output']>
  /** Location this pool belongs to. */
  locationId: Scalars['String']['output']
  /** Auto-scale ceiling. When set above poolSize, the pool buys more numbers automatically up to this cap. Unset or <= poolSize means auto-scale is off. */
  maxPoolSize?: Maybe<Scalars['Int']['output']>
  /** Auto-scale trigger. Buy more numbers when free pool numbers drop below this. */
  minFree?: Maybe<Scalars['Int']['output']>
  /** Auto-scale floor. Numbers up to this count are permanent and never auto-released. Only auto-scaled numbers above this count are released when idle. Defaults to poolSize. */
  minPoolSize?: Maybe<Scalars['Int']['output']>
  /** Organization that owns this pool (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Ids of the PhoneNumber records (roles pool/source) that belong to this pool. */
  phoneNumberIds: Array<Scalars['String']['output']>
  /** Number of tracking numbers in the pool */
  poolSize: Scalars['Int']['output']
  /** Session window in minutes before a number returns to the pool */
  sessionDuration: Scalars['Int']['output']
  /** When this pool was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this pool belongs to. */
  workspaceId: Scalars['String']['output']
}

export type DniListResult = {
  __typename?: 'DNIListResult'
  /** Results for the current page. */
  hits: Array<Dni>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type DataCompareResult = {
  __typename?: 'DataCompareResult'
  /** Whether the source record matched a Trackable record. */
  match: Scalars['Boolean']['output']
  /** Human-readable result message. */
  message: Scalars['String']['output']
  /** Source PMS record as JSON. */
  sourceRecord?: Maybe<Scalars['String']['output']>
  /** Whether the comparison ran successfully. */
  success: Scalars['Boolean']['output']
  /** Matching Trackable record as JSON. */
  targetRecord?: Maybe<Scalars['String']['output']>
}

export type DateRangeInput = {
  /** Start of the comparison date range (inclusive, ISO date). */
  compareFromDate?: InputMaybe<Scalars['String']['input']>
  /** End of the comparison date range (inclusive, ISO date). */
  compareToDate?: InputMaybe<Scalars['String']['input']>
  /** Start of the primary date range (inclusive, ISO date). */
  fromDate: Scalars['String']['input']
  /** End of the primary date range (inclusive, ISO date). */
  toDate: Scalars['String']['input']
}

export type ElevenLabsAgent = {
  __typename?: 'ElevenLabsAgent'
  /** ElevenLabs agent id */
  id: Scalars['String']['output']
  /** Whether this agent is already in use by an integration */
  isUsed: Scalars['Boolean']['output']
  /** ElevenLabs agent name */
  name: Scalars['String']['output']
}

export type ElevenLabsCostSummary = {
  __typename?: 'ElevenLabsCostSummary'
  /** Speech recognition (ASR) portion of the ElevenLabs cost, in USD. */
  asr?: Maybe<Scalars['Float']['output']>
  /** LLM portion of the ElevenLabs cost, in USD. */
  llm?: Maybe<Scalars['Float']['output']>
  /** Number of LLM input tokens consumed on the call. */
  llmInputTokens?: Maybe<Scalars['Int']['output']>
  /** Number of LLM output tokens produced on the call. */
  llmOutputTokens?: Maybe<Scalars['Int']['output']>
  /** Platform portion of the ElevenLabs cost, in USD. */
  platform?: Maybe<Scalars['Float']['output']>
  /** Total ElevenLabs voice cost for the call, in USD. */
  total?: Maybe<Scalars['Float']['output']>
  /** Text-to-speech portion of the ElevenLabs cost, in USD. */
  tts?: Maybe<Scalars['Float']['output']>
}

export type ElevenLabsDeployment = {
  __typename?: 'ElevenLabsDeployment'
  /** Category the prompt belongs to */
  category: PromptCategory
  /** When the deployment finished processing all targets */
  completedAt?: Maybe<Scalars['DateTime']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** When the deployment was applied */
  deployedAt?: Maybe<Scalars['DateTime']['output']>
  /** User who initiated this deployment */
  deployedBy: Scalars['ID']['output']
  /** Number of targets the deployment failed for */
  failedTargetCount?: Maybe<Scalars['Int']['output']>
  /** Unique identifier for this ElevenLabs deployment */
  id: Scalars['ID']['output']
  /** LLM model used for the deployed agent */
  model?: Maybe<Scalars['String']['output']>
  /** Optional note describing the deployment */
  note?: Maybe<Scalars['String']['output']>
  /** Prompt being deployed */
  promptId: Scalars['ID']['output']
  /** Stable key identifying the prompt */
  promptKey: Scalars['String']['output']
  /** Display name of the prompt */
  promptName: Scalars['String']['output']
  /** Revision number of the prompt that was deployed */
  promptRevision?: Maybe<Scalars['Int']['output']>
  /** When the deployment was requested */
  requestedAt: Scalars['DateTime']['output']
  /** Snapshot of the prompt body text that was deployed */
  sourceBody?: Maybe<Scalars['String']['output']>
  /** Source prompt draft this deployment was built from */
  sourceDraftId?: Maybe<Scalars['ID']['output']>
  /** Source prompt version this deployment was built from */
  sourceVersionId?: Maybe<Scalars['ID']['output']>
  /** Current status of the deployment */
  status: ElevenLabsDeploymentStatus
  /** Number of targets the deployment succeeded for */
  successfulTargetCount?: Maybe<Scalars['Int']['output']>
  /** Total number of targets this deployment was applied to */
  targetCount?: Maybe<Scalars['Int']['output']>
  /** Location ids targeted by this deployment */
  targetLocationIds?: Maybe<Array<Scalars['ID']['output']>>
  /** Scope the deployment targets (e.g. workspace or location) */
  targetScope?: Maybe<ElevenLabsDeploymentScope>
  /** Workspace ids targeted by this deployment */
  targetWorkspaceIds?: Maybe<Array<Scalars['ID']['output']>>
  /** Sampling temperature used for the deployed agent */
  temperature?: Maybe<Scalars['Float']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
}

export type ElevenLabsDeploymentListResult = {
  __typename?: 'ElevenLabsDeploymentListResult'
  /** Results for the current page. */
  hits: Array<ElevenLabsDeployment>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export enum ElevenLabsDeploymentScope {
  All = 'ALL',
  Location = 'LOCATION',
  Specific = 'SPECIFIC',
}

export enum ElevenLabsDeploymentStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  PartialFailure = 'PARTIAL_FAILURE',
  Ready = 'READY',
  Success = 'SUCCESS',
}

export type ElevenLabsDeploymentTarget = {
  __typename?: 'ElevenLabsDeploymentTarget'
  /** ElevenLabs agent id being deployed */
  agentId: Scalars['String']['output']
  /** When this target was claimed for processing */
  claimedAt?: Maybe<Scalars['DateTime']['output']>
  /** Client variables passed to the agent */
  clientVars?: Maybe<Scalars['JSON']['output']>
  /** Compiled agent prompt body pushed to ElevenLabs */
  compiledBody?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** The ElevenLabs deployment this target belongs to */
  deploymentId: Scalars['ID']['output']
  /** Config derived during compilation */
  derivedConfig?: Maybe<Scalars['JSON']['output']>
  /** Error message if the deployment failed */
  errorMessage?: Maybe<Scalars['String']['output']>
  /** Snapshots of prompt fragments at deploy time */
  fragmentSnapshots?: Maybe<Scalars['JSON']['output']>
  /** Unique identifier for this deployment target */
  id: Scalars['ID']['output']
  /** Location this agent is deployed to */
  locationId: Scalars['ID']['output']
  /** Human-readable name of the target location */
  locationName?: Maybe<Scalars['String']['output']>
  /** When the agent config was pushed to ElevenLabs */
  pushedAt?: Maybe<Scalars['DateTime']['output']>
  /** Deployment status of this target */
  status: ElevenLabsDeploymentTargetStatus
  /** Tags present on the agent but absent from the config */
  tagsNotInConfig?: Maybe<Array<Scalars['String']['output']>>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this deployment target belongs to */
  workspaceId?: Maybe<Scalars['ID']['output']>
}

export type ElevenLabsDeploymentTargetListResult = {
  __typename?: 'ElevenLabsDeploymentTargetListResult'
  /** Results for the current page. */
  hits: Array<ElevenLabsDeploymentTarget>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export enum ElevenLabsDeploymentTargetStatus {
  ExternalAccepted = 'EXTERNAL_ACCEPTED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Pushing = 'PUSHING',
  Success = 'SUCCESS',
}

export type EmailAttachment = {
  __typename?: 'EmailAttachment'
  /** MIME content type of the attachment. */
  contentType: Scalars['String']['output']
  /** Original filename of the attachment. */
  filename: Scalars['String']['output']
  /** File size in bytes. */
  sizeBytes: Scalars['Float']['output']
}

export type EmailAttachmentInput = {
  /** Base64-encoded file contents. */
  base64: Scalars['String']['input']
  /** Browser-reported MIME type. Falls back to the file extension when omitted or application/octet-stream. */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** File name, shown to the recipient. */
  filename: Scalars['String']['input']
}

export type EmailAttachmentLink = {
  __typename?: 'EmailAttachmentLink'
  /** MIME content type of the attachment. */
  contentType: Scalars['String']['output']
  /** File name, as attached. */
  filename: Scalars['String']['output']
  /** File size in bytes. */
  sizeBytes: Scalars['Float']['output']
  /** Presigned download URL, valid for 5 minutes from issue. */
  url: Scalars['String']['output']
}

export enum EntityType {
  Appointments = 'APPOINTMENTS',
  Appointmenttypes = 'APPOINTMENTTYPES',
  Commlogs = 'COMMLOGS',
  Insurance = 'INSURANCE',
  Patientprocedures = 'PATIENTPROCEDURES',
  Patients = 'PATIENTS',
  Procedures = 'PROCEDURES',
  Providers = 'PROVIDERS',
  Referrals = 'REFERRALS',
  Schedules = 'SCHEDULES',
  ScheduleAssignments = 'SCHEDULE_ASSIGNMENTS',
  Transactions = 'TRANSACTIONS',
  Treatmentplans = 'TREATMENTPLANS',
  Visits = 'VISITS',
}

export type Event = {
  __typename?: 'Event'
  /** What happened: created, updated, deleted, date_reached, completed, reconciled, merged, or a procedure/plan lifecycle action. */
  action: Scalars['String']['output']
  /** Actor who caused the event: a user, automation, or system, with kind/id/name/source. */
  actor?: Maybe<Scalars['JSON']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Field-level change set for the event, mapping each field to its from/to values. */
  data: Scalars['JSON']['output']
  /** When the event occurred. */
  eventDate: Scalars['DateTime']['output']
  /** Unique identifier for the event; deterministic for durable/idempotent event types. */
  id: Scalars['ID']['output']
  /** Intent attached to a journey change, or the source contact for a merge link. */
  journeyMeta?: Maybe<Scalars['JSON']['output']>
  /** Location this event belongs to. */
  locationId: Scalars['String']['output']
  /** Free-text reason attached to a manual change, e.g. a super-user correction of AI call analysis. */
  note?: Maybe<Scalars['String']['output']>
  /** Organization that owns this event (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Attribution for the event: an acting user, source entity, or System. */
  source: Scalars['String']['output']
  /** Entity type the event is about, e.g. Contact, Call, Form, Message, Appointment, Task, OptOut, TreatmentPlan, CommLog. */
  type: Scalars['String']['output']
  /** ID of the source entity this event refers to. */
  typeId: Scalars['String']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** IDs of workflows that have processed this event. */
  workflowIds: Array<Scalars['String']['output']>
  /** Workspace this event belongs to. */
  workspaceId: Scalars['String']['output']
}

export type EventListResult = {
  __typename?: 'EventListResult'
  /** Results for the current page. */
  hits: Array<Event>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type ExtractionDashboardResult = {
  __typename?: 'ExtractionDashboardResult'
  /** Shadow extraction statistics. */
  shadowStats: ShadowStats
  /** Workspace the stats are scoped to, if any. */
  workspaceId?: Maybe<Scalars['String']['output']>
}

export type ExtractionPrompt = {
  __typename?: 'ExtractionPrompt'
  /** Whether this is the active prompt for its stage; only one per stage is active. */
  active: Scalars['Boolean']['output']
  /** User ID that created this prompt version. */
  createdBy?: Maybe<Scalars['String']['output']>
  /** When this prompt version was created. */
  createdDate: Scalars['DateTime']['output']
  /** Unique prompt ID. */
  id: Scalars['ID']['output']
  /** Model identifier this prompt targets (e.g. gpt-4o). */
  model: Scalars['String']['output']
  /** Freeform notes about this prompt version. */
  notes?: Maybe<Scalars['String']['output']>
  /** Prompt text sent to the model for this stage. */
  prompt: Scalars['String']['output']
  /** Version identifier for this prompt, sortable per stage. */
  promptVersion: Scalars['String']['output']
  /** LangGraph extraction stage: overview, people, appointment, outcome, or validation. */
  stage: Scalars['String']['output']
  /** When this prompt version was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
}

export type ExtractionPromptListResult = {
  __typename?: 'ExtractionPromptListResult'
  /** Page of matching records */
  hits: Array<ExtractionPrompt>
  /** Current page number */
  page: Scalars['Int']['output']
  /** Total number of matching records across all pages */
  total: Scalars['Int']['output']
}

export type FacebookAccount = {
  __typename?: 'FacebookAccount'
  /** Facebook account id */
  id?: Maybe<Scalars['String']['output']>
  /** Whether this account is disabled */
  isDisabled: Scalars['Boolean']['output']
  /** Whether this account is already in use by an integration */
  isUsed: Scalars['Boolean']['output']
  /** Facebook account name */
  name?: Maybe<Scalars['String']['output']>
}

export type FacebookAdSet = {
  __typename?: 'FacebookAdSet'
  /** Facebook ad set id */
  id: Scalars['String']['output']
  /** Facebook ad set name */
  name: Scalars['String']['output']
}

export type FacebookAdsCampaignInput = {
  /** Grandparent node ID in the ad hierarchy (account for an ad set). */
  grandparentId?: InputMaybe<Scalars['String']['input']>
  /** Facebook object ID (campaign, ad set, or account). */
  id: Scalars['String']['input']
  /** Parent node ID in the ad hierarchy. */
  parentId?: InputMaybe<Scalars['String']['input']>
  /** Node type: account, campaign, or adSet. */
  type: Scalars['String']['input']
}

export type FacebookAdsConfig = {
  __typename?: 'FacebookAdsConfig'
  /** Facebook ads account id */
  accountId?: Maybe<Scalars['String']['output']>
  /** Facebook ad set id */
  adSetId?: Maybe<Scalars['String']['output']>
  /** Facebook campaign id */
  campaignId?: Maybe<Scalars['String']['output']>
}

export type FacebookLeadForm = {
  __typename?: 'FacebookLeadForm'
  /** Facebook lead form id */
  id: Scalars['String']['output']
  /** Facebook lead form name */
  name?: Maybe<Scalars['String']['output']>
}

export type FacebookLeadPage = {
  __typename?: 'FacebookLeadPage'
  /** Facebook lead page display name */
  name: Scalars['String']['output']
  /** Facebook lead page id value */
  value: Scalars['String']['output']
}

export type FacebookLeadPageConfig = {
  __typename?: 'FacebookLeadPageConfig'
  /** Specific form ids to pull; empty pulls all forms for the page */
  formIds?: Maybe<Array<Scalars['String']['output']>>
  /** Facebook account or page id to pull leads from */
  id: Scalars['String']['output']
}

export type FeatureToggle = {
  __typename?: 'FeatureToggle'
  /** Whether this toggle is archived and no longer active */
  archived: Scalars['Boolean']['output']
  /** Category used to group related feature toggles */
  category?: Maybe<FeatureToggleCategory>
  /** User who created this toggle */
  createdBy?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Human-readable description of what this toggle controls */
  description?: Maybe<Scalars['String']['output']>
  /** Friendly display name shown in the admin UI */
  displayName?: Maybe<Scalars['String']['output']>
  /** Unique identifier for this feature toggle */
  id: Scalars['ID']['output']
  /** Programmatic name/key of the feature toggle used in code checks */
  name: Scalars['String']['output']
  /** Release identifier this toggle is associated with */
  release?: Maybe<Scalars['String']['output']>
  /** Scope of the toggle: Global, Workspace, or User */
  type: Scalars['String']['output']
  /** Id of the scoped target (workspaceId or userId) when type is Workspace or User */
  typeId?: Maybe<Scalars['String']['output']>
  /** User who last updated this toggle */
  updatedBy?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
}

export enum FeatureToggleCategory {
  Analytics = 'ANALYTICS',
  Communications = 'COMMUNICATIONS',
  Contacts = 'CONTACTS',
  Integrations = 'INTEGRATIONS',
  Internal = 'INTERNAL',
  Platform = 'PLATFORM',
  Scheduling = 'SCHEDULING',
}

export type FeatureToggleListResult = {
  __typename?: 'FeatureToggleListResult'
  /** Matching records for the current page. */
  hits: Array<FeatureToggle>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching records across all pages. */
  total: Scalars['Int']['output']
}

export type FileImport = {
  __typename?: 'FileImport'
  /** Whether this file import has been archived. */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Timestamp when this file import was created. */
  createdDate?: Maybe<Scalars['DateTime']['output']>
  /** Original name of the uploaded file. */
  fileName: Scalars['String']['output']
  /** Unique identifier for this file import. */
  id: Scalars['ID']['output']
  /** Identifiers of the Import records created from this file. */
  importIds: Array<Scalars['String']['output']>
  /** Organization that owns this file import (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Timestamp when this file import was last updated. */
  updatedDate?: Maybe<Scalars['DateTime']['output']>
  /** Workspace this file import is scoped to, if any. */
  workspaceId?: Maybe<Scalars['String']['output']>
}

export type FileImportListResult = {
  __typename?: 'FileImportListResult'
  /** Matching items for this page. */
  hits: Array<FileImport>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching items across all pages. */
  total: Scalars['Int']['output']
}

export type FollowUpGql = {
  __typename?: 'FollowUpGQL'
  /** Scheduled appointment date linked to this follow-up. */
  appointmentDate?: Maybe<Scalars['DateTime']['output']>
  /** Index of the associated person within a multi-person record. */
  associatedPeopleIndex?: Maybe<Scalars['Int']['output']>
  /** Type of the associated record, e.g. call, appointment. */
  associatedType?: Maybe<Scalars['String']['output']>
  /** ID of the associated record. */
  associatedTypeId?: Maybe<Scalars['String']['output']>
  /** Contact this follow-up is for. */
  contactId: Scalars['ID']['output']
  /** When this follow-up was created. */
  createdDate?: Maybe<Scalars['DateTime']['output']>
  /** Notes describing the follow-up. */
  description?: Maybe<Scalars['String']['output']>
  /** Date the follow-up is due. */
  followUpDate?: Maybe<Scalars['DateTime']['output']>
  /** Unique identifier for the follow-up. */
  id: Scalars['ID']['output']
  /** Whether contact was successfully reached. */
  isConnected?: Maybe<Scalars['Boolean']['output']>
  /** Whether an appointment was scheduled from this follow-up. */
  isScheduled?: Maybe<Scalars['Boolean']['output']>
  /** Location this follow-up is associated with. */
  locationId: Scalars['ID']['output']
  /** Organization that owns this follow-up (multi-tenant isolation key). */
  orgId: Scalars['ID']['output']
  /** User who owns this follow-up. */
  ownerId?: Maybe<Scalars['ID']['output']>
  /** Display name of the follow-up owner. */
  ownerName?: Maybe<Scalars['String']['output']>
  /** When this follow-up was last updated. */
  updatedDate?: Maybe<Scalars['DateTime']['output']>
  /** Workspace this follow-up belongs to. */
  workspaceId: Scalars['ID']['output']
}

export type FollowUpGqlListResult = {
  __typename?: 'FollowUpGQLListResult'
  /** Matching records for the current page. */
  hits: Array<FollowUpGql>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching records across all pages. */
  total: Scalars['Int']['output']
}

export type FormFieldMapping = {
  __typename?: 'FormFieldMapping'
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Standardized field the raw key maps to (e.g. "patientName"). */
  formField: Scalars['String']['output']
  /** Deterministic identifier derived from orgId, workspaceId, rawKey, and formField. */
  id: Scalars['ID']['output']
  /** Organization that owns this mapping (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Raw incoming form field key to be mapped (e.g. "nombre"). */
  rawKey: Scalars['String']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this mapping is scoped to. */
  workspaceId: Scalars['String']['output']
}

export type FormFieldMappingListResult = {
  __typename?: 'FormFieldMappingListResult'
  /** Matching items for this page. */
  hits: Array<FormFieldMapping>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching items across all pages. */
  total: Scalars['Int']['output']
}

/** A single question in a form. The id is client-minted and preserved across versions. */
export type FormQuestionInput = {
  /** Optional help text shown under the question. */
  helpText?: InputMaybe<Scalars['String']['input']>
  /** Client-minted, stable across edits and versions */
  id: Scalars['String']['input']
  /** One of: shortText, longText, date, phone, email, address, singleSelect, multiSelect, yesNo, signature, initials, staticText */
  kind: Scalars['String']['input']
  /** Question label shown to the respondent. */
  label: Scalars['String']['input']
  /** The Contact field this answer maps to, or omit for answer-only */
  mappingTarget?: InputMaybe<Scalars['String']['input']>
  /** Choices for singleSelect or multiSelect questions. */
  options?: InputMaybe<Array<QuestionOptionInput>>
  /** Whether an answer is required. */
  required: Scalars['Boolean']['input']
  /** Conditional display rule for this question. */
  showWhen?: InputMaybe<ShowWhenInput>
}

export type FormSubmissionsNotificationInput = {
  /** Whether form-submission notifications are enabled. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Channels for new-form-submission notifications. */
  newFormSubmission?: InputMaybe<NotificationChannelInput>
}

export type FormSubmissionsNotificationSettings = {
  __typename?: 'FormSubmissionsNotificationSettings'
  /** Whether form-submission notifications are enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** Channels for new-form-submission notifications. */
  newFormSubmission?: Maybe<NotificationChannel>
}

export type FormTemplate = {
  __typename?: 'FormTemplate'
  /** Whether the form has been archived. */
  archived: Scalars['Boolean']['output']
  /** Category the form belongs to. */
  category: Scalars['String']['output']
  /** When the form template was created. */
  createdDate: Scalars['DateTime']['output']
  /** Optional description of the form's purpose. */
  description?: Maybe<Scalars['String']['output']>
  /** Stable identity of the form shared across all of its versions. */
  formId: Scalars['ID']['output']
  /** Version number of this form template row. */
  formVersion: Scalars['Int']['output']
  /** Unique identifier for this form template version row. */
  id: Scalars['ID']['output']
  /** Human-readable name of the form. */
  name: Scalars['String']['output']
  /** Organization that owns this form template (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** When this version was published and frozen; unset for drafts. */
  publishedDate?: Maybe<Scalars['DateTime']['output']>
  /** Ordered array of FormQuestion (typed JSON) */
  questionsJson: Scalars['JSON']['output']
  /** Lifecycle status: "draft" while editable or "published" once frozen. */
  status: Scalars['String']['output']
  /** When the form template was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this form template belongs to. */
  workspaceId: Scalars['String']['output']
}

export type FormTemplateListResult = {
  __typename?: 'FormTemplateListResult'
  /** Results for the current page. */
  hits: Array<FormTemplate>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type GoogleAdsAccount = {
  __typename?: 'GoogleAdsAccount'
  /** Google Ads account id */
  id?: Maybe<Scalars['String']['output']>
  /** Whether this account is disabled */
  isDisabled: Scalars['Boolean']['output']
  /** Whether this account is already in use by an integration */
  isUsed: Scalars['Boolean']['output']
  /** Google Ads account name */
  name?: Maybe<Scalars['String']['output']>
}

export type GoogleAdsV2Config = {
  __typename?: 'GoogleAdsV2Config'
  /** Google Ads account id */
  accountId: Scalars['String']['output']
  /** Google Ads ad group id */
  adGroupId?: Maybe<Scalars['String']['output']>
  /** Google Ads campaign id */
  campaignId?: Maybe<Scalars['String']['output']>
}

export type GoogleAdsV3Config = {
  __typename?: 'GoogleAdsV3Config'
  /** Google Ads account id */
  accountId: Scalars['String']['output']
  /** Campaign ids to track; empty means all campaigns in the account */
  campaignIds?: Maybe<Array<Scalars['String']['output']>>
  /** Map of conversion type to Google Ads conversion action id */
  conversionActions?: Maybe<Scalars['JSON']['output']>
}

export type GravityFormsMultiConfig = {
  __typename?: 'GravityFormsMultiConfig'
  /** Authentication key for the Gravity Forms API integration. */
  apiKey: Scalars['String']['output']
  /** Fallback location for unmatched form submissions. */
  defaultLocationId: Scalars['String']['output']
  /** Rules routing submissions to specific locations by form field. */
  routingRules?: Maybe<Array<GravityFormsRoutingRule>>
}

export type GravityFormsRoutingField = {
  __typename?: 'GravityFormsRoutingField'
  /** Name of the Gravity Forms field to match on. */
  name: Scalars['String']['output']
  /** Value the field must equal for this rule to match. */
  value: Scalars['String']['output']
}

export type GravityFormsRoutingRule = {
  __typename?: 'GravityFormsRoutingRule'
  /** Field match condition for this rule. */
  field?: Maybe<GravityFormsRoutingField>
  /** Gravity Forms form id this rule applies to. */
  formId?: Maybe<Scalars['String']['output']>
  /** Location submissions matching this rule are routed to. */
  locationId: Scalars['String']['output']
}

export enum HealthStatus {
  AtRisk = 'AT_RISK',
  Healthy = 'HEALTHY',
  Stale = 'STALE',
}

export type Import = {
  __typename?: 'Import'
  /** Date the imported activity occurred. */
  activityDate?: Maybe<Scalars['DateTime']['output']>
  /** Whether this import has been archived. */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Marketing channel attributed to this import. */
  channel?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Contact email on the imported record. */
  email?: Maybe<Scalars['String']['output']>
  /** ID of the parent file import this record came from. */
  fileImportId?: Maybe<Scalars['String']['output']>
  /** Unique import ID (derived from org, workspace, location, name, contact details, and date). */
  id: Scalars['ID']['output']
  /** Whether the imported record is already scheduled. */
  isScheduled?: Maybe<Scalars['Boolean']['output']>
  /** Location this import belongs to. */
  locationId: Scalars['String']['output']
  /** Name(s) on the imported record; multiple names are separated by "&". */
  name: Scalars['String']['output']
  /** Organization that owns this import (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Contact phone number on the imported record. */
  phone?: Maybe<Scalars['String']['output']>
  /** Requested appointment time from the import (ISO date/time). */
  requestedAppointmentTime?: Maybe<Scalars['String']['output']>
  /** Staff member associated with the import. */
  staff?: Maybe<Scalars['String']['output']>
  /** Treatment or service referenced by the import. */
  treatment?: Maybe<Scalars['String']['output']>
  /** Activity type this import creates (e.g. Online Scheduler, Virtual Consultation). */
  type: Scalars['String']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** UTM campaign attributed to this import. */
  utmCampaign?: Maybe<Scalars['String']['output']>
  /** UTM medium attributed to this import. */
  utmMedium?: Maybe<Scalars['String']['output']>
  /** UTM source attributed to this import. */
  utmSource?: Maybe<Scalars['String']['output']>
  /** Vendor the imported record came from. */
  vendor?: Maybe<Scalars['String']['output']>
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this import belongs to. */
  workspaceId: Scalars['String']['output']
}

export type ImportListResult = {
  __typename?: 'ImportListResult'
  /** Matching items for this page. */
  hits: Array<Import>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching items across all pages. */
  total: Scalars['Int']['output']
}

export type IncomingCall = {
  __typename?: 'IncomingCall'
  /** Caller's city, if known. */
  callerCity?: Maybe<Scalars['String']['output']>
  /** Caller's name, if known. */
  callerName?: Maybe<Scalars['String']['output']>
  /** Caller's phone number. */
  callerPhone: Scalars['String']['output']
  /** Caller's state, if known. */
  callerState?: Maybe<Scalars['String']['output']>
  /** Contact IDs matched to this call. */
  contactIds: Array<Scalars['String']['output']>
  /** Call ID. */
  id: Scalars['ID']['output']
  /** Location the call belongs to. */
  locationId: Scalars['String']['output']
  /** Source attributed to the call. */
  source?: Maybe<Scalars['String']['output']>
  /** When the call started ringing. */
  startedAt: Scalars['DateTime']['output']
  /** Tracking number the call came in on. */
  trackingNumber?: Maybe<Scalars['String']['output']>
  /** Name of the tracking number. */
  trackingNumberName?: Maybe<Scalars['String']['output']>
  /** Workspace the call belongs to. */
  workspaceId: Scalars['String']['output']
}

export type InitiateCallInput = {
  /** Contact to call. */
  contactId: Scalars['ID']['input']
  /** Number to place the call from. */
  fromNumber: Scalars['String']['input']
  /** Primary tracking number used as the caller ID. */
  primaryTrackingNumber: Scalars['String']['input']
  /** Number to dial. */
  toNumber: Scalars['String']['input']
}

export type InitiateCallResult = {
  __typename?: 'InitiateCallResult'
  /** ID of the created call, when successful. */
  callId?: Maybe<Scalars['String']['output']>
  /** The number that was actually dialed, when successful. */
  calledNumber?: Maybe<Scalars['String']['output']>
  /** Human-readable error message when initiation failed. */
  error?: Maybe<Scalars['String']['output']>
  /** Whether the outbound call was successfully initiated. */
  success: Scalars['Boolean']['output']
}

export type IntegrationOptionsQueries = {
  __typename?: 'IntegrationOptionsQueries'
  ascendLocations: Array<AscendLocation>
  callRailCompanies: Array<CallRailCompany>
  callrailTags: Array<Scalars['String']['output']>
  carestackPractices: Array<CarestackPractice>
  elevenLabsAgents: Array<ElevenLabsAgent>
  facebookAccounts: Array<FacebookAccount>
  facebookAdSets: Array<FacebookAdSet>
  facebookLeadForms: Array<FacebookLeadForm>
  facebookLeadPages: Array<FacebookLeadPage>
  googleAdsAccount?: Maybe<GoogleAdsAccount>
  googleAdsAccounts: Array<GoogleAdsAccount>
  jotformForms: Array<JotformForm>
  kollaPractices: Array<KollaPractice>
  ringCentralPhoneNumbers: Array<RingCentralPhoneNumber>
  sikkaOffices: Array<SikkaOffice>
  twilioPhoneNumbers: Array<TwilioPhoneNumber>
}

export type IntegrationOptionsQueriesAscendLocationsArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>
}

export type IntegrationOptionsQueriesCallRailCompaniesArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>
}

export type IntegrationOptionsQueriesCallrailTagsArgs = {
  companyId: Scalars['String']['input']
}

export type IntegrationOptionsQueriesCarestackPracticesArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>
}

export type IntegrationOptionsQueriesFacebookAdSetsArgs = {
  refresh?: InputMaybe<Scalars['Boolean']['input']>
}

export type IntegrationOptionsQueriesFacebookLeadFormsArgs = {
  locationId: Scalars['ID']['input']
}

export type IntegrationOptionsQueriesGoogleAdsAccountArgs = {
  accountId: Scalars['String']['input']
}

export type IntegrationOptionsQueriesJotformFormsArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>
}

export type IntegrationOptionsQueriesKollaPracticesArgs = {
  kollaConnectorId: Scalars['String']['input']
  kollaConsumerId: Scalars['String']['input']
}

export type IntegrationOptionsQueriesRingCentralPhoneNumbersArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>
}

export type IntegrationOptionsQueriesSikkaOfficesArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>
}

export type IntegrationOptionsQueriesTwilioPhoneNumbersArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>
}

export type IntegrationSaveResult = {
  __typename?: 'IntegrationSaveResult'
  /** Error message when the save failed. */
  error?: Maybe<Scalars['String']['output']>
  /** Whether the integration was saved successfully. */
  success: Scalars['Boolean']['output']
}

export type IntegrationStatus = {
  __typename?: 'IntegrationStatus'
  /** Appointment backfill completion percent */
  appointmentsCompletion?: Maybe<Scalars['Int']['output']>
  /** Overall backfill completion percent */
  completion?: Maybe<Scalars['Int']['output']>
  /** Number of pages configured for the integration */
  configuredPages?: Maybe<Scalars['Int']['output']>
  /** Additional detail about the status such as completion or staleness */
  detail?: Maybe<IntegrationStatusDetail>
  /** Patient backfill completion percent */
  patientsCompletion?: Maybe<Scalars['Int']['output']>
  /** Reason behind the current status */
  reason?: Maybe<IntegrationStatusReason>
  /** Appointments still to be backfilled */
  remainingAppointments?: Maybe<Scalars['Int']['output']>
  /** Calls still to be backfilled */
  remainingCalls?: Maybe<Scalars['Int']['output']>
  /** Forms still to be backfilled */
  remainingForms?: Maybe<Scalars['Int']['output']>
  /** Patients still to be backfilled */
  remainingPatients?: Maybe<Scalars['Int']['output']>
  /** Ad spend records still to be backfilled */
  remainingSpendRecords?: Maybe<Scalars['Int']['output']>
  /** Transactions still to be backfilled */
  remainingTransactions?: Maybe<Scalars['Int']['output']>
  /** Overall status: Active, Broken, Deleting, In Progress, or empty */
  status: Scalars['String']['output']
  /** Transaction backfill completion percent */
  transactionsCompletion?: Maybe<Scalars['Int']['output']>
}

export type IntegrationStatusDetail = {
  __typename?: 'IntegrationStatusDetail'
  /** Percent complete of the in-progress backfill */
  completionPercent?: Maybe<Scalars['Int']['output']>
  /** Days since the integration last synced successfully */
  daysStaleSince?: Maybe<Scalars['Int']['output']>
}

export enum IntegrationStatusReason {
  AuthFailed = 'AUTH_FAILED',
  BackfillQueued = 'BACKFILL_QUEUED',
  BackfillRunning = 'BACKFILL_RUNNING',
  BackfillStalled = 'BACKFILL_STALLED',
  ConfigIncomplete = 'CONFIG_INCOMPLETE',
  SyncStale = 'SYNC_STALE',
}

export type IntegrationV2 = {
  __typename?: 'IntegrationV2'
  /** When the integration was created */
  createdDate: Scalars['DateTime']['output']
  /** Unique identifier for the integration */
  id: Scalars['ID']['output']
  /** Id of the entity this integration is attached to (org, workspace, or location) */
  sourceId: Scalars['String']['output']
  /** Level the integration is attached at: Organization, Workspace, or Location */
  sourceType: Scalars['String']['output']
  /** Integration provider: sikka, callrail, jotform, google-ads, facebook-ads, facebook-leads, carestack, ascend, kolla, twilio, ringcentral, or clickfunnels */
  type: Scalars['String']['output']
  /** When the integration was last updated */
  updatedDate: Scalars['DateTime']['output']
  /** Username credential for the integration, when applicable */
  username?: Maybe<Scalars['String']['output']>
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
}

export type IvrConfigResult = {
  __typename?: 'IvrConfigResult'
  /** Whether the IVR phone menu is enabled */
  enabled: Scalars['Boolean']['output']
  /** Unique identifier for this IVR configuration */
  id: Scalars['String']['output']
  /** Location this IVR configuration applies to */
  locationId: Scalars['String']['output']
  /** The IVR menu tree nodes */
  nodes: Scalars['JSON']['output']
  /** Phone number this IVR is attached to */
  phoneNumberId?: Maybe<Scalars['String']['output']>
  /** Node id of the IVR menu's entry/root node */
  root?: Maybe<Scalars['String']['output']>
}

export type JotformConfig = {
  __typename?: 'JotformConfig'
  /** Jotform folder id containing the forms */
  folderId: Scalars['String']['output']
  /** Jotform form ids to process */
  formIds?: Maybe<Array<Scalars['String']['output']>>
}

export type JotformForm = {
  __typename?: 'JotformForm'
  /** Jotform form id */
  id: Scalars['String']['output']
  /** Whether this form is already in use by an integration */
  isUsed: Scalars['Boolean']['output']
  /** Jotform label id applied to the form */
  labelId?: Maybe<Scalars['String']['output']>
  /** Jotform label name applied to the form */
  labelName?: Maybe<Scalars['String']['output']>
  /** Jotform form name */
  name: Scalars['String']['output']
  /** Name of the location already using this form */
  usedByLocationName?: Maybe<Scalars['String']['output']>
}

export type JotformV2Config = {
  __typename?: 'JotformV2Config'
  /** Jotform form ids to process */
  formIds?: Maybe<Array<Scalars['String']['output']>>
  /** Jotform label id used to group forms */
  labelId: Scalars['String']['output']
}

export type KollaPractice = {
  __typename?: 'KollaPractice'
  /** Kolla practice id */
  id: Scalars['String']['output']
  /** Kolla practice name */
  name?: Maybe<Scalars['String']['output']>
}

export type KollaRequestInput = {
  /** JSON-encoded request body */
  body?: InputMaybe<Scalars['String']['input']>
  /** Location whose Kolla connector to proxy through. */
  locationId: Scalars['ID']['input']
  /** HTTP method: get, post, delete, or patch. */
  method?: Scalars['String']['input']
  /** Kolla API path to request. */
  path: Scalars['String']['input']
}

export type KollaRequestResult = {
  __typename?: 'KollaRequestResult'
  /** JSON-encoded response from Kolla */
  data?: Maybe<Scalars['String']['output']>
  /** Error message when the request failed. */
  error?: Maybe<Scalars['String']['output']>
  /** Round-trip response time in milliseconds. */
  responseTimeMs?: Maybe<Scalars['Int']['output']>
  /** Whether the Kolla request succeeded. */
  success: Scalars['Boolean']['output']
}

export type LeadOverrideConfig = {
  __typename?: 'LeadOverrideConfig'
  /** Amount of time in the configured unit. */
  amount: Scalars['Float']['output']
  /** Time unit for the amount: days or weeks. */
  unit: Scalars['String']['output']
}

export type LeadOverrideConfigInput = {
  /** Amount of the lead override window. */
  amount: Scalars['Float']['input']
  /** Time unit for the override amount, e.g. days, hours. */
  unit: Scalars['String']['input']
}

export type LeadsBreakdownBucket = {
  __typename?: 'LeadsBreakdownBucket'
  /** Number of leads in this bucket. */
  count: Scalars['Int']['output']
  /** Label identifying this bucket. */
  key: Scalars['String']['output']
}

export type LegacyLeadsBreakdown = {
  __typename?: 'LegacyLeadsBreakdown'
  /** Lead counts grouped into labelled buckets. */
  buckets: Array<LeadsBreakdownBucket>
  /** Lead counts grouped by first activity type. */
  byActivityTypes: Array<LegacyLeadsMetric>
  /** Lead counts grouped by lead status. */
  byLeadStatus: Array<LegacyLeadsMetric>
  /** Lead counts grouped by lead status for the comparison period. */
  byLeadStatusComparison: Array<LegacyLeadsMetric>
  /** Daily rows of lead counts with per-type and per-status breakdowns. */
  rows: Array<LegacyLeadsDailyMetric>
  /** Total number of leads in the breakdown. */
  total: Scalars['Int']['output']
}

export type LegacyLeadsByStatus = {
  __typename?: 'LegacyLeadsByStatus'
  /** Number of leads with this status. */
  count: Scalars['Int']['output']
  /** Lead status for this group. */
  status: Scalars['String']['output']
}

export type LegacyLeadsByType = {
  __typename?: 'LegacyLeadsByType'
  /** Number of leads with this first activity type. */
  count: Scalars['Int']['output']
  /** First activity type for this group. */
  type: Scalars['String']['output']
}

export type LegacyLeadsDailyMetric = {
  __typename?: 'LegacyLeadsDailyMetric'
  /** Label identifying this grouping bucket. */
  bucket: Scalars['String']['output']
  /** Date of this row (YYYY-MM-DD). */
  date: Scalars['String']['output']
  /** Number of leads on this date in this bucket. */
  leads: Scalars['Int']['output']
  /** Lead counts for this date grouped by first activity type. */
  leadsByFirstActivityType: Array<LegacyLeadsByType>
  /** Lead counts for this date grouped by lead status. */
  leadsByStatus: Array<LegacyLeadsByStatus>
}

export type LegacyLeadsMetric = {
  __typename?: 'LegacyLeadsMetric'
  /** Label identifying this grouping bucket. */
  bucket: Scalars['String']['output']
  /** Number of leads in this bucket. */
  leads: Scalars['Int']['output']
}

export type List = {
  __typename?: 'List'
  /** User who created this list; gates access for personal lists. Absent on older lists. */
  createdByUserId?: Maybe<Scalars['ID']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Stage id a rule-matched member lands in when it has no explicit stage yet. */
  defaultStageId?: Maybe<Scalars['ID']['output']>
  /** Entity type this list holds: Contact, Activity, TreatmentPlan, Appointment, or Task. */
  entityType: Scalars['String']['output']
  /** Membership rule as filter clauses, compiled to an OpenSearch query at read time; absent on a manual list. */
  filters?: Maybe<Array<CustomPageFilter>>
  /** Unique identifier for this list. */
  id: Scalars['ID']['output']
  /** How the rule clauses join: and or or. */
  join?: Maybe<Scalars['String']['output']>
  /** Display name of the list. */
  name: Scalars['String']['output']
  /** Organization that owns this list (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Ordered board columns (stages) for this list. */
  stages?: Maybe<Array<ListStage>>
  /** Whether this is a built-in, product-owned list that cannot be deleted. */
  system?: Maybe<Scalars['Boolean']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Who can see the list: shared (whole workspace) or personal (creator only). */
  visibility?: Maybe<Scalars['String']['output']>
  /** Workspace this list belongs to. */
  workspaceId: Scalars['String']['output']
}

export type ListItem = {
  __typename?: 'ListItem'
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** The member entity's id; its type is fixed by the list (List.entityType). */
  entityId: Scalars['ID']['output']
  /** Deterministic membership identifier (listId-entityId); one row per entity per list. */
  id: Scalars['ID']['output']
  /** The list this entity is a member of. */
  listId: Scalars['String']['output']
  /** Location of the entity, carried so the location-scoped Event ledger can record this membership's history. */
  locationId: Scalars['String']['output']
  /** Organization that owns this membership (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Id of the stage this member currently sits in; absent when the list has no stages. */
  stageId?: Maybe<Scalars['ID']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this membership belongs to. */
  workspaceId: Scalars['String']['output']
}

export type ListItemListResult = {
  __typename?: 'ListItemListResult'
  /** List items matching the query for the current page. */
  hits: Array<ListItem>
  /** Zero-based index of the returned page. */
  page: Scalars['Int']['output']
  /** Total number of list items matching the query across all pages. */
  total: Scalars['Int']['output']
}

export type ListMember = {
  __typename?: 'ListMember'
  /** Identifier of the entity that is a member of the list. */
  entityId: Scalars['ID']['output']
  /** Stage/lane the member is shown in; null when it has no resolved stage. */
  stageId?: Maybe<Scalars['ID']['output']>
  /** Entity type of this member (e.g. Contact, Activity, Task). */
  type: Scalars['String']['output']
}

export type ListMembersResult = {
  __typename?: 'ListMembersResult'
  /** List members for the requested page/lane. */
  members: Array<ListMember>
  /** Zero-based index of the returned page. */
  page: Scalars['Int']['output']
  /** Total number of members matching the query. */
  total: Scalars['Int']['output']
}

export type ListStage = {
  __typename?: 'ListStage'
  /** Color used to render this stage column. */
  color: Scalars['String']['output']
  /** Stable identifier for this stage; referenced by ListItem.stageId. */
  id: Scalars['ID']['output']
  /** Display name of the board column. */
  name: Scalars['String']['output']
  /** Whether this is a product-owned automatic stage that workspaces cannot rename, delete, or hand-pick. */
  system?: Maybe<Scalars['Boolean']['output']>
}

export type ListStageCount = {
  __typename?: 'ListStageCount'
  /** Number of members in this stage. */
  count: Scalars['Int']['output']
  /** Stage/lane the count is for. */
  stageId: Scalars['ID']['output']
}

export type ListStageInput = {
  /** Display color of the stage. */
  color: Scalars['String']['input']
  /** Stage id; omit to add a new stage (the server assigns one), pass to keep an existing stage. */
  id?: InputMaybe<Scalars['ID']['input']>
  /** Display name of the stage. */
  name: Scalars['String']['input']
}

export type Location = {
  __typename?: 'Location'
  /** Primary street address for this location */
  address?: Maybe<Scalars['String']['output']>
  /** Secondary address line (suite, building, etc.) */
  addressLine2?: Maybe<Scalars['String']['output']>
  /** End of the alarm quiet window in 24h Central Time (e.g. "06:00"); the window may wrap midnight */
  alarmQuietEnd?: Maybe<Scalars['String']['output']>
  /** Start of the alarm quiet window in 24h Central Time (e.g. "22:00"); scheduler health failures in this window don't trigger Discord notifications */
  alarmQuietStart?: Maybe<Scalars['String']['output']>
  /** Whether double booking is allowed when scheduling appointments */
  allowDoubleBookingScheduling?: Maybe<Scalars['Boolean']['output']>
  /** Whether this location is archived (soft-deleted and hidden from active use) */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Ascend PMS location identifier */
  ascendLocationId?: Maybe<Scalars['String']['output']>
  /** How scheduling availability is determined: standard (PMS-driven) or advanced (manually configured in Trackable) */
  availabilityMode?: Maybe<Scalars['String']['output']>
  /** Deprecated; use officeMainNumber instead */
  businessPhone?: Maybe<Scalars['String']['output']>
  /** Start date for backfilling CallRail calls; only calls on or after this date are pulled */
  callRailBackfillStartDate?: Maybe<Scalars['DateTime']['output']>
  /** CallRail company identifier used for call tracking and attribution */
  callRailCompanyId?: Maybe<Scalars['String']['output']>
  /** Maps CallRail tracking tags to specific location ids for call attribution */
  callRailRouting?: Maybe<Array<CallRailRoutingConfig>>
  /** Carestack PMS identifier, format {accountId}-{locationId} */
  carestackId?: Maybe<Scalars['String']['output']>
  /** City where this location is physically located */
  city?: Maybe<Scalars['String']['output']>
  /** Opaque routing key carried on the ClickFunnels webhook URL to resolve this location before verifying the signature */
  clickFunnelsKey?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Connection Health workflow status: unread, in_progress, awaiting, or ignored */
  currentStatus?: Maybe<Scalars['String']['output']>
  /** Hour (0-23) in Central Time when the daily Eaglesoft full sync runs; defaults to 19 (7 PM CT) */
  dailySyncHour?: Maybe<Scalars['Int']['output']>
  /** Free-text description or internal notes about this location */
  description?: Maybe<Scalars['String']['output']>
  /** ElevenLabs voice agent id bound to this location (1:1, one agent per location) */
  elevenLabsAgentId?: Maybe<Scalars['String']['output']>
  /** Facebook ad set ids used for marketing attribution and spend tracking */
  facebookAdSetIds?: Maybe<Array<Scalars['String']['output']>>
  /** Whether Facebook advertising is active for this location */
  facebookAdsActive?: Maybe<Scalars['Boolean']['output']>
  /** Facebook account/campaign/ad-set associations for attribution and spend tracking */
  facebookAdsV2?: Maybe<Array<FacebookAdsConfig>>
  /** Facebook form ids used by webhooks to resolve the location; managed by the attach-webhooks script, not user-editable */
  facebookFormIds?: Maybe<Array<Scalars['String']['output']>>
  /** Facebook Lead Ads configs (V2); each specifies an account/page and optional forms to pull leads from */
  facebookLeadsPages?: Maybe<Array<FacebookLeadPageConfig>>
  /** When Facebook advertising spend data was last updated */
  facebookSpendUpdateDate?: Maybe<Scalars['DateTime']['output']>
  /** Whether Google advertising is active for this location */
  googleAdsActive?: Maybe<Scalars['Boolean']['output']>
  /** Deprecated Google Ads customer id */
  googleAdsCustomerId?: Maybe<Scalars['String']['output']>
  /** Deprecated Google Ads account/campaign/ad-group associations for attribution and spend tracking */
  googleAdsV2?: Maybe<Array<GoogleAdsV2Config>>
  /** Google Ads V3 config: single account with multiple campaigns and account-level conversion actions */
  googleAdsV3?: Maybe<GoogleAdsV3Config>
  /** When Google advertising spend data was last updated */
  googleSpendUpdateDate?: Maybe<Scalars['DateTime']['output']>
  /** API key for the Gravity Forms integration */
  gravityFormsKey?: Maybe<Scalars['String']['output']>
  /** Unique identifier for this location (auto-generated) */
  id: Scalars['ID']['output']
  /** Whether the AI Agent product is live for this location */
  isAIAgentLive?: Maybe<Scalars['Boolean']['output']>
  /** Whether the Scheduler product is live for this location */
  isSchedulerLive?: Maybe<Scalars['Boolean']['output']>
  /** Jotform form ids to ignore for this location; they won't trigger webhook processing or lead creation */
  jotFormIgnoredForms?: Maybe<Array<Scalars['String']['output']>>
  /** Deprecated Jotform folder/form associations for lead generation */
  jotform?: Maybe<Array<JotformConfig>>
  /** Jotform form ids directly assigned to this location, used by webhooks to resolve the location */
  jotformFormIds?: Maybe<Array<Scalars['String']['output']>>
  /** Deprecated label-based Jotform configs; new integrations use jotformFormIds instead */
  jotformV2?: Maybe<Array<JotformV2Config>>
  /** Kolla PMS connector identifier */
  kollaConnectorId?: Maybe<Scalars['String']['output']>
  /** Kolla PMS consumer identifier */
  kollaConsumerId?: Maybe<Scalars['String']['output']>
  /** Override page size for Kolla API requests (defaults to 1000); useful when the PMS times out on large queries */
  kollaPageSize?: Maybe<Scalars['Int']['output']>
  /** Kolla practice this location maps to (practice_0 is the default for single-practice installs) */
  kollaPracticeId?: Maybe<Scalars['String']['output']>
  /** Additional labels for location categorization */
  labels?: Maybe<Array<Scalars['String']['output']>>
  /** When the most recent AI agent call occurred at this location */
  lastAICallDate?: Maybe<Scalars['DateTime']['output']>
  /** When a new or changed appointment record last arrived for this location. Unlike lastAppointmentSyncDate (which only records that a sync ran), this only advances when a load actually received new/changed data, so it answers "how current is the appointment data?". */
  lastAppointmentReceivedDate?: Maybe<Scalars['DateTime']['output']>
  /** Sync cursor for appointments: when the appointment load last ran for this location. Advances to the sync run's start time on every successful load and drives the incremental fetch window. Records that a sync ran, not that new data arrived. */
  lastAppointmentSyncDate?: Maybe<Scalars['DateTime']['output']>
  /** When a CallRail poll/backfill last ran successfully; advances even when no new calls, so idle integrations aren't flagged stale */
  lastCallrailSyncDate?: Maybe<Scalars['DateTime']['output']>
  /** When a CallRail webhook was last processed */
  lastCallrailWebhookDate?: Maybe<Scalars['DateTime']['output']>
  /** When the last accepted ClickFunnels form_submission.created delivery arrived */
  lastClickFunnelsWebhookDate?: Maybe<Scalars['DateTime']['output']>
  /** When a new or changed comm log (PMS communication log) last arrived for this location. Unlike lastCommLogSyncDate (which only records that a sync ran), this only advances when a load actually received new/changed data, so it answers "how current is the comm-log data?". */
  lastCommLogReceivedDate?: Maybe<Scalars['DateTime']['output']>
  /** Sync cursor for comm logs (PMS communication logs): when the comm-log load last ran for this location. Advances to the sync run's start time on every successful load and drives the incremental fetch window. Records that a sync ran, not that new data arrived. */
  lastCommLogSyncDate?: Maybe<Scalars['DateTime']['output']>
  /** When a Facebook Lead Ads webhook was last processed */
  lastFacebookWebhookDate?: Maybe<Scalars['DateTime']['output']>
  /** When a Gravity Forms webhook was last processed */
  lastGravityFormWebhookDate?: Maybe<Scalars['DateTime']['output']>
  /** When a JotForm webhook was last processed */
  lastJotformWebhookDate?: Maybe<Scalars['DateTime']['output']>
  /** When a new or changed patient record last arrived for this location. Unlike lastPatientSyncDate (which only records that a sync ran), this only advances when a load actually received new/changed data, so it answers "how current is the patient data?". */
  lastPatientReceivedDate?: Maybe<Scalars['DateTime']['output']>
  /** Sync cursor for patients: when the patient load last ran for this location. Advances to the sync run's start time on every successful load and drives the incremental fetch window. Records that a sync ran, not that new data arrived. */
  lastPatientSyncDate?: Maybe<Scalars['DateTime']['output']>
  /** When the last PMS sync chain finished (stamped by the final location-update-pms-sync-date step). Paired with lastPmsSyncStartDate to measure sync duration and detect in-progress syncs (start > complete). */
  lastPmsSyncCompleteDate?: Maybe<Scalars['DateTime']['output']>
  /** When the last successful PMS sync finished writing its data watermark. Advances forward only; drives the incremental fetch window for the next sync. A stale value means syncs have stopped succeeding. */
  lastPmsSyncDate?: Maybe<Scalars['DateTime']['output']>
  /** When the last PMS sync run started (stamped by the refresh script as it queues the sync chain). Paired with lastPmsSyncCompleteDate: if start is after complete, a sync is still in progress. */
  lastPmsSyncStartDate?: Maybe<Scalars['DateTime']['output']>
  /** When a new or changed procedure record last arrived for this location. Unlike lastProcedureSyncDate (which only records that a sync ran), this only advances when a load actually received new/changed data, so it answers "how current is the procedure data?". */
  lastProcedureReceivedDate?: Maybe<Scalars['DateTime']['output']>
  /** Sync cursor for procedures: when the procedure load last ran for this location. Advances to the sync run's start time on every successful load and drives the incremental fetch window. Records that a sync ran, not that new data arrived. */
  lastProcedureSyncDate?: Maybe<Scalars['DateTime']['output']>
  /** When a new or changed referral-source record last arrived for this location. Unlike lastReferralSourceSyncDate (which only records that a sync ran), this only advances when a load actually received new/changed data, so it answers "how current is the referral-source data?". */
  lastReferralSourceReceivedDate?: Maybe<Scalars['DateTime']['output']>
  /** Sync cursor for referral sources: when the referral-source load last ran for this location. Referral sources are the non-patient sources a patient can be referred from, resolved into a patient's referral type. Records that a sync ran, not that new data arrived. */
  lastReferralSourceSyncDate?: Maybe<Scalars['DateTime']['output']>
  /** When RingCentral data was last synced */
  lastRingCentralSyncDate?: Maybe<Scalars['DateTime']['output']>
  /** When a Sikka webhook was last processed */
  lastSikkaWebhookDate?: Maybe<Scalars['DateTime']['output']>
  /** When a PMS sync last failed (e.g. Kolla deadline exceeded, or a PMS API error). Set by PmsSyncRun.fail. Used for connection-health status in the ops dashboard. */
  lastSyncFailureDate?: Maybe<Scalars['DateTime']['output']>
  /** When a new or changed transaction record last arrived for this location. Unlike lastTransactionSyncDate (which only records that a sync ran), this only advances when a load actually received new/changed data, so it answers "how current is the transaction data?". */
  lastTransactionReceivedDate?: Maybe<Scalars['DateTime']['output']>
  /** Sync cursor for transactions: when the transaction load last ran for this location. Advances to the sync run's start time on every successful load and drives the incremental fetch window. Records that a sync ran, not that new data arrived. */
  lastTransactionSyncDate?: Maybe<Scalars['DateTime']['output']>
  /** When a new or changed treatment-plan record last arrived for this location. Unlike lastTreatmentPlanSyncDate (which only records that a sync ran), this only advances when a load actually received new/changed data, so it answers "how current is the treatment-plan data?". */
  lastTreatmentPlanReceivedDate?: Maybe<Scalars['DateTime']['output']>
  /** Sync cursor for treatment plans: when the treatment-plan load last ran for this location. Advances to the sync run's start time on every successful load and drives the incremental fetch window. Records that a sync ran, not that new data arrived. */
  lastTreatmentPlanSyncDate?: Maybe<Scalars['DateTime']['output']>
  /** When a Twilio webhook was last processed */
  lastTwilioWebhookDate?: Maybe<Scalars['DateTime']['output']>
  /** When a new or changed visit record last arrived for this location. Unlike lastVisitSyncDate (which only records that a sync ran), this only advances when a load actually received new/changed data, so it answers "how current is the visit data?". */
  lastVisitReceivedDate?: Maybe<Scalars['DateTime']['output']>
  /** Sync cursor for visits: when the visit load last ran for this location. Visits carry the procedures and fees for treatment-plan appointments, used to compute scheduled production. Records that a sync ran, not that new data arrived. */
  lastVisitSyncDate?: Maybe<Scalars['DateTime']['output']>
  /** Date the location migrated from a previous PMS; patients with earlier activity skip became-date calculations */
  migrationDate?: Maybe<Scalars['DateTime']['output']>
  /** Display name for this location */
  name: Scalars['String']['output']
  /** Ops investigation notes for sync issues, each with text, timestamp, and author */
  notes?: Maybe<Array<LocationNote>>
  /** The office's main phone number, reported by the AI agent and used as the default outbound number */
  officeMainNumber?: Maybe<Scalars['String']['output']>
  /** Direct office line that bypasses any IVR, used by the AI agent to transfer calls; falls back to officeMainNumber */
  officeTransferNumber?: Maybe<Scalars['String']['output']>
  /** Id of the PhoneNumber designated as the IVR transfer number ($transfer dial target) */
  officeTransferNumberId?: Maybe<Scalars['String']['output']>
  /** Operating hours for each day of the week */
  openHours?: Maybe<LocationOpenHours>
  /** Organization that owns this location (multi-tenant isolation key) */
  orgId: Scalars['ID']['output']
  /** Organization-level tags inherited from the parent organization */
  orgTags?: Maybe<Array<Scalars['String']['output']>>
  /** Deprecated; use officeMainNumber instead */
  phone?: Maybe<Scalars['String']['output']>
  /** Practice Management System this location integrates with (e.g. sikka, carestack, kolla) */
  pms?: Maybe<Scalars['String']['output']>
  /** Whether this location is integrated with a PMS */
  pmsIntegrated: Scalars['Boolean']['output']
  /** When PMS integration was first established */
  pmsIntegratedDate?: Maybe<Scalars['DateTime']['output']>
  /** Id of the PhoneNumber designated as the primary IVR number ($primary dial target) */
  primaryNumberId?: Maybe<Scalars['String']['output']>
  /** Primary number used for outbound SMS, selected from the location's integrated phone numbers */
  primarySmsNumber?: Maybe<Scalars['String']['output']>
  /** Primary CallRail tracking number used for click-to-call attribution */
  primaryTrackingNumber?: Maybe<Scalars['String']['output']>
  /** Trackable products enabled for this location (e.g. Scheduler, AI Agent, SMS Agent, CRM, Call Processing, Inbox) */
  products?: Maybe<Array<Scalars['String']['output']>>
  /** RingCentral phone numbers managed for this location */
  ringCentralPhoneNumbers?: Maybe<Array<Scalars['String']['output']>>
  /** Location-specific settings for patient calculations, PII handling, and comm-log writeback */
  settings?: Maybe<LocationSettings>
  /** Sikka PMS office identifier */
  sikkaOfficeId?: Maybe<Scalars['String']['output']>
  /** Sikka PMS practice identifier (combined with sikkaOfficeId for unique identification) */
  sikkaPracticeId?: Maybe<Scalars['String']['output']>
  /** State or province where this location is physically located */
  state?: Maybe<Scalars['String']['output']>
  /** Custom user-defined tags for categorizing and filtering this location */
  tags?: Maybe<Array<Scalars['String']['output']>>
  /** Timezone identifier for this location (e.g. America/New_York) */
  timezone?: Maybe<Scalars['String']['output']>
  /** Twilio phone numbers for this location: pool (DNI), ai/ai-testing (AI agent), source (DNI trackers), ivr (website number owning pool config) */
  twilioNumbers?: Maybe<Array<TwilioNumberConfig>>
  /** Practice classification: General or Specialty */
  type?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** API key for the Webflow Forms integration */
  webflowFormsKey?: Maybe<Scalars['String']['output']>
  /** Workspace this location belongs to (Organization > Workspace > Location hierarchy) */
  workspaceId: Scalars['String']['output']
  /** Postal/ZIP code for this location */
  zip?: Maybe<Scalars['String']['output']>
}

export type LocationEmailIdentity = {
  __typename?: 'LocationEmailIdentity'
  /** Full From address: local-part@domain. Derived on save. */
  address: Scalars['String']['output']
  /** When this email identity was created. */
  createdDate: Scalars['DateTime']['output']
  /** The verified domain, denormalized for the From address. */
  domain: Scalars['String']['output']
  /** Display name on the From header. */
  fromName?: Maybe<Scalars['String']['output']>
  /** Deterministic identifier derived from the globally-unique From address. */
  id: Scalars['ID']['output']
  /** Local part of the From address, lowercased. Unique per domain. */
  localPart: Scalars['String']['output']
  /** Location this From identity sends on behalf of. */
  locationId: Scalars['String']['output']
  /** Organization that owns this email identity (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Reply-To address for this location. */
  replyTo?: Maybe<Scalars['String']['output']>
  /** The custom SendingDomain this identity sends from. Empty for the shared Trackable domain. */
  sendingDomainId?: Maybe<Scalars['String']['output']>
  /** When this email identity was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this email identity belongs to. */
  workspaceId: Scalars['String']['output']
}

export type LocationEmailIdentityListResult = {
  __typename?: 'LocationEmailIdentityListResult'
  /** Results for the current page. */
  hits: Array<LocationEmailIdentity>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type LocationFilter = {
  /** Limit results to these connector types. */
  connectorType?: InputMaybe<Array<ConnectorType>>
  /** Only include locations that have a connector. */
  hasConnector?: InputMaybe<Scalars['Boolean']['input']>
  /** Only include locations that currently have an error. */
  hasError?: InputMaybe<Scalars['Boolean']['input']>
  /** Limit results to these health statuses. */
  healthStatus?: InputMaybe<Array<HealthStatus>>
  /** Limit results to this organization. */
  orgId?: InputMaybe<Scalars['ID']['input']>
  /** Free-text or field-scoped search query. */
  search?: InputMaybe<Scalars['String']['input']>
  /** Limit results to these workflow statuses. */
  workflowStatus?: InputMaybe<Array<WorkflowStatus>>
}

export type LocationInput = {
  /** End of the alarm quiet-hours window. */
  alarmQuietEnd?: InputMaybe<Scalars['String']['input']>
  /** Start of the alarm quiet-hours window. */
  alarmQuietStart?: InputMaybe<Scalars['String']['input']>
  /** Hour of day to schedule the daily sync. */
  dailySyncHour?: InputMaybe<Scalars['Int']['input']>
  /** Page size for Kolla sync requests; null to clear. */
  kollaPageSize?: InputMaybe<Scalars['Int']['input']>
  /** New ops workflow status for the location. */
  workflowStatus?: InputMaybe<WorkflowStatus>
}

export type LocationListResult = {
  __typename?: 'LocationListResult'
  /** Results for the current page. */
  hits: Array<Location>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type LocationNote = {
  __typename?: 'LocationNote'
  /** When the note was written */
  date: Scalars['DateTime']['output']
  /** Text of the note */
  text: Scalars['String']['output']
  /** User who wrote the note */
  userId: Scalars['String']['output']
}

export type LocationOpenDay = {
  __typename?: 'LocationOpenDay'
  /** Open time ranges for this day */
  hours: Array<OpenHoursRange>
  /** Whether the location is open on this day */
  open: Scalars['Boolean']['output']
}

export type LocationOpenDayInput = {
  /** Open-hours ranges for the day. */
  hours: Array<OpenHoursRangeInput>
  /** Whether the location is open on this day. */
  open: Scalars['Boolean']['input']
}

export type LocationOpenHours = {
  __typename?: 'LocationOpenHours'
  /** Open hours for Friday */
  friday?: Maybe<LocationOpenDay>
  /** Open hours for Monday */
  monday?: Maybe<LocationOpenDay>
  /** Open hours for Saturday */
  saturday?: Maybe<LocationOpenDay>
  /** Open hours for Sunday */
  sunday?: Maybe<LocationOpenDay>
  /** Open hours for Thursday */
  thursday?: Maybe<LocationOpenDay>
  /** Open hours for Tuesday */
  tuesday?: Maybe<LocationOpenDay>
  /** Open hours for Wednesday */
  wednesday?: Maybe<LocationOpenDay>
}

export type LocationOpenHoursInput = {
  /** Open hours for Friday. */
  friday?: InputMaybe<LocationOpenDayInput>
  /** Open hours for Monday. */
  monday?: InputMaybe<LocationOpenDayInput>
  /** Open hours for Saturday. */
  saturday?: InputMaybe<LocationOpenDayInput>
  /** Open hours for Sunday. */
  sunday?: InputMaybe<LocationOpenDayInput>
  /** Open hours for Thursday. */
  thursday?: InputMaybe<LocationOpenDayInput>
  /** Open hours for Tuesday. */
  tuesday?: InputMaybe<LocationOpenDayInput>
  /** Open hours for Wednesday. */
  wednesday?: InputMaybe<LocationOpenDayInput>
}

export type LocationSettings = {
  __typename?: 'LocationSettings'
  /** Appointment statuses that count as completed */
  appointmentCompletionStatuses?: Maybe<Array<Scalars['String']['output']>>
  /** Whether an appointment marks a patient as new */
  appointmentsSetNewPatient?: Maybe<Scalars['Boolean']['output']>
  /** Map of rule key to PMS channel; a key absent from the map is not written back */
  commLogWritebackChannels?: Maybe<Scalars['JSON']['output']>
  /** Whether comm-log writeback to the PMS is enabled */
  commLogWritebackEnabled?: Maybe<Scalars['Boolean']['output']>
  /** When comm-log writeback was turned on; only activity at or after this instant is written back */
  commLogWritebackEnabledDate?: Maybe<Scalars['DateTime']['output']>
  /** PMS user/scheduler resource that receives written-back entries (e.g. resources/user_1) */
  commLogWritebackProvider?: Maybe<Scalars['String']['output']>
  /** Whether to exclude parents from new-patient counts */
  excludeParentsFromNewPatients?: Maybe<Scalars['Boolean']['output']>
  /** Whether a patient's first visit marks them as new */
  firstVisitSetNewPatient?: Maybe<Scalars['Boolean']['output']>
  /** Whether to ignore PII when processing this location's data */
  ignorePII?: Maybe<Scalars['Boolean']['output']>
  /** Rule used to calculate new patients: ADA, all-procedures, new-patient-codes, or eligible-procedure */
  newPatientCalculation?: Maybe<Scalars['String']['output']>
  /** Procedure codes that count as a new patient visit */
  newPatientCodes?: Maybe<Array<Scalars['String']['output']>>
  /** Transaction codes that indicate a broken/cancelled appointment */
  transactionBrokenCodes?: Maybe<Array<Scalars['String']['output']>>
}

export type LoginPayload = {
  __typename?: 'LoginPayload'
  /** JWT access token, present when login completed without a second step. */
  accessToken?: Maybe<Scalars['String']['output']>
  /** Channel used to deliver the verification code (e.g. sms, email). */
  channel?: Maybe<Scalars['String']['output']>
  /** Short-lived token issued when a second login step (e.g. verification) is required. */
  pendingToken?: Maybe<Scalars['String']['output']>
  /** The authenticated user, when login completed. */
  user?: Maybe<User>
}

export type MarketingLeadsByType = {
  __typename?: 'MarketingLeadsByType'
  /** Number of appointments of this type. */
  appointments: Scalars['Int']['output']
  /** Number of leads of this type. */
  leads: Scalars['Int']['output']
  /** Number of marketing-qualified leads (MQLs) of this type. */
  mqls: Scalars['Int']['output']
  /** Number of new patients of this type. */
  patients: Scalars['Int']['output']
  /** First-activity type this breakdown row is for (e.g. the channel or activity that created the lead). */
  type: Scalars['String']['output']
}

export type MarketingMetrics = {
  __typename?: 'MarketingMetrics'
  /** Customer acquisition cost (cost per new patient), in dollars. */
  CAC: Scalars['Float']['output']
  /** Cost per appointment, in dollars. */
  CPA: Scalars['Float']['output']
  /** Cost per lead, in dollars. */
  CPL: Scalars['Float']['output']
  /** Cost per qualified lead, in dollars. */
  CPQL: Scalars['Float']['output']
  /** Number of marketing-qualified leads (uppercase alias of mqls). */
  MQLs: Scalars['Int']['output']
  /** Return on investment: production relative to spend. */
  ROI: Scalars['Float']['output']
  /** Total number of appointments in the period. */
  appointments: Scalars['Int']['output']
  /** Total marketing budget for the period, in dollars. */
  budget: Scalars['Float']['output']
  /** Number of leads marked closed-lost. */
  closedLost: Scalars['Int']['output']
  /** Number of leads marked closed-won. */
  closedWon: Scalars['Int']['output']
  /** Number of leads marked disqualified. */
  disqualified: Scalars['Int']['output']
  /** Facebook/Meta ad spend for the period, in dollars. */
  facebookSpend: Scalars['Float']['output']
  /** Google ad spend for the period, in dollars. */
  googleSpend: Scalars['Float']['output']
  /** Goal for number of leads in the period. */
  leadGoal: Scalars['Int']['output']
  /** Total number of leads in the period. */
  leads: Scalars['Int']['output']
  /** Breakdown of leads by the first activity type that created them. */
  leadsByFirstActivityType?: Maybe<Array<MarketingLeadsByType>>
  /** Number of leads that reached the closed-lost stage. */
  leadsClosedLost: Scalars['Int']['output']
  /** Number of leads that reached the closed-won stage. */
  leadsClosedWon: Scalars['Int']['output']
  /** Number of leads currently in progress. */
  leadsInProgress: Scalars['Int']['output']
  /** Number of leads currently needing action. */
  leadsNeedsAction: Scalars['Int']['output']
  /** Number of leads currently scheduled. */
  leadsScheduled: Scalars['Int']['output']
  /** Number of marketing-qualified leads (lowercase alias of MQLs). */
  mqls: Scalars['Int']['output']
  /** Goal for number of new patients in the period. */
  patientGoal: Scalars['Int']['output']
  /** Total number of new patients in the period. */
  patients: Scalars['Int']['output']
  /** Realized production (completed revenue) attributed to marketing, in dollars. */
  production: Scalars['Float']['output']
  /** Number of leads marked qualified. */
  qualified: Scalars['Int']['output']
  /** Share of leads that became scheduled, as a rate. */
  scheduleRate: Scalars['Float']['output']
  /** Number of leads marked scheduled. */
  scheduled: Scalars['Int']['output']
  /** Scheduled (not yet completed) production attributed to marketing, in dollars. */
  scheduledProduction: Scalars['Float']['output']
  /** Target (budgeted) spend for the period, in dollars. */
  targetSpend: Scalars['Float']['output']
}

export type MarketingMetricsResponse = {
  __typename?: 'MarketingMetricsResponse'
  /** Aggregate marketing metrics for the comparison period, when one is requested. */
  compareTo?: Maybe<MarketingMetrics>
  /** Per-bucket metric rows (alias of rows). */
  hits: Array<MarketingMetricsRow>
  /** Per-bucket metric rows making up the time series. */
  rows: Array<MarketingMetricsRow>
  /** Aggregate marketing metrics for the selected period. */
  summary: MarketingMetrics
  /** Total number of rows available. */
  total: Scalars['Int']['output']
}

export type MarketingMetricsRow = {
  __typename?: 'MarketingMetricsRow'
  /** Customer acquisition cost (cost per new patient), in dollars. */
  CAC: Scalars['Float']['output']
  /** Cost per appointment, in dollars. */
  CPA: Scalars['Float']['output']
  /** Cost per lead, in dollars. */
  CPL: Scalars['Float']['output']
  /** Cost per qualified lead, in dollars. */
  CPQL: Scalars['Float']['output']
  /** Number of marketing-qualified leads (uppercase alias of mqls). */
  MQLs: Scalars['Int']['output']
  /** Return on investment: production relative to spend. */
  ROI: Scalars['Float']['output']
  /** Total number of appointments in the period. */
  appointments: Scalars['Int']['output']
  /** Time bucket label this row covers (e.g. a date or period key). */
  bucket: Scalars['String']['output']
  /** Total marketing budget for the period, in dollars. */
  budget: Scalars['Float']['output']
  /** Per-channel breakdown of this row's metrics. */
  byChannel?: Maybe<Array<ChannelBreakdownEntry>>
  /** Number of leads marked closed-lost. */
  closedLost: Scalars['Int']['output']
  /** Number of leads marked closed-won. */
  closedWon: Scalars['Int']['output']
  /** Cost per lead for this row, in dollars. */
  cpls: Scalars['Float']['output']
  /** Number of leads marked disqualified. */
  disqualified: Scalars['Int']['output']
  /** Facebook/Meta ad spend for the period, in dollars. */
  facebookSpend: Scalars['Float']['output']
  /** Google ad spend for the period, in dollars. */
  googleSpend: Scalars['Float']['output']
  /** Incremental cost per lead for this row, in dollars. */
  iCPL: Scalars['Float']['output']
  /** Incremental cost per qualified lead for this row, in dollars. */
  iCPQL: Scalars['Float']['output']
  /** Goal for number of leads in the period. */
  leadGoal: Scalars['Int']['output']
  /** Total number of leads in the period. */
  leads: Scalars['Int']['output']
  /** Breakdown of leads by the first activity type that created them. */
  leadsByFirstActivityType?: Maybe<Array<MarketingLeadsByType>>
  /** Number of leads that reached the closed-lost stage. */
  leadsClosedLost: Scalars['Int']['output']
  /** Number of leads that reached the closed-won stage. */
  leadsClosedWon: Scalars['Int']['output']
  /** Number of leads currently in progress. */
  leadsInProgress: Scalars['Int']['output']
  /** Number of leads currently needing action. */
  leadsNeedsAction: Scalars['Int']['output']
  /** Number of leads currently scheduled. */
  leadsScheduled: Scalars['Int']['output']
  /** Location this row is scoped to, when broken out by location. */
  locationId?: Maybe<Scalars['String']['output']>
  /** Number of marketing-qualified leads (lowercase alias of MQLs). */
  mqls: Scalars['Int']['output']
  /** Goal for number of new patients in the period. */
  patientGoal: Scalars['Int']['output']
  /** Total number of new patients in the period. */
  patients: Scalars['Int']['output']
  /** Realized production (completed revenue) attributed to marketing, in dollars. */
  production: Scalars['Float']['output']
  /** Number of leads marked qualified. */
  qualified: Scalars['Int']['output']
  /** Return on investment for this row. */
  roi: Scalars['Float']['output']
  /** Share of leads that became scheduled, as a rate. */
  scheduleRate: Scalars['Float']['output']
  /** Number of leads marked scheduled. */
  scheduled: Scalars['Int']['output']
  /** Scheduled (not yet completed) production attributed to marketing, in dollars. */
  scheduledProduction: Scalars['Float']['output']
  /** Target (budgeted) spend for the period, in dollars. */
  targetSpend: Scalars['Float']['output']
  /** Workspace this row is scoped to, when broken out by workspace. */
  workspaceId?: Maybe<Scalars['String']['output']>
  /** Year-month (YYYY-MM) this row covers, when bucketed monthly. */
  yearMonth?: Maybe<Scalars['String']['output']>
}

export type Message = {
  __typename?: 'Message'
  /** ID of the AI workflow that produced this message. */
  aiWorkflowId?: Maybe<Scalars['String']['output']>
  /** Name of the AI workflow that produced this message. */
  aiWorkflowName?: Maybe<Scalars['String']['output']>
  /** Whether this message has been archived. */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Inline attachments sent with an email message, in attach order. */
  attachments?: Maybe<Array<EmailAttachment>>
  /** Caller ID associated with the message, when available. */
  callerId?: Maybe<Scalars['String']['output']>
  /** Message category: transactional (default) or marketing */
  category?: Maybe<Scalars['String']['output']>
  /** Delivery channel: email, sms, or rcs (defaults to sms). */
  channel: Scalars['String']['output']
  /** Contact this message is associated with. */
  contactId?: Maybe<Scalars['String']['output']>
  /** When this message record was created (draft/arrival time). */
  createdDate: Scalars['DateTime']['output']
  /** Computed direction: inbound (contact-initiated) or outbound (sent by user/agent/workflow) */
  direction?: Maybe<Scalars['String']['output']>
  /** Provider error code on failure */
  errorCode?: Maybe<Scalars['String']['output']>
  /** Human-readable delivery failure reason */
  errorMessage?: Maybe<Scalars['String']['output']>
  /** Sender contact point (phone number or email address). */
  from: Scalars['String']['output']
  /** From display name for email messages. */
  fromName?: Maybe<Scalars['String']['output']>
  /** Sanitized HTML body for email messages. */
  htmlBody?: Maybe<Scalars['String']['output']>
  /** Unique identifier for the message. */
  id: Scalars['ID']['output']
  /** S3 object keys for attached images */
  images?: Maybe<Array<Scalars['String']['output']>>
  /** Whether this message was sent by the AI agent. */
  isAgent?: Maybe<Scalars['Boolean']['output']>
  /** True only for the initial outbound message sent when an AI workflow is triggered. Undefined for all other messages. */
  isInitialMessage?: Maybe<Scalars['Boolean']['output']>
  /** Location this message is associated with. */
  locationId: Scalars['String']['output']
  /** Organization that owns this message (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Messaging provider: twilio, callrail, or aws-messaging */
  provider?: Maybe<Scalars['String']['output']>
  /** Provider message ID */
  providerMessageId?: Maybe<Scalars['String']['output']>
  /** Whether this message has been read. */
  read?: Maybe<Scalars['Boolean']['output']>
  /** For an inbound (patient) text: minutes between this text and its first outbound reply. Set once, when the first reply enters the conversation. Powers SMS Ops unanswered-thread and reply-time metrics. */
  replyDelay?: Maybe<Scalars['Float']['output']>
  /** For an inbound (patient) text: who sent its first reply — 'Agent' (AI or workflow) or 'User' (staff). Set together with replyDelay. */
  replyFrom?: Maybe<Scalars['String']['output']>
  /** Reply-To address for email messages. */
  replyTo?: Maybe<Scalars['String']['output']>
  /** When set, this message is held and dispatched by the scheduled-send poller at/after this instant, instead of being sent immediately. At send time the instant is checked against the recipient location's quiet hours; if it falls inside them, sendDate is bumped forward to the next legal send time (08:00 local) and the message stays held until then. */
  sendDate?: Maybe<Scalars['DateTime']['output']>
  /** User who sent this message, for staff-initiated outbound messages. */
  sentByUserId?: Maybe<Scalars['String']['output']>
  /** When this message was actually dispatched to the provider (outbound). Unlike createdDate, which is draft-creation time, this is the real send instant — for a held/scheduled message the two differ. Unset on inbound (createdDate is arrival time) and on un-sent drafts. */
  sentDate?: Maybe<Scalars['DateTime']['output']>
  /** Who created this message, stamped at create time: patient (inbound), staff (user send), agent (AI SMS agent reply), workflow (automation send), voiceAgent (voice agent send_sms tool), or external (CallRail dashboard send). Set on new rows only; old rows are null. */
  source?: Maybe<Scalars['String']['output']>
  /** Delivery status from provider (accepted, queued, sending, sent, delivered, undelivered, failed, canceled) */
  status?: Maybe<Scalars['String']['output']>
  /** Subject line for email messages. */
  subject?: Maybe<Scalars['String']['output']>
  /** Plain-text body of the message. */
  text: Scalars['String']['output']
  /** Conversation thread this message belongs to. */
  threadId?: Maybe<Scalars['String']['output']>
  /** Recipient contact point (phone number or email address). */
  to: Scalars['String']['output']
  /** When this message record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** ID of the workflow run that produced this message (loop guard for message_created triggers) */
  workflowRunId?: Maybe<Scalars['String']['output']>
  /** Workspace this message belongs to. */
  workspaceId: Scalars['String']['output']
}

export enum MessageCategory {
  Marketing = 'MARKETING',
  Transactional = 'TRANSACTIONAL',
}

export type MessageImageInput = {
  /** Base64-encoded image data */
  base64: Scalars['String']['input']
  /** MIME content type (e.g., image/jpeg) */
  contentType: Scalars['String']['input']
  /** Filename with extension */
  filename: Scalars['String']['input']
}

export type MessageListResult = {
  __typename?: 'MessageListResult'
  /** Results for the current page. */
  hits: Array<Message>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type MonthlyBucket = {
  __typename?: 'MonthlyBucket'
  /** New patient counts for this month broken down by channel. */
  byChannel: Array<ChannelCount>
  /** Number of new patients in this month. */
  count: Scalars['Int']['output']
  /** Month this count covers, as YYYY-MM. */
  month: Scalars['String']['output']
}

export type Mutation = {
  __typename?: 'Mutation'
  addActivityTags: Activity
  /** Add a note to a location. Super user only. */
  addLocationNote: OpsLocation
  addTags: Contact
  addToPipeline: Contact
  addWorkspaceOrgTag: Workspace
  archiveMessage: Message
  /** Proxy a request to the Ascend API for a given location. Super user only. All calls are logged for audit. */
  ascendRequest: AscendRequestResult
  bindLocationElevenLabsAgent: Location
  cacheDelete?: Maybe<Scalars['JSON']['output']>
  cacheFlush: CommandResult
  cacheSearch?: Maybe<Scalars['JSON']['output']>
  /** Cancel a paperwork send. The link stops working. Rejected once the packet is complete. */
  cancelPaperwork: Paperwork
  cancelScheduledMessage: Message
  cancelWorkflowRun: WorkflowRun
  /** Compare PMS data with Trackable. Auto-detects connector type. Super user only. */
  compareData: DataCompareResult
  /** Record the practice's confirmation that it holds texting consent for the people it texts. Required before a form-triggered texting workflow can go active. Overwrites any prior confirmation with the current user and time. */
  confirmMarketingConsent: Workspace
  createAction: Action
  createAdPlatformMapping: AdPlatformMapping
  createAvailability: Availability
  createBudget: BudgetResult
  createCallData: CallData
  createCdtCodeMapping: CdtCodeMapping
  createChannelMapping: ChannelMappingV2
  createCommLog: CommLog
  createCommLogWritebackRule: CommLogWritebackRule
  createContact: Contact
  createCustomPage: CustomPage
  createDni: Dni
  createElevenLabsDeployment: ElevenLabsDeployment
  createExtractionPrompt: ExtractionPrompt
  createFeatureToggle: FeatureToggle
  createFileImport: FileImport
  createFollowUp: FollowUpGql
  createFormFieldMapping: FormFieldMapping
  createFormTemplate: FormTemplate
  createImport: Import
  createIvrConfig: IvrConfigResult
  createList: List
  createListItem: ListItem
  createLocation: Location
  createNote: Activity
  createNoteTemplate: NoteTemplate
  /** Create a location-scoped communication opt-out. Existence of the returned record means the key is opted out; use deleteOptOut to opt it back in. */
  createOptOut: OptOut
  /** Send a paperwork template to a patient. Assembles a frozen snapshot, mints a private link, and returns the Paperwork (its token yields the link). */
  createPaperwork: Paperwork
  createPaperworkTemplate: PaperworkTemplate
  createPhoneNumber: PhoneNumber
  createPipeline: Pipeline
  createPmsReferralMapping: PmsReferralMapping
  createPrompt: Prompt
  createPromptDraft: PromptDraft
  createPromptFragment: PromptFragment
  createRegistrationProfile: RegistrationProfile
  createRole: Role
  createScorecard: Scorecard
  createSendingDomain: SendingDomain
  createSmsTemplate: SmsTemplate
  /** Create a new staff member. */
  createStaff: StaffResult
  createStoredCredential: StoredCredential
  createTagColor: TagColor
  createTask: Task
  createTaskTemplate: TaskTemplate
  createThread: Thread
  createUser: User
  createUtmAlias: UtmAlias
  createWorkflow: Workflow
  createWorkspace: Workspace
  createWorkspaceInvite: WorkspaceInvite
  deleteAction: Scalars['Boolean']['output']
  deleteActivity: Scalars['Boolean']['output']
  deleteAdPlatformMapping: Scalars['Boolean']['output']
  deleteBudget: BudgetResult
  /** Soft delete a call by archiving it. */
  deleteCall: Scalars['Boolean']['output']
  deleteCallData: Scalars['Boolean']['output']
  deleteCdtCodeMapping: Scalars['Boolean']['output']
  deleteChannelMapping: Scalars['Boolean']['output']
  deleteCommLogWritebackRule: Scalars['Boolean']['output']
  deleteCustomPage: Scalars['Boolean']['output']
  deleteDni: Scalars['Boolean']['output']
  deleteFeatureToggle: Scalars['Boolean']['output']
  deleteFileImport: Scalars['Boolean']['output']
  deleteFollowUp: Scalars['Boolean']['output']
  deleteFormFieldMapping: Scalars['Boolean']['output']
  deleteFormTemplate: Scalars['Boolean']['output']
  deleteList: Scalars['Boolean']['output']
  deleteListItem: Scalars['Boolean']['output']
  deleteLocation: Scalars['Boolean']['output']
  deleteLocationEmailIdentity: Scalars['Boolean']['output']
  /** Delete a note from a location by index. Super user only. */
  deleteLocationNote: OpsLocation
  deleteNoteTemplate: Scalars['Boolean']['output']
  /** Delete an OptOut record. This is the opt-in path: deleting the record clears the opt-out and allows communication again for that key/location/channel. */
  deleteOptOut: Scalars['Boolean']['output']
  deletePaperworkTemplate: Scalars['Boolean']['output']
  deletePipeline: Scalars['Boolean']['output']
  deletePromptDraft: Scalars['Boolean']['output']
  deleteProviderAvailability: Scalars['Boolean']['output']
  deleteRole: Scalars['Boolean']['output']
  deleteSendingDomain: Scalars['Boolean']['output']
  deleteSmsTemplate: Scalars['Boolean']['output']
  /** Delete a staff member. */
  deleteStaff: Scalars['Boolean']['output']
  deleteStoredCredential: Scalars['Boolean']['output']
  deleteTagColor: Scalars['Boolean']['output']
  deleteTask: Scalars['Boolean']['output']
  deleteTaskTemplate: Scalars['Boolean']['output']
  deleteUser: Scalars['Boolean']['output']
  deleteUtmAlias: Scalars['Boolean']['output']
  deleteWorkflow: Scalars['Boolean']['output']
  deleteWorkspace: Scalars['Boolean']['output']
  deleteWorkspaceInvite: Scalars['Boolean']['output']
  deployElevenLabsPrompt: ElevenLabsDeployment
  /** Start a new editable draft from a published form version. Copies its content under the same formId with the next version number. Question ids are preserved so mappings survive. */
  draftNextFormTemplateVersion: FormTemplate
  /** Enroll a contact in a workflow, bypassing trigger filter evaluation. Optionally record the source record (appointment, call, or form) the enrollment matched so the run renders that source's fields and branches on them like a trigger-started run. */
  enroll: Workflow
  /** Impersonate another user. Only super users can perform this action. */
  impersonateUser: AuthPayload
  /** Initiate an outbound click-to-call via CallRail. */
  initiateCall: InitiateCallResult
  /** Proxy a request to Kolla's API for a given location. Super user only. All calls are logged for audit. */
  kollaRequest: KollaRequestResult
  linkMessageToContact: Message
  /** Email/password login. Skips OTP if authenticated within 24h, otherwise sends OTP. */
  login: LoginPayload
  /** Google OAuth login with auth code (redirect flow). Exchanges code for ID token. */
  loginWithGoogleCode: LoginPayload
  /** Invalidate current JWT. */
  logout: Scalars['Boolean']['output']
  markAllNotificationsRead: NotificationCommandResult
  markMessageRead: Message
  mergeContacts: Contact
  /** Set a user's type (super or standard). Super user only. Restores the legacy super-only control the public updateUser mutation lacks. */
  opsSetUserType: OpsUserType
  /** Update voice-agent compiler config for a location (addendum, exam/pediatric toggles, tools). Super user only. */
  opsUpdateAIAgentCompilerConfig: AiAgentConfiguration
  /** Update voice agent configuration for a location. Service token or super user required. */
  opsUpdateAIAgentConfiguration: AiAgentConfiguration
  opsUpdateAIAgentLocationConfig: AiAgentConfiguration
  /** Ping Kolla connector health. Super user only. */
  pingKollaConnector: PingResult
  promotePromptDraft: Prompt
  /** Freeze the given draft version as published. The published version never changes after this. */
  publishFormTemplate: FormTemplate
  purchasePhoneNumber: PhoneNumber
  reassignActivity: Activity
  recalculateContact: Contact
  releasePhoneNumber: PhoneNumber
  /** Re-run contact matching for an activity. */
  rematchActivity: Activity
  removeActivityTags: Activity
  removeIntegration: Scalars['Boolean']['output']
  removeLocationIntegration: IntegrationSaveResult
  removeTags: Contact
  removeWorkspaceOrgTag: Workspace
  /** Reissue the link on a paperwork send: mints a fresh token, resets the expiry, and returns it to "sent". Rejected once the packet is complete. */
  resendPaperwork: Paperwork
  resetNotificationUnseen: NotificationCommandResult
  /** Send a password reset email. Always returns true to prevent email enumeration. */
  resetPassword: Scalars['Boolean']['output']
  saveAscendIntegration: IntegrationSaveResult
  saveCallRailIntegration: IntegrationSaveResult
  saveCarestackIntegration: IntegrationSaveResult
  saveFacebookAdsIntegration: IntegrationSaveResult
  saveGravityFormsIntegration: IntegrationSaveResult
  saveKollaIntegration: IntegrationSaveResult
  saveRingCentralIntegration: IntegrationSaveResult
  saveSikkaIntegration: IntegrationSaveResult
  saveTwilioIntegration: IntegrationSaveResult
  /** Save user settings by key as JSON string */
  saveUserSettings: UserSetting
  saveWebflowFormsIntegration: IntegrationSaveResult
  sendContactEmail: Message
  sendSms: Message
  setLocationEmailIdentity: LocationEmailIdentity
  /** Set password during account activation. Validates token, sets password, and returns auth payload. */
  setPassword: AuthPayload
  setWorkflowCategory: Workflow
  setupIntegration: IntegrationV2
  /** Submit the answers for one form in a paperwork packet. No login. A blocked link saves nothing and returns its state and the practice that sent it. When the last form is submitted the packet becomes complete and the link stops working. */
  submitPaperworkForm: PublicPaperwork
  /** Switch workspace (and optionally org for super users). Returns new JWT. */
  switchWorkspace: AuthPayload
  syncProviders: CommandResult
  syncSchedules: CommandResult
  threadEngageAgent: Thread
  /** Manually trigger a multi-step workflow on a specific contact, bypassing filter evaluation. */
  triggerWorkflowOnContact: TriggerWorkflowOnContactResult
  unbindLocationElevenLabsAgent: Location
  updateAIAgentLocationConfig: AiAgentOverview
  updateAction: Action
  updateAdPlatformMapping: AdPlatformMapping
  updateAppointmentType: AppointmentType
  updateAvailability: Availability
  updateBlockoutNotes: Location
  updateBudget: BudgetResult
  updateCall: Call
  updateCallData: CallData
  updateCdtCodeMapping: CdtCodeMapping
  updateChannelMapping: ChannelMappingV2
  updateCommLogWritebackRule: CommLogWritebackRule
  updateContact: Contact
  updateCustomPage: CustomPage
  updateDni: Dni
  updateExtractionPrompt: ExtractionPrompt
  updateFacebookLeadPages: Location
  updateFeatureToggle: FeatureToggle
  updateFollowUp: FollowUpGql
  updateFormFieldMapping: FormFieldMapping
  /** Update a form. A draft is edited in place. Editing a published form is rejected — publish mints new immutable versions; create the next draft explicitly. */
  updateFormTemplate: FormTemplate
  updateIvrConfig: IvrConfigResult
  updateList: List
  updateListItem: ListItem
  updateLocation: Location
  updateMe: User
  updateMilestone: Activity
  updateNote: Activity
  updateNoteTemplate: NoteTemplate
  updateNotification: Notification
  /** Update a location-scoped communication opt-out. To clear an opt-out and allow communication again, call deleteOptOut instead. */
  updateOptOut: OptOut
  updatePaperworkTemplate: PaperworkTemplate
  updatePhoneNumber: PhoneNumber
  updatePipeline: Pipeline
  updatePmsReferralMapping: PmsReferralMapping
  updatePrompt: Prompt
  updatePromptFragment: PromptFragment
  updateProvider: Provider
  updateRegistrationProfile: RegistrationProfile
  updateRole: Role
  updateSchedulingConfiguration: SchedulingConfiguration
  updateScorecard: Scorecard
  updateSmsTemplate: SmsTemplate
  /** Update an existing staff member. */
  updateStaff: StaffResult
  updateStoredCredential: StoredCredential
  /** Set the current super user's notification settings. Super user only. */
  updateSuperNotifications: SuperNotificationSettings
  updateTagColor: TagColor
  updateTask: Task
  updateTaskTemplate: TaskTemplate
  updateThread: Thread
  updateUser: User
  updateUserNotificationSettings: NotificationCommandResult
  updateUtmAlias: UtmAlias
  updateWorkflow: Workflow
  updateWorkspace: Workspace
  updateWorkspaceInvite: WorkspaceInvite
  /** Verify OTP code and return JWT. */
  verifyOtp: AuthPayload
  verifySendingDomain: SendingDomain
}

export type MutationAddActivityTagsArgs = {
  id: Scalars['ID']['input']
  tags: Array<Scalars['String']['input']>
}

export type MutationAddLocationNoteArgs = {
  locationId: Scalars['ID']['input']
  text: Scalars['String']['input']
}

export type MutationAddTagsArgs = {
  id: Scalars['ID']['input']
  tags: Array<Scalars['String']['input']>
}

export type MutationAddToPipelineArgs = {
  id: Scalars['ID']['input']
  pipeline: ContactPipelineInput
}

export type MutationAddWorkspaceOrgTagArgs = {
  id: Scalars['ID']['input']
  tag: Scalars['String']['input']
}

export type MutationArchiveMessageArgs = {
  archived: Scalars['Boolean']['input']
  id: Scalars['ID']['input']
}

export type MutationAscendRequestArgs = {
  input: AscendRequestInput
}

export type MutationBindLocationElevenLabsAgentArgs = {
  elevenLabsAgentId: Scalars['String']['input']
  locationId: Scalars['ID']['input']
}

export type MutationCacheDeleteArgs = {
  pattern: Scalars['String']['input']
}

export type MutationCacheFlushArgs = {
  pattern: Scalars['String']['input']
}

export type MutationCacheSearchArgs = {
  pattern: Scalars['String']['input']
}

export type MutationCancelPaperworkArgs = {
  id: Scalars['ID']['input']
}

export type MutationCancelScheduledMessageArgs = {
  id: Scalars['ID']['input']
}

export type MutationCancelWorkflowRunArgs = {
  id: Scalars['ID']['input']
}

export type MutationCompareDataArgs = {
  locationId: Scalars['ID']['input']
}

export type MutationCreateActionArgs = {
  input: CreateActionInput
}

export type MutationCreateAdPlatformMappingArgs = {
  input: CreateAdPlatformMappingInput
}

export type MutationCreateAvailabilityArgs = {
  input: CreateAvailabilityInput
}

export type MutationCreateBudgetArgs = {
  input: CreateBudgetInput
}

export type MutationCreateCallDataArgs = {
  input: CreateCallDataInput
}

export type MutationCreateCdtCodeMappingArgs = {
  input: CreateCdtCodeMappingInput
}

export type MutationCreateChannelMappingArgs = {
  input: CreateChannelMappingInput
}

export type MutationCreateCommLogArgs = {
  input: CreateCommLogInput
}

export type MutationCreateCommLogWritebackRuleArgs = {
  input: CreateCommLogWritebackRuleInput
}

export type MutationCreateContactArgs = {
  input: CreateContactInput
}

export type MutationCreateCustomPageArgs = {
  input: CreateCustomPageInput
}

export type MutationCreateDniArgs = {
  input: CreateDniInput
}

export type MutationCreateElevenLabsDeploymentArgs = {
  input: CreateElevenLabsDeploymentInput
}

export type MutationCreateExtractionPromptArgs = {
  input: CreateExtractionPromptInput
}

export type MutationCreateFeatureToggleArgs = {
  input: CreateFeatureToggleInput
}

export type MutationCreateFileImportArgs = {
  input: CreateFileImportInput
}

export type MutationCreateFollowUpArgs = {
  input: CreateFollowUpInput
}

export type MutationCreateFormFieldMappingArgs = {
  input: CreateFormFieldMappingInput
}

export type MutationCreateFormTemplateArgs = {
  input: CreateFormTemplateInput
}

export type MutationCreateImportArgs = {
  input: CreateImportInput
}

export type MutationCreateIvrConfigArgs = {
  input: SaveIvrConfigInput
}

export type MutationCreateListArgs = {
  input: CreateListInput
}

export type MutationCreateListItemArgs = {
  input: CreateListItemInput
}

export type MutationCreateLocationArgs = {
  input: CreateLocationInput
}

export type MutationCreateNoteArgs = {
  input: CreateActivityInput
}

export type MutationCreateNoteTemplateArgs = {
  input: CreateNoteTemplateInput
}

export type MutationCreateOptOutArgs = {
  input: CreateOptOutInput
}

export type MutationCreatePaperworkArgs = {
  input: CreatePaperworkInput
}

export type MutationCreatePaperworkTemplateArgs = {
  input: CreatePaperworkTemplateInput
}

export type MutationCreatePhoneNumberArgs = {
  input: CreatePhoneNumberInput
}

export type MutationCreatePipelineArgs = {
  input: CreatePipelineInput
}

export type MutationCreatePmsReferralMappingArgs = {
  input: CreatePmsReferralMappingInput
}

export type MutationCreatePromptArgs = {
  input: CreatePromptInput
}

export type MutationCreatePromptDraftArgs = {
  input: CreatePromptDraftInput
}

export type MutationCreatePromptFragmentArgs = {
  input: CreatePromptFragmentInput
}

export type MutationCreateRegistrationProfileArgs = {
  input: CreateRegistrationProfileInput
}

export type MutationCreateRoleArgs = {
  input: CreateRoleInput
}

export type MutationCreateScorecardArgs = {
  input: CreateScorecardInput
}

export type MutationCreateSendingDomainArgs = {
  input: CreateSendingDomainInput
}

export type MutationCreateSmsTemplateArgs = {
  input: CreateSmsTemplateInput
}

export type MutationCreateStaffArgs = {
  input: CreateStaffInput
}

export type MutationCreateStoredCredentialArgs = {
  input: CreateStoredCredentialInput
  targetWorkspaceId: Scalars['ID']['input']
}

export type MutationCreateTagColorArgs = {
  input: CreateTagColorInput
}

export type MutationCreateTaskArgs = {
  input: CreateTaskInput
}

export type MutationCreateTaskTemplateArgs = {
  input: CreateTaskTemplateInput
}

export type MutationCreateThreadArgs = {
  input: CreateThreadInput
}

export type MutationCreateUserArgs = {
  input: CreateUserInput
}

export type MutationCreateUtmAliasArgs = {
  input: CreateUtmAliasInput
}

export type MutationCreateWorkflowArgs = {
  input: CreateWorkflowInput
}

export type MutationCreateWorkspaceArgs = {
  input: CreateWorkspaceInput
}

export type MutationCreateWorkspaceInviteArgs = {
  input: CreateWorkspaceInviteInput
}

export type MutationDeleteActionArgs = {
  actionId: Scalars['ID']['input']
}

export type MutationDeleteActivityArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteAdPlatformMappingArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteBudgetArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteCallArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteCallDataArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteCdtCodeMappingArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteChannelMappingArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteCommLogWritebackRuleArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteCustomPageArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteDniArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteFeatureToggleArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteFileImportArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteFollowUpArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteFormFieldMappingArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteFormTemplateArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteListArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteListItemArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteLocationArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteLocationEmailIdentityArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteLocationNoteArgs = {
  locationId: Scalars['ID']['input']
  noteIndex: Scalars['Int']['input']
}

export type MutationDeleteNoteTemplateArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteOptOutArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeletePaperworkTemplateArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeletePipelineArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeletePromptDraftArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteProviderAvailabilityArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteRoleArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteSendingDomainArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteSmsTemplateArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteStaffArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteStoredCredentialArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteTagColorArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteTaskArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteTaskTemplateArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteUtmAliasArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteWorkflowArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteWorkspaceArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteWorkspaceInviteArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeployElevenLabsPromptArgs = {
  deploymentId: Scalars['ID']['input']
}

export type MutationDraftNextFormTemplateVersionArgs = {
  id: Scalars['ID']['input']
}

export type MutationEnrollArgs = {
  contactId: Scalars['ID']['input']
  sourceId?: InputMaybe<Scalars['ID']['input']>
  sourceType?: InputMaybe<Scalars['String']['input']>
  workflowId: Scalars['ID']['input']
}

export type MutationImpersonateUserArgs = {
  userId: Scalars['String']['input']
}

export type MutationInitiateCallArgs = {
  input: InitiateCallInput
}

export type MutationKollaRequestArgs = {
  input: KollaRequestInput
}

export type MutationLinkMessageToContactArgs = {
  contactId: Scalars['String']['input']
  id: Scalars['ID']['input']
}

export type MutationLoginArgs = {
  clientType: ClientType
  email: Scalars['String']['input']
  password: Scalars['String']['input']
}

export type MutationLoginWithGoogleCodeArgs = {
  clientType: ClientType
  code: Scalars['String']['input']
  redirectUri: Scalars['String']['input']
}

export type MutationMarkMessageReadArgs = {
  id: Scalars['ID']['input']
  read: Scalars['Boolean']['input']
}

export type MutationMergeContactsArgs = {
  leftId: Scalars['ID']['input']
  rightId: Scalars['ID']['input']
}

export type MutationOpsSetUserTypeArgs = {
  type: Scalars['String']['input']
  userId: Scalars['ID']['input']
}

export type MutationOpsUpdateAiAgentCompilerConfigArgs = {
  input: UpdateAiAgentCompilerConfigInput
  locationId: Scalars['ID']['input']
}

export type MutationOpsUpdateAiAgentConfigurationArgs = {
  input: OpsUpdateAiAgentLocationConfigInput
  locationId: Scalars['ID']['input']
}

export type MutationOpsUpdateAiAgentLocationConfigArgs = {
  input: OpsUpdateAiAgentLocationConfigInput
  locationId: Scalars['ID']['input']
}

export type MutationPingKollaConnectorArgs = {
  locationId: Scalars['ID']['input']
}

export type MutationPromotePromptDraftArgs = {
  changeSummary?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

export type MutationPublishFormTemplateArgs = {
  id: Scalars['ID']['input']
}

export type MutationPurchasePhoneNumberArgs = {
  input: PurchasePhoneNumberInput
}

export type MutationReassignActivityArgs = {
  id: Scalars['ID']['input']
  input: ReassignActivityInput
}

export type MutationRecalculateContactArgs = {
  id: Scalars['ID']['input']
}

export type MutationReleasePhoneNumberArgs = {
  id: Scalars['ID']['input']
}

export type MutationRematchActivityArgs = {
  contactId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

export type MutationRemoveActivityTagsArgs = {
  id: Scalars['ID']['input']
  tags: Array<Scalars['String']['input']>
}

export type MutationRemoveIntegrationArgs = {
  integration: Scalars['String']['input']
}

export type MutationRemoveLocationIntegrationArgs = {
  integration: Scalars['String']['input']
  locationId: Scalars['ID']['input']
}

export type MutationRemoveTagsArgs = {
  id: Scalars['ID']['input']
  tags: Array<Scalars['String']['input']>
}

export type MutationRemoveWorkspaceOrgTagArgs = {
  id: Scalars['ID']['input']
  tag: Scalars['String']['input']
}

export type MutationResendPaperworkArgs = {
  expiresInDays?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['ID']['input']
}

export type MutationResetPasswordArgs = {
  email: Scalars['String']['input']
}

export type MutationSaveAscendIntegrationArgs = {
  ascendLocationId: Scalars['String']['input']
  locationId: Scalars['ID']['input']
}

export type MutationSaveCallRailIntegrationArgs = {
  backfillStartDate?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['String']['input']
  isNew?: InputMaybe<Scalars['Boolean']['input']>
  locationId: Scalars['ID']['input']
}

export type MutationSaveCarestackIntegrationArgs = {
  locationId: Scalars['ID']['input']
  selection: Scalars['String']['input']
}

export type MutationSaveFacebookAdsIntegrationArgs = {
  account?: InputMaybe<Scalars['String']['input']>
  campaigns?: InputMaybe<Array<FacebookAdsCampaignInput>>
  isNew?: InputMaybe<Scalars['Boolean']['input']>
  locationId: Scalars['ID']['input']
}

export type MutationSaveGravityFormsIntegrationArgs = {
  gravityFormsKey: Scalars['String']['input']
  isNew?: InputMaybe<Scalars['Boolean']['input']>
  locationId: Scalars['ID']['input']
}

export type MutationSaveKollaIntegrationArgs = {
  kollaConnectorId?: InputMaybe<Scalars['String']['input']>
  kollaConsumerId: Scalars['String']['input']
  kollaPracticeId?: InputMaybe<Scalars['String']['input']>
  locationId: Scalars['ID']['input']
}

export type MutationSaveRingCentralIntegrationArgs = {
  isNew?: InputMaybe<Scalars['Boolean']['input']>
  locationId: Scalars['ID']['input']
  phoneNumbers: Array<Scalars['String']['input']>
}

export type MutationSaveSikkaIntegrationArgs = {
  locationId: Scalars['ID']['input']
  selection: Scalars['String']['input']
}

export type MutationSaveTwilioIntegrationArgs = {
  aiSelection?: InputMaybe<Scalars['String']['input']>
  aiTestingSelection?: InputMaybe<Scalars['String']['input']>
  isNew?: InputMaybe<Scalars['Boolean']['input']>
  locationId: Scalars['ID']['input']
  poolSelection?: InputMaybe<Array<TwilioNumberInput>>
}

export type MutationSaveUserSettingsArgs = {
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationSaveWebflowFormsIntegrationArgs = {
  isNew?: InputMaybe<Scalars['Boolean']['input']>
  locationId: Scalars['ID']['input']
  webflowFormsKey: Scalars['String']['input']
}

export type MutationSendContactEmailArgs = {
  input: SendContactEmailInput
}

export type MutationSendSmsArgs = {
  input: SendMessageInput
}

export type MutationSetLocationEmailIdentityArgs = {
  input: SetLocationEmailIdentityInput
}

export type MutationSetPasswordArgs = {
  clientType: ClientType
  email: Scalars['String']['input']
  password: Scalars['String']['input']
  token: Scalars['String']['input']
}

export type MutationSetWorkflowCategoryArgs = {
  category: MessageCategory
  id: Scalars['ID']['input']
}

export type MutationSetupIntegrationArgs = {
  input: SetupIntegrationInput
  integration: Scalars['String']['input']
}

export type MutationSubmitPaperworkFormArgs = {
  answers: Array<PublicAnswerInput>
  formId: Scalars['ID']['input']
  formVersion: Scalars['Int']['input']
  token: Scalars['String']['input']
}

export type MutationSwitchWorkspaceArgs = {
  targetOrgId?: InputMaybe<Scalars['String']['input']>
  targetWorkspaceId?: InputMaybe<Scalars['String']['input']>
}

export type MutationSyncProvidersArgs = {
  locationId: Scalars['ID']['input']
}

export type MutationSyncSchedulesArgs = {
  locationId: Scalars['ID']['input']
}

export type MutationThreadEngageAgentArgs = {
  contactId?: InputMaybe<Scalars['ID']['input']>
  threadId: Scalars['ID']['input']
}

export type MutationTriggerWorkflowOnContactArgs = {
  contactId: Scalars['ID']['input']
  workflowId: Scalars['ID']['input']
}

export type MutationUnbindLocationElevenLabsAgentArgs = {
  locationId: Scalars['ID']['input']
}

export type MutationUpdateAiAgentLocationConfigArgs = {
  input: UpdateAiAgentLocationConfigInput
  locationId: Scalars['ID']['input']
}

export type MutationUpdateActionArgs = {
  actionId: Scalars['ID']['input']
  input: UpdateActionInput
}

export type MutationUpdateAdPlatformMappingArgs = {
  id: Scalars['ID']['input']
  input: UpdateAdPlatformMappingInput
}

export type MutationUpdateAppointmentTypeArgs = {
  id: Scalars['ID']['input']
  input: UpdateAppointmentTypeInput
}

export type MutationUpdateAvailabilityArgs = {
  id: Scalars['ID']['input']
  input: UpdateAvailabilityInput
}

export type MutationUpdateBlockoutNotesArgs = {
  locationId: Scalars['ID']['input']
  notes: Array<BlockoutNoteInput>
}

export type MutationUpdateBudgetArgs = {
  id: Scalars['ID']['input']
  input: UpdateBudgetInput
}

export type MutationUpdateCallArgs = {
  id: Scalars['ID']['input']
  input: UpdateCallInput
}

export type MutationUpdateCallDataArgs = {
  id: Scalars['ID']['input']
  input: UpdateCallDataInput
}

export type MutationUpdateCdtCodeMappingArgs = {
  id: Scalars['ID']['input']
  input: UpdateCdtCodeMappingInput
}

export type MutationUpdateChannelMappingArgs = {
  id: Scalars['ID']['input']
  input: UpdateChannelMappingInput
}

export type MutationUpdateCommLogWritebackRuleArgs = {
  id: Scalars['ID']['input']
  input: UpdateCommLogWritebackRuleInput
}

export type MutationUpdateContactArgs = {
  id: Scalars['ID']['input']
  input: UpdateContactInput
}

export type MutationUpdateCustomPageArgs = {
  id: Scalars['ID']['input']
  input: UpdateCustomPageInput
}

export type MutationUpdateDniArgs = {
  id: Scalars['ID']['input']
  input: UpdateDniInput
}

export type MutationUpdateExtractionPromptArgs = {
  input: UpdateExtractionPromptInput
  slug: Scalars['String']['input']
}

export type MutationUpdateFacebookLeadPagesArgs = {
  locationId: Scalars['ID']['input']
  pageIds: Array<Scalars['String']['input']>
}

export type MutationUpdateFeatureToggleArgs = {
  id: Scalars['ID']['input']
  input: UpdateFeatureToggleInput
}

export type MutationUpdateFollowUpArgs = {
  id: Scalars['ID']['input']
  input: UpdateFollowUpInput
}

export type MutationUpdateFormFieldMappingArgs = {
  id: Scalars['ID']['input']
  input: UpdateFormFieldMappingInput
}

export type MutationUpdateFormTemplateArgs = {
  id: Scalars['ID']['input']
  input: UpdateFormTemplateInput
}

export type MutationUpdateIvrConfigArgs = {
  input: SaveIvrConfigInput
}

export type MutationUpdateListArgs = {
  id: Scalars['ID']['input']
  input: UpdateListInput
}

export type MutationUpdateListItemArgs = {
  id: Scalars['ID']['input']
  input: UpdateListItemInput
}

export type MutationUpdateLocationArgs = {
  id: Scalars['ID']['input']
  input: UpdateLocationInput
}

export type MutationUpdateMeArgs = {
  input: UpdateUserInput
}

export type MutationUpdateMilestoneArgs = {
  id: Scalars['ID']['input']
  input: UpdateMilestoneInput
}

export type MutationUpdateNoteArgs = {
  id: Scalars['ID']['input']
  input: UpdateNoteInput
}

export type MutationUpdateNoteTemplateArgs = {
  id: Scalars['ID']['input']
  input: UpdateNoteTemplateInput
}

export type MutationUpdateNotificationArgs = {
  id: Scalars['ID']['input']
  input: UpdateNotificationInput
}

export type MutationUpdateOptOutArgs = {
  id: Scalars['ID']['input']
  input: UpdateOptOutInput
}

export type MutationUpdatePaperworkTemplateArgs = {
  id: Scalars['ID']['input']
  input: UpdatePaperworkTemplateInput
}

export type MutationUpdatePhoneNumberArgs = {
  id: Scalars['ID']['input']
  input: UpdatePhoneNumberInput
}

export type MutationUpdatePipelineArgs = {
  id: Scalars['ID']['input']
  input: UpdatePipelineInput
}

export type MutationUpdatePmsReferralMappingArgs = {
  id: Scalars['ID']['input']
  input: UpdatePmsReferralMappingInput
}

export type MutationUpdatePromptArgs = {
  id: Scalars['ID']['input']
  input: UpdatePromptInput
}

export type MutationUpdatePromptFragmentArgs = {
  id: Scalars['ID']['input']
  input: UpdatePromptFragmentInput
}

export type MutationUpdateProviderArgs = {
  id: Scalars['ID']['input']
  input: UpdateProviderInput
}

export type MutationUpdateRegistrationProfileArgs = {
  id: Scalars['ID']['input']
  input: UpdateRegistrationProfileInput
}

export type MutationUpdateRoleArgs = {
  id: Scalars['ID']['input']
  input: UpdateRoleInput
}

export type MutationUpdateSchedulingConfigurationArgs = {
  input: UpdateSchedulingConfigurationInput
  locationId: Scalars['ID']['input']
}

export type MutationUpdateScorecardArgs = {
  id: Scalars['ID']['input']
  input: UpdateScorecardInput
}

export type MutationUpdateSmsTemplateArgs = {
  id: Scalars['ID']['input']
  input: UpdateSmsTemplateInput
}

export type MutationUpdateStaffArgs = {
  id: Scalars['ID']['input']
  input: UpdateStaffInput
}

export type MutationUpdateStoredCredentialArgs = {
  id: Scalars['ID']['input']
  input: UpdateStoredCredentialInput
}

export type MutationUpdateSuperNotificationsArgs = {
  input: SuperNotificationSettingsInput
}

export type MutationUpdateTagColorArgs = {
  color: Scalars['String']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateTaskArgs = {
  id: Scalars['ID']['input']
  input: UpdateTaskInput
}

export type MutationUpdateTaskTemplateArgs = {
  id: Scalars['ID']['input']
  input: UpdateTaskTemplateInput
}

export type MutationUpdateThreadArgs = {
  id: Scalars['ID']['input']
  input: UpdateThreadInput
}

export type MutationUpdateUserArgs = {
  id: Scalars['ID']['input']
  input: UpdateUserInput
}

export type MutationUpdateUserNotificationSettingsArgs = {
  input: UserNotificationSettingsInput
  userId: Scalars['ID']['input']
}

export type MutationUpdateUtmAliasArgs = {
  id: Scalars['ID']['input']
  input: UpdateUtmAliasInput
}

export type MutationUpdateWorkflowArgs = {
  id: Scalars['ID']['input']
  input: UpdateWorkflowInput
}

export type MutationUpdateWorkspaceArgs = {
  id: Scalars['ID']['input']
  input: UpdateWorkspaceInput
}

export type MutationUpdateWorkspaceInviteArgs = {
  id: Scalars['ID']['input']
  input: UpdateWorkspaceInviteInput
}

export type MutationVerifyOtpArgs = {
  clientType: ClientType
  code: Scalars['String']['input']
  pendingToken: Scalars['String']['input']
}

export type MutationVerifySendingDomainArgs = {
  id: Scalars['ID']['input']
}

export type NewPatientsLocationRow = {
  __typename?: 'NewPatientsLocationRow'
  /** Average production per new-patient visit, in dollars. */
  averageProductionPerNewPatientVisit: Scalars['Float']['output']
  /** Average time from lead to first appointment, in days. */
  averageTimeToAppointment: Scalars['Float']['output']
  /** Number of broken (missed/cancelled) appointments. */
  brokenAppointmentCount: Scalars['Int']['output']
  /** Time bucket label this row covers. */
  bucket: Scalars['String']['output']
  /** Number of completed new-patient visits. */
  completed: Scalars['Int']['output']
  /** The location this row is for. */
  location?: Maybe<NewPatientsLocationSummary>
  /** Total number of new patients. */
  newPatients: Scalars['Int']['output']
  /** Number of new patients from digital marketing. */
  newPatientsFromDigitalMarketing: Scalars['Int']['output']
  /** Number of new patients from referral marketing. */
  newPatientsFromReferralMarketing: Scalars['Int']['output']
  /** Number of new patients from traditional marketing. */
  newPatientsFromTraditionalMarketing: Scalars['Int']['output']
  /** Number of new patients with unknown attribution. */
  newPatientsFromUnknown: Scalars['Int']['output']
  /** Share of new patients who booked a follow-up, as a percentage. */
  reappointmentPercentage: Scalars['Float']['output']
  /** Number of new patients who booked a follow-up (reappointment). */
  reappointments: Scalars['Int']['output']
  /** Number of scheduled new patients. */
  scheduledNewPatients: Scalars['Int']['output']
}

export type NewPatientsLocationSummary = {
  __typename?: 'NewPatientsLocationSummary'
  /** Location id. */
  id: Scalars['String']['output']
  /** When the location last synced from its PMS, as an ISO date/time string. */
  lastPmsSyncDate?: Maybe<Scalars['String']['output']>
  /** Location display name. */
  name: Scalars['String']['output']
  /** Whether the location has a connected PMS integration. */
  pmsIntegrated: Scalars['Boolean']['output']
}

export type NewPatientsMetricBucket = {
  __typename?: 'NewPatientsMetricBucket'
  /** Time bucket label this count covers. */
  bucket: Scalars['String']['output']
  /** New patient counts for this bucket broken down by channel. */
  byChannel: Array<ChannelCount>
  /** Number of new patients in this bucket. */
  count: Scalars['Int']['output']
}

export type NewPatientsMetricsResponse = {
  __typename?: 'NewPatientsMetricsResponse'
  /** Daily new-patient metric buckets for the comparison period. */
  comparisonMetrics: Array<NewPatientsMetricBucket>
  /** Aggregate new-patient metrics for the comparison period, when requested. */
  comparisonSummary?: Maybe<NewPatientsSummary>
  /** Daily new-patient metric buckets. */
  dailyMetrics: Array<NewPatientsMetricBucket>
  /** Daily scheduled new-patient metric buckets. */
  dailyScheduledMetrics: Array<ScheduledNewPatientsMetricBucket>
  /** New patient counts bucketed by month. */
  monthlyBuckets: Array<MonthlyBucket>
  /** Per-location new-patient metric rows. */
  rows: Array<NewPatientsLocationRow>
  /** Aggregate new-patient metrics for the period. */
  summary: NewPatientsSummary
}

export type NewPatientsMonthlyBreakdownRow = {
  __typename?: 'NewPatientsMonthlyBreakdownRow'
  /** Average production per new-patient visit, in dollars. */
  averageProductionPerNewPatientVisit: Scalars['Float']['output']
  /** Average time from lead to first appointment, in days. */
  averageTimeToAppointment: Scalars['Float']['output']
  /** Number of broken (missed/cancelled) appointments. */
  brokenAppointmentCount: Scalars['Int']['output']
  /** Month this row covers, as a bucket label. */
  bucket: Scalars['String']['output']
  /** Total number of new patients in the month. */
  newPatients: Scalars['Int']['output']
  /** Share of new patients who booked a follow-up, as a percentage. */
  reappointmentPercentage: Scalars['Float']['output']
  /** Number of scheduled new patients in the month. */
  scheduledNewPatients: Scalars['Int']['output']
}

export type NewPatientsSummary = {
  __typename?: 'NewPatientsSummary'
  /** Average production per new-patient visit, in dollars. */
  averageProductionPerNewPatientVisit: Scalars['Float']['output']
  /** Average time from lead to first appointment, in days. */
  averageTimeToAppointment: Scalars['Float']['output']
  /** New patient counts broken down by marketing channel. */
  byChannel: Array<ChannelCount>
  /** Number of completed new-patient visits. */
  completed: Scalars['Int']['output']
  /** Share of new patients who booked a follow-up appointment, as a percentage. */
  reappointmentPercentage: Scalars['Float']['output']
  /** Number of new patients who booked a follow-up (reappointment). */
  reappointments: Scalars['Int']['output']
  /** Number of scheduled new-patient appointments. */
  scheduled: Scalars['Int']['output']
}

export type NoteTemplate = {
  __typename?: 'NoteTemplate'
  /** Template body content. */
  body: Scalars['String']['output']
  /** Timestamp when this template was created. */
  createdDate: Scalars['DateTime']['output']
  /** Unique identifier for this note template. */
  id: Scalars['ID']['output']
  /** Display name of the note template. */
  name: Scalars['String']['output']
  /** Organization that owns this note template (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Timestamp when this template was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this note template is scoped to. */
  workspaceId: Scalars['String']['output']
}

export type NoteTemplateListResult = {
  __typename?: 'NoteTemplateListResult'
  /** Results for the current page. */
  hits: Array<NoteTemplate>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type Notification = {
  __typename?: 'Notification'
  /** Related activity (call/form/scheduler) ID, when applicable. */
  activityId?: Maybe<Scalars['ID']['output']>
  /** Whether this notification has been archived. */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Whether the recipient has clicked through this notification. */
  clicked?: Maybe<Scalars['Boolean']['output']>
  /** Related contact ID, when applicable. */
  contactId?: Maybe<Scalars['ID']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Deterministic identifier for this notification (dedupes per user/object/day/medium). */
  id: Scalars['ID']['output']
  /** Location the notification relates to, when applicable. */
  locationId?: Maybe<Scalars['ID']['output']>
  /** Whether this is a managed (system-controlled) notification. */
  managedNotification?: Maybe<Scalars['Boolean']['output']>
  /** Delivery medium: email or app. */
  medium: Scalars['String']['output']
  /** Related message ID, when applicable. */
  messageId?: Maybe<Scalars['ID']['output']>
  /** Source object type: call, form, scheduler, contact, message, registration, or workflow. */
  objectType: Scalars['String']['output']
  /** Organization that owns this notification (multi-tenant isolation key). */
  orgId: Scalars['ID']['output']
  /** Whether the recipient has read this notification. */
  read?: Maybe<Scalars['Boolean']['output']>
  /** When the underlying event occurred and the notification should be delivered. */
  triggerDate: Scalars['String']['output']
  /** Notification types that apply, e.g. missed-call, voicemail, new-text-message, new-appointment-booked. */
  types?: Maybe<Array<Scalars['String']['output']>>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** User this notification is addressed to. */
  userId: Scalars['ID']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Related workflow ID, when applicable. */
  workflowId?: Maybe<Scalars['ID']['output']>
  /** For workflow-paused notifications, the reason the workflow was paused. */
  workflowReason?: Maybe<Scalars['String']['output']>
  /** For workflow-paused notifications, the step that broke. */
  workflowStep?: Maybe<Scalars['String']['output']>
  /** Workspace this notification belongs to. */
  workspaceId: Scalars['ID']['output']
}

export type NotificationChannel = {
  __typename?: 'NotificationChannel'
  /** Deliver this notification in-app. */
  app?: Maybe<Scalars['Boolean']['output']>
  /** Deliver this notification by email. */
  email?: Maybe<Scalars['Boolean']['output']>
  /** Show this notification as a popup. */
  popup?: Maybe<Scalars['Boolean']['output']>
  /** Play a sound for this notification. */
  sound?: Maybe<Scalars['Boolean']['output']>
}

export type NotificationChannelInput = {
  /** Deliver this notification in-app. */
  app?: InputMaybe<Scalars['Boolean']['input']>
  /** Deliver this notification by email. */
  email?: InputMaybe<Scalars['Boolean']['input']>
  /** Show this notification as a popup. */
  popup?: InputMaybe<Scalars['Boolean']['input']>
  /** Play a sound for this notification. */
  sound?: InputMaybe<Scalars['Boolean']['input']>
}

export type NotificationCommandResult = {
  __typename?: 'NotificationCommandResult'
  /** Error message if the command failed */
  error?: Maybe<Scalars['String']['output']>
  /** Whether the command succeeded */
  success?: Maybe<Scalars['Boolean']['output']>
}

export type NotificationListResult = {
  __typename?: 'NotificationListResult'
  /** Matching records for the current page. */
  hits: Array<Notification>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching records across all pages. */
  total: Scalars['Int']['output']
}

export type OpenHoursRange = {
  __typename?: 'OpenHoursRange'
  /** Opening time of this range in HH:MMam/HH:MMpm local format */
  from: Scalars['String']['output']
  /** Closing time of this range in HH:MMam/HH:MMpm local format */
  to: Scalars['String']['output']
}

export type OpenHoursRangeInput = {
  /** Start time of the open-hours range (e.g. 09:00). */
  from: Scalars['String']['input']
  /** End time of the open-hours range (e.g. 17:00). */
  to: Scalars['String']['input']
}

export type Operatory = {
  __typename?: 'Operatory'
  /** Display name of the operatory. */
  display_name: Scalars['String']['output']
  /** Internal operatory id. */
  id?: Maybe<Scalars['String']['output']>
  /** Location the operatory belongs to. */
  locationId?: Maybe<Scalars['String']['output']>
  /** Operatory name from the PMS. */
  name: Scalars['String']['output']
  /** Operatory identifier in the source PMS. */
  remote_id: Scalars['String']['output']
  /** Operatory type. */
  type: Scalars['String']['output']
}

export type OpsLocation = {
  __typename?: 'OpsLocation'
  /** End of the alarm quiet-hours window. */
  alarmQuietEnd?: Maybe<Scalars['String']['output']>
  /** Start of the alarm quiet-hours window. */
  alarmQuietStart?: Maybe<Scalars['String']['output']>
  /** CareStack id for this location. */
  carestackId?: Maybe<Scalars['String']['output']>
  /** Active PMS connector type for this location. */
  connectorType?: Maybe<ConnectorType>
  /** Hour of day the daily sync is scheduled to run. */
  dailySyncHour?: Maybe<Scalars['Int']['output']>
  /** Whether the location currently has a sync error. */
  hasError: Scalars['Boolean']['output']
  /** Derived sync health status of the location. */
  healthStatus: HealthStatus
  /** Unique identifier for the location. */
  id: Scalars['ID']['output']
  /** Kolla connector id for this location. */
  kollaConnectorId?: Maybe<Scalars['String']['output']>
  /** Kolla consumer id for this location. */
  kollaConsumerId?: Maybe<Scalars['String']['output']>
  /** Page size used for Kolla sync requests. */
  kollaPageSize?: Maybe<Scalars['Int']['output']>
  /** Kolla practice id for this location. */
  kollaPracticeId?: Maybe<Scalars['String']['output']>
  /** When a new or changed appointment record last arrived for this location. Unlike lastAppointmentSyncDate (which only records that a sync ran), this only advances when a load actually received new/changed data. */
  lastAppointmentReceivedDate?: Maybe<Scalars['DateTime']['output']>
  /** Sync cursor for appointments: when the appointment load last ran for this location. Records that a sync ran, not that new data arrived. */
  lastAppointmentSyncDate?: Maybe<Scalars['DateTime']['output']>
  /** When a new or changed patient record last arrived for this location. Unlike lastPatientSyncDate (which only records that a sync ran), this only advances when a load actually received new/changed data. */
  lastPatientReceivedDate?: Maybe<Scalars['DateTime']['output']>
  /** Sync cursor for patients: when the patient load last ran for this location. Records that a sync ran, not that new data arrived. */
  lastPatientSyncDate?: Maybe<Scalars['DateTime']['output']>
  /** When the last PMS sync chain finished (stamped by the final sync step). Paired with lastPmsSyncStartDate to measure sync duration and detect in-progress syncs (start > complete). */
  lastPmsSyncCompleteDate?: Maybe<Scalars['DateTime']['output']>
  /** When the last successful PMS sync finished writing its data watermark. Advances forward only; drives the incremental fetch window for the next sync. A stale value means syncs have stopped succeeding. */
  lastPmsSyncDate?: Maybe<Scalars['DateTime']['output']>
  /** When the last PMS sync run started (stamped as the refresh queues the sync chain). Paired with lastPmsSyncCompleteDate: if start is after complete, a sync is still in progress. */
  lastPmsSyncStartDate?: Maybe<Scalars['DateTime']['output']>
  /** When a new or changed procedure record last arrived for this location. Unlike lastProcedureSyncDate (which only records that a sync ran), this only advances when a load actually received new/changed data. */
  lastProcedureReceivedDate?: Maybe<Scalars['DateTime']['output']>
  /** Sync cursor for procedures: when the procedure load last ran for this location. Records that a sync ran, not that new data arrived. */
  lastProcedureSyncDate?: Maybe<Scalars['DateTime']['output']>
  /** When the last Sikka webhook was received. */
  lastSikkaWebhookDate?: Maybe<Scalars['DateTime']['output']>
  /** Ops-list staleness signal: the OLDEST of the PMS, patient, appointment, and transaction sync dates, so a lagging entity surfaces the location as stale. Derived in the resolver, not stored on the location. */
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>
  /** When a new or changed transaction record last arrived for this location. Unlike lastTransactionSyncDate (which only records that a sync ran), this only advances when a load actually received new/changed data. */
  lastTransactionReceivedDate?: Maybe<Scalars['DateTime']['output']>
  /** Sync cursor for transactions: when the transaction load last ran for this location. Records that a sync ran, not that new data arrived. */
  lastTransactionSyncDate?: Maybe<Scalars['DateTime']['output']>
  /** When a new or changed treatment-plan record last arrived for this location. Unlike lastTreatmentPlanSyncDate (which only records that a sync ran), this only advances when a load actually received new/changed data. */
  lastTreatmentPlanReceivedDate?: Maybe<Scalars['DateTime']['output']>
  /** Sync cursor for treatment plans: when the treatment-plan load last ran for this location. Records that a sync ran, not that new data arrived. */
  lastTreatmentPlanSyncDate?: Maybe<Scalars['DateTime']['output']>
  /** Most recent error message for this location. */
  latestError?: Maybe<Scalars['String']['output']>
  /** When the most recent error occurred. */
  latestErrorAt?: Maybe<Scalars['DateTime']['output']>
  /** Display name of the location. */
  name: Scalars['String']['output']
  /** Ops notes attached to this location. */
  notes: Array<LocationNote>
  /** Organization that owns this location. */
  orgId: Scalars['ID']['output']
  /** PMS vendor name for this location. */
  pms?: Maybe<Scalars['String']['output']>
  /** When the PMS integration was first connected. */
  pmsIntegratedDate?: Maybe<Scalars['DateTime']['output']>
  /** Sikka office id for this location. */
  sikkaOfficeId?: Maybe<Scalars['String']['output']>
  /** Sikka practice id for this location. */
  sikkaPracticeId?: Maybe<Scalars['String']['output']>
  /** IANA timezone of the location. */
  timezone?: Maybe<Scalars['String']['output']>
  /** Ops workflow status for this location. */
  workflowStatus?: Maybe<WorkflowStatus>
  /** Workspace this location belongs to. */
  workspaceId?: Maybe<Scalars['ID']['output']>
}

export type OpsLocationConnection = {
  __typename?: 'OpsLocationConnection'
  /** Locations for the current page. */
  nodes: Array<OpsLocation>
  /** Pagination metadata. */
  pageInfo: PageInfo
}

export type OpsUpdateAiAgentLocationConfigInput = {
  /** Name the AI agent uses for itself */
  agentName?: InputMaybe<Scalars['String']['input']>
  /** ElevenLabs voice id the agent speaks with */
  agentVoiceId?: InputMaybe<Scalars['String']['input']>
  /** Business address the agent references */
  businessAddress?: InputMaybe<Scalars['String']['input']>
  /** Business name the agent references */
  businessName?: InputMaybe<Scalars['String']['input']>
  /** Greeting the agent opens with */
  greeting?: InputMaybe<Scalars['String']['input']>
  /** Message sent after booking a hygiene appointment */
  hygienePostBookingMessage?: InputMaybe<Scalars['String']['input']>
  /** LLM model used by the SMS agent */
  model?: InputMaybe<Scalars['String']['input']>
  /** Offers the practice promotes */
  offers?: InputMaybe<Array<AiAgentOfferInput>>
  /** Office main phone number, written through to the Location */
  officeMainNumber?: InputMaybe<Scalars['String']['input']>
  /** Office transfer phone number, written through to the Location */
  officeTransferNumber?: InputMaybe<Scalars['String']['input']>
  /** Message sent to the patient after booking */
  postBookingMessage?: InputMaybe<Scalars['String']['input']>
  /** Free-form version label stamped when Atlas deploys the prompt */
  promptVersion?: InputMaybe<Scalars['String']['input']>
  /** Say This, Not That phrase rules the agent applies when responding */
  sayThisNotThatRules?: InputMaybe<Array<SayThisNotThatRuleInput>>
  /** Services the practice offers */
  services?: InputMaybe<Array<AiAgentServiceInput>>
  /** Services the practice does not offer */
  servicesNotOffered?: InputMaybe<Array<AiAgentServiceInput>>
  /** Whether SMS appointment confirmations are enabled */
  smsConfirmationEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** System prompt for the SMS agent LLM */
  systemPrompt?: InputMaybe<Scalars['String']['input']>
  /** LLM sampling temperature for the SMS agent */
  temperature?: InputMaybe<Scalars['Float']['input']>
  /** Tool definitions available to the SMS agent */
  tools?: InputMaybe<Scalars['JSON']['input']>
}

export type OpsUpdateCallDataInput = {
  /** Correction for the editable ElevenLabs data-collection map (id -> stringified value). Replaces the map; the transcript is re-rendered from it and extraction is re-queued. Supersedes the individual field corrections below. */
  extractedData?: InputMaybe<Scalars['JSON']['input']>
  /** Deprecated: use extractedData. Correction for the reason no booking was made. */
  noBookingReason?: InputMaybe<Scalars['String']['input']>
  /** Optional note explaining the correction. */
  note?: InputMaybe<Scalars['String']['input']>
  /** Deprecated: use extractedData. Correction for whether a duplicate tool call occurred. */
  toolDuplicate?: InputMaybe<Scalars['Boolean']['input']>
  /** Deprecated: use extractedData. Correction for whether a tool error occurred. */
  toolError?: InputMaybe<Scalars['Boolean']['input']>
  /** Deprecated: use extractedData. Correction for whether a tool timeout occurred. */
  toolTimeout?: InputMaybe<Scalars['Boolean']['input']>
}

export type OpsUser = {
  __typename?: 'OpsUser'
  /** User's email address. */
  email?: Maybe<Scalars['String']['output']>
  /** Unique identifier for the user. */
  id: Scalars['ID']['output']
  /** User's display name. */
  name?: Maybe<Scalars['String']['output']>
}

export type OpsUserListResult = {
  __typename?: 'OpsUserListResult'
  /** Matching users for this page. */
  hits: Array<OpsUser>
  /** Zero-based index of the returned page. */
  page: Scalars['Int']['output']
  /** Total number of matching users across all pages. */
  total: Scalars['Int']['output']
}

export type OpsUserLogin = {
  __typename?: 'OpsUserLogin'
  /** Whether the user is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** User's email address. */
  email?: Maybe<Scalars['String']['output']>
  /** Unique identifier for the user. */
  id: Scalars['ID']['output']
  /** When the user last logged in. */
  lastLoginDate?: Maybe<Scalars['DateTime']['output']>
  /** User's display name. */
  name?: Maybe<Scalars['String']['output']>
  /** Organization the user belongs to. */
  orgId: Scalars['String']['output']
  /** Workspace the user belongs to. */
  workspaceId?: Maybe<Scalars['String']['output']>
}

export type OpsUserLoginListResult = {
  __typename?: 'OpsUserLoginListResult'
  /** Matching user login records for this page. */
  hits: Array<OpsUserLogin>
  /** Zero-based index of the returned page. */
  page: Scalars['Int']['output']
  /** Total number of matching records across all pages. */
  total: Scalars['Int']['output']
}

export type OpsUserType = {
  __typename?: 'OpsUserType'
  /** User's email address. */
  email?: Maybe<Scalars['String']['output']>
  /** Unique identifier for the user. */
  id: Scalars['ID']['output']
  /** User's display name. */
  name?: Maybe<Scalars['String']['output']>
  /** User's type: "super" or "standard". */
  type: Scalars['String']['output']
}

export type OpsWorkspaceSearchResult = {
  __typename?: 'OpsWorkspaceSearchResult'
  /** Matched location id, if any. */
  locationId?: Maybe<Scalars['ID']['output']>
  /** Matched location name, if any. */
  locationName?: Maybe<Scalars['String']['output']>
  /** Organization that owns the workspace. */
  orgId: Scalars['ID']['output']
  /** Unique identifier for the matched workspace. */
  workspaceId: Scalars['ID']['output']
  /** Display name of the matched workspace. */
  workspaceName: Scalars['String']['output']
}

/** Location-scoped communication opt-out. Existence of this record means the phone or email key is opted out; delete the record to opt the key back in. */
export type OptOut = {
  __typename?: 'OptOut'
  /** Why the key was opted out (hard bounce, complaint, unsubscribe link, carrier/platform opt-out, or manual). */
  cause?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Deterministic identifier for this opt-out: md5(locationId-type-key). */
  id: Scalars['ID']['output']
  /** Normalized opted-out key. Phone keys are digits-only last 10 digits; email keys are lowercased and trimmed. Delete this OptOut record to clear the opt-out. */
  key: Scalars['String']['output']
  /** Location where this communication opt-out applies. */
  locationId: Scalars['ID']['output']
  /** Organization that owns this opt-out (multi-tenant isolation key). */
  orgId: Scalars['ID']['output']
  /** Opted-out communication channel: phone or email. */
  type: OptOutType
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this opt-out belongs to. */
  workspaceId: Scalars['ID']['output']
}

export type OptOutListResult = {
  __typename?: 'OptOutListResult'
  /** Results for the current page. */
  hits: Array<OptOut>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

/** Communication channel for a location-scoped opt-out record. */
export enum OptOutType {
  Email = 'EMAIL',
  Phone = 'PHONE',
}

export type PageInfo = {
  __typename?: 'PageInfo'
  /** Whether another page of results exists after the current one. */
  hasNextPage: Scalars['Boolean']['output']
  /** Whether a page of results exists before the current one. */
  hasPreviousPage: Scalars['Boolean']['output']
  /** Total number of results across all pages. */
  total: Scalars['Int']['output']
}

/** Offset-based pagination. Pages are zero-indexed: page 0 returns the first `limit` results, page 1 returns the next `limit`, etc. */
export type PaginationInput = {
  /** Maximum number of results per page. Defaults to 1000. Clamped to a maximum of 1000. */
  limit?: Scalars['Int']['input']
  /** Zero-based page number. Page 0 is the first page. */
  page?: Scalars['Int']['input']
}

export type Paperwork = {
  __typename?: 'Paperwork'
  /** When the packet was cancelled */
  cancelledDate?: Maybe<Scalars['DateTime']['output']>
  /** PMS chart-write outcome for each form, in packet order */
  chartWriteStatuses: Array<PaperworkChartWrite>
  /** Array of PaperworkChartWrite, one per form written to the PMS */
  chartWritesJson?: Maybe<Scalars['JSON']['output']>
  /** When the patient completed the packet */
  completedDate?: Maybe<Scalars['DateTime']['output']>
  /** When the packet was created */
  createdDate: Scalars['DateTime']['output']
  /** When the link expires and can no longer be used */
  expiresDate: Scalars['DateTime']['output']
  /** Completion of each form in the packet, in order */
  formStatuses: Array<PaperworkFormStatus>
  /** Patient finished AND all supported PMS writes succeeded */
  fullyComplete: Scalars['Boolean']['output']
  /** Unique identifier for this sent paperwork packet */
  id: Scalars['ID']['output']
  /** The private link a patient opens to fill this paperwork */
  link: Scalars['String']['output']
  /** Location this packet belongs to */
  locationId: Scalars['String']['output']
  /** When the patient first opened the link */
  openedDate?: Maybe<Scalars['DateTime']['output']>
  /** Organization that owns this packet (multi-tenant isolation key) */
  orgId: Scalars['String']['output']
  /** Template this packet was sent from; the snapshot is authoritative for what the patient sees */
  paperworkTemplateId: Scalars['ID']['output']
  /** Patient this packet was sent to */
  patientId: Scalars['ID']['output']
  /** When post-completion PMS processing finished */
  processingCompletedDate?: Maybe<Scalars['DateTime']['output']>
  /** Post-completion PMS processing rollup: PENDING, IN_PROGRESS, SUCCESS, PARTIAL_FAILURE, or FAILED */
  processingStatus: PaperworkProcessingStatus
  /** Frozen assembled packet the patient fills out */
  snapshotJson: Scalars['JSON']['output']
  /** Lifecycle status: sent, opened, completed, expired, or cancelled */
  status: Scalars['String']['output']
  /** Array of PaperworkFormSubmission, one per completed form */
  submissionsJson?: Maybe<Scalars['JSON']['output']>
  /** Private link credential; not returned on the public read path */
  token: Scalars['String']['output']
  /** When the packet was last updated */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this packet belongs to */
  workspaceId: Scalars['String']['output']
}

/** Practice identity shown to the patient */
export type PaperworkBrandingInput = {
  /** Practice display name shown to the patient. */
  displayName: Scalars['String']['input']
  /** URL of the practice logo. */
  logoUrl?: InputMaybe<Scalars['String']['input']>
  /** Practice phone number shown to the patient. */
  phone?: InputMaybe<Scalars['String']['input']>
}

export type PaperworkChartWrite = {
  __typename?: 'PaperworkChartWrite'
  /** When the chart write completed */
  completedDate?: Maybe<Scalars['DateTime']['output']>
  /** Error message if the chart write failed */
  errorMessage?: Maybe<Scalars['String']['output']>
  /** PMS document resource id on a successful write */
  externalId?: Maybe<Scalars['String']['output']>
  /** Id of the form written to the PMS chart */
  formId: Scalars['ID']['output']
  /** Outcome of writing this form to the PMS chart */
  status: PaperworkChartWriteStatus
}

export enum PaperworkChartWriteStatus {
  Failed = 'FAILED',
  NotSupported = 'NOT_SUPPORTED',
  Pending = 'PENDING',
  Success = 'SUCCESS',
}

/** A form in a packet, pinned to a specific published version */
export type PaperworkFormInput = {
  /** Form included in the packet. */
  formId: Scalars['ID']['input']
  /** Published form version pinned for this packet. */
  formVersion: Scalars['Int']['input']
}

export type PaperworkFormStatus = {
  __typename?: 'PaperworkFormStatus'
  /** Whether the patient has submitted this form */
  completed: Scalars['Boolean']['output']
  /** Id of the form this status is for */
  formId: Scalars['ID']['output']
  /** Name of the form */
  name: Scalars['String']['output']
  /** When this form was submitted */
  submittedDate?: Maybe<Scalars['DateTime']['output']>
}

export type PaperworkListResult = {
  __typename?: 'PaperworkListResult'
  /** Results for the current page. */
  hits: Array<Paperwork>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export enum PaperworkProcessingStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  PartialFailure = 'PARTIAL_FAILURE',
  Pending = 'PENDING',
  Success = 'SUCCESS',
}

export type PaperworkTemplate = {
  __typename?: 'PaperworkTemplate'
  /** Appearance { accentColor, backgroundPreset, fontPreset } */
  appearanceJson?: Maybe<Scalars['JSON']['output']>
  /** Whether this template is archived and hidden from active use */
  archived: Scalars['Boolean']['output']
  /** Branding { displayName, logoUrl, phone } */
  brandingJson?: Maybe<Scalars['JSON']['output']>
  /** Completion screen { title, body } */
  completionJson?: Maybe<Scalars['JSON']['output']>
  /** When this template was created */
  createdDate: Scalars['DateTime']['output']
  /** Optional internal description of the template */
  description?: Maybe<Scalars['String']['output']>
  /** Ordered array of PaperworkForm { formId, version } */
  formsJson: Scalars['JSON']['output']
  /** Unique identifier for this paperwork template */
  id: Scalars['ID']['output']
  /** Display name of the paperwork template */
  name: Scalars['String']['output']
  /** Organization that owns this template (multi-tenant isolation key) */
  orgId: Scalars['String']['output']
  /** When this template was last updated */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Welcome screen { title, body } */
  welcomeJson?: Maybe<Scalars['JSON']['output']>
  /** Workspace this template belongs to */
  workspaceId: Scalars['String']['output']
}

export type PaperworkTemplateListResult = {
  __typename?: 'PaperworkTemplateListResult'
  /** Results for the current page. */
  hits: Array<PaperworkTemplate>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type Patient = {
  __typename?: 'Patient'
  /** Primary address line for patient correspondence */
  addressLine1?: Maybe<Scalars['String']['output']>
  /** Secondary address line (apartment, suite, etc.) */
  addressLine2?: Maybe<Scalars['String']['output']>
  /** Patient's date of birth (date only, no time component) */
  birthDate?: Maybe<Scalars['DateTime']['output']>
  /** Patient's mobile phone number, primary channel for SMS communication */
  cellPhone?: Maybe<Scalars['String']['output']>
  /** City from the patient's address */
  city?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Patient's email address, normalized to lowercase */
  email?: Maybe<Scalars['String']['output']>
  /** Whether the patient opted in to email messages (from PMS); null when the PMS provided no data */
  emailOptIn?: Maybe<Scalars['Boolean']['output']>
  /** Earliest known activity date for this patient (appointments, transactions, notes); used to identify pre-migration patients */
  firstActivityDate?: Maybe<Scalars['DateTime']['output']>
  /** Patient's first name from the Practice Management System */
  firstName?: Maybe<Scalars['String']['output']>
  /** Date of the patient's first visit or appointment */
  firstVisit?: Maybe<Scalars['DateTime']['output']>
  /** Patient's gender for healthcare demographics */
  gender?: Maybe<Scalars['String']['output']>
  /** First name of the financial guarantor */
  guarantorFirstName?: Maybe<Scalars['String']['output']>
  /** Financial guarantor identifier (person responsible for payment) */
  guarantorId?: Maybe<Scalars['String']['output']>
  /** Last name of the financial guarantor */
  guarantorLastName?: Maybe<Scalars['String']['output']>
  /** Patient's home phone number */
  homePhone?: Maybe<Scalars['String']['output']>
  /** Unique identifier for the patient record; format varies by vendor (Sikka: {officeId}-{practiceId}-{patientId}, Carestack: C-{accountId}-{patientId}, Kolla: K-{locationKey}-{patientId}) */
  id: Scalars['ID']['output']
  /** Name of the patient's insurance company */
  insuranceProvider?: Maybe<Scalars['String']['output']>
  /** Patient's last name from the Practice Management System */
  lastName?: Maybe<Scalars['String']['output']>
  /** Date of the patient's most recent visit */
  lastVisit?: Maybe<Scalars['DateTime']['output']>
  /** Location/practice this patient belongs to (Organization > Workspace > Location hierarchy) */
  locationId: Scalars['ID']['output']
  /** Organization that owns this patient (multi-tenant isolation key) */
  orgId?: Maybe<Scalars['String']['output']>
  /** Date the patient record was created in the Practice Management System */
  patientCreatedDate?: Maybe<Scalars['DateTime']['output']>
  /** Specific patient referral information (e.g. referring patient name) */
  patientReferral?: Maybe<Scalars['String']['output']>
  /** Phonetic representation of the patient name used for fuzzy name matching */
  phoneme?: Maybe<Scalars['String']['output']>
  /** Patient id from the Practice Management System, used for data synchronization */
  pmsPatientId?: Maybe<Scalars['String']['output']>
  /** Patient's preferred name if different from first name */
  preferredName?: Maybe<Scalars['String']['output']>
  /** Type or source of the patient's referral, used for marketing attribution */
  referralType?: Maybe<Scalars['String']['output']>
  /** Sikka office identifier used with pmsPatientId for Sikka patient identification */
  sikkaOfficeId?: Maybe<Scalars['String']['output']>
  /** Sikka practice identifier within the office */
  sikkaPracticeId?: Maybe<Scalars['String']['output']>
  /** Whether the patient opted in to SMS text messages (from PMS); null when the PMS provided no data */
  smsOptIn?: Maybe<Scalars['Boolean']['output']>
  /** State or province from the patient's address */
  state?: Maybe<Scalars['String']['output']>
  /** Patient status in the Practice Management System (e.g. Active, Inactive, NonPat) */
  status?: Maybe<Scalars['String']['output']>
  /** General subscriber id for the patient's insurance plan */
  subscriberId?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Source Practice Management System: sikka, carestack, kolla, or ascend */
  vendor?: Maybe<Scalars['String']['output']>
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Patient's work phone number */
  workPhone?: Maybe<Scalars['String']['output']>
  /** Workspace this patient belongs to within the organization hierarchy */
  workspaceId?: Maybe<Scalars['String']['output']>
  /** Postal or ZIP code from the patient's address */
  zip?: Maybe<Scalars['String']['output']>
}

export type PatientListResult = {
  __typename?: 'PatientListResult'
  /** Results for the current page. */
  hits: Array<Patient>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type PhoneCallsNotificationInput = {
  /** Channels for all unscheduled-call notifications. */
  allUnscheduledCalls?: InputMaybe<NotificationChannelInput>
  /** Channels for callback-requested notifications. */
  callbackRequested?: InputMaybe<NotificationChannelInput>
  /** Channels for canceled-appointment notifications. */
  canceledAppointment?: InputMaybe<NotificationChannelInput>
  /** Whether phone-call notifications are enabled. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Channels for incoming-call notifications. */
  incomingCall?: InputMaybe<NotificationChannelInput>
  /** Channels for missed-call notifications. */
  missedCalls?: InputMaybe<NotificationChannelInput>
  /** Channels for new-patient unscheduled-call notifications. */
  newPatientUnscheduledCalls?: InputMaybe<NotificationChannelInput>
  /** Channels for voicemail notifications. */
  voicemail?: InputMaybe<NotificationChannelInput>
}

export type PhoneCallsNotificationSettings = {
  __typename?: 'PhoneCallsNotificationSettings'
  /** Channels for all unscheduled-call notifications. */
  allUnscheduledCalls?: Maybe<NotificationChannel>
  /** Channels for callback-requested notifications. */
  callbackRequested?: Maybe<NotificationChannel>
  /** Channels for canceled-appointment notifications. */
  canceledAppointment?: Maybe<NotificationChannel>
  /** Whether phone-call notifications are enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** Channels for incoming-call notifications. */
  incomingCall?: Maybe<NotificationChannel>
  /** Channels for missed-call notifications. */
  missedCalls?: Maybe<NotificationChannel>
  /** Channels for new-patient unscheduled-call notifications. */
  newPatientUnscheduledCalls?: Maybe<NotificationChannel>
  /** Channels for voicemail notifications. */
  voicemail?: Maybe<NotificationChannel>
}

export type PhoneNumber = {
  __typename?: 'PhoneNumber'
  /** When this phone number record was created. */
  createdDate: Scalars['DateTime']['output']
  /** Whether this phone number is enabled for use. */
  enabled: Scalars['Boolean']['output']
  /** Unique identifier for the phone number record. */
  id: Scalars['ID']['output']
  /** Optional human-readable label for this phone number. */
  label?: Maybe<Scalars['String']['output']>
  /** Location this phone number is assigned to. */
  locationId: Scalars['String']['output']
  /** Organization that owns this phone number (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** The E.164 phone number. */
  phone: Scalars['String']['output']
  /** twilio, aws-chime, aws-messaging */
  provider: Scalars['String']['output']
  /** Provider-specific resource ID (Twilio SID, AWS phone number ID) */
  providerResourceId: Scalars['String']['output']
  /** Human-readable error when provisioningStatus is failed */
  provisioningError?: Maybe<Scalars['String']['output']>
  /** Provisioning lifecycle: ordering, active, failed, released */
  provisioningStatus: Scalars['String']['output']
  /** AWS campaign registration ID for messaging number readiness */
  registrationId?: Maybe<Scalars['String']['output']>
  /** Registration status for messaging numbers: pending, approved, rejected */
  registrationStatus?: Maybe<Scalars['String']['output']>
  /** Assigned roles: ivr, pool, source, messaging, ai-agent */
  roles: Array<Scalars['String']['output']>
  /** When this phone number record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this phone number belongs to. */
  workspaceId: Scalars['String']['output']
}

export type PhoneNumberListResult = {
  __typename?: 'PhoneNumberListResult'
  /** Results for the current page. */
  hits: Array<PhoneNumber>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export enum PhoneNumberType {
  Messaging = 'MESSAGING',
  Voice = 'VOICE',
}

export type PingResult = {
  __typename?: 'PingResult'
  /** Human-readable result message. */
  message: Scalars['String']['output']
  /** Round-trip response time in milliseconds. */
  responseTimeMs?: Maybe<Scalars['Int']['output']>
  /** Whether the connector responded successfully. */
  success: Scalars['Boolean']['output']
}

export type Pipeline = {
  __typename?: 'Pipeline'
  /** Unique identifier for the pipeline. */
  id: Scalars['ID']['output']
  /** Human-readable name of the pipeline. */
  name: Scalars['String']['output']
  /** Organization that owns this pipeline (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Ordered stages that make up this pipeline. */
  stages?: Maybe<Array<PipelineStage>>
  /** Workspace this pipeline belongs to. */
  workspaceId: Scalars['String']['output']
}

export type PipelineStage = {
  __typename?: 'PipelineStage'
  /** Color used to render the stage in the UI. */
  color: Scalars['String']['output']
  /** Display name of the stage. */
  name: Scalars['String']['output']
  /** Position of the stage within the pipeline. */
  order: Scalars['Int']['output']
}

export type PipelineStageInput = {
  /** Stage color (hex). */
  color: Scalars['String']['input']
  /** Stage name. */
  name: Scalars['String']['input']
  /** Position of the stage within the pipeline. */
  order: Scalars['Int']['input']
}

export type PmsDataNotificationInput = {
  /** Channels for broken-appointment notifications. */
  brokenAppointment?: InputMaybe<NotificationChannelInput>
  /** Whether PMS-data notifications are enabled. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Channels for no-appointment-found-on-scheduled-contact notifications. */
  noAppointmentFoundOnScheduledContact?: InputMaybe<NotificationChannelInput>
  /** Channels for no-patient-linked-on-scheduled-contact notifications. */
  noPatientLinkedOnScheduledContact?: InputMaybe<NotificationChannelInput>
}

export type PmsDataNotificationSettings = {
  __typename?: 'PmsDataNotificationSettings'
  /** Channels for broken-appointment notifications. */
  brokenAppointment?: Maybe<NotificationChannel>
  /** Whether PMS-data notifications are enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** Channels for no-appointment-found-on-scheduled-contact notifications. */
  noAppointmentFoundOnScheduledContact?: Maybe<NotificationChannel>
  /** Channels for no-patient-linked-on-scheduled-contact notifications. */
  noPatientLinkedOnScheduledContact?: Maybe<NotificationChannel>
}

export type PmsReferralMapping = {
  __typename?: 'PmsReferralMapping'
  /** UTM campaign this mapping matches. */
  campaign?: Maybe<Scalars['String']['output']>
  /** The marketing channel this referral type maps to. */
  channel?: Maybe<Scalars['String']['output']>
  /** When true, this mapping forces the channel assignment regardless of other attribution. */
  force?: Maybe<Scalars['Boolean']['output']>
  /** Unique identifier for this referral-to-channel mapping. */
  id: Scalars['ID']['output']
  /** UTM medium this mapping matches. */
  medium?: Maybe<Scalars['String']['output']>
  /** Organization that owns this mapping (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** The PMS referral type being mapped to a channel. */
  referralType: Scalars['String']['output']
  /** UTM source this mapping matches. */
  source?: Maybe<Scalars['String']['output']>
  /** Workspace this mapping belongs to. */
  workspaceId: Scalars['String']['output']
}

export type PmsReferralMappingListResult = {
  __typename?: 'PmsReferralMappingListResult'
  /** The page of PMS referral-type mappings matching the query. */
  hits: Array<PmsReferralMapping>
  /** Zero-based index of the returned page. */
  page: Scalars['Int']['output']
  /** Total number of mappings matching the query across all pages. */
  total: Scalars['Int']['output']
}

export type Procedure = {
  __typename?: 'Procedure'
  /** Appointment ids (K-{locationKey}-{remoteId}) this procedure is linked to */
  appointmentIds?: Maybe<Array<Scalars['String']['output']>>
  /** Amount billed for the procedure */
  billedAmount?: Maybe<Scalars['Float']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Human-readable description of the procedure */
  description?: Maybe<Scalars['String']['output']>
  /** Standard fee amount for the procedure */
  feeAmount?: Maybe<Scalars['Float']['output']>
  /** Unique identifier for this procedure (K-{locationKey}-{remoteId}) */
  id: Scalars['ID']['output']
  /** Location this procedure was performed at */
  locationId: Scalars['String']['output']
  /** Organization that owns this procedure (multi-tenant isolation key) */
  orgId: Scalars['String']['output']
  /** Patient this procedure is associated with */
  patientId?: Maybe<Scalars['String']['output']>
  /** Treatment plan ids this procedure belongs to */
  planIds?: Maybe<Array<Scalars['String']['output']>>
  /** Practice-defined priority text sent by Kolla; many procedures have none */
  priority?: Maybe<Scalars['String']['output']>
  /** Dental procedure code (e.g. CDT code) */
  procedureCode?: Maybe<Scalars['String']['output']>
  /** When the procedure was created in the source PMS */
  procedureCreateDate?: Maybe<Scalars['DateTime']['output']>
  /** When the procedure was last updated in the source PMS */
  procedureUpdateDate?: Maybe<Scalars['DateTime']['output']>
  /** Provider who performed or is assigned to the procedure */
  providerId?: Maybe<Scalars['String']['output']>
  /** Current state/status of the procedure */
  state?: Maybe<Scalars['String']['output']>
  /** Tooth number the procedure applies to */
  tooth?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** PMS vendor this procedure was sourced from: sikka or kolla */
  vendor?: Maybe<Scalars['String']['output']>
  /** Source PMS vendor's identifier for this procedure */
  vendorId: Scalars['String']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this procedure belongs to */
  workspaceId: Scalars['String']['output']
}

export type ProcedureListResult = {
  __typename?: 'ProcedureListResult'
  /** Matching records for the current page. */
  hits: Array<Procedure>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching records across all pages. */
  total: Scalars['Int']['output']
}

export type Prompt = {
  __typename?: 'Prompt'
  /** Whether this prompt has been archived. */
  archived: Scalars['Boolean']['output']
  /** Prompt body/template text sent to the model. */
  body: Scalars['String']['output']
  /** Category this prompt belongs to. */
  category: PromptCategory
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Optional description of what this prompt is used for. */
  description?: Maybe<Scalars['String']['output']>
  /** Counter tracking draft iterations since the last deploy. */
  draftCounter: Scalars['Int']['output']
  /** Unique identifier for this prompt. */
  id: Scalars['ID']['output']
  /** Stable key used to reference this prompt in code. */
  key: Scalars['String']['output']
  /** Identifier of the most recently deployed version of this prompt. */
  lastDeployedVersionId?: Maybe<Scalars['ID']['output']>
  /** LLM model identifier this prompt runs against. */
  model: Scalars['String']['output']
  /** Human-readable name of the prompt. */
  name: Scalars['String']['output']
  /** Revision number, incremented on each saved change. */
  revision: Scalars['Int']['output']
  /** Sampling temperature used when running the prompt. */
  temperature: Scalars['Float']['output']
  /** User who last updated this prompt. */
  updatedBy?: Maybe<Scalars['ID']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
}

export enum PromptCategory {
  CallProcessing = 'CALL_PROCESSING',
  Sms = 'SMS',
  Voice = 'VOICE',
}

export type PromptDraft = {
  __typename?: 'PromptDraft'
  /** Prompt version this draft was branched from, if any. */
  baseVersionId?: Maybe<Scalars['ID']['output']>
  /** Draft prompt body text. */
  body: Scalars['String']['output']
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Sequential draft number for this prompt. */
  draftNumber: Scalars['Int']['output']
  /** User who authored this draft. */
  editor: Scalars['ID']['output']
  /** Optional human-friendly label for the draft. */
  friendlyName?: Maybe<Scalars['String']['output']>
  /** Unique identifier for this draft. */
  id: Scalars['ID']['output']
  /** Prompt this draft belongs to. */
  promptId: Scalars['ID']['output']
  /** Key of the prompt this draft belongs to. */
  promptKey: Scalars['String']['output']
  /** Name of the prompt this draft belongs to. */
  promptName: Scalars['String']['output']
  /** When this draft was last saved. */
  savedAt: Scalars['DateTime']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
}

export type PromptDraftListResult = {
  __typename?: 'PromptDraftListResult'
  /** Results for the current page. */
  hits: Array<PromptDraft>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type PromptFragment = {
  __typename?: 'PromptFragment'
  /** Whether this fragment is archived and hidden from active use. */
  archived: Scalars['Boolean']['output']
  /** The prompt text content of the fragment. */
  body: Scalars['String']['output']
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Optional notes describing what this prompt fragment is for. */
  description?: Maybe<Scalars['String']['output']>
  /** Identifier of the user who last edited this fragment. */
  editor?: Maybe<Scalars['String']['output']>
  /** Unique identifier for the prompt fragment. */
  id: Scalars['ID']['output']
  /** Human-readable name of the prompt fragment. */
  name: Scalars['String']['output']
  /** Monotonic revision number, incremented on each edit (starts at 1). */
  revision: Scalars['Int']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
}

export type PromptFragmentListResult = {
  __typename?: 'PromptFragmentListResult'
  /** Results for the current page. */
  hits: Array<PromptFragment>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type PromptListResult = {
  __typename?: 'PromptListResult'
  /** Results for the current page. */
  hits: Array<Prompt>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type PromptVersion = {
  __typename?: 'PromptVersion'
  /** Prompt body text for this version. */
  body: Scalars['String']['output']
  /** Category the prompt belongs to. */
  category: PromptCategory
  /** Optional summary of what changed in this version. */
  changeSummary?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** User who saved this version. */
  editor: Scalars['ID']['output']
  /** Unique identifier for this prompt version. */
  id: Scalars['ID']['output']
  /** Whether this is the currently active version of the prompt. */
  isCurrent: Scalars['Boolean']['output']
  /** Model this version runs against. */
  model: Scalars['String']['output']
  /** Prompt this version belongs to. */
  promptId: Scalars['ID']['output']
  /** Key of the prompt this version belongs to. */
  promptKey: Scalars['String']['output']
  /** Name of the prompt this version belongs to. */
  promptName: Scalars['String']['output']
  /** Sequential revision number of this version. */
  revision: Scalars['Int']['output']
  /** When this version was saved. */
  savedAt: Scalars['DateTime']['output']
  /** Sampling temperature used for this version. */
  temperature: Scalars['Float']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
}

export type PromptVersionListResult = {
  __typename?: 'PromptVersionListResult'
  /** Results for the current page. */
  hits: Array<PromptVersion>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type Provider = {
  __typename?: 'Provider'
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Whether the provider is deactivated and excluded from scheduling. */
  deactivated?: Maybe<Scalars['Boolean']['output']>
  /** User-editable display name shown for the provider. */
  displayName: Scalars['String']['output']
  /** Whether the provider has an uploaded profile picture. */
  hasProfilePicture?: Maybe<Scalars['Boolean']['output']>
  /** Unique identifier for the provider. */
  id: Scalars['ID']['output']
  /** Whether this is the primary provider. */
  isPrimary?: Maybe<Scalars['Boolean']['output']>
  /** Kolla consumer id for the connector this provider syncs through. */
  kollaConsumerId: Scalars['String']['output']
  /** Organization that owns this provider (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Provider's name exactly as reported by the PMS (source of truth). */
  pmsDisplayName?: Maybe<Scalars['String']['output']>
  /** Provider's short name exactly as reported by the PMS. */
  pmsShortDisplayName?: Maybe<Scalars['String']['output']>
  /** PMS practice ids this provider is associated with. */
  practiceIds?: Maybe<Array<Scalars['String']['output']>>
  /** Sort priority used when ordering providers. */
  priority?: Maybe<Scalars['Float']['output']>
  /** PMS resource identifier, e.g. 'resources/provider_XYZ'. */
  resourceName: Scalars['String']['output']
  /** Provider's taxonomy or specialty code. */
  taxonomy?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Source PMS vendor, e.g. 'kolla' or 'carestack'. */
  vendor?: Maybe<Scalars['String']['output']>
  /** Provider's identifier in the source PMS vendor system. */
  vendorId: Scalars['String']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this provider belongs to. */
  workspaceId: Scalars['String']['output']
}

export type ProviderListResult = {
  __typename?: 'ProviderListResult'
  /** The page of items matching the query. */
  hits: Array<Provider>
  /** Zero-based index of the returned page. */
  page: Scalars['Int']['output']
  /** Total number of items matching the query across all pages. */
  total: Scalars['Int']['output']
}

/** One submitted answer */
export type PublicAnswerInput = {
  /** Id of the question being answered */
  questionId: Scalars['String']['input']
  /** Answer value(s). A single-value answer is a one-element array. */
  value: Array<Scalars['String']['input']>
}

/** The patient-facing view of a paperwork link, resolved by its token */
export type PublicPaperwork = {
  __typename?: 'PublicPaperwork'
  /** When the link expires. Null for not_found. */
  expiresDate?: Maybe<Scalars['DateTime']['output']>
  /** Why the link is or is not usable: open, not_found, cancelled, completed, expired */
  linkState: Scalars['String']['output']
  /** The assembled packet: name, branding, appearance, welcome/completion screens, and forms with questions. Null for a blocked link. */
  packet?: Maybe<Scalars['JSON']['output']>
  /** The practice that sent the link, from the frozen snapshot. Null for not_found. */
  practice?: Maybe<PublicPaperworkPractice>
  /** Lifecycle state: sent, opened, completed, expired, cancelled. Null for not_found. */
  status?: Maybe<Scalars['String']['output']>
  /** formIds already submitted, so the runtime can resume mid-packet. Null for a blocked link. */
  submittedFormIds?: Maybe<Scalars['JSON']['output']>
}

/** The practice that sent the link, frozen at send time */
export type PublicPaperworkPractice = {
  __typename?: 'PublicPaperworkPractice'
  /** Practice display name shown to the patient */
  displayName: Scalars['String']['output']
  /** Practice logo URL */
  logoUrl?: Maybe<Scalars['String']['output']>
  /** Practice phone number for the patient to call */
  phone?: Maybe<Scalars['String']['output']>
}

export type PurchasePhoneNumberInput = {
  /** Human-readable label for the number. */
  label?: InputMaybe<Scalars['String']['input']>
  /** Location that will own the purchased number. */
  locationId: Scalars['String']['input']
  /** E.164 — required for voice (from search) */
  phone?: InputMaybe<Scalars['String']['input']>
  /** Roles the number will fill (e.g. pool, ai). */
  roles: Array<Scalars['String']['input']>
  /** Number capability type to purchase (e.g. voice, messaging). */
  type: PhoneNumberType
}

export type QualifiedLeadCounts = {
  __typename?: 'QualifiedLeadCounts'
  /** Qualified-lead statistics for the comparison period, if requested. */
  comparisonStats?: Maybe<QualifiedLeadStats>
  /** Number of disqualified leads in the period. */
  disqualified: Scalars['Int']['output']
  /** Number of qualified leads in the period. */
  qualified: Scalars['Int']['output']
  /** Daily time series of qualified-lead counts. */
  series: Array<QualifiedLeadSeriesRow>
  /** Per-staff conversion metrics for the period. */
  staffConversionMetrics: Array<StaffConversionMetric>
  /** Aggregate qualified-lead statistics for the period. */
  stats: QualifiedLeadStats
  /** Total number of leads in the period. */
  total: Scalars['Int']['output']
}

export type QualifiedLeadSeriesRow = {
  __typename?: 'QualifiedLeadSeriesRow'
  /** Date of this data point (YYYY-MM-DD). */
  date: Scalars['String']['output']
  /** Number of leads on this date. */
  leads: Scalars['Int']['output']
  /** Number of leads scheduled on this date. */
  scheduled: Scalars['Int']['output']
  /** Share of leads scheduled on this date (0-1). */
  scheduledRate: Scalars['Float']['output']
}

export type QualifiedLeadStats = {
  __typename?: 'QualifiedLeadStats'
  /** Number of marketing-qualified leads. */
  mqls: Scalars['Int']['output']
  /** Number of qualified leads that were not scheduled. */
  notScheduled: Scalars['Int']['output']
  /** Share of qualified leads that were scheduled (0-1). */
  scheduleRate: Scalars['Float']['output']
  /** Number of qualified leads that were scheduled. */
  scheduled: Scalars['Int']['output']
}

export type Query = {
  __typename?: 'Query'
  action: Action
  actionHistory: ActionListResult
  actions: ActionListResult
  /** Validate an activation token and return user info for the activation form. */
  activateAccount?: Maybe<ActivateAccountResult>
  activities: ActivityListResult
  activity: Activity
  activityCount: ActivityCountResult
  adPlatformMappings: AdPlatformMappingListResult
  aiAgentCallLog: AiConversationTurnListResult
  aiAgentConfiguration?: Maybe<AiAgentOverview>
  aiAgentConfigurations: Array<AiAgentConfiguration>
  aiConversationTurn: AiConversationTurn
  aiConversationTurns: AiConversationTurnListResult
  appointment: Appointment
  appointmentTypes: AppointmentTypeListResult
  appointments: AppointmentListResult
  /** Get a single background job's progress by jobId. Super user only. */
  backgroundJob?: Maybe<BackgroundJobProgress>
  /** List background jobs with filtering. Super user only. */
  backgroundJobs: BackgroundJobProgressConnection
  blockoutNotes: Array<BlockoutNote>
  budgetMetrics: BudgetMetricsResponse
  budgets: BudgetListResult
  /** Get call details by ID. */
  call?: Maybe<Call>
  callData: CallDataListResult
  callDatum: CallData
  /** Get a signed recording URL for a call. */
  callRecordingUrl?: Maybe<Scalars['String']['output']>
  /** Get SRT transcription text for a call. */
  callTranscription?: Maybe<Scalars['String']['output']>
  /** Look up caller ID name and customer name for a phone number at a location. */
  callerId?: Maybe<CallerIdResult>
  /** List calls with search, pagination, and sorting. */
  calls: CallListResult
  campaign: AdCampaign
  campaigns: CampaignListResult
  /** Fetch Carestack PMS sync stats as a CloudWatch chart. Super user only. */
  carestackDashboard: CarestackDashboardResult
  cdtCodeMappings: CdtCodeMappingListResult
  channelMappings: ChannelMappingV2ListResult
  checkSendingEmailAvailable: Scalars['Boolean']['output']
  commLog: CommLog
  commLogWritebackRules: CommLogWritebackRuleListResult
  commLogs: CommLogListResult
  contact: Contact
  contacts: ContactListResult
  conversionLogs: ConversionLogListResult
  conversionMetrics: ConversionMetricsResponse
  customPage: CustomPage
  customPages: CustomPageListResult
  dni: Dni
  dniPoolNumbers: Array<PhoneNumber>
  dnis: DniListResult
  elevenLabsDeployment?: Maybe<ElevenLabsDeployment>
  elevenLabsDeploymentTargets: ElevenLabsDeploymentTargetListResult
  elevenLabsDeployments: ElevenLabsDeploymentListResult
  emailAttachmentUrls: Array<EmailAttachmentLink>
  event: Event
  events: EventListResult
  extractionDashboard: ExtractionDashboardResult
  extractionPrompt?: Maybe<ExtractionPrompt>
  extractionPrompts: ExtractionPromptListResult
  featureToggleDefinitions: FeatureToggleListResult
  featureToggles: FeatureToggleListResult
  featureTogglesByName: Array<FeatureToggle>
  fileImport: FileImport
  fileImports: FileImportListResult
  followUp: FollowUpGql
  followUps: FollowUpGqlListResult
  formFieldMappings: FormFieldMappingListResult
  formTemplate: FormTemplate
  formTemplates: FormTemplateListResult
  /** The current super user's notification settings. Super user only. */
  getSuperNotifications: SuperNotificationSettings
  importDetail: Import
  imports: ImportListResult
  /** List calls that are currently ringing for the active workspace. */
  incomingCalls: Array<IncomingCall>
  integration?: Maybe<IntegrationV2>
  integrationOptions: IntegrationOptionsQueries
  integrationStatus: IntegrationStatus
  ivrConfig?: Maybe<IvrConfigResult>
  ivrConfigs: Array<IvrConfigResult>
  leadsBreakdown: LegacyLeadsBreakdown
  list: List
  listItem?: Maybe<ListItem>
  listItems: ListItemListResult
  listMembers: ListMembersResult
  listStageCounts: Array<ListStageCount>
  lists: Array<List>
  location?: Maybe<Location>
  locationCanSendEmail: Scalars['Boolean']['output']
  locationEmailIdentities: LocationEmailIdentityListResult
  locationEmailIdentity: LocationEmailIdentity
  locationIvrNumbers: Array<Scalars['String']['output']>
  locationLeadStatuses: Array<Scalars['String']['output']>
  locationOutboundNumbers: Array<Scalars['String']['output']>
  locationSmsNumbers: Array<SmsNumber>
  locations: LocationListResult
  locationsByIds: Array<Location>
  marketingContacts: ContactListResult
  marketingMetrics: MarketingMetricsResponse
  /** Get the currently authenticated user */
  me: User
  message: Message
  messageImageUrls: Array<Scalars['String']['output']>
  messages: MessageListResult
  newPatientsMetrics: NewPatientsMetricsResponse
  newPatientsMonthlyBreakdown: Array<NewPatientsMonthlyBreakdownRow>
  noteTemplate: NoteTemplate
  noteTemplates: NoteTemplateListResult
  notification?: Maybe<Notification>
  notifications: NotificationListResult
  operatories: Array<Operatory>
  /** Get voice agent configuration for a location. Service token or super user required. */
  opsAIAgentConfiguration?: Maybe<AiAgentConfiguration>
  /** Get a single location by ID. Super user only. */
  opsLocation?: Maybe<OpsLocation>
  /** List locations with filtering. Service token or super user required. */
  opsLocations: OpsLocationConnection
  /** SMS per-day counts and per-SMS-Agent-location daily AI texts for the SMS Ops charts and Silent Agents grid. Aggregate counts only. Service token or super user required. */
  opsSmsDailyMetrics: SmsDailyMetricsResponse
  /** SMS counts per location for the SMS Ops tab (counts, not rates). Service token or super user required. */
  opsSmsLocationMetrics: SmsLocationMetricsResponse
  /** AI text conversation takeovers per staff member and location for the SMS Ops tab, split by staff reply vs. inbox toggle. One per thread by its first takeover in range; opt-outs excluded. Service token or super user required. */
  opsSmsStaffTakeovers: SmsStaffTakeoverResponse
  /** Usage/cost aggregation (voice + SMS) across locations. Super user required. */
  opsUsageCostMetrics: UsageCostResponse
  /** The SMS agent conversation threads behind one location's smsCostUsd in opsUsageCostMetrics, most expensive first. Super user required. */
  opsUsageCostSmsThreads: UsageCostSmsThreadListResult
  /** The individual AI agent calls behind one location's voiceCostUsd in opsUsageCostMetrics. Super user required. */
  opsUsageCostVoiceCalls: UsageCostVoiceCallListResult
  /** User login dates across all orgs/workspaces for the Atlas sync. Service token or super user required. */
  opsUserLogins: OpsUserLoginListResult
  /** User search across all orgs/workspaces for the Feature Toggles user pickers. Super user required. */
  opsUsers: OpsUserListResult
  /** Voice agent per-day counts and per-location daily call counts for the Ops charts and slipping grid. Aggregate counts only — no call-level data. Service token or super user required. */
  opsVoiceAgentDailyMetrics: VoiceAgentDailyMetricsResponse
  /** Voice agent metrics per location for the Ops tab (counts, not rates). Service token or super user required. */
  opsVoiceAgentLocationMetrics: VoiceAgentLocationMetricsResponse
  /** Voice agent metrics for a workspace. Service token or super user required. */
  opsVoiceAgentMetrics: VoiceAgentMetricsResponse
  /** Search workspaces and locations across organizations. Super user only. */
  opsWorkspaceSearch: Array<OpsWorkspaceSearchResult>
  /** Get one location-scoped communication opt-out. If it exists, the key is opted out. */
  optOut?: Maybe<OptOut>
  /** List location-scoped communication opt-outs. A returned record means the key is opted out; delete the record to clear the opt-out. */
  optOuts: OptOutListResult
  paperwork: Paperwork
  /** Read a paperwork link by its token. No login. A blocked link returns its state and the practice that sent it, no packet. An open link is marked opened on first read and returns the packet. Returns only patient-safe data. */
  paperworkByToken: PublicPaperwork
  /** Signed URL to download one file a patient attached to a form question. The same file filed to the patient chart. Returns null when the question has no attached file. Staff-only, scoped like the form PDF download; the patient link cannot reach it. */
  paperworkFileUrl?: Maybe<Scalars['String']['output']>
  /** Signed URL to download the rendered PDF of one finished form in a packet. The same document filed to the patient chart. Returns null until the form's PDF has been rendered. */
  paperworkFormPdfUrl?: Maybe<Scalars['String']['output']>
  paperworkTemplate: PaperworkTemplate
  paperworkTemplates: PaperworkTemplateListResult
  paperworks: PaperworkListResult
  patient: Patient
  patients: PatientListResult
  phoneNumber: PhoneNumber
  phoneNumbers: PhoneNumberListResult
  pipeline: Pipeline
  pipelines: Array<Pipeline>
  pmsCommTypeName?: Maybe<Scalars['String']['output']>
  pmsReferralMappings: PmsReferralMappingListResult
  pmsUserName?: Maybe<Scalars['String']['output']>
  /** Read-only preview: which past events a trigger definition would match in a time window. Accepts a definition from an unsaved workflow. Writes nothing. */
  previewWorkflowTrigger: TriggerPreviewResultType
  procedure: Procedure
  procedures: ProcedureListResult
  prompt?: Maybe<Prompt>
  promptDraft?: Maybe<PromptDraft>
  promptDrafts: PromptDraftListResult
  promptFragment?: Maybe<PromptFragment>
  promptFragments: PromptFragmentListResult
  promptVersion?: Maybe<PromptVersion>
  promptVersions: PromptVersionListResult
  prompts: PromptListResult
  provider: Provider
  providerAvailabilities: Array<Availability>
  providers: ProviderListResult
  qualifiedLeadCounts: QualifiedLeadCounts
  registrationProfile: RegistrationProfile
  registrationProfileDocumentUrls: Array<Scalars['String']['output']>
  registrationProfiles: RegistrationProfileListResult
  resourceSchedule: ResourceSchedule
  resourceSchedules: ResourceScheduleListResult
  revenueMetrics: RevenueMetricsResponse
  /** Get a role by ID. */
  role?: Maybe<Role>
  roles: RoleListResult
  scheduler: Scheduler
  schedulers: SchedulerListResult
  schedulingConfiguration?: Maybe<SchedulingConfiguration>
  schedulingConfigurations: SchedulingConfigurationListResult
  scorecardMetrics: Array<ScorecardMetricsRow>
  scorecards: ScorecardListResult
  searchAvailablePhoneNumbers: Array<AvailablePhoneNumber>
  sendingDomain: SendingDomain
  sendingDomains: SendingDomainListResult
  smsAgentReady: Scalars['Boolean']['output']
  smsOpsMetrics: SmsOpsMetrics
  smsTemplate: SmsTemplate
  smsTemplates: SmsTemplateListResult
  staffBreakdown: StaffBreakdownResponse
  staffCallActivities: ActivityListResult
  /** Get a staff member by ID. */
  staffMember: Staff
  /** List staff members with search/pagination/sort. */
  staffMembers: StaffListResult
  storedCredential: StoredCredential
  storedCredentialPassword: StoredCredentialSecret
  storedCredentials: StoredCredentialListResult
  /** Get a single sync run by ID. Super user only. */
  syncRun?: Maybe<SyncRun>
  /** List sync runs with filtering. Service token or super user required. */
  syncRuns: SyncRunConnection
  tagColor: TagColor
  tagColors: TagColorListResult
  /** Typeahead for tag values on a given entity (activities, contacts, calls). */
  tagValues: Array<Scalars['String']['output']>
  task: Task
  taskTemplate: TaskTemplate
  taskTemplates: TaskTemplateListResult
  tasks: TaskListResult
  thread: Thread
  threads: ThreadListResult
  trackableSendingDomain: Scalars['String']['output']
  transaction: Transaction
  transactions: TransactionListResult
  treatmentPlan: TreatmentPlan
  treatmentPlans: TreatmentPlanListResult
  unmappedFormKeys: UnmappedFormKeyListResult
  /** Get a user by ID. Super users and service tokens can access any user; others are restricted to their own org. */
  user?: Maybe<User>
  userActivity: UserActivityResult
  userNotificationSettings?: Maybe<UserNotificationSettings>
  /** Get user settings by key as JSON string */
  userSettings?: Maybe<Scalars['String']['output']>
  users: UserListResult
  utmAliases: UtmAliasListResult
  voiceAgentMetrics: VoiceAgentMetricsResponse
  workflow: Workflow
  /** Returns all date fields available for date-reached workflow triggers, optionally filtered by source type */
  workflowDateTriggerFields: Array<WorkflowDateTriggerField>
  workflowRun: WorkflowRun
  workflowRunEvents: WorkflowRunEventListResult
  workflowRuns: WorkflowRunListResult
  workflows: WorkflowListResult
  workspace: Workspace
  workspaceInvite: WorkspaceInvite
  workspaceInvites: WorkspaceInviteListResult
  workspaces: WorkspaceListResult
}

export type QueryActionArgs = {
  actionId: Scalars['ID']['input']
}

export type QueryActionHistoryArgs = {
  actionId: Scalars['ID']['input']
  pagination?: InputMaybe<PaginationInput>
}

export type QueryActionsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryActivateAccountArgs = {
  email: Scalars['String']['input']
  token: Scalars['String']['input']
}

export type QueryActivitiesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryActivityArgs = {
  id: Scalars['ID']['input']
}

export type QueryActivityCountArgs = {
  endDate: Scalars['String']['input']
  locationId: Scalars['ID']['input']
  startDate: Scalars['String']['input']
  tags?: InputMaybe<Array<Array<Scalars['String']['input']>>>
  type?: InputMaybe<Scalars['String']['input']>
}

export type QueryAdPlatformMappingsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
  workspaceId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryAiAgentCallLogArgs = {
  locationId: Scalars['ID']['input']
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SortInput>
}

export type QueryAiAgentConfigurationArgs = {
  locationId: Scalars['ID']['input']
}

export type QueryAiAgentConfigurationsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  locationId?: InputMaybe<Scalars['ID']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

export type QueryAiConversationTurnArgs = {
  id: Scalars['ID']['input']
}

export type QueryAiConversationTurnsArgs = {
  aiWorkflowId?: InputMaybe<Scalars['ID']['input']>
  archived?: InputMaybe<Scalars['Boolean']['input']>
  contactId?: InputMaybe<Scalars['ID']['input']>
  locationId?: InputMaybe<Scalars['ID']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
  threadId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryAppointmentArgs = {
  id: Scalars['ID']['input']
}

export type QueryAppointmentTypesArgs = {
  locationId: Scalars['ID']['input']
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryAppointmentsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryBackgroundJobArgs = {
  jobId: Scalars['ID']['input']
}

export type QueryBackgroundJobsArgs = {
  filter?: InputMaybe<BackgroundJobFilter>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SortInput>
}

export type QueryBlockoutNotesArgs = {
  locationId: Scalars['ID']['input']
}

export type QueryBudgetMetricsArgs = {
  dateRange: DateRangeInput
}

export type QueryBudgetsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryCallArgs = {
  id: Scalars['ID']['input']
}

export type QueryCallDataArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryCallDatumArgs = {
  id: Scalars['ID']['input']
}

export type QueryCallRecordingUrlArgs = {
  id: Scalars['ID']['input']
}

export type QueryCallTranscriptionArgs = {
  id: Scalars['ID']['input']
}

export type QueryCallerIdArgs = {
  callerPhone: Scalars['String']['input']
  locationId: Scalars['ID']['input']
}

export type QueryCallsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryCampaignArgs = {
  id: Scalars['ID']['input']
}

export type QueryCampaignsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryCarestackDashboardArgs = {
  period?: Scalars['String']['input']
}

export type QueryCdtCodeMappingsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
  workspaceId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryChannelMappingsArgs = {
  medium?: InputMaybe<Scalars['String']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
  source?: InputMaybe<Scalars['String']['input']>
  workspaceId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryCheckSendingEmailAvailableArgs = {
  domain: Scalars['String']['input']
  localPart: Scalars['String']['input']
  locationId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryCommLogArgs = {
  id: Scalars['ID']['input']
}

export type QueryCommLogWritebackRulesArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryCommLogsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryContactArgs = {
  id: Scalars['ID']['input']
}

export type QueryContactsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  fields?: InputMaybe<Array<Scalars['String']['input']>>
  magicTerms?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryConversionLogsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryConversionMetricsArgs = {
  dateRange: DateRangeInput
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
}

export type QueryCustomPageArgs = {
  id: Scalars['ID']['input']
}

export type QueryCustomPagesArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryDniArgs = {
  id: Scalars['ID']['input']
}

export type QueryDniPoolNumbersArgs = {
  dniId: Scalars['ID']['input']
}

export type QueryDnisArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryElevenLabsDeploymentArgs = {
  id: Scalars['ID']['input']
}

export type QueryElevenLabsDeploymentTargetsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryElevenLabsDeploymentsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryEmailAttachmentUrlsArgs = {
  id: Scalars['ID']['input']
}

export type QueryEventArgs = {
  id: Scalars['ID']['input']
}

export type QueryEventsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryExtractionPromptArgs = {
  slug: Scalars['String']['input']
}

export type QueryExtractionPromptsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryFeatureToggleDefinitionsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryFeatureTogglesArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
}

export type QueryFeatureTogglesByNameArgs = {
  names: Array<Scalars['String']['input']>
}

export type QueryFileImportArgs = {
  id: Scalars['ID']['input']
}

export type QueryFileImportsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryFollowUpArgs = {
  id: Scalars['ID']['input']
}

export type QueryFollowUpsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryFormFieldMappingsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
  workspaceId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryFormTemplateArgs = {
  id: Scalars['ID']['input']
}

export type QueryFormTemplatesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  formId?: InputMaybe<Scalars['ID']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
  status?: InputMaybe<Scalars['String']['input']>
}

export type QueryImportDetailArgs = {
  id: Scalars['ID']['input']
}

export type QueryImportsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryIntegrationArgs = {
  type: Scalars['String']['input']
}

export type QueryIntegrationStatusArgs = {
  integration: Scalars['String']['input']
  locationId: Scalars['ID']['input']
}

export type QueryIvrConfigArgs = {
  phoneNumberId: Scalars['String']['input']
}

export type QueryIvrConfigsArgs = {
  locationId: Scalars['String']['input']
}

export type QueryLeadsBreakdownArgs = {
  channel?: InputMaybe<Scalars['String']['input']>
  compareRange?: InputMaybe<DateRangeInput>
  dateRange: DateRangeInput
  filters?: InputMaybe<Scalars['String']['input']>
  integrationStatus?: InputMaybe<Scalars['String']['input']>
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
  platform?: InputMaybe<Scalars['String']['input']>
  showDisqualified?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryListArgs = {
  id: Scalars['ID']['input']
}

export type QueryListItemArgs = {
  id: Scalars['ID']['input']
}

export type QueryListItemsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryListMembersArgs = {
  listId: Scalars['ID']['input']
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
  stageId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryListStageCountsArgs = {
  listId: Scalars['ID']['input']
  search?: InputMaybe<Scalars['String']['input']>
}

export type QueryListsArgs = {
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SortInput>
}

export type QueryLocationArgs = {
  id: Scalars['ID']['input']
}

export type QueryLocationCanSendEmailArgs = {
  locationId: Scalars['ID']['input']
}

export type QueryLocationEmailIdentitiesArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryLocationEmailIdentityArgs = {
  id: Scalars['ID']['input']
}

export type QueryLocationIvrNumbersArgs = {
  locationId: Scalars['ID']['input']
}

export type QueryLocationLeadStatusesArgs = {
  locationId: Scalars['ID']['input']
}

export type QueryLocationOutboundNumbersArgs = {
  locationId: Scalars['ID']['input']
}

export type QueryLocationSmsNumbersArgs = {
  locationId: Scalars['ID']['input']
}

export type QueryLocationsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryLocationsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>
}

export type QueryMarketingContactsArgs = {
  campaign?: InputMaybe<Scalars['String']['input']>
  channel?: InputMaybe<Scalars['String']['input']>
  filterBy: Scalars['String']['input']
  filters?: InputMaybe<Scalars['String']['input']>
  firstActivityType?: InputMaybe<Scalars['String']['input']>
  fromDate: Scalars['String']['input']
  hideMultiLocationPatients?: InputMaybe<Scalars['Boolean']['input']>
  hideNonPatients?: InputMaybe<Scalars['Boolean']['input']>
  leadOwnerId?: InputMaybe<Scalars['String']['input']>
  leadOwnerName?: InputMaybe<Scalars['String']['input']>
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
  pagination?: InputMaybe<PaginationInput>
  platform?: InputMaybe<Scalars['String']['input']>
  rawChannel?: InputMaybe<Scalars['String']['input']>
  reportedAttribution?: InputMaybe<Scalars['String']['input']>
  schedulingActivityType?: InputMaybe<Scalars['String']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  showDisqualified?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<SortInput>
  toDate: Scalars['String']['input']
  trackableCampaignId?: InputMaybe<Scalars['String']['input']>
  utmCampaign?: InputMaybe<Scalars['String']['input']>
  utmMedium?: InputMaybe<Scalars['String']['input']>
  utmSource?: InputMaybe<Scalars['String']['input']>
}

export type QueryMarketingMetricsArgs = {
  channel?: InputMaybe<Scalars['String']['input']>
  channelOp?: InputMaybe<Scalars['String']['input']>
  compareRange?: InputMaybe<DateRangeInput>
  dateRange: DateRangeInput
  filters?: InputMaybe<Scalars['String']['input']>
  groupBy?: InputMaybe<Scalars['String']['input']>
  hideMultiLocationPatients?: InputMaybe<Scalars['Boolean']['input']>
  integrationStatus?: InputMaybe<Scalars['String']['input']>
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
  platform?: InputMaybe<Scalars['String']['input']>
  query?: InputMaybe<Scalars['String']['input']>
  showDisqualified?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryMessageArgs = {
  id: Scalars['ID']['input']
}

export type QueryMessageImageUrlsArgs = {
  id: Scalars['ID']['input']
}

export type QueryMessagesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryNewPatientsMetricsArgs = {
  channel?: InputMaybe<Scalars['String']['input']>
  compareRange?: InputMaybe<DateRangeInput>
  dateRange: DateRangeInput
  filters?: InputMaybe<Scalars['String']['input']>
  hideMultiLocationPatients?: InputMaybe<Scalars['Boolean']['input']>
  integrationStatus?: InputMaybe<Scalars['String']['input']>
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
  platform?: InputMaybe<Scalars['String']['input']>
}

export type QueryNewPatientsMonthlyBreakdownArgs = {
  channel?: InputMaybe<Scalars['String']['input']>
  dateRange: DateRangeInput
  filters?: InputMaybe<Scalars['String']['input']>
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
}

export type QueryNoteTemplateArgs = {
  id: Scalars['ID']['input']
}

export type QueryNoteTemplatesArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryNotificationArgs = {
  id: Scalars['ID']['input']
}

export type QueryNotificationsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryOperatoriesArgs = {
  locationId: Scalars['ID']['input']
}

export type QueryOpsAiAgentConfigurationArgs = {
  locationId: Scalars['ID']['input']
}

export type QueryOpsLocationArgs = {
  id: Scalars['ID']['input']
}

export type QueryOpsLocationsArgs = {
  filter?: InputMaybe<LocationFilter>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SortInput>
}

export type QueryOpsSmsDailyMetricsArgs = {
  dateRange: DateRangeInput
  search?: InputMaybe<Scalars['String']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
}

export type QueryOpsSmsLocationMetricsArgs = {
  compareDateRange?: InputMaybe<DateRangeInput>
  dateRange: DateRangeInput
  search?: InputMaybe<Scalars['String']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
}

export type QueryOpsSmsStaffTakeoversArgs = {
  dateRange: DateRangeInput
  search?: InputMaybe<Scalars['String']['input']>
}

export type QueryOpsUsageCostMetricsArgs = {
  input: UsageCostInput
}

export type QueryOpsUsageCostSmsThreadsArgs = {
  input: UsageCostDetailInput
}

export type QueryOpsUsageCostVoiceCallsArgs = {
  input: UsageCostDetailInput
  sort?: InputMaybe<SortInput>
}

export type QueryOpsUserLoginsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
}

export type QueryOpsUsersArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
}

export type QueryOpsVoiceAgentDailyMetricsArgs = {
  input: VoiceAgentDailyMetricsInput
}

export type QueryOpsVoiceAgentLocationMetricsArgs = {
  input: VoiceAgentLocationMetricsInput
}

export type QueryOpsVoiceAgentMetricsArgs = {
  dateRange: DateRangeInput
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
  workspaceId: Scalars['String']['input']
}

export type QueryOpsWorkspaceSearchArgs = {
  query: Scalars['String']['input']
}

export type QueryOptOutArgs = {
  id: Scalars['ID']['input']
}

export type QueryOptOutsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryPaperworkArgs = {
  id: Scalars['ID']['input']
}

export type QueryPaperworkByTokenArgs = {
  token: Scalars['String']['input']
}

export type QueryPaperworkFileUrlArgs = {
  formId: Scalars['ID']['input']
  id: Scalars['ID']['input']
  questionId: Scalars['ID']['input']
}

export type QueryPaperworkFormPdfUrlArgs = {
  formId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type QueryPaperworkTemplateArgs = {
  id: Scalars['ID']['input']
}

export type QueryPaperworkTemplatesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryPaperworksArgs = {
  pagination?: InputMaybe<PaginationInput>
  patientId?: InputMaybe<Scalars['ID']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryPatientArgs = {
  id: Scalars['ID']['input']
}

export type QueryPatientsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryPhoneNumberArgs = {
  id: Scalars['ID']['input']
}

export type QueryPhoneNumbersArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryPipelineArgs = {
  id: Scalars['ID']['input']
}

export type QueryPmsCommTypeNameArgs = {
  commType: Scalars['Int']['input']
  locationId: Scalars['ID']['input']
}

export type QueryPmsReferralMappingsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
}

export type QueryPmsUserNameArgs = {
  locationId: Scalars['ID']['input']
  userNum: Scalars['Int']['input']
}

export type QueryPreviewWorkflowTriggerArgs = {
  locationId: Scalars['ID']['input']
  pagination?: InputMaybe<PaginationInput>
  trigger: WorkflowTriggerInput
  windowEnd: Scalars['DateTime']['input']
  windowStart: Scalars['DateTime']['input']
}

export type QueryProcedureArgs = {
  id: Scalars['ID']['input']
}

export type QueryProceduresArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryPromptArgs = {
  id: Scalars['ID']['input']
}

export type QueryPromptDraftArgs = {
  id: Scalars['ID']['input']
}

export type QueryPromptDraftsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryPromptFragmentArgs = {
  id: Scalars['ID']['input']
}

export type QueryPromptFragmentsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryPromptVersionArgs = {
  id: Scalars['ID']['input']
}

export type QueryPromptVersionsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryPromptsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryProviderArgs = {
  id: Scalars['ID']['input']
}

export type QueryProviderAvailabilitiesArgs = {
  providerId: Scalars['ID']['input']
}

export type QueryProvidersArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryQualifiedLeadCountsArgs = {
  activityType?: InputMaybe<Scalars['String']['input']>
  channel?: InputMaybe<Scalars['String']['input']>
  compareFromDate?: InputMaybe<Scalars['String']['input']>
  compareToDate?: InputMaybe<Scalars['String']['input']>
  dateRange: DateRangeInput
  filters?: InputMaybe<Scalars['String']['input']>
  integrationStatus?: InputMaybe<Scalars['String']['input']>
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
  platform?: InputMaybe<Scalars['String']['input']>
}

export type QueryRegistrationProfileArgs = {
  id: Scalars['ID']['input']
}

export type QueryRegistrationProfileDocumentUrlsArgs = {
  id: Scalars['ID']['input']
  keys: Array<Scalars['String']['input']>
}

export type QueryRegistrationProfilesArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryResourceScheduleArgs = {
  id: Scalars['ID']['input']
}

export type QueryResourceSchedulesArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryRevenueMetricsArgs = {
  compareRange?: InputMaybe<DateRangeInput>
  dateRange: DateRangeInput
  integrationStatus?: InputMaybe<Scalars['String']['input']>
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
}

export type QueryRoleArgs = {
  id: Scalars['ID']['input']
}

export type QueryRolesArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QuerySchedulerArgs = {
  id: Scalars['ID']['input']
}

export type QuerySchedulersArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QuerySchedulingConfigurationArgs = {
  locationId: Scalars['ID']['input']
}

export type QuerySchedulingConfigurationsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryScorecardMetricsArgs = {
  dateRange: Scalars['String']['input']
  grouping: Scalars['String']['input']
  locations?: InputMaybe<Array<Scalars['String']['input']>>
  lookbackAmount?: InputMaybe<Scalars['Int']['input']>
  lookbackType?: InputMaybe<Scalars['String']['input']>
  staff?: InputMaybe<Array<Scalars['String']['input']>>
}

export type QueryScorecardsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QuerySearchAvailablePhoneNumbersArgs = {
  areaCode: Scalars['String']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
  type: PhoneNumberType
}

export type QuerySendingDomainArgs = {
  id: Scalars['ID']['input']
}

export type QuerySendingDomainsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QuerySmsAgentReadyArgs = {
  locationId: Scalars['ID']['input']
}

export type QuerySmsOpsMetricsArgs = {
  dateRange: DateRangeInput
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
}

export type QuerySmsTemplateArgs = {
  id: Scalars['ID']['input']
}

export type QuerySmsTemplatesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryStaffBreakdownArgs = {
  channel?: InputMaybe<Scalars['String']['input']>
  dateRange: DateRangeInput
  filters?: InputMaybe<Scalars['String']['input']>
  integrationStatus?: InputMaybe<Scalars['String']['input']>
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
}

export type QueryStaffCallActivitiesArgs = {
  bucket: Scalars['String']['input']
  channel?: InputMaybe<Scalars['String']['input']>
  dateRange: DateRangeInput
  filters?: InputMaybe<Scalars['String']['input']>
  locationId?: InputMaybe<Scalars['String']['input']>
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
  pagination?: InputMaybe<PaginationInput>
  query?: InputMaybe<Scalars['String']['input']>
  staffId?: InputMaybe<Scalars['String']['input']>
  staffName?: InputMaybe<Scalars['String']['input']>
}

export type QueryStaffMemberArgs = {
  id: Scalars['ID']['input']
}

export type QueryStaffMembersArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryStoredCredentialArgs = {
  id: Scalars['ID']['input']
}

export type QueryStoredCredentialPasswordArgs = {
  id: Scalars['ID']['input']
}

export type QueryStoredCredentialsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QuerySyncRunArgs = {
  id: Scalars['ID']['input']
}

export type QuerySyncRunsArgs = {
  filter?: InputMaybe<SyncRunFilter>
  pagination?: InputMaybe<PaginationInput>
  sort?: InputMaybe<SortInput>
}

export type QueryTagColorArgs = {
  id: Scalars['ID']['input']
}

export type QueryTagColorsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryTagValuesArgs = {
  entity: Scalars['String']['input']
  search?: InputMaybe<Scalars['String']['input']>
}

export type QueryTaskArgs = {
  id: Scalars['ID']['input']
}

export type QueryTaskTemplateArgs = {
  id: Scalars['ID']['input']
}

export type QueryTaskTemplatesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryTasksArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryThreadArgs = {
  id: Scalars['ID']['input']
}

export type QueryThreadsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryTransactionArgs = {
  id: Scalars['ID']['input']
}

export type QueryTransactionsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryTreatmentPlanArgs = {
  id: Scalars['ID']['input']
}

export type QueryTreatmentPlansArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryUnmappedFormKeysArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryUserArgs = {
  id: Scalars['ID']['input']
}

export type QueryUserActivityArgs = {
  userId: Scalars['ID']['input']
}

export type QueryUserNotificationSettingsArgs = {
  userId: Scalars['ID']['input']
}

export type QueryUserSettingsArgs = {
  key: Scalars['String']['input']
}

export type QueryUsersArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryUtmAliasesArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
  workspaceId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryVoiceAgentMetricsArgs = {
  dateRange: DateRangeInput
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
}

export type QueryWorkflowArgs = {
  id: Scalars['ID']['input']
}

export type QueryWorkflowDateTriggerFieldsArgs = {
  sourceType?: InputMaybe<Scalars['String']['input']>
}

export type QueryWorkflowRunArgs = {
  id: Scalars['ID']['input']
}

export type QueryWorkflowRunEventsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryWorkflowRunsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryWorkflowsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryWorkspaceArgs = {
  id: Scalars['ID']['input']
}

export type QueryWorkspaceInviteArgs = {
  id: Scalars['ID']['input']
}

export type QueryWorkspaceInvitesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

export type QueryWorkspacesArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
}

/** A choice for a singleSelect or multiSelect question */
export type QuestionOptionInput = {
  /** Stable id for this option. */
  id: Scalars['String']['input']
  /** Display label for this option. */
  label: Scalars['String']['input']
}

export type RcsCardInput = {
  /** Card description. */
  description?: InputMaybe<Scalars['String']['input']>
  /** S3 keys for card images. */
  imageKeys?: InputMaybe<Array<Scalars['String']['input']>>
  /** Suggested reply actions on the card. */
  suggestions?: InputMaybe<Array<RcsCardSuggestionInput>>
  /** Card title. */
  title?: InputMaybe<Scalars['String']['input']>
}

export type RcsCardSuggestionInput = {
  /** ID of the suggested action. */
  actionId: Scalars['String']['input']
  /** Reply text sent when the suggestion is tapped. */
  replyText: Scalars['String']['input']
}

export type ReassignActivityInput = {
  /** ID of the new activity owner. */
  ownerId: Scalars['String']['input']
  /** Name of the new activity owner. */
  ownerName: Scalars['String']['input']
}

export type RegistrationProfile = {
  __typename?: 'RegistrationProfile'
  /** Hex accent color for RCS agent card */
  accentColor?: Maybe<Scalars['String']['output']>
  /** Business address city. */
  addressCity?: Maybe<Scalars['String']['output']>
  /** Business address country. */
  addressCountry?: Maybe<Scalars['String']['output']>
  /** Business address postal/ZIP code. */
  addressPostalCode?: Maybe<Scalars['String']['output']>
  /** Business address state or region. */
  addressState?: Maybe<Scalars['String']['output']>
  /** Business street address. */
  addressStreet?: Maybe<Scalars['String']['output']>
  /** RCS agent description */
  agentDescription?: Maybe<Scalars['String']['output']>
  /** RCS agent service name */
  agentServiceName?: Maybe<Scalars['String']['output']>
  /** Description of the brand. */
  brandDescription?: Maybe<Scalars['String']['output']>
  /** Brand name presented to subscribers. */
  brandName?: Maybe<Scalars['String']['output']>
  /** Industry the business operates in. */
  businessIndustry?: Maybe<Scalars['String']['output']>
  /** Country where the business is registered. */
  businessRegistrationCountry?: Maybe<Scalars['String']['output']>
  /** Business type: sole_proprietor, partnership, corporation, llc, nonprofit */
  businessType?: Maybe<Scalars['String']['output']>
  /** Email address of the registration contact. */
  contactEmail?: Maybe<Scalars['String']['output']>
  /** First name of the registration contact. */
  contactFirstName?: Maybe<Scalars['String']['output']>
  /** Last name of the registration contact. */
  contactLastName?: Maybe<Scalars['String']['output']>
  /** Phone number of the registration contact. */
  contactPhone?: Maybe<Scalars['String']['output']>
  /** Job title of the registration contact. */
  contactTitle?: Maybe<Scalars['String']['output']>
  /** When this profile was created. */
  createdDate: Scalars['DateTime']['output']
  /** Employer Identification Number (tax ID). */
  ein?: Maybe<Scalars['String']['output']>
  /** HELP keyword response message */
  helpMessage?: Maybe<Scalars['String']['output']>
  /** Unique registration profile ID. */
  id: Scalars['ID']['output']
  /** Registered legal name of the business. */
  legalBusinessName?: Maybe<Scalars['String']['output']>
  /** Monthly RCS message volume estimate */
  monthlyRcsVolume?: Maybe<Scalars['String']['output']>
  /** Display name for this registration profile. */
  name: Scalars['String']['output']
  /** Opt-in confirmation message sent to subscribers */
  optInConfirmationMessage?: Maybe<Scalars['String']['output']>
  /** S3 keys for opt-in screenshots/documents */
  optInDocuments?: Maybe<Array<Scalars['String']['output']>>
  /** Public URL showing opt-in screenshot (for RCS) */
  optInScreenshotUrl?: Maybe<Scalars['String']['output']>
  /** Public URL where opt-in occurs, if applicable */
  optInUrl?: Maybe<Scalars['String']['output']>
  /** Description of how opt-in consent is collected */
  optInWorkflowDescription?: Maybe<Scalars['String']['output']>
  /** Description of how users can opt out */
  optOutDetails?: Maybe<Scalars['String']['output']>
  /** Organization that owns this profile (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Public URL to privacy policy */
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>
  /** S3 key for RCS banner image (1440x560) */
  rcsBannerImageKey?: Maybe<Scalars['String']['output']>
  /** S3 key for RCS logo image (224x224) */
  rcsLogoImageKey?: Maybe<Scalars['String']['output']>
  /** Sample messages that will be sent */
  sampleMessages?: Maybe<Array<Scalars['String']['output']>>
  /** STOP keyword response message */
  stopMessage?: Maybe<Scalars['String']['output']>
  /** S3 keys for supplemental registration documents */
  supplementalDocuments?: Maybe<Array<Scalars['String']['output']>>
  /** Public URL to terms and conditions */
  termsUrl?: Maybe<Scalars['String']['output']>
  /** When this profile was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Use case category: marketing, customer_care, account_notification, etc. */
  useCaseCategory?: Maybe<Scalars['String']['output']>
  /** Use case description for the campaign */
  useCaseDescription?: Maybe<Scalars['String']['output']>
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** YouTube or public video URL for RCS brand verification */
  videoUrl?: Maybe<Scalars['String']['output']>
  /** Business website URL. */
  websiteUrl?: Maybe<Scalars['String']['output']>
  /** Workspace this registration profile belongs to. */
  workspaceId: Scalars['String']['output']
}

export type RegistrationProfileListResult = {
  __typename?: 'RegistrationProfileListResult'
  /** The registration profiles on this page. */
  hits: Array<RegistrationProfile>
  /** Current page number. */
  page: Scalars['Int']['output']
  /** Total number of matching registration profiles. */
  total: Scalars['Int']['output']
}

export type ResourceSchedule = {
  __typename?: 'ResourceSchedule'
  /** Available time blocks for the resource on this date. */
  blocks: Array<ResourceScheduleBlock>
  /** Timestamp when this schedule was created. */
  createdDate: Scalars['DateTime']['output']
  /** Calendar date this schedule applies to (YYYY-MM-DD). */
  date: Scalars['String']['output']
  /** Unique identifier for this resource schedule. */
  id: Scalars['ID']['output']
  /** Kolla consumer identifier this schedule was sourced from. */
  kollaConsumerId: Scalars['String']['output']
  /** Name of the scheduled resource (provider or operatory). */
  name: Scalars['String']['output']
  /** Notes/blockouts applied to specific time ranges on this date. */
  notes: Array<ResourceScheduleNote>
  /** Organization that owns this schedule (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Type of resource scheduled: PROVIDER or OPERATORY. */
  type: Scalars['String']['output']
  /** Timestamp when this schedule was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this schedule belongs to. */
  workspaceId: Scalars['String']['output']
}

export type ResourceScheduleBlock = {
  __typename?: 'ResourceScheduleBlock'
  /** End time of the schedule block (HH:mm). */
  endTime: Scalars['String']['output']
  /** Start time of the schedule block (HH:mm). */
  startTime: Scalars['String']['output']
}

export type ResourceScheduleListResult = {
  __typename?: 'ResourceScheduleListResult'
  /** Results for the current page. */
  hits: Array<ResourceSchedule>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type ResourceScheduleNote = {
  __typename?: 'ResourceScheduleNote'
  /** Structured metadata attached to the note. */
  additionalData?: Maybe<ResourceScheduleNoteData>
  /** End time of the schedule block (HH:mm). */
  endTime: Scalars['String']['output']
  /** Free-text note for this schedule block. */
  note: Scalars['String']['output']
  /** Start time of the schedule block (HH:mm). */
  startTime: Scalars['String']['output']
}

export type ResourceScheduleNoteData = {
  __typename?: 'ResourceScheduleNoteData'
  /** Appointment type associated with this schedule note. */
  appointmentType?: Maybe<Scalars['String']['output']>
}

export type RevenueDailyMetric = {
  __typename?: 'RevenueDailyMetric'
  /** Day this metric covers, as a bucket label. */
  bucket: Scalars['String']['output']
  /** Collections for the day, in dollars. */
  collections: Scalars['Float']['output']
  /** Gross production for the day, in dollars. */
  grossProduction: Scalars['Float']['output']
  /** Net production for the day, in dollars. */
  netProduction: Scalars['Float']['output']
}

export type RevenueMetricsResponse = {
  __typename?: 'RevenueMetricsResponse'
  /** Daily revenue metric series for the comparison period. */
  comparisonDailyMetrics: Array<RevenueDailyMetric>
  /** Aggregate revenue stats for the comparison period, when requested. */
  comparisonStats?: Maybe<RevenueStats>
  /** Daily revenue metric series. */
  dailyMetrics: Array<RevenueDailyMetric>
  /** Aggregate revenue stats for the period. */
  stats: RevenueStats
}

export type RevenueStats = {
  __typename?: 'RevenueStats'
  /** Total adjustments (write-offs/discounts), in dollars. */
  adjustments: Scalars['Float']['output']
  /** Average adjustments per visit, in dollars. */
  avgAdjustmentsPerVisit: Scalars['Float']['output']
  /** Average gross production per visit, in dollars. */
  avgGrossProductionPerVisit: Scalars['Float']['output']
  /** Average net production per visit, in dollars. */
  avgNetProductionPerVisit: Scalars['Float']['output']
  /** Total collections received, in dollars. */
  collections: Scalars['Float']['output']
  /** Gross production (before adjustments), in dollars. */
  grossProduction: Scalars['Float']['output']
  /** Net production (gross minus adjustments), in dollars. */
  netProduction: Scalars['Float']['output']
}

export type RingCentralPhoneNumber = {
  __typename?: 'RingCentralPhoneNumber'
  /** RingCentral phone number id */
  id: Scalars['String']['output']
  /** Whether this number is already in use by an integration */
  isUsed: Scalars['Boolean']['output']
  /** RingCentral phone number */
  name: Scalars['String']['output']
}

export type Role = {
  __typename?: 'Role'
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Unique identifier for this role. */
  id: Scalars['ID']['output']
  /** Whether this is a system default role provided out of the box. */
  isDefault: Scalars['Boolean']['output']
  /** Human-readable name of the role. */
  name: Scalars['String']['output']
  /** Organization that owns this role (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Permission keys granted to this role (e.g. pages:contacts, roles:manage, org:settings:manage-users). */
  permissions: Array<Scalars['String']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this role is scoped to; null for org-level roles that apply across all workspaces. */
  workspaceId?: Maybe<Scalars['String']['output']>
}

export type RoleListResult = {
  __typename?: 'RoleListResult'
  /** Matching records for the current page. */
  hits: Array<Role>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching records across all pages. */
  total: Scalars['Int']['output']
}

export type SaveIvrConfigInput = {
  /** Whether the IVR phone menu is enabled */
  enabled: Scalars['Boolean']['input']
  /** Location this IVR configuration applies to */
  locationId: Scalars['String']['input']
  /** The IVR menu tree nodes */
  nodes: Scalars['JSON']['input']
  /** Phone number this IVR is attached to */
  phoneNumberId?: InputMaybe<Scalars['String']['input']>
  /** Node id of the IVR menu's entry/root node */
  root?: InputMaybe<Scalars['String']['input']>
}

export type SayThisNotThatRuleInput = {
  /** voice, sms, or both */
  channel: Scalars['String']['input']
  /** Phrase the agent should say instead of the stop phrase. */
  replacementPhrase: Scalars['String']['input']
  /** Phrase the agent should avoid saying. */
  stopPhrase: Scalars['String']['input']
}

export type SayThisNotThatRuleType = {
  __typename?: 'SayThisNotThatRuleType'
  /** voice, sms, or both */
  channel: Scalars['String']['output']
  /** Phrase the agent should say instead of the stop phrase. */
  replacementPhrase: Scalars['String']['output']
  /** Phrase the agent should avoid saying. */
  stopPhrase: Scalars['String']['output']
}

export type ScheduledNewPatientsMetricBucket = {
  __typename?: 'ScheduledNewPatientsMetricBucket'
  /** Time bucket label this count covers. */
  bucket: Scalars['String']['output']
  /** New patient counts for this bucket broken down by channel. */
  byChannel: Array<ChannelCount>
  /** Number of new patients in this bucket. */
  count: Scalars['Int']['output']
}

export type Scheduler = {
  __typename?: 'Scheduler'
  /** Id of the booked appointment in the PMS. */
  appointmentId: Scalars['String']['output']
  /** Type of appointment requested. */
  appointmentType?: Maybe<Scalars['String']['output']>
  /** Patient's date of birth. */
  birthDate?: Maybe<Scalars['DateTime']['output']>
  /** Id of the user who booked the appointment, if booked by staff. */
  bookedByUserId?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Appointment date in date-only (YYYY-MM-DD) form. */
  day?: Maybe<Scalars['String']['output']>
  /** Email address provided during booking. */
  email?: Maybe<Scalars['String']['output']>
  /** Extra booking fields as a JSON string. */
  extraFields?: Maybe<Scalars['String']['output']>
  /** Facebook click id attributed to this booking. */
  fbclid?: Maybe<Scalars['String']['output']>
  /** Google click id attributed to this booking. */
  gclid?: Maybe<Scalars['String']['output']>
  /** Unique identifier for this scheduler booking. */
  id: Scalars['ID']['output']
  /** Whether the booking is for a new patient. */
  isNewPatient?: Maybe<Scalars['Boolean']['output']>
  /** Location the appointment was booked at. */
  locationId: Scalars['String']['output']
  /** Name of the person booking the appointment. */
  name?: Maybe<Scalars['String']['output']>
  /** Id of the operatory (chair/room) booked. */
  operatoryId?: Maybe<Scalars['String']['output']>
  /** Organization that owns this booking (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Id of the patient the appointment is for. */
  patientId: Scalars['String']['output']
  /** Phone number provided during booking. */
  phone?: Maybe<Scalars['String']['output']>
  /** Id of the provider the appointment is with. */
  providerId?: Maybe<Scalars['String']['output']>
  /** Referral URL the booking originated from, used to derive UTM attribution. */
  referralURL?: Maybe<Scalars['String']['output']>
  /** Origin of the booking: 'app' (in-app scheduler) or 'scheduler' (public scheduler). */
  source?: Maybe<Scalars['String']['output']>
  /** Appointment time of day. */
  time?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** UTM account id attributed to this booking. */
  utmAccountId?: Maybe<Scalars['String']['output']>
  /** UTM campaign attributed to this booking. */
  utmCampaign?: Maybe<Scalars['String']['output']>
  /** UTM campaign id attributed to this booking. */
  utmCampaignId?: Maybe<Scalars['String']['output']>
  /** UTM content attributed to this booking. */
  utmContent?: Maybe<Scalars['String']['output']>
  /** UTM keywords/term attributed to this booking. */
  utmKeywords?: Maybe<Scalars['String']['output']>
  /** UTM medium attributed to this booking. */
  utmMedium?: Maybe<Scalars['String']['output']>
  /** UTM source attributed to this booking. */
  utmSource?: Maybe<Scalars['String']['output']>
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this booking belongs to. */
  workspaceId: Scalars['String']['output']
}

export type SchedulerListResult = {
  __typename?: 'SchedulerListResult'
  /** Results for the current page. */
  hits: Array<Scheduler>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type SchedulerNotificationInput = {
  /** Whether scheduler notifications are enabled. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Channels for new-appointment-booked notifications. */
  newAppointmentBooked?: InputMaybe<NotificationChannelInput>
}

export type SchedulerNotificationSettings = {
  __typename?: 'SchedulerNotificationSettings'
  /** Whether scheduler notifications are enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** Channels for new-appointment-booked notifications. */
  newAppointmentBooked?: Maybe<NotificationChannel>
}

export type SchedulingConfiguration = {
  __typename?: 'SchedulingConfiguration'
  /** Whether multiple appointments can be booked in the same slot. */
  allowDoubleBooking?: Maybe<Scalars['Boolean']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Custom questions shown on the scheduling form. */
  customQuestions?: Maybe<Array<CustomQuestion>>
  /** Max concurrent appointments per provider when double booking is on; null or 0 means uncapped. */
  doubleBookingCount?: Maybe<Scalars['Float']['output']>
  /** Scheduling slot granularity in minutes. */
  granularity: Scalars['Float']['output']
  /** Unique identifier for this scheduling configuration. */
  id: Scalars['ID']['output']
  /** Insurance plans this location accepts. */
  insurancesAccepted?: Maybe<Array<Scalars['String']['output']>>
  /** Insurance plans this location does not accept. */
  insurancesRejected?: Maybe<Array<Scalars['String']['output']>>
  /** Whether state-funded insurance is accepted. */
  isStateInsuranceAccepted?: Maybe<Scalars['Boolean']['output']>
  /** Lead-override timing configuration. */
  leadOverrideConfig?: Maybe<LeadOverrideConfig>
  /** Whether lead-override timing is enabled. */
  leadOverrideEnabled?: Maybe<Scalars['Boolean']['output']>
  /** Location this configuration belongs to. */
  locationId: Scalars['String']['output']
  /** Organization that owns this configuration (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this configuration belongs to. */
  workspaceId: Scalars['String']['output']
}

export type SchedulingConfigurationListResult = {
  __typename?: 'SchedulingConfigurationListResult'
  /** Matching records for the current page. */
  hits: Array<SchedulingConfiguration>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching records across all pages. */
  total: Scalars['Int']['output']
}

export type Scorecard = {
  __typename?: 'Scorecard'
  /** Ordered list of column ids. */
  columnOrder?: Maybe<Array<Scalars['String']['output']>>
  /** Per-column visibility toggles keyed by column id. */
  columnVisibility?: Maybe<Scalars['JSON']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Selected reporting date range, e.g. today, this_week, this_month, last_30_days, last_12_months. */
  dateRange?: Maybe<Scalars['String']['output']>
  /** Whether this is the workspace's default scorecard. */
  default?: Maybe<Scalars['Boolean']['output']>
  /** How rows are grouped: by 'Location' or by 'Staff'. */
  grouping: Scalars['String']['output']
  /** Unique identifier for this scorecard. */
  id: Scalars['ID']['output']
  /** Number of prior periods to include for comparison. */
  lookbackAmount?: Maybe<Scalars['Int']['output']>
  /** Comparison mode for prior periods: 'trailing_periods' or 'year_over_year'. */
  lookbackType?: Maybe<Scalars['String']['output']>
  /** Display name of the scorecard. */
  name: Scalars['String']['output']
  /** Ids of the locations or staff included in the scorecard. */
  objectIds?: Maybe<Array<Scalars['String']['output']>>
  /** Organization that owns this scorecard (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Sort configuration: column id and descending flag. */
  sort?: Maybe<Scalars['JSON']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this scorecard belongs to. */
  workspaceId: Scalars['String']['output']
}

export type ScorecardListResult = {
  __typename?: 'ScorecardListResult'
  /** Matching items for this page. */
  hits: Array<Scorecard>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching items across all pages. */
  total: Scalars['Int']['output']
}

export type ScorecardMetricsRow = {
  __typename?: 'ScorecardMetricsRow'
  /** Customer acquisition cost for this row, in dollars. */
  CAC: Scalars['Float']['output']
  /** Cost per appointment for this row, in dollars. */
  CPA: Scalars['Float']['output']
  /** Cost per lead for this row, in dollars. */
  CPL: Scalars['Float']['output']
  /** Cost per qualified lead for this row, in dollars. */
  CPQL: Scalars['Float']['output']
  /** Number of marketing-qualified leads in this row. */
  MQLs: Scalars['Int']['output']
  /** Return on investment for this row. */
  ROI: Scalars['Float']['output']
  /** Number of appointments in this row. */
  appointments: Scalars['Int']['output']
  /** Time bucket label this row covers. */
  bucket: Scalars['String']['output']
  /** Budget for this row, in dollars. */
  budget: Scalars['Float']['output']
  /** Number of leads in this row. */
  leads: Scalars['Int']['output']
  /** Number of leads that reached closed-lost. */
  leadsClosedLost: Scalars['Int']['output']
  /** Number of leads that reached closed-won. */
  leadsClosedWon: Scalars['Int']['output']
  /** Number of leads currently in progress. */
  leadsInProgress: Scalars['Int']['output']
  /** Number of leads currently needing action. */
  leadsNeedsAction: Scalars['Int']['output']
  /** Number of leads currently scheduled. */
  leadsScheduled: Scalars['Int']['output']
  /** Number of new patients in this row. */
  patients: Scalars['Int']['output']
  /** Period label for this row, when applicable. */
  period?: Maybe<Scalars['String']['output']>
  /** Realized production in this row, in dollars. */
  production: Scalars['Float']['output']
  /** Share of leads that became scheduled, as a rate. */
  scheduleRate: Scalars['Float']['output']
  /** Scheduled production in this row, in dollars. */
  scheduledProduction: Scalars['Float']['output']
  /** Nested sub-rows making up this row's breakdown. */
  subRows?: Maybe<Array<ScorecardMetricsRow>>
  /** Total ad spend for this row, in dollars. */
  totalSpend: Scalars['Float']['output']
}

/** A welcome or completion screen */
export type ScreenContentInput = {
  /** Screen body text. */
  body: Scalars['String']['input']
  /** Screen heading text. */
  title: Scalars['String']['input']
}

export type SendContactEmailInput = {
  /** Inline attachments. Max 10 files, 10 MB total. */
  attachments?: InputMaybe<Array<EmailAttachmentInput>>
  /** Contact to email. */
  contactId: Scalars['String']['input']
  /** HTML body. Sanitized server-side to a safe allowlist. */
  html: Scalars['String']['input']
  /** Sending location (owns the From identity). */
  locationId: Scalars['String']['input']
  /** Email subject line. */
  subject: Scalars['String']['input']
  /** Recipient address. Defaults to the contact's email when omitted. */
  to?: InputMaybe<Scalars['String']['input']>
}

export type SendMessageInput = {
  /** Message category: transactional (default) or marketing */
  category?: InputMaybe<Scalars['String']['input']>
  /** Contact ID. Required for contact-based sends. */
  contactId?: InputMaybe<Scalars['String']['input']>
  /** Bypass RCS, send SMS only */
  forceSms?: InputMaybe<Scalars['Boolean']['input']>
  /** Explicit sending number. If omitted, uses location default. */
  from?: InputMaybe<Scalars['String']['input']>
  /** Outbound images as base64 */
  images?: InputMaybe<Array<MessageImageInput>>
  /** Sending location that owns the from number. */
  locationId: Scalars['String']['input']
  /** Optional RCS rich card content */
  rcsCard?: InputMaybe<RcsCardInput>
  /** If set, hold the message and send it at this instant instead of immediately. */
  sendDate?: InputMaybe<Scalars['DateTime']['input']>
  /** Message body text. */
  text: Scalars['String']['input']
  /** Recipient phone number. Required for number-based sends. */
  to?: InputMaybe<Scalars['String']['input']>
}

export type SendingDomain = {
  __typename?: 'SendingDomain'
  /** When this sending domain was created */
  createdDate: Scalars['DateTime']['output']
  /** DNS records the customer must publish to verify the domain. */
  dnsRecords?: Maybe<Array<SendingDomainDnsRecord>>
  /** The domain, e.g. mail.smithdental.com */
  domain: Scalars['String']['output']
  /** Unique identifier for this sending domain */
  id: Scalars['ID']['output']
  /** Organization that owns this sending domain (multi-tenant isolation key) */
  orgId: Scalars['String']['output']
  /** SES verification status: pending, verified, failed */
  status: Scalars['String']['output']
  /** Domain type: trackable (shared) or custom (customer-owned) */
  type: Scalars['String']['output']
  /** When this sending domain was last updated */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this sending domain belongs to */
  workspaceId: Scalars['String']['output']
}

export type SendingDomainDnsRecord = {
  __typename?: 'SendingDomainDnsRecord'
  /** Whether this record currently resolves correctly at the domain's DNS. Null until the domain is verified. */
  found?: Maybe<Scalars['Boolean']['output']>
  /** DNS record hostname the customer must create */
  name: Scalars['String']['output']
  /** CNAME, TXT, etc. */
  type: Scalars['String']['output']
  /** DNS record value the customer must set for the hostname */
  value: Scalars['String']['output']
}

export type SendingDomainListResult = {
  __typename?: 'SendingDomainListResult'
  /** Results for the current page. */
  hits: Array<SendingDomain>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type SetLocationEmailIdentityInput = {
  /** The shared Trackable sending domain, used instead of sendingDomainId. */
  domain?: InputMaybe<Scalars['String']['input']>
  /** Display name on the From header. */
  fromName?: InputMaybe<Scalars['String']['input']>
  /** Local part of the From address. Unique per domain. */
  localPart: Scalars['String']['input']
  /** Location to set the From identity for. */
  locationId: Scalars['String']['input']
  /** Reply-To address for this location. */
  replyTo?: InputMaybe<Scalars['String']['input']>
  /** The verified custom SendingDomain to send from. Omit when using the shared Trackable domain. */
  sendingDomainId?: InputMaybe<Scalars['String']['input']>
}

export type SetupIntegrationInput = {
  /** Access token credential for the integration */
  accessToken?: InputMaybe<Scalars['String']['input']>
  /** Account id for the integration */
  accountId?: InputMaybe<Scalars['String']['input']>
  /** Account key credential for the integration */
  accountKey?: InputMaybe<Scalars['String']['input']>
  /** Twilio account SID */
  accountSID?: InputMaybe<Scalars['String']['input']>
  /** Account URL for the integration */
  accountUrl?: InputMaybe<Scalars['String']['input']>
  /** Ascend organization id */
  ascendOrgId?: InputMaybe<Scalars['String']['input']>
  /** Auth token credential for the integration */
  authToken?: InputMaybe<Scalars['String']['input']>
  /** Client id credential for the integration */
  clientId?: InputMaybe<Scalars['String']['input']>
  /** Client secret credential for the integration */
  clientSecret?: InputMaybe<Scalars['String']['input']>
  /** JWT credential for the integration */
  jwt?: InputMaybe<Scalars['String']['input']>
  /** Password credential for the integration */
  password?: InputMaybe<Scalars['String']['input']>
  /** Token credential for the integration */
  token?: InputMaybe<Scalars['String']['input']>
  /** Username credential for the integration */
  username?: InputMaybe<Scalars['String']['input']>
}

export type ShadowStats = {
  __typename?: 'ShadowStats'
  /** Average match score across shadow extractions. */
  avgMatchScore: Scalars['Int']['output']
  /** Per-workspace extraction counts. */
  byWorkspace: Array<WorkspaceStat>
  /** Shadow extractions in the last 24 hours. */
  last24h: Scalars['Int']['output']
  /** Total number of shadow extractions. */
  total: Scalars['Int']['output']
}

/** One level of conditional display: show this question when another equals a value */
export type ShowWhenInput = {
  /** Value the controlling question must equal for this question to show. */
  equals: Scalars['String']['input']
  /** Id of the question this visibility condition depends on. */
  questionId: Scalars['String']['input']
}

export type SikkaOffice = {
  __typename?: 'SikkaOffice'
  /** Sikka office id */
  id: Scalars['String']['output']
  /** Sikka office name */
  name: Scalars['String']['output']
  /** Practices belonging to this Sikka office */
  practices: Array<SikkaPractice>
}

export type SikkaPractice = {
  __typename?: 'SikkaPractice'
  /** Sikka practice id */
  id: Scalars['String']['output']
  /** Whether this practice is already in use by an integration */
  isUsed: Scalars['Boolean']['output']
  /** Sikka practice name */
  name: Scalars['String']['output']
}

export type SmsDailyCounts = {
  __typename?: 'SmsDailyCounts'
  /** Number of AI agent texts on this day. */
  agentTexts: Scalars['Int']['output']
  /** AI reply failures on this day. */
  aiReplyFailures: Scalars['Int']['output']
  /** Carrier-failed texts on this day. */
  carrierFailedTexts: Scalars['Int']['output']
  /** Day these counts fall on, as YYYY-MM-DD in the request timezone. */
  date: Scalars['String']['output']
  /** Number of inbound texts on this day. */
  inbound: Scalars['Int']['output']
  /** Manual-toggle takeovers on this day. */
  manualToggleTakeovers: Scalars['Int']['output']
  /** No-consent blocked texts on this day. */
  noConsentTexts: Scalars['Int']['output']
  /** Opt-out takeovers on this day. */
  optOutTakeovers: Scalars['Int']['output']
  /** Opt-outs recorded on this day. */
  optOuts: Scalars['Int']['output']
  /** Other texts on this day (external plus voice-agent texts). */
  otherTexts: Scalars['Int']['output']
  /** Quiet-hours blocked texts on this day. */
  quietHoursTexts: Scalars['Int']['output']
  /** Staff-reply takeovers on this day. */
  staffReplyTakeovers: Scalars['Int']['output']
  /** Number of staff texts on this day. */
  staffTexts: Scalars['Int']['output']
  /** Texts stuck pending on this day. */
  stuckPendingTexts: Scalars['Int']['output']
  /** Undelivered texts on this day. */
  undeliveredTexts: Scalars['Int']['output']
  /** Number of workflow texts on this day. */
  workflowTexts: Scalars['Int']['output']
}

export type SmsDailyMetricsResponse = {
  __typename?: 'SmsDailyMetricsResponse'
  /** Totals per day across all locations in scope, for the charts. */
  daily: Array<SmsDailyCounts>
  /** Per-SMS-Agent-location daily AI texts plus last AI text before the range, for the grid. */
  locations: Array<SmsLocationDailyReplies>
}

export type SmsLocationCompareCounts = {
  __typename?: 'SmsLocationCompareCounts'
  /** Number of AI conversations in the comparison period. */
  aiConversations: Scalars['Int']['output']
  /** Number of inbound threads in the comparison period. */
  inboundThreads: Scalars['Int']['output']
  /** Location these comparison-period counts are for. */
  locationId: Scalars['ID']['output']
  /** Number of takeovers in the comparison period. */
  takeovers: Scalars['Int']['output']
  /** Number of unanswered threads in the comparison period. */
  unansweredThreads: Scalars['Int']['output']
}

export type SmsLocationCounts = {
  __typename?: 'SmsLocationCounts'
  /** Number of texts sent by the AI agent. */
  agentTexts: Scalars['Int']['output']
  /** Number of AI agent conversations. */
  aiConversations: Scalars['Int']['output']
  /** Total AI cost at this location, in dollars. */
  aiCostUsd: Scalars['Float']['output']
  /** Sum of AI reply latency across turns, in milliseconds. */
  aiLatencyMsTotal: Scalars['Float']['output']
  /** Number of AI reply failures. */
  aiReplyFailures: Scalars['Int']['output']
  /** Number of AI agent turns. */
  aiTurns: Scalars['Int']['output']
  /** Number of appointment bookings from SMS. */
  bookings: Scalars['Int']['output']
  /** Number of texts that failed at the carrier. */
  carrierFailedTexts: Scalars['Int']['output']
  /** Number of texts sent by external senders. */
  externalTexts: Scalars['Int']['output']
  /** Number of failed texts (the five group counts below sum to this). */
  failedTexts: Scalars['Int']['output']
  /** Number of inbound texts. */
  inbound: Scalars['Int']['output']
  /** Number of inbound conversation threads. */
  inboundThreads: Scalars['Int']['output']
  /** Latest AI agent text at the location, any time up to the range's toDate. */
  lastAgentTextDate?: Maybe<Scalars['String']['output']>
  /** Location these counts are for ("total" on the total row). */
  locationId: Scalars['ID']['output']
  /** Location display name. */
  locationName?: Maybe<Scalars['String']['output']>
  /** Takeovers caused by a manual AI-off toggle. */
  manualToggleTakeovers: Scalars['Int']['output']
  /** Number of texts blocked due to no consent. */
  noConsentTexts: Scalars['Int']['output']
  /** Takeovers caused by an opt-out. */
  optOutTakeovers: Scalars['Int']['output']
  /** Number of opt-outs recorded. */
  optOuts: Scalars['Int']['output']
  /** Number of outbound texts (equals the five sender counts' sum). */
  outbound: Scalars['Int']['output']
  /** Number of texts blocked by quiet-hours rules. */
  quietHoursTexts: Scalars['Int']['output']
  /** Number of AI conversations that received a reply. */
  repliedConversations: Scalars['Int']['output']
  /** Takeovers caused by a staff reply. */
  staffReplyTakeovers: Scalars['Int']['output']
  /** Sum of staff response time across responses, in minutes. */
  staffResponseMinutesTotal: Scalars['Float']['output']
  /** Number of staff responses. */
  staffResponses: Scalars['Int']['output']
  /** Number of texts sent by staff. */
  staffTexts: Scalars['Int']['output']
  /** Number of texts stuck in a pending state. */
  stuckPendingTexts: Scalars['Int']['output']
  /** Distinct threads whose AI was turned off in range (the three cause counts sum to this). */
  takeovers: Scalars['Int']['output']
  /** Number of AI turns that hit a tool error. */
  toolErrorTurns: Scalars['Int']['output']
  /** Number of inbound threads that went unanswered. */
  unansweredThreads: Scalars['Int']['output']
  /** Number of texts that were undelivered. */
  undeliveredTexts: Scalars['Int']['output']
  /** Number of texts sent by the voice agent. */
  voiceAgentTexts: Scalars['Int']['output']
  /** Number of texts sent by workflows. */
  workflowTexts: Scalars['Int']['output']
  /** Workspace this location belongs to. */
  workspaceId?: Maybe<Scalars['String']['output']>
  /** Workspace display name. */
  workspaceName?: Maybe<Scalars['String']['output']>
}

export type SmsLocationDailyReplies = {
  __typename?: 'SmsLocationDailyReplies'
  /** One entry per day with at least one AI agent text; days without are omitted. */
  days: Array<SmsLocationDayCount>
  /** Last day with an AI agent text before the range starts; null when there is none. */
  lastAgentTextBeforeRange?: Maybe<Scalars['String']['output']>
  /** Location these daily reply counts are for. */
  locationId: Scalars['ID']['output']
}

export type SmsLocationDayCount = {
  __typename?: 'SmsLocationDayCount'
  /** Number of AI agent texts at the location on this day. */
  agentTexts: Scalars['Int']['output']
  /** Day this count falls on, as YYYY-MM-DD. */
  date: Scalars['String']['output']
}

export type SmsLocationMetricsResponse = {
  __typename?: 'SmsLocationMetricsResponse'
  /** Per-location comparison counts; present only when compareDateRange was supplied. */
  compareRows?: Maybe<Array<SmsLocationCompareCounts>>
  /** Comparison-period total; present only when compareDateRange was supplied. */
  compareTotal?: Maybe<SmsLocationCompareCounts>
  /** One row per location with SMS activity in scope. */
  rows: Array<SmsLocationCounts>
  /** The weighted total across every location in scope. */
  total: SmsLocationCounts
}

export type SmsNumber = {
  __typename?: 'SmsNumber'
  /** Human-readable label for this number. */
  label?: Maybe<Scalars['String']['output']>
  /** The SMS phone number. */
  phone: Scalars['String']['output']
  /** Telephony provider for this number. */
  provider: Scalars['String']['output']
  /** 10DLC/toll-free registration status of this number. */
  registrationStatus?: Maybe<Scalars['String']['output']>
}

export type SmsOpsMetrics = {
  __typename?: 'SmsOpsMetrics'
  /** Inbound texts the AI agent answered first. */
  agentReplied: Scalars['Int']['output']
  /** AI-answered texts whose first reply took more than 5 minutes (replied late). */
  agentRepliedLate: Scalars['Int']['output']
  /** Average minutes to the first AI reply, over agent-answered texts. Null when none. */
  avgAgentReplyMinutes?: Maybe<Scalars['Float']['output']>
  /** Average minutes to the first staff reply, over staff-answered texts. Null when none. */
  avgStaffReplyMinutes?: Maybe<Scalars['Float']['output']>
  /** Inbound texts a human staff member answered first. */
  staffReplied: Scalars['Int']['output']
  /** Inbound patient texts in the window. */
  totalInbound: Scalars['Int']['output']
  /** Inbound patient texts with no reply, or a first reply later than 24 hours. */
  unanswered: Scalars['Int']['output']
}

export type SmsStaffTakeoverCounts = {
  __typename?: 'SmsStaffTakeoverCounts'
  /** ISO date of this person's most recent takeover in the range (the first takeover of their latest thread). */
  lastTakeoverDate: Scalars['String']['output']
  /** Location these takeovers occurred at. */
  locationId: Scalars['ID']['output']
  /** Location display name. */
  locationName?: Maybe<Scalars['String']['output']>
  /** Takeovers where the staff member replied on the thread (staffReplied + staffTurnedOff = total). */
  staffReplied: Scalars['Int']['output']
  /** Takeovers where the staff member turned the AI off via the inbox toggle. */
  staffTurnedOff: Scalars['Int']['output']
  /** Total takeovers by this staff member at this location. */
  total: Scalars['Int']['output']
  /** Staff member (user) these takeover counts are for. */
  userId: Scalars['ID']['output']
  /** Staff member's name, resolved server-side; null when the user record can't be found. */
  userName?: Maybe<Scalars['String']['output']>
  /** Workspace this location belongs to. */
  workspaceId?: Maybe<Scalars['ID']['output']>
  /** Workspace display name. */
  workspaceName?: Maybe<Scalars['String']['output']>
}

export type SmsStaffTakeoverResponse = {
  __typename?: 'SmsStaffTakeoverResponse'
  /** One row per staff member + location with a takeover in scope. */
  rows: Array<SmsStaffTakeoverCounts>
}

export type SmsTemplate = {
  __typename?: 'SmsTemplate'
  /** Message body text sent when the template is used. */
  body: Scalars['String']['output']
  /** When the template was created. */
  createdDate: Scalars['DateTime']['output']
  /** Unique identifier for the SMS template. */
  id: Scalars['ID']['output']
  /** Human-readable name of the template. */
  name: Scalars['String']['output']
  /** Organization that owns this template (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** When the template was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this template belongs to. */
  workspaceId: Scalars['String']['output']
}

export type SmsTemplateListResult = {
  __typename?: 'SmsTemplateListResult'
  /** Results for the current page. */
  hits: Array<SmsTemplate>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type SortInput = {
  /** Default sort direction (asc or desc) applied to keys that do not carry their own. */
  direction?: SortDirection
  /** Field to sort by. Pass a comma-separated list to sort by multiple keys in priority order (e.g. `date,time` sorts by day, then by time within the day). A key may carry its own `asc`/`desc` direction (e.g. `date:asc,time:desc`); keys without one use the top-level `direction`. */
  field: Scalars['String']['input']
}

export type Staff = {
  __typename?: 'Staff'
  /** Alternative names or nicknames used to match this staff member in imports and historical data. */
  aliases?: Maybe<Array<Scalars['String']['output']>>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Unique identifier for the staff member (auto-generated if not provided). */
  id: Scalars['ID']['output']
  /** Display name of the staff member, typically the full professional name. */
  name: Scalars['String']['output']
  /** Organization that owns this staff member (multi-tenant isolation key). */
  orgId: Scalars['ID']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Optional linked User account; when set, this staff member can log into the system. */
  userId?: Maybe<Scalars['ID']['output']>
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this staff member belongs to (workspace-level access control). */
  workspaceId: Scalars['ID']['output']
}

export type StaffBreakdownResponse = {
  __typename?: 'StaffBreakdownResponse'
  /** Per-staff-member breakdown rows. */
  hits: Array<StaffBreakdownRow>
}

export type StaffBreakdownRow = {
  __typename?: 'StaffBreakdownRow'
  /** Share of new-patient calls that became scheduled, as a rate. */
  NPCallScheduleRate: Scalars['Float']['output']
  /** Average call duration, in seconds. */
  averageDuration: Scalars['Float']['output']
  /** Time bucket label this row covers. */
  bucket: Scalars['String']['output']
  /** Day this row covers, as a date string. */
  date: Scalars['String']['output']
  /** Number of new-patient calls marked disqualified. */
  disqualifiedNPCalls: Scalars['Int']['output']
  /** Staff member (user) id this row is for. */
  id: Scalars['ID']['output']
  /** Whether this row represents a staff member (vs. the voice agent). */
  isStaff: Scalars['Boolean']['output']
  /** Number of new-patient calls handled. */
  newPatientCalls: Scalars['Int']['output']
  /** Number of new-patient calls marked qualified. */
  qualifiedNPCalls: Scalars['Int']['output']
  /** Number of new-patient calls that resulted in a scheduled appointment. */
  scheduledNPCalls: Scalars['Int']['output']
  /** Average speed-to-lead (time to first response), in minutes. */
  speedToLead: Scalars['Float']['output']
  /** Number of new-patient calls that did not result in a scheduled appointment. */
  unscheduledNPCalls: Scalars['Int']['output']
}

export type StaffConversionMetric = {
  __typename?: 'StaffConversionMetric'
  /** Number of leads this user disqualified. */
  disqualified: Scalars['Int']['output']
  /** Number of leads handled by this user. */
  leads: Scalars['Int']['output']
  /** Number of leads this user qualified. */
  qualified: Scalars['Int']['output']
  /** User the conversion metric is for. */
  userId: Scalars['String']['output']
  /** Display name of the user. */
  userName: Scalars['String']['output']
}

export type StaffListResult = {
  __typename?: 'StaffListResult'
  /** Staff members matching the query for the current page */
  hits: Array<Staff>
  /** Current page number (1-based) */
  page: Scalars['Int']['output']
  /** Total number of staff members matching the query */
  total: Scalars['Int']['output']
}

export type StaffResult = {
  __typename?: 'StaffResult'
  /** Alternate names the staff member is also known by */
  aliases?: Maybe<Array<Scalars['String']['output']>>
  /** Error message when the operation failed */
  error?: Maybe<Scalars['String']['output']>
  /** Unique identifier of the staff member */
  id?: Maybe<Scalars['ID']['output']>
  /** Whether the name or an alias already exists for another staff member */
  isDuplicated?: Maybe<Scalars['Boolean']['output']>
  /** Display name of the staff member */
  name?: Maybe<Scalars['String']['output']>
  /** Linked user account id, if the staff member has one */
  userId?: Maybe<Scalars['ID']['output']>
}

export type StaffSummary = {
  __typename?: 'StaffSummary'
  /** Alternate names/aliases for the staff member. */
  aliases?: Maybe<Array<Scalars['String']['output']>>
  /** Identifier of the staff member. */
  id?: Maybe<Scalars['ID']['output']>
  /** Display name of the staff member. */
  name: Scalars['String']['output']
  /** User account linked to this staff member, if any. */
  userId?: Maybe<Scalars['ID']['output']>
}

export type StoredCredential = {
  __typename?: 'StoredCredential'
  /** User id that created this credential. */
  createdBy: Scalars['String']['output']
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Unique identifier for this stored credential. */
  id: Scalars['ID']['output']
  /** Human-readable label identifying what this credential is for. */
  label: Scalars['String']['output']
  /** Location this credential is scoped to, if any. */
  locationId?: Maybe<Scalars['String']['output']>
  /** Free-form metadata associated with this credential. */
  metadata?: Maybe<Scalars['String']['output']>
  /** Organization that owns this credential (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** User id that last updated this credential. */
  updatedBy: Scalars['String']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Username for the stored credential. */
  username: Scalars['String']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this credential belongs to. */
  workspaceId: Scalars['String']['output']
}

export type StoredCredentialListResult = {
  __typename?: 'StoredCredentialListResult'
  /** Matching stored credentials for this page (secrets omitted). */
  hits: Array<StoredCredential>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching credentials across all pages. */
  total: Scalars['Int']['output']
}

export type StoredCredentialSecret = {
  __typename?: 'StoredCredentialSecret'
  /** ID of the stored credential. */
  id: Scalars['ID']['output']
  /** Decrypted password for the credential. */
  password: Scalars['String']['output']
}

export type SuperNotificationSettings = {
  __typename?: 'SuperNotificationSettings'
  /** Whether alerts about agent appointment-type changes are emailed to this super user. */
  agentChangeAppointmentTypes: Scalars['Boolean']['output']
  /** Whether alerts about agent business-detail changes are emailed to this super user. */
  agentChangeBusinessDetails: Scalars['Boolean']['output']
  /** Whether alerts about agent offer changes are emailed to this super user. */
  agentChangeOffers: Scalars['Boolean']['output']
  /** Whether alerts about agent service changes are emailed to this super user. */
  agentChangeServices: Scalars['Boolean']['output']
  /** Whether agent change alerts are enabled for this super user. */
  agentChangesEnabled: Scalars['Boolean']['output']
  /** Whether agent diagnostics alerts are enabled for this super user. */
  enabled: Scalars['Boolean']['output']
  /** Whether alerts for agents with no calls in 48 hours are emailed to this super user. */
  noCallsIn48h: Scalars['Boolean']['output']
  /** Whether duplicate tool call alerts are emailed to this super user. */
  toolDuplicate: Scalars['Boolean']['output']
  /** Whether tool error alerts are emailed to this super user. */
  toolError: Scalars['Boolean']['output']
  /** Whether tool timeout alerts are emailed to this super user. */
  toolTimeout: Scalars['Boolean']['output']
}

export type SuperNotificationSettingsInput = {
  /** Enable or disable alerts about agent appointment-type changes. */
  agentChangeAppointmentTypes?: InputMaybe<Scalars['Boolean']['input']>
  /** Enable or disable alerts about agent business-detail changes. */
  agentChangeBusinessDetails?: InputMaybe<Scalars['Boolean']['input']>
  /** Enable or disable alerts about agent offer changes. */
  agentChangeOffers?: InputMaybe<Scalars['Boolean']['input']>
  /** Enable or disable alerts about agent service changes. */
  agentChangeServices?: InputMaybe<Scalars['Boolean']['input']>
  /** Enable or disable agent change alerts for this super user. */
  agentChangesEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Enable or disable agent diagnostics alerts for this super user. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Enable or disable alerts for agents with no calls in 48 hours. */
  noCallsIn48h?: InputMaybe<Scalars['Boolean']['input']>
  /** Enable or disable emailed duplicate tool call alerts. */
  toolDuplicate?: InputMaybe<Scalars['Boolean']['input']>
  /** Enable or disable emailed tool error alerts. */
  toolError?: InputMaybe<Scalars['Boolean']['input']>
  /** Enable or disable emailed tool timeout alerts. */
  toolTimeout?: InputMaybe<Scalars['Boolean']['input']>
}

export type SyncRun = {
  __typename?: 'SyncRun'
  /** When the run completed; unset if still running. */
  completedAt?: Maybe<Scalars['DateTime']['output']>
  /** Connector type the run used. */
  connectorType: ConnectorType
  /** Entity type the run synced. */
  entityType: EntityType
  /** Error message when the run failed. */
  errorMessage?: Maybe<Scalars['String']['output']>
  /** Unique identifier for the sync run. */
  id: Scalars['ID']['output']
  /** Location this sync run belongs to. */
  locationId: Scalars['ID']['output']
  /** Number of records processed by the run. */
  recordsProcessed?: Maybe<Scalars['Int']['output']>
  /** When the run started. */
  startedAt: Scalars['DateTime']['output']
  /** Whether the run succeeded. */
  success?: Maybe<Scalars['Boolean']['output']>
}

export type SyncRunConnection = {
  __typename?: 'SyncRunConnection'
  /** Sync runs for the current page. */
  nodes: Array<SyncRun>
  /** Pagination metadata. */
  pageInfo: PageInfo
}

export type SyncRunFilter = {
  /** Limit results to these connector types. */
  connectorType?: InputMaybe<Array<ConnectorType>>
  /** Limit results to these entity types. */
  entityType?: InputMaybe<Array<EntityType>>
  /** Limit results to this location. */
  locationId?: InputMaybe<Scalars['ID']['input']>
  /** Limit results to this organization. */
  orgId?: InputMaybe<Scalars['ID']['input']>
  /** Only include runs started after this time. */
  startedAfter?: InputMaybe<Scalars['DateTime']['input']>
  /** Only include runs started before this time. */
  startedBefore?: InputMaybe<Scalars['DateTime']['input']>
  /** Limit results by success state. */
  success?: InputMaybe<Scalars['Boolean']['input']>
}

export type TagColor = {
  __typename?: 'TagColor'
  /** CSS background color class for the tag; defaults to bg-tags-silver. */
  color?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Entity type the tag applies to: Location, Workspace, Contact, Activity, Call, or Form. */
  entity: Scalars['String']['output']
  /** Unique identifier, composed from org, workspace, entity, and cleaned tag name. */
  id: Scalars['ID']['output']
  /** Whether this is an organization-level tag shared across all workspaces. */
  isOrgTag: Scalars['Boolean']['output']
  /** Timestamp when this tag was last used. */
  lastUsedDate?: Maybe<Scalars['DateTime']['output']>
  /** The tag name this color applies to. */
  name: Scalars['String']['output']
  /** Organization that owns this tag color (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this tag color belongs to; null for org-level tags. */
  workspaceId?: Maybe<Scalars['String']['output']>
}

export type TagColorListResult = {
  __typename?: 'TagColorListResult'
  /** Matching records for the current page. */
  hits: Array<TagColor>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching records across all pages. */
  total: Scalars['Int']['output']
}

export type Task = {
  __typename?: 'Task'
  /** Whether this task has been archived. */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** User who completed this task, recorded when it is closed. */
  completedByUserId?: Maybe<Scalars['ID']['output']>
  /** Contact this task relates to, when applicable. */
  contactId?: Maybe<Scalars['ID']['output']>
  /** User who created this task. */
  createdById: Scalars['ID']['output']
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Optional longer description of the task. */
  description?: Maybe<Scalars['String']['output']>
  /** Date the task is due. */
  dueDate: Scalars['DateTime']['output']
  /** Unique identifier for the task. */
  id: Scalars['ID']['output']
  /** Location this task is associated with. */
  locationId: Scalars['ID']['output']
  /** Organization that owns this task (multi-tenant isolation key). */
  orgId: Scalars['ID']['output']
  /** User assigned to own this task, when applicable. */
  ownerId?: Maybe<Scalars['ID']['output']>
  /** Role assigned to own this task (role-owned tasks have no single user owner). */
  roleId?: Maybe<Scalars['ID']['output']>
  /** Task status: open or closed. */
  status: Scalars['String']['output']
  /** Short title of the task. */
  title: Scalars['String']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this task belongs to. */
  workspaceId: Scalars['ID']['output']
}

export type TaskListResult = {
  __typename?: 'TaskListResult'
  /** Results for the current page. */
  hits: Array<Task>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type TaskTemplate = {
  __typename?: 'TaskTemplate'
  /** When the task template was created */
  createdDate: Scalars['DateTime']['output']
  /** Description applied to tasks created from this template */
  description?: Maybe<Scalars['String']['output']>
  /** Number of days from creation until the task is due */
  dueInDays?: Maybe<Scalars['Int']['output']>
  /** Unique identifier for the task template */
  id: Scalars['ID']['output']
  /** Internal name of the task template */
  name: Scalars['String']['output']
  /** Organization that owns this task template (multi-tenant isolation key) */
  orgId: Scalars['String']['output']
  /** Default owner (user id) assigned to tasks created from this template */
  ownerId?: Maybe<Scalars['String']['output']>
  /** Title applied to tasks created from this template */
  title: Scalars['String']['output']
  /** When the task template was last updated */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this task template belongs to */
  workspaceId: Scalars['String']['output']
}

export type TaskTemplateListResult = {
  __typename?: 'TaskTemplateListResult'
  /** Results for the current page. */
  hits: Array<TaskTemplate>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type TextMessagesNotificationInput = {
  /** Whether text-message notifications are enabled. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Channels for new-text-message notifications. */
  newTextMessage?: InputMaybe<NotificationChannelInput>
}

export type TextMessagesNotificationSettings = {
  __typename?: 'TextMessagesNotificationSettings'
  /** Whether text-message notifications are enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** Channels for new-text-message notifications. */
  newTextMessage?: Maybe<NotificationChannel>
}

export type Thread = {
  __typename?: 'Thread'
  /** The workflow that supplied the active brief. */
  activeWorkflowId?: Maybe<Scalars['ID']['output']>
  /** Activity that started the active agent conversation, when the handoff workflow was activity-triggered. */
  agentActivityId?: Maybe<Scalars['ID']['output']>
  /** The brief the AI agent works to on this thread; a workflow sets it at handoff and one is active at a time. */
  agentBrief?: Maybe<Scalars['String']['output']>
  /** When the active brief was set. */
  agentBriefSetDate?: Maybe<Scalars['DateTime']['output']>
  /** When the agent last sent a message on this thread. */
  agentLastMessageDate?: Maybe<Scalars['DateTime']['output']>
  /** Next legal send time for a reply held for quiet hours; cleared on a successful send. */
  agentReplyDueDate?: Maybe<Scalars['DateTime']['output']>
  /** Whether AI is enabled for this thread; undefined means no inbound AI replies until a workflow enables it. */
  aiEnabled?: Maybe<Scalars['Boolean']['output']>
  /** Timestamp when this thread was created. */
  createdDate: Scalars['DateTime']['output']
  /** Same value as Message.threadId: md5(locationId + normalizedExternalPhone) for SMS, or the Gmail threadId for email. */
  id: Scalars['ID']['output']
  /** When the most recent inbound (patient) message arrived on this thread. */
  lastIncomingMessageDate?: Maybe<Scalars['DateTime']['output']>
  /** When the most recent outbound (staff/agent/workflow) message was sent on this thread. */
  lastOutgoingMessageDate?: Maybe<Scalars['DateTime']['output']>
  /** Location (phone line or mailbox) this thread belongs to. */
  locationId: Scalars['String']['output']
  /** Display name for this thread (e.g. contact name or phone number). */
  name?: Maybe<Scalars['String']['output']>
  /** When the name was last set or cleared. */
  nameSetAtDate?: Maybe<Scalars['DateTime']['output']>
  /** User who last set or cleared the name. */
  nameSetByUserId?: Maybe<Scalars['ID']['output']>
  /** Organization that owns this thread (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** The external phone number on this thread (E.164), i.e. the patient's number. */
  phone?: Maybe<Scalars['String']['output']>
  /** Timestamp when this thread was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace within the org, set from the authenticated user on creation. */
  workspaceId: Scalars['String']['output']
}

export type ThreadListResult = {
  __typename?: 'ThreadListResult'
  /** Results for the current page. */
  hits: Array<Thread>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type Transaction = {
  __typename?: 'Transaction'
  /** Monetary value of the transaction; positive for charges, negative for adjustments/refunds. */
  amount?: Maybe<Scalars['Float']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Unique transaction identifier; vendor-prefixed and used to dedupe/link transactions across PMS systems. */
  id: Scalars['ID']['output']
  /** Location/practice this transaction occurred at. */
  locationId: Scalars['ID']['output']
  /** Organization that owns this transaction (multi-tenant isolation key). */
  orgId?: Maybe<Scalars['String']['output']>
  /** Patient this transaction belongs to; key for patient lifecycle and LTV calculations. */
  patientId: Scalars['ID']['output']
  /** ADA procedure code for the dental treatment; drives treatment categorization and broken-appointment detection. */
  procedureCode?: Maybe<Scalars['String']['output']>
  /** Human-readable description of the dental procedure. */
  procedureDescription?: Maybe<Scalars['String']['output']>
  /** Healthcare provider(s) who performed the procedure; may be comma-separated for multi-provider procedures. */
  providerId?: Maybe<Scalars['String']['output']>
  /** Sikka office identifier used for Sikka PMS integration and ID/location mapping. */
  sikkaOfficeId?: Maybe<Scalars['String']['output']>
  /** Date the procedure or transaction occurred; central to appointment matching and patient-journey analytics. */
  transactionDate?: Maybe<Scalars['DateTime']['output']>
  /** Date the transaction was entered into the source PMS. */
  transactionEntryDate?: Maybe<Scalars['DateTime']['output']>
  /** Transaction serial number from the source PMS, used for deduplication and ID generation. */
  transactionSrNo?: Maybe<Scalars['String']['output']>
  /** Transaction category used for business logic: Procedure, Payment, or Adjustment. */
  transactionType?: Maybe<Scalars['String']['output']>
  /** Treatment category derived from the procedure code (e.g. Restorative); recomputed when CDT mappings change. */
  treatmentCategory?: Maybe<Scalars['String']['output']>
  /** Mirror of transactionType kept in sync for consistent categorization. */
  type?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Source PMS vendor: sikka, carestack, kolla, or ascend. */
  vendor?: Maybe<Scalars['String']['output']>
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this transaction belongs to (Organization -> Workspace -> Location hierarchy). */
  workspaceId?: Maybe<Scalars['String']['output']>
}

export type TransactionListResult = {
  __typename?: 'TransactionListResult'
  /** Results for the current page. */
  hits: Array<Transaction>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type TreatmentPlan = {
  __typename?: 'TreatmentPlan'
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Exact plan display name as returned by the PMS. */
  displayName?: Maybe<Scalars['String']['output']>
  /** Unique identifier for the treatment plan record. */
  id: Scalars['ID']['output']
  /** Location this treatment plan belongs to. */
  locationId: Scalars['String']['output']
  /** Organization that owns this treatment plan (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Patient/contact this treatment plan is linked to. */
  patientId?: Maybe<Scalars['String']['output']>
  /** When the plan was created in the PMS. */
  planCreateDate?: Maybe<Scalars['DateTime']['output']>
  /** When the plan was last updated in the PMS. */
  planUpdateDate?: Maybe<Scalars['DateTime']['output']>
  /** JSON map of procedure id to fee override amount; fall back to Procedure.feeAmount when absent. */
  procedureFeeOverrides?: Maybe<Scalars['String']['output']>
  /** Procedure ids referenced by this plan. */
  procedureIds?: Maybe<Array<Scalars['String']['output']>>
  /** Derived plan state (e.g. open/closed) across its procedures. */
  state?: Maybe<Scalars['String']['output']>
  /** Plan status as reported by the PMS. */
  status?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Source PMS vendor: 'sikka' or 'kolla'. */
  vendor?: Maybe<Scalars['String']['output']>
  /** Plan's identifier in the source PMS vendor system. */
  vendorId: Scalars['String']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this treatment plan belongs to. */
  workspaceId: Scalars['String']['output']
}

export type TreatmentPlanListResult = {
  __typename?: 'TreatmentPlanListResult'
  /** Matching records for the current page. */
  hits: Array<TreatmentPlan>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching records across all pages. */
  total: Scalars['Int']['output']
}

/** How many examined events a single trigger condition rejected */
export type TriggerPreviewConditionRejectType = {
  __typename?: 'TriggerPreviewConditionRejectType'
  /** Attribute this condition evaluated */
  attribute: Scalars['String']['output']
  /** Comparison operator this condition used */
  operator: Scalars['String']['output']
  /** How many records this single condition rejected. For "just changed" conditions this is the count across the whole window; for "currently" (state) conditions it is the count within the current page only, because state is evaluated per page. */
  rejectedCount: Scalars['Int']['output']
  /** Value this condition compared against */
  value?: Maybe<Scalars['JSON']['output']>
}

/** A past event or record that a workflow trigger would match */
export type TriggerPreviewMatchType = {
  __typename?: 'TriggerPreviewMatchType'
  /** The value each condition read on this match, keyed by attribute */
  conditionValues: Scalars['JSON']['output']
  /** The contact the run would enroll, if resolved */
  contactId?: Maybe<Scalars['ID']['output']>
  /** When the match occurred (event date or due date) */
  date: Scalars['DateTime']['output']
  /** Event index ID when the match came from an event */
  eventId?: Maybe<Scalars['ID']['output']>
  /** True when reconstructed from a source record because the date precedes event history */
  reconstructedFromRecord: Scalars['Boolean']['output']
  /** Source entity ID */
  sourceId: Scalars['ID']['output']
  /** Source entity type (Contact, Call, Appointment, ...) */
  sourceType: Scalars['String']['output']
}

/** Read-only preview of which past events a workflow trigger matches */
export type TriggerPreviewResultType = {
  __typename?: 'TriggerPreviewResultType'
  /** Per-condition rejection counts (useful when there are zero matches) */
  conditionRejections: Array<TriggerPreviewConditionRejectType>
  /** The date the event history starts; matches before it are reconstructed from records */
  eventHistoryStart: Scalars['DateTime']['output']
  /** How many events/records were examined in the window */
  examinedCount: Scalars['Int']['output']
  /** Matches, newest first, for this page */
  matches: Array<TriggerPreviewMatchType>
  /** Zero-based index of the returned page */
  page: Scalars['Int']['output']
  /** Count of events matching the "just changed" conditions. When the trigger has a "currently" (state) condition this is an UPPER BOUND, not the survivor count: state conditions are applied per page, so a page can return fewer rows than this implies and some pages can be empty. Use it to compute how many pages to request. */
  total: Scalars['Int']['output']
}

/** Result of manually triggering a workflow on a contact */
export type TriggerWorkflowOnContactResult = {
  __typename?: 'TriggerWorkflowOnContactResult'
  /** ID of the contact the workflow was triggered on */
  contactId: Scalars['ID']['output']
  /** Whether the workflow was successfully triggered */
  success: Scalars['Boolean']['output']
  /** ID of the triggered workflow */
  workflowId: Scalars['ID']['output']
  /** Type of workflow triggered: "ai" or "multi_step" */
  workflowType: Scalars['String']['output']
}

export type TwilioNumberConfig = {
  __typename?: 'TwilioNumberConfig'
  /** Area code used when purchasing pool numbers (IVR only) */
  areaCode?: Maybe<Scalars['String']['output']>
  /** Unique id for this Twilio number entry */
  id?: Maybe<Scalars['String']['output']>
  /** Display name for IVR numbers (e.g. "Main Line") */
  label?: Maybe<Scalars['String']['output']>
  /** The Twilio phone number in E.164 format */
  phone?: Maybe<Scalars['String']['output']>
  /** IVR entry id that owns this pool (self-referential for IVR numbers) */
  poolId?: Maybe<Scalars['String']['output']>
  /** Desired number of pool numbers (IVR only) */
  poolSize?: Maybe<Scalars['Int']['output']>
  /** Session duration in minutes a visitor keeps a pool number (IVR only) */
  sessionDuration?: Maybe<Scalars['Int']['output']>
  /** Label for source tracker numbers (e.g. "I-35 Billboard") */
  sourceName?: Maybe<Scalars['String']['output']>
  /** Number role: pool, ai, ai-testing, source, or ivr */
  type: Scalars['String']['output']
}

export type TwilioNumberInput = {
  /** Twilio phone number ID (E.164 number). */
  id: Scalars['String']['input']
}

export type TwilioPhoneNumber = {
  __typename?: 'TwilioPhoneNumber'
  /** Twilio phone number id */
  id: Scalars['String']['output']
  /** Whether this number is already in use by an integration */
  isUsed: Scalars['Boolean']['output']
  /** Twilio phone number */
  name: Scalars['String']['output']
}

export type UnmappedFormKey = {
  __typename?: 'UnmappedFormKey'
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Deterministic composite ID: md5(orgId-workspaceId-rawKey). One record per unique raw key per workspace. */
  id: Scalars['ID']['output']
  /** Organization that owns this record (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Raw form field key from the submission that matched no mapping, stored lowercase. */
  rawKey: Scalars['String']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Vendor frequency map counting how many times each vendor submitted this key, e.g. { "Jotform": 42, "Facebook": 3 }. */
  vendors?: Maybe<Scalars['JSON']['output']>
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this unmapped key is scoped to. */
  workspaceId: Scalars['String']['output']
}

export type UnmappedFormKeyListResult = {
  __typename?: 'UnmappedFormKeyListResult'
  /** Matching items for this page. */
  hits: Array<UnmappedFormKey>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching items across all pages. */
  total: Scalars['Int']['output']
}

export type UpdateAiAgentCompilerConfigInput = {
  /** Whether cleanings require an initial exam */
  cleaningRequiresInitialExam?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether the practice is pediatric only */
  pediatricOnly?: InputMaybe<Scalars['Boolean']['input']>
  /** Addendum appended to the voice agent prompt */
  voiceAgentAddendum?: InputMaybe<Scalars['String']['input']>
  /** Tools enabled for the voice agent */
  voiceAgentTools?: InputMaybe<Array<Scalars['String']['input']>>
}

export type UpdateAiAgentLocationConfigInput = {
  /** Name the AI agent uses for itself */
  agentName?: InputMaybe<Scalars['String']['input']>
  /** Business address the agent references */
  businessAddress?: InputMaybe<Scalars['String']['input']>
  /** Business name the agent references */
  businessName?: InputMaybe<Scalars['String']['input']>
  /** Greeting the agent opens with; keeps {{businessName}}/{{agentName}} placeholders verbatim */
  greeting?: InputMaybe<Scalars['String']['input']>
  /** Message sent to the patient after a hygiene appointment booking */
  hygienePostBookingMessage?: InputMaybe<Scalars['String']['input']>
  /** Offers the agent can mention to callers */
  offers?: InputMaybe<Array<AiAgentOfferInput>>
  /** Office main phone number */
  officeMainNumber?: InputMaybe<Scalars['String']['input']>
  /** Office transfer phone number */
  officeTransferNumber?: InputMaybe<Scalars['String']['input']>
  /** Message sent to the patient after booking */
  postBookingMessage?: InputMaybe<Scalars['String']['input']>
  /** Say This, Not That phrase rules the agent applies when responding */
  sayThisNotThatRules?: InputMaybe<Array<SayThisNotThatRuleInput>>
  /** Services the agent offers */
  services?: InputMaybe<Array<AiAgentServiceInput>>
  /** Services the agent explicitly does not offer */
  servicesNotOffered?: InputMaybe<Array<AiAgentServiceInput>>
  /** Whether an SMS confirmation is sent after booking */
  smsConfirmationEnabled?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdateActionInput = {
  /** Updated free-text note on the action. */
  note?: InputMaybe<Scalars['String']['input']>
  /** New state for the action. */
  state?: InputMaybe<Scalars['String']['input']>
  /** New date the action is deferred until. */
  untilDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type UpdateAdPlatformMappingInput = {
  /** UTM medium to match. */
  medium?: InputMaybe<Scalars['String']['input']>
  /** Ad platform this source/medium maps to. */
  platform?: InputMaybe<Scalars['String']['input']>
  /** UTM source to match. */
  source?: InputMaybe<Scalars['String']['input']>
}

export type UpdateAppointmentTypeInput = {
  /** Whether the AI agent can book this appointment type. */
  activeAgent?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether this type is available in the online scheduler. */
  activeScheduler?: InputMaybe<Scalars['Boolean']['input']>
  /** Display alias for the appointment type. */
  alias?: InputMaybe<Scalars['String']['input']>
  /** Length of the appointment in minutes. */
  appointmentLength?: InputMaybe<Scalars['Int']['input']>
  /** Whether scheduling of this appointment type is blocked. */
  blockScheduling?: InputMaybe<Scalars['Boolean']['input']>
  /** Notes describing when scheduling is blocked. */
  blockSchedulingNotes?: InputMaybe<Array<Scalars['String']['input']>>
  /** Whether this type is excluded from double-booking rules. */
  doubleBookingExclusion?: InputMaybe<Scalars['Boolean']['input']>
  /** Blockout ids excluded for this appointment type. */
  excludedBlockouts?: InputMaybe<Array<Scalars['String']['input']>>
  /** General buffer in minutes applied around appointments. */
  generalBuffer?: InputMaybe<Scalars['Int']['input']>
  /** Additional buffer in minutes for morning appointments. */
  morningBuffer?: InputMaybe<Scalars['Int']['input']>
  /** Lookahead window in minutes for applying the morning buffer. */
  morningBufferLookahead?: InputMaybe<Scalars['Int']['input']>
  /** Sort order of the appointment type. */
  order?: InputMaybe<Scalars['Int']['input']>
  /** Patient type the appointment applies to (e.g. new, existing). */
  patientType?: InputMaybe<Scalars['String']['input']>
  /** Increment in minutes between available start times. */
  startIncrement?: InputMaybe<Scalars['Int']['input']>
}

export type UpdateAvailabilityInput = {
  /** Appointment type IDs this availability applies to. */
  appointmentTypeIds?: InputMaybe<Array<Scalars['String']['input']>>
  /** Whether this is backup availability, used only when primary availability is unavailable. */
  backupAvailability?: InputMaybe<Scalars['Boolean']['input']>
  /** Operatory IDs where the provider can be scheduled. */
  operatoryIds?: InputMaybe<Array<Scalars['String']['input']>>
  /** Weekly time slots when the provider is available. */
  timeSlots?: InputMaybe<LocationOpenHoursInput>
}

export type UpdateBudgetInput = {
  /** New budgeted amount for the channel, in dollars. */
  amount?: InputMaybe<Scalars['Float']['input']>
  /** New goal for number of appointments. */
  appointmentGoal?: InputMaybe<Scalars['Int']['input']>
  /** New internal goal amount for the channel, in dollars. */
  internalGoal?: InputMaybe<Scalars['Float']['input']>
  /** New goal for number of leads. */
  leadGoal?: InputMaybe<Scalars['Int']['input']>
  /** New goal for number of MQLs. */
  mqlGoal?: InputMaybe<Scalars['Int']['input']>
  /** New goal for number of new patients. */
  patientGoal?: InputMaybe<Scalars['Int']['input']>
  /** New target ad spend for the channel, in dollars. */
  targetSpend?: InputMaybe<Scalars['Float']['input']>
}

export type UpdateCallDataInput = {
  /** Raw call data payload. */
  data?: InputMaybe<Scalars['JSON']['input']>
  /** ElevenLabs conversation id associated with the call. */
  elevenLabsConversationId?: InputMaybe<Scalars['String']['input']>
  /** New location for this call data. */
  locationId?: InputMaybe<Scalars['ID']['input']>
}

export type UpdateCallInput = {
  /** AI extraction data for the call. */
  ai?: InputMaybe<CallAiInput>
  /** Appointment date as a string. */
  appointmentDateString?: InputMaybe<Scalars['String']['input']>
  /** Marketing channel attributed to the call. */
  channel?: InputMaybe<Scalars['String']['input']>
  /** Freeform note on the call. */
  note?: InputMaybe<Scalars['String']['input']>
  /** Patients associated with the call. */
  patients?: InputMaybe<Array<CallPatientInput>>
  /** Staff member assigned to the call. */
  staff?: InputMaybe<CallStaffInput>
  /** Call status. */
  status?: InputMaybe<Scalars['String']['input']>
  /** Tags applied to the call. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>
}

export type UpdateCdtCodeMappingInput = {
  /** Category this CDT code maps to. */
  category?: InputMaybe<Scalars['String']['input']>
  /** CDT dental procedure code. */
  cdtCode?: InputMaybe<Scalars['String']['input']>
}

export type UpdateChannelMappingInput = {
  /** Channel this source/medium maps to. */
  channel?: InputMaybe<Scalars['String']['input']>
  /** UTM medium to match. */
  medium?: InputMaybe<Scalars['String']['input']>
  /** UTM source to match. */
  source?: InputMaybe<Scalars['String']['input']>
}

export type UpdateCommLogWritebackRuleInput = {
  /** PMS channel entries of this type are written under */
  channel?: InputMaybe<Scalars['String']['input']>
  /** Comm-log writeback type the rule covers */
  type?: InputMaybe<Scalars['String']['input']>
}

export type UpdateContactInput = {
  /** Date the contact became a lead. */
  becameLeadDate?: InputMaybe<Scalars['String']['input']>
  /** Date the contact became a patient. */
  becamePatientDate?: InputMaybe<Scalars['String']['input']>
  /** New cell phone number. */
  cellPhone?: InputMaybe<Scalars['String']['input']>
  /** New marketing channel. */
  channel?: InputMaybe<Scalars['String']['input']>
  /** Reason the lead was closed lost. */
  closedLostReason?: InputMaybe<Scalars['String']['input']>
  /** New email address. */
  email?: InputMaybe<Scalars['String']['input']>
  /** Date the first appointment was made. */
  firstAppointmentMadeDate?: InputMaybe<Scalars['String']['input']>
  /** New home phone number. */
  homePhone?: InputMaybe<Scalars['String']['input']>
  /** Whether the contact is marked qualified. */
  isQualified?: InputMaybe<Scalars['Boolean']['input']>
  /** Staff member who owns this lead. */
  leadOwner?: InputMaybe<ContactStaffInput>
  /** New lead status. */
  leadStatus?: InputMaybe<Scalars['String']['input']>
  /** New lifecycle stage. */
  lifecycleStage?: InputMaybe<Scalars['String']['input']>
  /** New contact name. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Note recorded with a Closed Lost transition. */
  note?: InputMaybe<Scalars['String']['input']>
  /** Id of the staff member performing the change. */
  ownerId?: InputMaybe<Scalars['String']['input']>
  /** Name of the staff member performing the change. */
  ownerName?: InputMaybe<Scalars['String']['input']>
  /** New patient status. */
  patientStatus?: InputMaybe<Scalars['String']['input']>
  /** Pipeline stage assignments for the contact. */
  pipelines?: InputMaybe<Array<ContactPipelineInput>>
  /** Preferred communication method. */
  preferredCommunicationMethod?: InputMaybe<Scalars['String']['input']>
  /** Preferred contact person. */
  preferredContact?: InputMaybe<Scalars['String']['input']>
  /** Preferred name for the contact. */
  preferredName?: InputMaybe<Scalars['String']['input']>
  /** Lifetime production value for the contact. */
  productionLtv?: InputMaybe<Scalars['Float']['input']>
  /** Patient-reported attribution. */
  reportedAttribution?: InputMaybe<Scalars['String']['input']>
  /** Scheduled production value for the contact. */
  scheduledProduction?: InputMaybe<Scalars['Float']['input']>
  /** Whether the contact consents to SMS marketing. */
  smsMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>
  /** Tags applied to the contact. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  /** New UTM campaign. */
  utmCampaign?: InputMaybe<Scalars['String']['input']>
  /** New UTM content. */
  utmContent?: InputMaybe<Scalars['String']['input']>
  /** New UTM keywords. */
  utmKeywords?: InputMaybe<Scalars['String']['input']>
  /** New UTM medium. */
  utmMedium?: InputMaybe<Scalars['String']['input']>
  /** New UTM source. */
  utmSource?: InputMaybe<Scalars['String']['input']>
  /** New work phone number. */
  workPhone?: InputMaybe<Scalars['String']['input']>
}

export type UpdateCustomPageInput = {
  /** Updated JSON-encoded array of filters to apply. */
  filters?: InputMaybe<Scalars['String']['input']>
  /** Updated join operator applied to the filters (e.g. AND/OR). */
  join?: InputMaybe<Scalars['String']['input']>
  /** Updated display name for the custom page. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Updated base page/entity type the custom page is built on. */
  page?: InputMaybe<Scalars['String']['input']>
}

export type UpdateDniInput = {
  /** Area code used when provisioning pool phone numbers */
  areaCode?: InputMaybe<Scalars['String']['input']>
  /** Number of phone numbers to buy at a time when growing the pool */
  buyStep?: InputMaybe<Scalars['Int']['input']>
  /** Whether this DNI pool is active */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Destination phone number that pool calls are forwarded to */
  forwardTo?: InputMaybe<Scalars['String']['input']>
  /** IVR configuration to apply to pool calls */
  ivrConfigId?: InputMaybe<Scalars['String']['input']>
  /** Optional label to identify this DNI pool */
  label?: InputMaybe<Scalars['String']['input']>
  /** Maximum number of phone numbers the pool may grow to */
  maxPoolSize?: InputMaybe<Scalars['Int']['input']>
  /** Minimum number of free (unassigned) numbers to keep available in the pool */
  minFree?: InputMaybe<Scalars['Int']['input']>
  /** Minimum number of phone numbers to keep in the pool */
  minPoolSize?: InputMaybe<Scalars['Int']['input']>
  /** Number of tracking phone numbers to provision in the pool */
  poolSize?: InputMaybe<Scalars['Int']['input']>
  /** How long (seconds) a visitor keeps the same assigned number */
  sessionDuration?: InputMaybe<Scalars['Int']['input']>
}

export type UpdateExtractionPromptInput = {
  /** Whether the prompt is active */
  active?: InputMaybe<Scalars['Boolean']['input']>
  /** LLM model to use */
  model?: InputMaybe<Scalars['String']['input']>
  /** Free-form notes about the prompt */
  notes?: InputMaybe<Scalars['String']['input']>
  /** New prompt text */
  prompt?: InputMaybe<Scalars['String']['input']>
  /** Version label for the prompt */
  promptVersion?: InputMaybe<Scalars['String']['input']>
}

export type UpdateFeatureToggleInput = {
  /** Whether the toggle is archived. */
  archived?: InputMaybe<Scalars['Boolean']['input']>
  /** Category grouping for the toggle. */
  category?: InputMaybe<FeatureToggleCategory>
  /** Description of what the feature toggle controls. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Human-readable display name for the toggle. */
  displayName?: InputMaybe<Scalars['String']['input']>
  /** Internal name of the feature toggle. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Release the toggle is associated with. */
  release?: InputMaybe<Scalars['String']['input']>
  /** Scope type of the toggle, e.g. org, workspace, location. */
  type?: InputMaybe<Scalars['String']['input']>
  /** ID of the entity the toggle is scoped to. */
  typeId?: InputMaybe<Scalars['String']['input']>
}

export type UpdateFollowUpInput = {
  /** Scheduled appointment date linked to this follow-up. */
  appointmentDate?: InputMaybe<Scalars['String']['input']>
  /** Notes describing the follow-up. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Date the follow-up is due. */
  followUpDate?: InputMaybe<Scalars['String']['input']>
  /** Whether contact was successfully reached. */
  isConnected?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether an appointment was scheduled from this follow-up. */
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>
  /** User to assign as the follow-up owner. */
  ownerId?: InputMaybe<Scalars['ID']['input']>
  /** Display name of the follow-up owner. */
  ownerName?: InputMaybe<Scalars['String']['input']>
}

export type UpdateFormFieldMappingInput = {
  /** Trackable form field the raw key maps to. */
  formField?: InputMaybe<Scalars['String']['input']>
  /** Raw incoming form key to map. */
  rawKey?: InputMaybe<Scalars['String']['input']>
}

/** Update a draft form. Published versions are immutable — updating one mints a new draft version. */
export type UpdateFormTemplateInput = {
  /** One of: registration, medicalHistory, consent, financialPolicy, custom */
  category?: InputMaybe<Scalars['String']['input']>
  /** Form description. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Form name. */
  name?: InputMaybe<Scalars['String']['input']>
  /** The ordered questions that make up the form. */
  questions?: InputMaybe<Array<FormQuestionInput>>
}

export type UpdateListInput = {
  /** Updated default stage rule matches fall into when they have no stored row. */
  defaultStageId?: InputMaybe<Scalars['ID']['input']>
  /** Updated list rule as a JSON-encoded FilterObject array. */
  filters?: InputMaybe<Scalars['String']['input']>
  /** Updated join operator applied across the rule filters (e.g. and/or). */
  join?: InputMaybe<Scalars['String']['input']>
  /** Updated display name of the list. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Updated set of stages/lanes for the list. */
  stages?: InputMaybe<Array<ListStageInput>>
  /** Updated list visibility: shared or personal (only the creator may change a personal list). */
  visibility?: InputMaybe<Scalars['String']['input']>
}

export type UpdateListItemInput = {
  /** Stage/lane to move the member into. */
  stageId?: InputMaybe<Scalars['ID']['input']>
}

export type UpdateLocationInput = {
  /** Street address of the location. */
  address?: InputMaybe<Scalars['String']['input']>
  /** Second line of the street address. */
  addressLine2?: InputMaybe<Scalars['String']['input']>
  /** End of the quiet-hours window for alarms. */
  alarmQuietEnd?: InputMaybe<Scalars['String']['input']>
  /** Start of the quiet-hours window for alarms. */
  alarmQuietStart?: InputMaybe<Scalars['String']['input']>
  /** Whether double-booking is allowed when scheduling. */
  allowDoubleBookingScheduling?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether the location is archived. */
  archived?: InputMaybe<Scalars['Boolean']['input']>
  /** Availability mode used for scheduling. */
  availabilityMode?: InputMaybe<Scalars['String']['input']>
  /** Business phone number of the location. */
  businessPhone?: InputMaybe<Scalars['String']['input']>
  /** City of the location. */
  city?: InputMaybe<Scalars['String']['input']>
  /** Current operational status of the location. */
  currentStatus?: InputMaybe<Scalars['String']['input']>
  /** Hour of day the daily PMS sync runs. */
  dailySyncHour?: InputMaybe<Scalars['Int']['input']>
  /** Free-text description of the location. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Facebook ad set ids associated with the location. */
  facebookAdSetIds?: InputMaybe<Array<Scalars['String']['input']>>
  /** Whether the AI agent is live for this location. */
  isAIAgentLive?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether the online scheduler is live for this location. */
  isSchedulerLive?: InputMaybe<Scalars['Boolean']['input']>
  /** Labels applied to the location. */
  labels?: InputMaybe<Array<Scalars['String']['input']>>
  /** Date the location was migrated, or null to clear it. */
  migrationDate?: InputMaybe<Scalars['DateTime']['input']>
  /** Name of the location. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Main office phone number of the location. */
  officeMainNumber?: InputMaybe<Scalars['String']['input']>
  /** Number calls are transferred to from the office line. */
  officeTransferNumber?: InputMaybe<Scalars['String']['input']>
  /** Identifier of the office transfer number. */
  officeTransferNumberId?: InputMaybe<Scalars['String']['input']>
  /** Weekly open hours for the location. */
  openHours?: InputMaybe<LocationOpenHoursInput>
  /** Primary phone number of the location. */
  phone?: InputMaybe<Scalars['String']['input']>
  /** Practice management system for the location. */
  pms?: InputMaybe<Scalars['String']['input']>
  /** Identifier of the primary phone number. */
  primaryNumberId?: InputMaybe<Scalars['String']['input']>
  /** Primary SMS number for the location. */
  primarySmsNumber?: InputMaybe<Scalars['String']['input']>
  /** Primary tracking number for the location. */
  primaryTrackingNumber?: InputMaybe<Scalars['String']['input']>
  /** Products associated with the location. */
  products?: InputMaybe<Array<Scalars['String']['input']>>
  /** Questions asked during scheduling at this location. */
  schedulingQuestions?: InputMaybe<Array<Scalars['String']['input']>>
  /** Arbitrary per-location settings. */
  settings?: InputMaybe<Scalars['JSON']['input']>
  /** State of the location. */
  state?: InputMaybe<Scalars['String']['input']>
  /** Tags applied to the location. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  /** IANA timezone of the location. */
  timezone?: InputMaybe<Scalars['String']['input']>
  /** Twilio phone numbers configured for the location. */
  twilioNumbers?: InputMaybe<Scalars['JSON']['input']>
  /** Type of location. */
  type?: InputMaybe<Scalars['String']['input']>
  /** ZIP/postal code of the location. */
  zip?: InputMaybe<Scalars['String']['input']>
}

export type UpdateMilestoneInput = {
  /** Reason the opportunity was closed lost. */
  closedLostReason?: InputMaybe<Scalars['String']['input']>
  /** Whether the milestone is marked qualified. */
  isQualified?: InputMaybe<Scalars['Boolean']['input']>
  /** Freeform note on the milestone. */
  note?: InputMaybe<Scalars['String']['input']>
  /** ID of the milestone owner. */
  ownerId?: InputMaybe<Scalars['String']['input']>
  /** Name of the milestone owner. */
  ownerName?: InputMaybe<Scalars['String']['input']>
}

export type UpdateNoteInput = {
  /** Note text. */
  description: Scalars['String']['input']
}

export type UpdateNoteTemplateInput = {
  /** New body text for the note template. */
  body?: InputMaybe<Scalars['String']['input']>
  /** New name for the note template. */
  name?: InputMaybe<Scalars['String']['input']>
}

export type UpdateNotificationInput = {
  /** Set the notification's archived state. */
  archived?: InputMaybe<Scalars['Boolean']['input']>
  /** Set the notification's clicked state. */
  clicked?: InputMaybe<Scalars['Boolean']['input']>
  /** Set the notification's managed state. */
  managedNotification?: InputMaybe<Scalars['Boolean']['input']>
  /** Set the notification's read state. */
  read?: InputMaybe<Scalars['Boolean']['input']>
}

/** Update a location-scoped communication opt-out. To opt a key back in, delete the OptOut record instead of updating it. */
export type UpdateOptOutInput = {
  /** New phone number or email key. Delete this OptOut record to clear the opt-out. */
  key?: InputMaybe<Scalars['String']['input']>
  /** New location scope for this opt-out. */
  locationId?: InputMaybe<Scalars['ID']['input']>
  /** New communication channel for this opt-out. */
  type?: InputMaybe<OptOutType>
}

export type UpdatePaperworkTemplateInput = {
  /** Updated visual presets for the packet. */
  appearance?: InputMaybe<AppearanceInput>
  /** Updated practice branding for the packet. */
  branding?: InputMaybe<PaperworkBrandingInput>
  /** Updated completion screen content. */
  completion?: InputMaybe<ScreenContentInput>
  /** New description for the template. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Replacement ordered list of forms to send. */
  forms?: InputMaybe<Array<PaperworkFormInput>>
  /** New name for the paperwork template. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Updated welcome screen content. */
  welcome?: InputMaybe<ScreenContentInput>
}

export type UpdatePhoneNumberInput = {
  /** Whether this phone number is enabled. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Updated human-readable label. */
  label?: InputMaybe<Scalars['String']['input']>
  /** Updated registration identifier from the provider. */
  registrationId?: InputMaybe<Scalars['String']['input']>
  /** Updated 10DLC/toll-free registration status. */
  registrationStatus?: InputMaybe<Scalars['String']['input']>
  /** Updated roles for this phone number. */
  roles?: InputMaybe<Array<Scalars['String']['input']>>
}

export type UpdatePipelineInput = {
  /** Pipeline name. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Ordered stages for the pipeline. */
  stages?: InputMaybe<Array<PipelineStageInput>>
}

export type UpdatePmsReferralMappingInput = {
  /** Updated UTM campaign for this referral type. */
  campaign?: InputMaybe<Scalars['String']['input']>
  /** Updated marketing channel for this referral type. */
  channel?: InputMaybe<Scalars['String']['input']>
  /** Force the mapping even if it conflicts with existing rules. */
  force?: InputMaybe<Scalars['Boolean']['input']>
  /** Updated UTM medium for this referral type. */
  medium?: InputMaybe<Scalars['String']['input']>
  /** Updated UTM source for this referral type. */
  source?: InputMaybe<Scalars['String']['input']>
}

export type UpdatePromptFragmentInput = {
  /** Whether the fragment is archived. */
  archived?: InputMaybe<Scalars['Boolean']['input']>
  /** New body text for the fragment. */
  body?: InputMaybe<Scalars['String']['input']>
  /** New description for the fragment. */
  description?: InputMaybe<Scalars['String']['input']>
  /** New name for the fragment. */
  name?: InputMaybe<Scalars['String']['input']>
}

export type UpdatePromptInput = {
  /** Whether the prompt is archived. */
  archived?: InputMaybe<Scalars['Boolean']['input']>
  /** New prompt body text. */
  body?: InputMaybe<Scalars['String']['input']>
  /** Summary of what changed in this update. */
  changeSummary?: InputMaybe<Scalars['String']['input']>
  /** New description for the prompt. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Expected current revision for optimistic concurrency. */
  expectedRevision?: InputMaybe<Scalars['Int']['input']>
  /** New model for the prompt. */
  model?: InputMaybe<Scalars['String']['input']>
  /** New display name for the prompt. */
  name?: InputMaybe<Scalars['String']['input']>
  /** New sampling temperature for the prompt. */
  temperature?: InputMaybe<Scalars['Float']['input']>
}

export type UpdateProviderInput = {
  /** Whether the provider is deactivated. */
  deactivated?: InputMaybe<Scalars['Boolean']['input']>
  /** Display name of the provider. */
  displayName?: InputMaybe<Scalars['String']['input']>
  /** Sort priority of the provider. */
  priority?: InputMaybe<Scalars['Int']['input']>
}

export type UpdateRegistrationProfileInput = {
  /** Brand accent color. */
  accentColor?: InputMaybe<Scalars['String']['input']>
  /** Business address city. */
  addressCity?: InputMaybe<Scalars['String']['input']>
  /** Business address country. */
  addressCountry?: InputMaybe<Scalars['String']['input']>
  /** Business address postal code. */
  addressPostalCode?: InputMaybe<Scalars['String']['input']>
  /** Business address state. */
  addressState?: InputMaybe<Scalars['String']['input']>
  /** Business street address. */
  addressStreet?: InputMaybe<Scalars['String']['input']>
  /** Agent description. */
  agentDescription?: InputMaybe<Scalars['String']['input']>
  /** Agent service name. */
  agentServiceName?: InputMaybe<Scalars['String']['input']>
  /** Brand description. */
  brandDescription?: InputMaybe<Scalars['String']['input']>
  /** Brand name. */
  brandName?: InputMaybe<Scalars['String']['input']>
  /** Business industry. */
  businessIndustry?: InputMaybe<Scalars['String']['input']>
  /** Country the business is registered in. */
  businessRegistrationCountry?: InputMaybe<Scalars['String']['input']>
  /** Business entity type. */
  businessType?: InputMaybe<Scalars['String']['input']>
  /** Contact email address. */
  contactEmail?: InputMaybe<Scalars['String']['input']>
  /** Contact first name. */
  contactFirstName?: InputMaybe<Scalars['String']['input']>
  /** Contact last name. */
  contactLastName?: InputMaybe<Scalars['String']['input']>
  /** Contact phone number. */
  contactPhone?: InputMaybe<Scalars['String']['input']>
  /** Contact job title. */
  contactTitle?: InputMaybe<Scalars['String']['input']>
  /** Employer Identification Number (EIN). */
  ein?: InputMaybe<Scalars['String']['input']>
  /** HELP keyword response message. */
  helpMessage?: InputMaybe<Scalars['String']['input']>
  /** Legal business name. */
  legalBusinessName?: InputMaybe<Scalars['String']['input']>
  /** Estimated monthly RCS message volume. */
  monthlyRcsVolume?: InputMaybe<Scalars['String']['input']>
  /** Profile name. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Opt-in confirmation message. */
  optInConfirmationMessage?: InputMaybe<Scalars['String']['input']>
  /** S3 keys for uploaded opt-in documents. */
  optInDocuments?: InputMaybe<Array<Scalars['String']['input']>>
  /** S3 key for the opt-in screenshot. */
  optInScreenshotUrl?: InputMaybe<Scalars['String']['input']>
  /** URL where users opt in. */
  optInUrl?: InputMaybe<Scalars['String']['input']>
  /** Description of the opt-in workflow. */
  optInWorkflowDescription?: InputMaybe<Scalars['String']['input']>
  /** Opt-out details. */
  optOutDetails?: InputMaybe<Scalars['String']['input']>
  /** Privacy policy URL. */
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>
  /** S3 key for the RCS banner image. */
  rcsBannerImageKey?: InputMaybe<Scalars['String']['input']>
  /** S3 key for the RCS logo image. */
  rcsLogoImageKey?: InputMaybe<Scalars['String']['input']>
  /** Sample messages sent to recipients. */
  sampleMessages?: InputMaybe<Array<Scalars['String']['input']>>
  /** STOP keyword response message. */
  stopMessage?: InputMaybe<Scalars['String']['input']>
  /** S3 keys for uploaded supplemental documents. */
  supplementalDocuments?: InputMaybe<Array<Scalars['String']['input']>>
  /** Terms of service URL. */
  termsUrl?: InputMaybe<Scalars['String']['input']>
  /** Messaging use case category. */
  useCaseCategory?: InputMaybe<Scalars['String']['input']>
  /** Description of the messaging use case. */
  useCaseDescription?: InputMaybe<Scalars['String']['input']>
  /** Promotional video URL. */
  videoUrl?: InputMaybe<Scalars['String']['input']>
  /** Business website URL. */
  websiteUrl?: InputMaybe<Scalars['String']['input']>
}

export type UpdateRoleInput = {
  /** New name for the role. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Permission keys granted to the role. */
  permissions?: InputMaybe<Array<Scalars['String']['input']>>
}

export type UpdateSchedulingConfigurationInput = {
  /** Whether double-booking of appointment slots is allowed. */
  allowDoubleBooking?: InputMaybe<Scalars['Boolean']['input']>
  /** Custom intake questions to ask when booking. */
  customQuestions?: InputMaybe<Array<CustomQuestionInput>>
  /** Maximum number of concurrent bookings allowed per slot. */
  doubleBookingCount?: InputMaybe<Scalars['Float']['input']>
  /** Slot granularity in minutes. */
  granularity?: InputMaybe<Scalars['Float']['input']>
  /** Insurance plans that are accepted. */
  insurancesAccepted?: InputMaybe<Array<Scalars['String']['input']>>
  /** Insurance plans that are rejected. */
  insurancesRejected?: InputMaybe<Array<Scalars['String']['input']>>
  /** Whether state insurance is accepted. */
  isStateInsuranceAccepted?: InputMaybe<Scalars['Boolean']['input']>
  /** Configuration for the lead override scheduling window. */
  leadOverrideConfig?: InputMaybe<LeadOverrideConfigInput>
  /** Whether lead override scheduling is enabled. */
  leadOverrideEnabled?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdateScorecardInput = {
  /** Ordered list of column IDs. */
  columnOrder?: InputMaybe<Array<Scalars['String']['input']>>
  /** Per-column visibility settings. */
  columnVisibility?: InputMaybe<Scalars['JSON']['input']>
  /** Date range preset for the scorecard. */
  dateRange?: InputMaybe<Scalars['String']['input']>
  /** Whether this is the default scorecard. */
  default?: InputMaybe<Scalars['Boolean']['input']>
  /** Grouping dimension for the scorecard. */
  grouping?: InputMaybe<Scalars['String']['input']>
  /** Lookback window amount. */
  lookbackAmount?: InputMaybe<Scalars['Int']['input']>
  /** Lookback window type. */
  lookbackType?: InputMaybe<Scalars['String']['input']>
  /** Scorecard name. */
  name?: InputMaybe<Scalars['String']['input']>
  /** IDs of objects included in the scorecard. */
  objectIds?: InputMaybe<Array<Scalars['String']['input']>>
  /** Sort configuration for the scorecard. */
  sort?: InputMaybe<Scalars['JSON']['input']>
}

export type UpdateSmsTemplateInput = {
  /** Updated message body of the SMS template. */
  body?: InputMaybe<Scalars['String']['input']>
  /** Updated name of the SMS template. */
  name?: InputMaybe<Scalars['String']['input']>
}

export type UpdateStaffInput = {
  /** Alternate names the staff member is also known by */
  aliases?: InputMaybe<Array<Scalars['String']['input']>>
  /** Display name of the staff member */
  name?: InputMaybe<Scalars['String']['input']>
  /** Linked user account id to associate with this staff member */
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type UpdateStoredCredentialInput = {
  /** Human-readable label for the credential. */
  label?: InputMaybe<Scalars['String']['input']>
  /** Location this credential is scoped to, if any. */
  locationId?: InputMaybe<Scalars['String']['input']>
  /** Optional JSON metadata for the credential. */
  metadata?: InputMaybe<Scalars['String']['input']>
  /** Password for the credential (stored encrypted). */
  password?: InputMaybe<Scalars['String']['input']>
  /** Username for the credential. */
  username?: InputMaybe<Scalars['String']['input']>
}

export type UpdateTaskInput = {
  /** Contact the task is linked to. */
  contactId?: InputMaybe<Scalars['String']['input']>
  /** Task description. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Task due date (ISO date). */
  dueDate?: InputMaybe<Scalars['String']['input']>
  /** ID of the task owner. */
  ownerId?: InputMaybe<Scalars['String']['input']>
  /** Role assigned to the task. */
  roleId?: InputMaybe<Scalars['String']['input']>
  /** Task status. */
  status?: InputMaybe<Scalars['String']['input']>
  /** Task title. */
  title?: InputMaybe<Scalars['String']['input']>
}

export type UpdateTaskTemplateInput = {
  /** Optional description applied to tasks created from this template. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Number of days after creation that the task is due. */
  dueInDays?: InputMaybe<Scalars['Int']['input']>
  /** Internal name of the task template. */
  name?: InputMaybe<Scalars['String']['input']>
  /** User assigned as the owner of tasks created from this template. */
  ownerId?: InputMaybe<Scalars['String']['input']>
  /** Title applied to tasks created from this template. */
  title?: InputMaybe<Scalars['String']['input']>
}

export type UpdateThreadInput = {
  /** Whether the AI assistant is enabled for this thread. */
  aiEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Display name for the thread. */
  name?: InputMaybe<Scalars['String']['input']>
}

export type UpdateUserInput = {
  /** Location IDs this user is allowed to access. */
  allowedLocationIds?: InputMaybe<Array<Scalars['String']['input']>>
  /** Whether the user is archived (deactivated). */
  archived?: InputMaybe<Scalars['Boolean']['input']>
  /** User's email address. */
  email?: InputMaybe<Scalars['String']['input']>
  /** User's job title. */
  jobTitle?: InputMaybe<Scalars['String']['input']>
  /** User's display name. */
  name?: InputMaybe<Scalars['String']['input']>
  /** User's phone number. */
  phone?: InputMaybe<Scalars['String']['input']>
  /** User's position/seniority within the practice. */
  position?: InputMaybe<UserPosition>
  /** Role assigned to the user. */
  roleId?: InputMaybe<Scalars['ID']['input']>
}

export type UpdateUtmAliasInput = {
  /** Canonical value the original is aliased to. */
  alias?: InputMaybe<Scalars['String']['input']>
  /** Original UTM value to be normalized. */
  original?: InputMaybe<Scalars['String']['input']>
  /** UTM parameter type being aliased, e.g. source, medium, campaign. */
  type?: InputMaybe<Scalars['String']['input']>
}

/** Update an existing workflow. Only provided fields are changed. Setting active=true validates the graph before activating. */
export type UpdateWorkflowInput = {
  /** Activate or deactivate. Activation validates the graph (nodes must exist, edges must reference valid nodes). */
  active?: InputMaybe<Scalars['Boolean']['input']>
  /** Opaque JSON blob for the frontend builder (preserved, never interpreted by engine). */
  builderJson?: InputMaybe<Scalars['String']['input']>
  /** The workflow graph edges connecting nodes */
  edges?: InputMaybe<Array<WorkflowEdgeInput>>
  /** Change the workflow's location (only while inactive) */
  locationId?: InputMaybe<Scalars['String']['input']>
  /** Human-readable workflow name */
  name?: InputMaybe<Scalars['String']['input']>
  /** The workflow graph nodes */
  nodes?: InputMaybe<Array<WorkflowNodeInput>>
  /** Pause or unpause a running workflow. While paused, patients stay at their current step, no steps run, and no new patients enroll. Unpausing resumes patients from where they stopped. Pausing does not end any run; use active=false to end them. */
  paused?: InputMaybe<Scalars['Boolean']['input']>
  /** Why the workflow is being paused. Required when paused is set to true. */
  pausedReason?: InputMaybe<Scalars['String']['input']>
  /** JSON settings object (quiet hours, etc.) */
  settings?: InputMaybe<Scalars['String']['input']>
  /** When this workflow should enroll contacts */
  trigger?: InputMaybe<WorkflowTriggerInput>
  /** Date on which a date-based trigger starts evaluating; enrollments before it are ignored */
  triggerStartDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type UpdateWorkspaceInput = {
  /** Max workflow enrollments per hour across all workflows. Null = unlimited. */
  maxEnrollmentsPerHour?: InputMaybe<Scalars['Int']['input']>
  /** Max outbound actions all workflows may send per calendar day (Eastern TZ). Null = unlimited. */
  maxOutboundDaily?: InputMaybe<Scalars['Int']['input']>
  /** Max outbound actions all workflows may send per calendar month. Null = unlimited. */
  maxOutboundMonthly?: InputMaybe<Scalars['Int']['input']>
  /** New name for the workspace. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Additional prompt text appended to AI generations for this workspace. */
  promptAddendum?: InputMaybe<Scalars['String']['input']>
}

export type UpdateWorkspaceInviteInput = {
  /** Email address being invited. */
  email?: InputMaybe<Scalars['String']['input']>
  /** Invite expiration timestamp (ISO date). */
  expiresAt?: InputMaybe<Scalars['String']['input']>
  /** Locations the invitee will have access to. */
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
  /** Role to assign the invitee on acceptance. */
  roleId?: InputMaybe<Scalars['String']['input']>
  /** Existing staff record to link to the invite, if any. */
  staffId?: InputMaybe<Scalars['String']['input']>
}

export type UsageCostBucket = {
  __typename?: 'UsageCostBucket'
  /** Bucket label (date/time) this usage falls in. */
  date: Scalars['String']['output']
  /** Number of SMS conversations in this bucket. */
  smsConversations: Scalars['Int']['output']
  /** SMS cost in this bucket, in dollars. */
  smsCostUsd: Scalars['Float']['output']
  /** LLM input tokens in this bucket. */
  tokensInput: Scalars['Int']['output']
  /** LLM output tokens in this bucket. */
  tokensOutput: Scalars['Int']['output']
  /** Number of voice calls in this bucket. */
  voiceCalls: Scalars['Int']['output']
  /** Voice cost in this bucket, in dollars. */
  voiceCostUsd: Scalars['Float']['output']
  /** Voice minutes in this bucket. */
  voiceMinutes: Scalars['Float']['output']
}

export type UsageCostCount = {
  __typename?: 'UsageCostCount'
  /** Number of occurrences for this key. */
  count: Scalars['Int']['output']
  /** Key being counted (e.g. an outcome category or tool name). */
  key: Scalars['String']['output']
}

export type UsageCostDetailInput = {
  /** Date range to pull drill-down records over. */
  dateRange: DateRangeInput
  /** Location to pull drill-down records for. */
  locationId: Scalars['String']['input']
  /** Pagination controls for the drill-down list. */
  pagination?: InputMaybe<PaginationInput>
  /** Restrict to these workspace ids; omit for all accessible workspaces. */
  workspaceIds?: InputMaybe<Array<Scalars['String']['input']>>
}

export type UsageCostInput = {
  /** Date range to compute usage and cost over. */
  dateRange: DateRangeInput
  /** Time bucket granularity: 'hourly' | 'daily' | 'weekly' | 'monthly'. */
  granularity: Scalars['String']['input']
  /** Restrict to these location ids; omit for all accessible locations. */
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
  /** Restrict to a product: 'voice' | 'sms' | 'all'. */
  product?: InputMaybe<Scalars['String']['input']>
  /** Restrict to these workspace ids; omit for all accessible workspaces. */
  workspaceIds?: InputMaybe<Array<Scalars['String']['input']>>
}

export type UsageCostLocation = {
  __typename?: 'UsageCostLocation'
  /** Average cost per interaction (voice call or SMS conversation) at this location, in dollars. */
  avgCostPerInteraction: Scalars['Float']['output']
  /** Location these usage costs are for. */
  locationId: Scalars['ID']['output']
  /** Display name of the location. */
  locationName?: Maybe<Scalars['String']['output']>
  /** Number of SMS conversations at this location. */
  smsConversations: Scalars['Int']['output']
  /** SMS cost at this location, in dollars. */
  smsCostUsd: Scalars['Float']['output']
  /** Total cost at this location, in dollars. */
  totalCostUsd: Scalars['Float']['output']
  /** Number of voice calls at this location. */
  voiceCalls: Scalars['Int']['output']
  /** Voice cost at this location, in dollars. */
  voiceCostUsd: Scalars['Float']['output']
  /** Display name of the location's workspace. */
  workspaceName?: Maybe<Scalars['String']['output']>
}

export type UsageCostResponse = {
  __typename?: 'UsageCostResponse'
  /** Average SMS agent reply latency in milliseconds. */
  avgSmsLatencyMs?: Maybe<Scalars['Float']['output']>
  /** Per-time-bucket usage and cost series. */
  buckets: Array<UsageCostBucket>
  /** Per-location usage and cost breakdown. */
  locations: Array<UsageCostLocation>
  /** Tool invocation counts across SMS agent turns, a cost driver indicator. */
  smsToolCalls: Array<UsageCostCount>
  /** Aggregate usage and cost totals for the period. */
  summary: UsageCostSummary
  /** Voice call outcome roll-up (Qualified, Disqualified, Scheduled, Unscheduled). */
  voiceOutcomes: Array<UsageCostCount>
  /** Number of voice calls that were transferred to a human. */
  voiceTransferredCalls: Scalars['Int']['output']
}

/** One SMS agent conversation thread, with the turn costs that roll up into UsageCostLocation.smsCostUsd. */
export type UsageCostSmsThread = {
  __typename?: 'UsageCostSmsThread'
  /** Average agent reply latency for this thread, in milliseconds. */
  avgLatencyMs?: Maybe<Scalars['Float']['output']>
  /** Carrier (delivery) cost for this thread, in dollars. */
  carrierCostUsd: Scalars['Float']['output']
  /** Contact the thread is with. */
  contactId?: Maybe<Scalars['String']['output']>
  /** When the thread's first turn occurred, as an ISO date/time string. */
  firstTurnDate?: Maybe<Scalars['String']['output']>
  /** When the thread's last turn occurred, as an ISO date/time string. */
  lastTurnDate?: Maybe<Scalars['String']['output']>
  /** LLM cost for this thread, in dollars. */
  llmCostUsd: Scalars['Float']['output']
  /** SMS conversation thread this cost breakdown is for. */
  threadId: Scalars['ID']['output']
  /** LLM input tokens consumed by this thread. */
  tokensInput: Scalars['Int']['output']
  /** LLM output tokens produced by this thread. */
  tokensOutput: Scalars['Int']['output']
  /** Total cost of this thread (LLM + carrier), in dollars. */
  totalCostUsd: Scalars['Float']['output']
  /** Number of agent turns in the thread. */
  turns: Scalars['Int']['output']
}

export type UsageCostSmsThreadListResult = {
  __typename?: 'UsageCostSmsThreadListResult'
  /** SMS thread cost records for the page, most expensive first. */
  hits: Array<UsageCostSmsThread>
  /** Zero-based page index of these results. */
  page: Scalars['Int']['output']
  /** Distinct thread count for the location/date range; matches UsageCostLocation.smsConversations. */
  total: Scalars['Int']['output']
}

export type UsageCostSummary = {
  __typename?: 'UsageCostSummary'
  /** Average cost per SMS conversation, in dollars. */
  avgCostPerSmsConversation: Scalars['Float']['output']
  /** Average cost per voice call, in dollars. */
  avgCostPerVoiceCall: Scalars['Float']['output']
  /** ElevenLabs LLM cost, in dollars. */
  elevenLabsLlmUsd: Scalars['Float']['output']
  /** ElevenLabs platform cost, in dollars. */
  elevenLabsPlatformUsd: Scalars['Float']['output']
  /** Total ElevenLabs cost (LLM + platform + voice), in dollars. */
  elevenLabsTotalUsd: Scalars['Float']['output']
  /** SMS carrier (delivery) cost, in dollars. */
  smsCarrierCostUsd: Scalars['Float']['output']
  /** Number of SMS agent conversations in the period. */
  smsConversations: Scalars['Int']['output']
  /** SMS LLM cost, in dollars. */
  smsLlmCostUsd: Scalars['Float']['output']
  /** Telephony (carrier) cost for voice, in dollars. */
  telephonyCostUsd: Scalars['Float']['output']
  /** Total cost across all products for the period, in dollars. */
  totalCostUsd: Scalars['Float']['output']
  /** Total LLM input tokens consumed in the period. */
  totalTokensInput: Scalars['Int']['output']
  /** Total LLM output tokens produced in the period. */
  totalTokensOutput: Scalars['Int']['output']
  /** Number of voice agent calls in the period. */
  voiceCalls: Scalars['Int']['output']
  /** Total voice agent minutes in the period. */
  voiceMinutes: Scalars['Float']['output']
}

/** One AI agent call, with the cost components that roll up into UsageCostLocation.voiceCostUsd. */
export type UsageCostVoiceCall = {
  __typename?: 'UsageCostVoiceCall'
  /** When the call occurred, as an ISO date/time string. */
  callDate?: Maybe<Scalars['String']['output']>
  /** Call this cost breakdown is for. */
  callId: Scalars['ID']['output']
  /** Caller's phone number. */
  callerPhone?: Maybe<Scalars['String']['output']>
  /** Call duration in seconds. */
  durationSeconds: Scalars['Int']['output']
  /** ElevenLabs automatic speech recognition cost for this call, in dollars. */
  elevenLabsAsrUsd: Scalars['Float']['output']
  /** ElevenLabs LLM cost for this call, in dollars. */
  elevenLabsLlmUsd: Scalars['Float']['output']
  /** ElevenLabs platform cost for this call, in dollars. */
  elevenLabsPlatformUsd: Scalars['Float']['output']
  /** Single ElevenLabs total ElevenLabs bills; the asr/tts/llm/platform breakdown may not sum exactly to it. */
  elevenLabsTotalUsd: Scalars['Float']['output']
  /** ElevenLabs text-to-speech cost for this call, in dollars. */
  elevenLabsTtsUsd: Scalars['Float']['output']
  /** LLM input tokens consumed by this call. */
  llmInputTokens: Scalars['Int']['output']
  /** LLM output tokens produced by this call. */
  llmOutputTokens: Scalars['Int']['output']
  /** Call status/outcome. */
  status?: Maybe<Scalars['String']['output']>
  /** Telephony (carrier) cost for this call, in dollars. */
  telephonyCostUsd: Scalars['Float']['output']
  /** Total cost of this call (telephony + ElevenLabs total), in dollars. */
  totalCostUsd: Scalars['Float']['output']
  /** Whether the call was transferred to a human. */
  transferred: Scalars['Boolean']['output']
}

export type UsageCostVoiceCallListResult = {
  __typename?: 'UsageCostVoiceCallListResult'
  /** Voice call cost records for the page. */
  hits: Array<UsageCostVoiceCall>
  /** Zero-based page index of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching voice call records. */
  total: Scalars['Int']['output']
}

export type User = {
  __typename?: 'User'
  /** Alternate names used to match this user on activities. */
  aliases?: Maybe<Array<Scalars['String']['output']>>
  /** Specific locations a workspace-level user may access; empty means all locations in the workspace. */
  allowedLocationIds?: Maybe<Array<Scalars['String']['output']>>
  /** Whether the user is archived (deactivated). */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Locations an org-level user is assigned to, used to filter their locations. */
  assignedLocationIds?: Maybe<Array<Scalars['String']['output']>>
  /** Workspaces an org-level user is assigned to. */
  assignedWorkspaceIds?: Maybe<Array<Scalars['String']['output']>>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** User's email address, used as login identifier. */
  email: Scalars['String']['output']
  /** Unique identifier for the user. */
  id: Scalars['ID']['output']
  /** Whether the user holds an org-level role (access across all workspaces). */
  isOrgRole?: Maybe<Scalars['Boolean']['output']>
  /** User's job title. */
  jobTitle?: Maybe<Scalars['String']['output']>
  /** Timestamp of the user's last login. */
  lastLoginDate?: Maybe<Scalars['DateTime']['output']>
  /** User's full name. */
  name?: Maybe<Scalars['String']['output']>
  /** Organization the user belongs to (multi-tenant isolation key). */
  orgId: Scalars['ID']['output']
  /** Resolved permission strings granted to this user. */
  permissions?: Maybe<Array<Scalars['String']['output']>>
  /** User's phone number. */
  phone?: Maybe<Scalars['String']['output']>
  /** User's position: Executive, Consultant, Dentist, Hygienist, Manager, Treatment Coordinator, Administrator, or Other. */
  position?: Maybe<Scalars['String']['output']>
  /** Preferred contact channel: 'email' or 'SMS'. */
  preferredChannel?: Maybe<Scalars['String']['output']>
  products: Array<Scalars['String']['output']>
  /** Numeric role level controlling access tier. */
  role?: Maybe<Scalars['Int']['output']>
  /** Role id assigned to this user. */
  roleId?: Maybe<Scalars['ID']['output']>
  roleName: Scalars['String']['output']
  /** User's IANA timezone. */
  timezone?: Maybe<Scalars['String']['output']>
  /** User tier: 'super' or 'standard'. */
  type: Scalars['String']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace the user belongs to (for workspace-level users). */
  workspaceId?: Maybe<Scalars['ID']['output']>
  /** Multi-workspace assignments for workspace-level users (staff-v2). */
  workspaces?: Maybe<Array<AssignedWorkspace>>
}

export type UserActivityEntry = {
  __typename?: 'UserActivityEntry'
  /** Action the user performed. */
  action: Scalars['String']['output']
  /** When the action occurred. */
  dateTime: Scalars['String']['output']
  /** Email of the user who performed the action. */
  email: Scalars['String']['output']
  /** Role of the user at the time of the action. */
  role: Scalars['String']['output']
}

export type UserActivityResult = {
  __typename?: 'UserActivityResult'
  /** User activity log entries. */
  activities: Array<UserActivityEntry>
}

export type UserListResult = {
  __typename?: 'UserListResult'
  /** Results for the current page. */
  hits: Array<User>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type UserNotificationSettings = {
  __typename?: 'UserNotificationSettings'
  /** AI-agent notification preferences. */
  aiAgent?: Maybe<AiAgentNotificationSettings>
  /** Form-submission notification preferences. */
  formSubmissions?: Maybe<FormSubmissionsNotificationSettings>
  /** Phone-call notification preferences. */
  phoneCalls?: Maybe<PhoneCallsNotificationSettings>
  /** PMS-data notification preferences. */
  pmsData?: Maybe<PmsDataNotificationSettings>
  /** Scheduler notification preferences. */
  scheduler?: Maybe<SchedulerNotificationSettings>
  /** Text-message notification preferences. */
  textMessages?: Maybe<TextMessagesNotificationSettings>
  /** Workflow-paused notification preferences. */
  workflowPaused?: Maybe<WorkflowPausedNotificationSettings>
}

export type UserNotificationSettingsInput = {
  /** AI-agent notification preferences. */
  aiAgent?: InputMaybe<AiAgentNotificationInput>
  /** Form-submission notification preferences. */
  formSubmissions?: InputMaybe<FormSubmissionsNotificationInput>
  /** Phone-call notification preferences. */
  phoneCalls?: InputMaybe<PhoneCallsNotificationInput>
  /** PMS-data notification preferences. */
  pmsData?: InputMaybe<PmsDataNotificationInput>
  /** Scheduler notification preferences. */
  scheduler?: InputMaybe<SchedulerNotificationInput>
  /** Text-message notification preferences. */
  textMessages?: InputMaybe<TextMessagesNotificationInput>
  /** Workflow-paused notification preferences. */
  workflowPaused?: InputMaybe<WorkflowPausedNotificationInput>
}

export enum UserPosition {
  Administrator = 'ADMINISTRATOR',
  Consultant = 'CONSULTANT',
  Dentist = 'DENTIST',
  Executive = 'EXECUTIVE',
  Hygienist = 'HYGIENIST',
  Manager = 'MANAGER',
  Other = 'OTHER',
  TreatmentCoordinator = 'TREATMENT_COORDINATOR',
}

export type UserSetting = {
  __typename?: 'UserSetting'
  /** Setting key identifying which preference this record stores. */
  key: Scalars['String']['output']
  /** User this setting belongs to. */
  userId: Scalars['String']['output']
  /** Stored value for this setting, serialized as arbitrary JSON. */
  value?: Maybe<Scalars['JSON']['output']>
}

export type UtmAlias = {
  __typename?: 'UtmAlias'
  /** The normalized display value that the original value maps to */
  alias: Scalars['String']['output']
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Unique identifier for this UTM alias (derived from workspaceId, type, and original value) */
  id: Scalars['ID']['output']
  /** Organization that owns this alias (multi-tenant isolation key) */
  orgId: Scalars['String']['output']
  /** The original raw UTM value captured from tracking links */
  original: Scalars['String']['output']
  /** Which UTM dimension this alias applies to: either "source" or "medium" */
  type: Scalars['String']['output']
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this UTM alias belongs to */
  workspaceId: Scalars['String']['output']
}

export type UtmAliasListResult = {
  __typename?: 'UtmAliasListResult'
  /** Matching records for the current page. */
  hits: Array<UtmAlias>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching records across all pages. */
  total: Scalars['Int']['output']
}

export type VoiceAgentDailyCounts = {
  __typename?: 'VoiceAgentDailyCounts'
  /** Number of AI agent calls on this day. */
  aiCalls: Scalars['Int']['output']
  /** The day these counts fall on, as YYYY-MM-DD in the location's local time. */
  date: Scalars['String']['output']
  /** Number of calls on this day with any ElevenLabs failure. */
  elevenLabsFailedCalls: Scalars['Int']['output']
  /** Number of calls on this day with any tool flag. */
  failedCalls: Scalars['Int']['output']
  /** Number of calls on this day with any GPT failure. */
  gptFailedCalls: Scalars['Int']['output']
}

export type VoiceAgentDailyMetricsInput = {
  /** Date range to compute daily voice agent counts over. */
  dateRange: DateRangeInput
  /** Restrict to these location ids; omit for all accessible locations. */
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
}

export type VoiceAgentDailyMetricsResponse = {
  __typename?: 'VoiceAgentDailyMetricsResponse'
  /** Totals per day across all locations in scope, for the charts. */
  daily: Array<VoiceAgentDailyCounts>
  /** Per-location daily AI call counts plus last call before the range, for the grid. */
  locations: Array<VoiceAgentLocationDailyCalls>
}

export type VoiceAgentLocationCounts = {
  __typename?: 'VoiceAgentLocationCounts'
  /** Number of AI agent calls at this location. */
  aiCalls: Scalars['Int']['output']
  /** Number of appointments booked by the agent. */
  appointmentsBooked: Scalars['Int']['output']
  /** Number of booked appointments that were completed. */
  appointmentsCompleted: Scalars['Int']['output']
  /** Number of calls flagged as disconnected. */
  disconnectedCalls: Scalars['Int']['output']
  /** Number of calls with any ElevenLabs failure (Disconnected, Max Duration, Error, Unsuccessful). */
  elevenLabsFailedCalls: Scalars['Int']['output']
  /** Number of calls flagged with a generic error. */
  errorCalls: Scalars['Int']['output']
  /** Number of calls with at least one tool flag (not the sum of the three tool flag counts). */
  failedCalls: Scalars['Int']['output']
  /** Number of calls with any GPT failure (LLM Failed or LLM Slow). */
  gptFailedCalls: Scalars['Int']['output']
  /** Number of calls flagged as LLM failed. */
  llmFailedCalls: Scalars['Int']['output']
  /** Number of calls flagged as LLM slow. */
  llmSlowCalls: Scalars['Int']['output']
  /** Location these counts are for. */
  locationId: Scalars['ID']['output']
  /** Location display name. */
  locationName?: Maybe<Scalars['String']['output']>
  /** Number of calls that hit the maximum duration. */
  maxDurationCalls: Scalars['Int']['output']
  /** Number of new-patient calls at this location. */
  newPatientCalls: Scalars['Int']['output']
  /** Number of calls flagged with a duplicate tool invocation. */
  toolDuplicateCalls: Scalars['Int']['output']
  /** Number of calls flagged with a tool error. */
  toolErrorCalls: Scalars['Int']['output']
  /** Number of calls flagged with a tool timeout. */
  toolTimeoutCalls: Scalars['Int']['output']
  /** Number of calls flagged as unsuccessful. */
  unsuccessfulCalls: Scalars['Int']['output']
  /** Workspace this location belongs to. */
  workspaceId?: Maybe<Scalars['String']['output']>
  /** Workspace display name. */
  workspaceName?: Maybe<Scalars['String']['output']>
}

export type VoiceAgentLocationDailyCalls = {
  __typename?: 'VoiceAgentLocationDailyCalls'
  /** One entry per day that had AI calls (days with none are omitted). */
  days: Array<VoiceAgentLocationDayCount>
  /** Last day with an AI call before the range starts; null when there is none. */
  lastCallBeforeRange?: Maybe<Scalars['String']['output']>
  /** Location these daily counts are for. */
  locationId: Scalars['ID']['output']
}

export type VoiceAgentLocationDayCount = {
  __typename?: 'VoiceAgentLocationDayCount'
  /** Number of AI agent calls at the location on this day. */
  aiCalls: Scalars['Int']['output']
  /** Day these counts fall on, as YYYY-MM-DD. */
  date: Scalars['String']['output']
}

export type VoiceAgentLocationMetricsInput = {
  /** Optional previous period; when set, the same counts are returned as compareRows. */
  compareDateRange?: InputMaybe<DateRangeInput>
  /** Date range to compute per-location voice agent counts over. */
  dateRange: DateRangeInput
  /** Restrict to these location ids; omit for all accessible locations. */
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
}

export type VoiceAgentLocationMetricsResponse = {
  __typename?: 'VoiceAgentLocationMetricsResponse'
  /** Per-location counts for the comparison period; present only when compareDateRange was supplied. */
  compareRows?: Maybe<Array<VoiceAgentLocationCounts>>
  /** Weighted total for the comparison period; present only when compareDateRange was supplied. */
  compareTotal?: Maybe<VoiceAgentLocationCounts>
  /** One row per location that has calls in scope. */
  rows: Array<VoiceAgentLocationCounts>
  /** The weighted total across every location in scope. */
  total: VoiceAgentLocationCounts
}

export type VoiceAgentMetricsResponse = {
  __typename?: 'VoiceAgentMetricsResponse'
  /** Number of appointments booked by the voice agent. */
  appointmentsBooked: Scalars['Int']['output']
  /** Number of booked appointments that were completed. */
  appointmentsCompleted: Scalars['Int']['output']
  /** Number of locations included in these metrics. */
  locationCount: Scalars['Int']['output']
  /** Number of new-patient calls handled by the voice agent. */
  newPatientCalls: Scalars['Int']['output']
  /** Share of new-patient calls that resulted in a booked appointment, as a rate. */
  scheduleRate: Scalars['Float']['output']
  /** Total number of calls handled by the voice agent. */
  totalCalls: Scalars['Int']['output']
}

export type Workflow = {
  __typename?: 'Workflow'
  /** Whether the workflow is currently active and enrolling contacts. */
  active: Scalars['Boolean']['output']
  /** Opaque frontend builder state (preserved by engine, never interpreted) */
  builderJson?: Maybe<Scalars['JSON']['output']>
  /** Message category: transactional or marketing */
  category?: Maybe<Scalars['String']['output']>
  /** When this workflow was created. */
  createdDate: Scalars['DateTime']['output']
  /** Array of workflow edges (typed JSON) */
  edgesJson: Scalars['JSON']['output']
  /** Unique identifier for the workflow. */
  id: Scalars['ID']['output']
  /** Optional location this workflow is scoped to. */
  locationId?: Maybe<Scalars['String']['output']>
  /** Human-readable name of the workflow. */
  name: Scalars['String']['output']
  /** Array of workflow nodes (typed JSON) */
  nodesJson: Scalars['JSON']['output']
  /** Organization that owns this workflow (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** Whether the workflow is paused. A pause holds every patient at their current step, runs no steps, and blocks new enrollment until the workflow is unpaused. Set by staff from the builder or by the engine when a step cannot run due to the location's setup. */
  paused: Scalars['Boolean']['output']
  /** When the workflow was paused. */
  pausedDate?: Maybe<Scalars['DateTime']['output']>
  /** The node whose setup failure paused the workflow, when the engine paused it. Empty for a manual staff pause. */
  pausedNodeId?: Maybe<Scalars['String']['output']>
  /** Why the engine paused the workflow (the setup failure reason code). Empty for a deliberate staff pause. */
  pausedReason?: Maybe<Scalars['String']['output']>
  /** Optional workflow settings */
  settingsJson?: Maybe<Scalars['JSON']['output']>
  /** Trigger configuration: { event, filters, reenrollment } */
  triggerJson: Scalars['JSON']['output']
  /** Date from which the workflow trigger begins evaluating enrollments. */
  triggerStartDate: Scalars['DateTime']['output']
  /** When this workflow was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace this workflow belongs to. */
  workspaceId: Scalars['String']['output']
}

/** A date field available for date-reached workflow triggers */
export type WorkflowDateTriggerField = {
  __typename?: 'WorkflowDateTriggerField'
  /** Attribute path of the date field on the source entity */
  attribute: Scalars['String']['output']
  /** Source entity type that owns the date field (e.g. Contact, Appointment) */
  sourceType: Scalars['String']['output']
  /** Storage type: date, datetime, or composite */
  storage: Scalars['String']['output']
}

/** A directed connection between two nodes. sourceHandle determines which outcome port to follow (e.g. "done", "replied", "no_reply", "answered", "voicemail", "no_answer", "timeout"). */
export type WorkflowEdgeInput = {
  /** Unique edge ID (client-generated) */
  id: Scalars['String']['input']
  /** Source node ID */
  source: Scalars['String']['input']
  /** Output handle on the source node: "done" for action/wait nodes, or a named outcome for branch nodes ("replied", "no_reply", "answered", "voicemail", "no_answer", "timeout"). A Wait node with early-exit conditions uses "conditions_met" and "timed_out" instead of "done". */
  sourceHandle: Scalars['String']['input']
  /** Target node ID */
  target: Scalars['String']['input']
  /** Input handle on the target node (usually "in") */
  targetHandle: Scalars['String']['input']
}

export type WorkflowListResult = {
  __typename?: 'WorkflowListResult'
  /** Results for the current page. */
  hits: Array<Workflow>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

/** A single node in the workflow graph. The 'type' field determines which config fields are required. Unused fields for a given type should be omitted or null. */
export type WorkflowNodeInput = {
  /** edit_task: set the task archived flag. Archiving removes it from the Tasks list without closing it. */
  archived?: InputMaybe<Scalars['Boolean']['input']>
  /** User ID to assign the task to */
  assigneeId?: InputMaybe<Scalars['String']['input']>
  /** The brief that sets the agent's goal for this conversation. The workflow supplies only this; the prompt and voice are shared. */
  brief?: InputMaybe<Scalars['String']['input']>
  /** If true, adjusts the resume time to fall within the contact's location business hours */
  businessHoursOnly?: InputMaybe<Scalars['Boolean']['input']>
  /** What to do when the agent is already engaged on the thread: "take_over" (replace the active brief and send) or "do_nothing" (stand down). */
  busyBehavior?: InputMaybe<Scalars['String']['input']>
  /** For "do_nothing": if the agent's last message is older than this many days, the prior engagement has lapsed and the workflow takes over anyway. Unset means always stand down. */
  busyLimitDays?: InputMaybe<Scalars['Int']['input']>
  /** Delivery channel: "app", "email", or "both" */
  channel?: InputMaybe<Scalars['String']['input']>
  /** JSON array of conditions: [{ id, label?, filters: [{ attribute, operator, value }], filterLogic?, source? }]. source is "contact" (default), "activity", "appointment" (the appointment the run enrolled from — branch on an appointment field), or "thread" (the contact's SMS thread — e.g. filter thread.aiEnabled to skip a handoff when the agent is already engaged). Each condition's id is used as the sourceHandle for outgoing edges. A fallback edge uses sourceHandle "default". */
  conditions?: InputMaybe<Scalars['String']['input']>
  /** log_follow_up: Connected value — "yes", "no", or "from_direction" (default: yes when the comm log was received, no for sent, unknown direction, or no comm log). */
  connected?: InputMaybe<Scalars['String']['input']>
  /** Note content text */
  content?: InputMaybe<Scalars['String']['input']>
  /** Task description/body */
  description?: InputMaybe<Scalars['String']['input']>
  /** Absolute due date (ISO string). Takes precedence over dueInDays. */
  dueDate?: InputMaybe<Scalars['String']['input']>
  /** Number of days from now for the task due date */
  dueInDays?: InputMaybe<Scalars['Int']['input']>
  /** Duration to pause, e.g. "30m", "2h", "1d" */
  duration?: InputMaybe<Scalars['String']['input']>
  /** For a Wait node: optional early-exit conditions on the run's contact, as a JSON object { filters: [{ attribute, operator, value }], filterLogic? }. Same shape as a Filter step. When set, the Wait ends early with sourceHandle "conditions_met" the moment the contact matches (checked at wait start, on contact changes, and once a day), otherwise "timed_out" when the duration elapses. Omit for a plain single-path Wait. */
  earlyExit?: InputMaybe<Scalars['String']['input']>
  /** Days until the paperwork link expires (default 14) */
  expiresInDays?: InputMaybe<Scalars['Int']['input']>
  /** JSON object of field names to values to set on the contact. Use null to clear a field. */
  fields?: InputMaybe<Scalars['String']['input']>
  /** log_follow_up: whether the follow-up date is the comm log date ("comm_log", default) or the time the step runs ("now"). With no comm log on the run, both are the time the step runs. */
  followUpDate?: InputMaybe<Scalars['String']['input']>
  /** send_email: the HTML email body. Supports {{token}} templating. */
  html?: InputMaybe<Scalars['String']['input']>
  /** Unique node ID (client-generated, used in edge references) */
  id: Scalars['String']['input']
  /** Message text to send, or the notification message body. */
  message?: InputMaybe<Scalars['String']['input']>
  /** log_follow_up: the follow-up note text. Comm log event data is available as {{commLog.channelLabel}}, {{commLog.direction}}, {{commLog.subject}}, {{commLog.note}}, {{commLog.date}}. Empty inserts nothing. */
  note?: InputMaybe<Scalars['String']['input']>
  /** edit_task: when true, only edit the branch task if its status is open; otherwise the step no-ops and its path continues. */
  onlyIfOpen?: InputMaybe<Scalars['Boolean']['input']>
  /** log_follow_up: the user to own the follow-up. A deactivated or missing user leaves the follow-up unowned. */
  ownerId?: InputMaybe<Scalars['String']['input']>
  /** PaperworkTemplate ID to send to the enrolled contact's patient */
  paperworkTemplateId?: InputMaybe<Scalars['String']['input']>
  /** Pipeline ID to set the stage on */
  pipelineId?: InputMaybe<Scalars['String']['input']>
  /** Canvas position (x, y) */
  position: WorkflowNodePositionInput
  /** What to do when the send falls in quiet hours (20:00–08:00 location time): "hold" (default, sends at 08:00) or "skip" (don't send). */
  quietHoursAction?: InputMaybe<Scalars['String']['input']>
  /** User IDs to notify */
  recipients?: InputMaybe<Array<Scalars['String']['input']>>
  /** For a Wait for reply node: JSON array of named reply options [{ id, label, keywords: [String] }]. Each option's id is the sourceHandle of its outgoing edge; a reply matching one of its keywords (trim + lowercase, exact) takes that exit. Any other inbound text takes sourceHandle "other_reply"; the window ending with no reply takes "no_reply". Omit or pass an empty array for the original two exits, "replied" and "no_reply". */
  replyOptions?: InputMaybe<Scalars['String']['input']>
  /** Staff phone number to ring and bridge to the contact. Caller ID is always the location primary tracking number. */
  ringNumber?: InputMaybe<Scalars['String']['input']>
  /** Role ID to assign the task to. A task has a user or a role, not both. */
  roleId?: InputMaybe<Scalars['String']['input']>
  /** Stage name to set */
  stage?: InputMaybe<Scalars['String']['input']>
  /** edit_task: new task status, "open" or "closed". An edit_task close leaves completedByUserId empty; a reopen clears it. */
  status?: InputMaybe<Scalars['String']['input']>
  /** Stop the run (without taking the no-reply path) once a person is handling this patient: a staff member replies, someone takes the thread over from the agent, or another workflow's brief supersedes this one. Unset defaults to on. An opt-out always ends the run regardless. */
  stopOnHumanTakeover?: InputMaybe<Scalars['Boolean']['input']>
  /** send_email: the email subject. Supports {{token}} templating. */
  subject?: InputMaybe<Scalars['String']['input']>
  /** Tags to add or remove */
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  /** Target entity: "contact" (default) or "activity" */
  target?: InputMaybe<Scalars['String']['input']>
  /** Max time to wait for the event before timing out, e.g. "24h", "7d" */
  timeout?: InputMaybe<Scalars['String']['input']>
  /** Task title */
  title?: InputMaybe<Scalars['String']['input']>
  /** Which phone field to send to: "cellPhone", "homePhone", "workPhone". Defaults to first available. */
  toField?: InputMaybe<Scalars['String']['input']>
  /** Determines the node's behavior and which config fields are relevant */
  type: WorkflowNodeType
  /** User ID to assign as contact owner */
  userId?: InputMaybe<Scalars['String']['input']>
  /** Optional TTS whisper message played to the staff member before bridging. Supports {{contact.*}} and {{activity.*}} template variables. */
  whisperMessage?: InputMaybe<Scalars['String']['input']>
}

/** Canvas position for the node (used by the frontend builder, preserved by the backend) */
export type WorkflowNodePositionInput = {
  /** Horizontal canvas coordinate of the node */
  x: Scalars['Int']['input']
  /** Vertical canvas coordinate of the node */
  y: Scalars['Int']['input']
}

/** The type of action or control a workflow node performs */
export enum WorkflowNodeType {
  AddTags = 'ADD_TAGS',
  AssignOwner = 'ASSIGN_OWNER',
  Branch = 'BRANCH',
  ConfirmAppointment = 'CONFIRM_APPOINTMENT',
  CreateNote = 'CREATE_NOTE',
  CreateTask = 'CREATE_TASK',
  EditActivity = 'EDIT_ACTIVITY',
  EditContact = 'EDIT_CONTACT',
  EditTask = 'EDIT_TASK',
  InitiateAgent = 'INITIATE_AGENT',
  InitiateCall = 'INITIATE_CALL',
  LogFollowUp = 'LOG_FOLLOW_UP',
  RemoveFromPipeline = 'REMOVE_FROM_PIPELINE',
  RemoveTags = 'REMOVE_TAGS',
  SendEmail = 'SEND_EMAIL',
  SendNotification = 'SEND_NOTIFICATION',
  SendPaperwork = 'SEND_PAPERWORK',
  SendSms = 'SEND_SMS',
  SetPipelineStage = 'SET_PIPELINE_STAGE',
  Wait = 'WAIT',
  WaitForCallResult = 'WAIT_FOR_CALL_RESULT',
  WaitForReply = 'WAIT_FOR_REPLY',
}

export type WorkflowPausedNotificationInput = {
  /** Deliver workflow-paused notifications in-app. */
  app?: InputMaybe<Scalars['Boolean']['input']>
  /** Deliver workflow-paused notifications by email. */
  email?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether workflow-paused notifications are enabled. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
}

export type WorkflowPausedNotificationSettings = {
  __typename?: 'WorkflowPausedNotificationSettings'
  /** Deliver workflow-paused notifications in-app. */
  app?: Maybe<Scalars['Boolean']['output']>
  /** Deliver workflow-paused notifications by email. */
  email?: Maybe<Scalars['Boolean']['output']>
  /** Whether workflow-paused notifications are enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>
}

/** How the workflow handles a contact that triggers again while already enrolled */
export enum WorkflowReenrollmentPolicy {
  AllowMultiple = 'ALLOW_MULTIPLE',
  Ignore = 'IGNORE',
  Restart = 'RESTART',
}

export type WorkflowRun = {
  __typename?: 'WorkflowRun'
  /** Activity this run is associated with, if any. */
  activityId?: Maybe<Scalars['String']['output']>
  /** For a task-branch run, the task an edit_task step on this branch edits. */
  branchTaskId?: Maybe<Scalars['String']['output']>
  /** Contact this run is enrolled for. */
  contactId?: Maybe<Scalars['String']['output']>
  /** Timestamp when this run record was created. */
  createdDate: Scalars['DateTime']['output']
  /** Identifier of the workflow node currently being executed. */
  currentNodeId: Scalars['String']['output']
  /** User who manually enrolled the contact into this run. */
  enrolledByUserId?: Maybe<Scalars['String']['output']>
  /** Event that enrolled this run, for trigger-started runs. */
  enrollmentEventId?: Maybe<Scalars['String']['output']>
  /** Reason this run exited, when it has ended. */
  exitReason?: Maybe<Scalars['String']['output']>
  /** Unique identifier for this workflow run. */
  id: Scalars['ID']['output']
  /** Location this run is scoped to, if any. */
  locationId?: Maybe<Scalars['String']['output']>
  /** Organization that owns this run (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** For a task-branch run, the main-path run this branch links back to. */
  parentRunId?: Maybe<Scalars['String']['output']>
  /** When a waiting run should resume. */
  resumeAt?: Maybe<Scalars['DateTime']['output']>
  /** The most recent paperwork packet this run's send_paperwork step created. */
  sentPaperworkId?: Maybe<Scalars['String']['output']>
  /** Identifier of the source record a manual enrollment started from. */
  sourceId?: Maybe<Scalars['String']['output']>
  /** Type of the source record a manual enrollment started from (appointment, call, form, activity). */
  sourceType?: Maybe<Scalars['String']['output']>
  /** When this run started. */
  startedAt: Scalars['DateTime']['output']
  /** Current status of this run (e.g. running, waiting, completed). */
  status: Scalars['String']['output']
  /** Timestamp when this run record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** What a waiting run is waiting for (e.g. reply, call_result, wait). */
  waitingFor?: Maybe<Scalars['String']['output']>
  /** The workflow definition this run executes. */
  workflowId: Scalars['String']['output']
  /** Workspace this run belongs to. */
  workspaceId: Scalars['String']['output']
}

export type WorkflowRunEvent = {
  __typename?: 'WorkflowRunEvent'
  /** Contact this workflow run event relates to, if any. */
  contactId?: Maybe<Scalars['String']['output']>
  /** Timestamp when this event record was created. */
  createdDate: Scalars['DateTime']['output']
  /** Identifier of the triggering event, if any. */
  eventId?: Maybe<Scalars['String']['output']>
  /** Unique identifier for this workflow run event. */
  id: Scalars['ID']['output']
  /** Identifier of the workflow node that produced this event. */
  nodeId: Scalars['String']['output']
  /** Type of the workflow node that produced this event. */
  nodeType: Scalars['String']['output']
  /** Organization that owns this event (multi-tenant isolation key). */
  orgId: Scalars['String']['output']
  /** JSON-encoded output produced by the node for this event. */
  outputJson?: Maybe<Scalars['JSON']['output']>
  /** Identifier of the workflow run this event is part of. */
  runId?: Maybe<Scalars['String']['output']>
  /** Execution status of the node for this event. */
  status: Scalars['String']['output']
  /** Time at which this event occurred. */
  timestamp: Scalars['DateTime']['output']
  /** Timestamp when this event record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Identifier of the workflow definition that produced this event. */
  workflowId?: Maybe<Scalars['String']['output']>
  /** Workspace this event belongs to. */
  workspaceId: Scalars['String']['output']
}

export type WorkflowRunEventListResult = {
  __typename?: 'WorkflowRunEventListResult'
  /** Results for the current page. */
  hits: Array<WorkflowRunEvent>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type WorkflowRunListResult = {
  __typename?: 'WorkflowRunListResult'
  /** Results for the current page. */
  hits: Array<WorkflowRun>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export enum WorkflowStatus {
  Awaiting = 'AWAITING',
  Ignored = 'IGNORED',
  InProgress = 'IN_PROGRESS',
  Unread = 'UNREAD',
}

/** The entity lifecycle event that triggers workflow enrollment */
export enum WorkflowTriggerEvent {
  ActivityCreated = 'ACTIVITY_CREATED',
  ActivityDateReached = 'ACTIVITY_DATE_REACHED',
  ActivityUpdated = 'ACTIVITY_UPDATED',
  AppointmentCreated = 'APPOINTMENT_CREATED',
  AppointmentDateReached = 'APPOINTMENT_DATE_REACHED',
  AppointmentUpdated = 'APPOINTMENT_UPDATED',
  CallCreated = 'CALL_CREATED',
  CallDateReached = 'CALL_DATE_REACHED',
  CallFinishedProcessing = 'CALL_FINISHED_PROCESSING',
  CallUpdated = 'CALL_UPDATED',
  CommLogCreated = 'COMM_LOG_CREATED',
  ContactCreated = 'CONTACT_CREATED',
  ContactDateReached = 'CONTACT_DATE_REACHED',
  ContactUpdated = 'CONTACT_UPDATED',
  FormCreated = 'FORM_CREATED',
  FormDateReached = 'FORM_DATE_REACHED',
  FormUpdated = 'FORM_UPDATED',
  MessageCreated = 'MESSAGE_CREATED',
  MessageDateReached = 'MESSAGE_DATE_REACHED',
  PaperworkCompleted = 'PAPERWORK_COMPLETED',
  TaskCreated = 'TASK_CREATED',
  TaskDateReached = 'TASK_DATE_REACHED',
  TaskUpdated = 'TASK_UPDATED',
  TreatmentPlanClosed = 'TREATMENT_PLAN_CLOSED',
  TreatmentPlanCreated = 'TREATMENT_PLAN_CREATED',
  TreatmentPlanProcedureBooked = 'TREATMENT_PLAN_PROCEDURE_BOOKED',
  TreatmentPlanProcedureBrokenBooking = 'TREATMENT_PLAN_PROCEDURE_BROKEN_BOOKING',
  TreatmentPlanProcedureCompleted = 'TREATMENT_PLAN_PROCEDURE_COMPLETED',
  TreatmentPlanProcedurePresented = 'TREATMENT_PLAN_PROCEDURE_PRESENTED',
  TreatmentPlanUpdated = 'TREATMENT_PLAN_UPDATED',
}

/** A single filter condition evaluated against the triggering entity. All filters must match (AND logic). */
export type WorkflowTriggerFilterInput = {
  /** Dot-notation path on the entity to evaluate, e.g. "tags", "type", "leadStatus" */
  attribute: Scalars['String']['input']
  /** Comparison operator: in, not_in, exactly, not_exactly, contains, not_contains, attribute_exists, attribute_not_exists, greater_than, greater_equal_than, lesser_than, between, in_the_past */
  operator: Scalars['String']['input']
  /** The value to compare against. For array operators (in, not_in, between), pass a JSON-encoded array string. */
  value?: InputMaybe<Scalars['String']['input']>
}

/** Defines when a workflow enrolls contacts. Combines an event type, filter conditions, and a re-enrollment policy. */
export type WorkflowTriggerInput = {
  /** The entity lifecycle event that fires this trigger */
  event: WorkflowTriggerEvent
  /** How to combine change filters: "and" (all must match, default) or "or" (any must match) */
  filterLogic?: InputMaybe<Scalars['String']['input']>
  /** Change conditions — evaluated against the Event (field changed to X). AND logic by default. */
  filters: Array<WorkflowTriggerFilterInput>
  /** What happens if a contact triggers this workflow while already enrolled: ignore (skip), restart (cancel + re-enroll), allow_multiple (run in parallel) */
  reenrollment?: WorkflowReenrollmentPolicy
  /** When true, skip enrollment for activities that have no linked contacts (unknown callers, unmatched forms) */
  requireContactMatch?: InputMaybe<Scalars['Boolean']['input']>
  /** How to combine state filters: "and" (all must match, default) or "or" (any must match) */
  stateFilterLogic?: InputMaybe<Scalars['String']['input']>
  /** State conditions — evaluated against the live source record at enrollment time (record currently is X). AND logic by default. */
  stateFilters?: InputMaybe<Array<WorkflowTriggerFilterInput>>
}

export type Workspace = {
  __typename?: 'Workspace'
  /** Soft-delete flag; archived workspaces are hidden from normal queries but retained. */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Dentrix Ascend Organization-ID header for this workspace's connected customer organization. */
  ascendOrgId?: Maybe<Scalars['String']['output']>
  /** Carestack PMS account identifier linking this workspace to its Carestack integration. */
  carestackId?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** When true, outbound email sending for this workspace is paused (TRK-6051). */
  emailSendingPaused?: Maybe<Scalars['Boolean']['output']>
  /** Configuration for routing Gravity Forms webhook submissions to specific locations. */
  gravityFormsMultiConfig?: Maybe<GravityFormsMultiConfig>
  /** Unique identifier for the workspace (primary key, auto-generated). */
  id: Scalars['ID']['output']
  /** Timestamp of the last Facebook Leads error, used to throttle error notification emails. */
  lastFacebookLeadsErrorDate?: Maybe<Scalars['DateTime']['output']>
  /** Timestamp of the last successful PMS synchronization; used for integration health and incremental sync. */
  lastPmsSyncDate?: Maybe<Scalars['DateTime']['output']>
  /** User who last confirmed the marketing-consent attestation. */
  marketingConsentConfirmedByUserId?: Maybe<Scalars['String']['output']>
  /** When the workspace confirmed it holds texting consent; gates form-triggered texting workflows. */
  marketingConsentConfirmedDate?: Maybe<Scalars['DateTime']['output']>
  /** Max workflow enrollments per hour across all workflows. Null = unlimited. */
  maxEnrollmentsPerHour?: Maybe<Scalars['Float']['output']>
  /** Max outbound actions all workflows may send per calendar day (Eastern TZ). Null = unlimited. */
  maxOutboundDaily?: Maybe<Scalars['Float']['output']>
  /** Max outbound actions (SMS, calls, notifications) all workflows in this workspace may send per calendar month. Null = unlimited. */
  maxOutboundMonthly?: Maybe<Scalars['Float']['output']>
  /** Human-readable display name for the workspace. */
  name: Scalars['String']['output']
  /** Organization that owns this workspace (multi-tenant isolation key). */
  orgId: Scalars['ID']['output']
  /** Organization-level tags for workspace categorization and filtering. */
  orgTags?: Maybe<Array<Scalars['String']['output']>>
  /** Custom AI prompt text appended to call-processing system prompts for this workspace. */
  promptAddendum?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
}

export type WorkspaceInvite = {
  __typename?: 'WorkspaceInvite'
  /** Invite code used to accept the invitation */
  code: Scalars['String']['output']
  /** When the invite was created */
  createdAt: Scalars['DateTime']['output']
  /** Timestamp when this record was first created. */
  createdDate: Scalars['DateTime']['output']
  /** Email address the invite was sent to */
  email: Scalars['String']['output']
  /** When the invite expires and can no longer be accepted */
  expiresAt: Scalars['DateTime']['output']
  /** Unique identifier for the workspace invite */
  id: Scalars['ID']['output']
  /** User id of the person who sent the invite */
  invitedBy: Scalars['String']['output']
  /** Locations the invitee will be granted access to */
  locationIds?: Maybe<Array<Scalars['String']['output']>>
  /** Organization that owns this invite (multi-tenant isolation key) */
  orgId: Scalars['String']['output']
  /** Role the invitee will be granted upon accepting */
  roleId: Scalars['String']['output']
  /** Staff id associated with the invitee, if any */
  staffId?: Maybe<Scalars['String']['output']>
  /** Timestamp when this record was last updated. */
  updatedDate: Scalars['DateTime']['output']
  /** User id of the invitee once they have an account */
  userId?: Maybe<Scalars['String']['output']>
  /** Monotonic version number, incremented on every save for optimistic concurrency. */
  version: Scalars['Int']['output']
  /** Workspace the invitee is being invited to join */
  workspaceId: Scalars['String']['output']
}

export type WorkspaceInviteListResult = {
  __typename?: 'WorkspaceInviteListResult'
  /** Matching workspace invites for this page. */
  hits: Array<WorkspaceInvite>
  /** Zero-based index of the current page. */
  page: Scalars['Int']['output']
  /** Total number of matching invites across all pages. */
  total: Scalars['Int']['output']
}

export type WorkspaceListResult = {
  __typename?: 'WorkspaceListResult'
  /** Results for the current page. */
  hits: Array<Workspace>
  /** Zero-based page number of these results. */
  page: Scalars['Int']['output']
  /** Total number of matching results across all pages. */
  total: Scalars['Int']['output']
}

export type WorkspaceStat = {
  __typename?: 'WorkspaceStat'
  /** Workspace name. */
  name: Scalars['String']['output']
  /** Count of records for this workspace. */
  total: Scalars['Int']['output']
}
